var home24Reboot =
webpackJsonphome24Reboot([20],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(465);
	
	__webpack_require__(73);
	
	__webpack_require__(192);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _translation = __webpack_require__(12);
	
	var _Client = __webpack_require__(27);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _config = __webpack_require__(4);
	
	var _validationController = __webpack_require__(13);
	
	var _desktop = __webpack_require__(293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	  module.hot.accept();
	}
	
	var _client$getInformatio = _Client2.default.getInformation(),
	    appDomainId = _client$getInformatio.appDomainId,
	    language = _client$getInformatio.language;
	
	var config = __webpack_require__(77);
	var validation = __webpack_require__(102)("./validation-" + appDomainId + '.js');
	var translation = __webpack_require__(54)("./translation-" + appDomainId + '-' + language + '.js');
	
	Promise.all([config(), validation(), translation()]).then(function (configs) {
	  (0, _config.setConfig)(configs[0]);
	  (0, _translation.setTranslations)(configs[2]);
	  (0, _validationController.initialize)(_jquery2.default.extend(true, {}, configs[1], configs[1].validation));
	
	  __webpack_require__(286);
	  (0, _desktop.quickview)();
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.View.extend({
	  /**
	   *
	   */
	  constructor: function constructor() {
	    this.bindRivetsEventHandlers();
	
	    _backbone2.default.View.apply(this, arguments);
	  },
	
	  /*
	   * Scroll window to new element
	   */
	  scrollToElement: function scrollToElement(options) {
	    var $element = (0, _jquery2.default)(options.el);
	    var topPosition = $element.offset().top;
	
	    (0, _jquery2.default)('body, html').animate({
	      scrollTop: topPosition - config.getInt('sliders.scrollFactor')
	    }, 300, function () {
	      if (options.callback && typeof options.callback === 'function') {
	        options.callback();
	      }
	    });
	  },
	
	  /**
	   *
	   */
	  bindRivetsEventHandlers: function bindRivetsEventHandlers() {
	    if (_underscore2.default.isArray(this.rivetsEventHandlers)) {
	      _underscore2.default.bindAll.apply(this, [].concat(this, this.rivetsEventHandlers));
	    }
	  },
	
	  /**
	   * destroy backbone view, unbind all events etc.
	   */
	  destroy: function destroy() {
	    this.undelegateEvents();
	    this.$el.removeData().unbind();
	    this.remove();
	    _backbone2.default.View.prototype.remove.call(this);
	  }
	});

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setConfig = setConfig;
	exports.get = get;
	exports.getInt = getInt;
	exports.getBaseUrl = getBaseUrl;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _get = __webpack_require__(30);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var url = (0, _jquery2.default)('meta[name=base-url]').attr('content');
	var c = {};
	
	function setConfig(config) {
	  var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : url;
	
	  c = config;
	  url = baseUrl;
	}
	
	/**
	 * @param {String} key
	 * @return {*}
	 */
	function get(key) {
	  return (0, _get2.default)(c, key, null);
	}
	
	/**
	 * Method returns config value casted to int
	 * @param {String} key
	 * @return {int}
	 */
	function getInt(key) {
	  return parseInt((0, _get2.default)(c, key, null), 10);
	}
	
	/**
	 * @return {*}
	 */
	function getBaseUrl() {
	  return url;
	}

/***/ },
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStorage = getStorage;
	
	var _localStorage = __webpack_require__(70);
	
	var local = _interopRequireWildcard(_localStorage);
	
	var _memoryStorage = __webpack_require__(71);
	
	var memory = _interopRequireWildcard(_memoryStorage);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function hasLocalStorage() {
	  var test = 'test';
	
	  try {
	    localStorage.setItem(test, test);
	    localStorage.removeItem(test);
	
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	
	// test according to modernizr
	// https://github.com/Modernizr/Modernizr/blob/master/feature-detects/json.js
	function hasJson() {
	  return 'JSON' in window && 'parse' in JSON && 'stringify' in JSON;
	}
	
	function getStorage() {
	  var storage = memory;
	
	  // return based on browser capability
	  if (hasLocalStorage() && hasJson()) {
	    storage = local;
	  }
	
	  return storage;
	}

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.register = register;
	exports.run = run;
	exports.runOne = runOne;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Features:
	 *
	 * module can be registered for several pages with names separated by space
	 * register('page1 page2 page3', callback);
	 * ------------------------------------------------------------------------
	 * page name can be a combination of space separated names
	 * <body data-page="page1 page2">
	 *
	 * **/
	
	var bootstraps = {};
	var commonBootstraps = [];
	var bootstrappingExecuted = false;
	var body = (0, _jquery2.default)('body');
	var modules = body.data('page');
	
	/**
	 * Method registers bootstrap method to be executed after all code is loaded
	 * @param {String} name
	 * @param {Function} bootstrapFunction
	 */
	function register(name, bootstrapFunction) {
	  if (typeof bootstrapFunction === 'function') {
	    if (typeof name === 'string') {
	      var names = name.split(/\s+/);
	
	      _underscore2.default.each(names, function (n) {
	        /*
	                 If bootstrap name is not initialized, initialize
	                 */
	        if (!bootstraps[n]) {
	          bootstraps[n] = [];
	        }
	
	        bootstraps[n].push(bootstrapFunction);
	      });
	    } else if (name === null) {
	      commonBootstraps.push(bootstrapFunction);
	    }
	  }
	}
	
	/**
	 * Method executes current bootstrap function based on classnames attached to body element
	 */
	function run() {
	  if (!bootstrappingExecuted) {
	    /*
	     * Execute common initializers
	     */
	    _underscore2.default.each(commonBootstraps, function (commonBootstrap) {
	      commonBootstrap();
	    });
	
	    if (modules) {
	      /*
	             Iterate over all modules to be initialized
	             */
	      _underscore2.default.each(modules.split(/\s+/), function (className) {
	        runOne(className);
	      }, this);
	    }
	
	    bootstrappingExecuted = true;
	  }
	}
	
	/**
	 * Method executes bootstrapper for 'moduleName'
	 */
	function runOne(moduleName) {
	  var moduleBootstraps = bootstraps[moduleName];
	
	  if (moduleBootstraps) {
	    _underscore2.default.each(moduleBootstraps, function (moduleBootstrap) {
	      moduleBootstrap();
	    });
	  }
	}

/***/ },
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addToDataLayerForLinks = addToDataLayerForLinks;
	exports.addToDataLayerForSubmit = addToDataLayerForSubmit;
	exports._redirect = _redirect;
	exports.getCurrentDataLayer = getCurrentDataLayer;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Add data to dataLayer for links
	 * @param {Event} event - click event
	 * @param {Object} data
	 */
	function addToDataLayerForLinks(event, data) {
	  var href = event.target.href || (0, _jquery2.default)(event.currentTarget).prop('href');
	  var redirectCallback;
	  var redirectTimeout;
	  var timeoutTime = 500;
	
	  if (typeof href === 'string') {
	    event.preventDefault();
	
	    redirectCallback = _underscore2.default.bind(function () {
	      clearTimeout(redirectTimeout);
	      _redirect(href);
	    }, this);
	
	    redirectTimeout = setTimeout(function () {
	      redirectCallback();
	    }, timeoutTime);
	
	    data.eventCallback = redirectCallback;
	
	    window.dataLayer.push(data);
	  }
	}
	
	/**
	 * Add data to dataLayer for submit
	 * @param {Event} event - submit event
	 * @param {Object} data
	 */
	function addToDataLayerForSubmit(event, data) {
	  if (event.type !== 'submit') {
	    return;
	  }
	  var form = event.currentTarget;
	  var submitCallback;
	  var submitTimeout;
	  var timeoutTime = 500;
	  event.preventDefault();
	
	  submitCallback = _underscore2.default.bind(function () {
	    clearTimeout(submitTimeout);
	    form.submit();
	  }, this);
	
	  submitTimeout = setTimeout(function () {
	    submitCallback();
	  }, timeoutTime);
	
	  data.eventCallback = submitCallback;
	
	  window.dataLayer.push(data);
	}
	
	function _redirect(href) {
	  document.location.assign(href);
	}
	
	/**
	 * Method return first state of dataLayer object
	 * @return {Object}
	 */
	function getCurrentDataLayer() {
	  var blackListKey = 'event';
	  var result = {};
	
	  if (typeof window.dataLayer !== 'undefined') {
	    var resultArray = _underscore2.default.reject(window.dataLayer, function (currentLayer) {
	      return currentLayer[blackListKey];
	    });
	
	    if (resultArray.length > 0) {
	      result = resultArray[0];
	    }
	  }
	
	  return result;
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setConfig = setConfig;
	exports.open = open;
	exports.close = close;
	exports.getLightboxContainer = getLightboxContainer;
	exports.getContent = getContent;
	exports.exportLightBoxToWindow = exportLightBoxToWindow;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _customElements = __webpack_require__(18);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var publicScope = {};
	var privateScope = {};
	var lightboxConfig = {
	  className: '',
	  $dialog: {},
	  onOpen: null,
	  onClose: null
	};
	var isOpen = false;
	var isDomBinded = false;
	var selectors = {
	  main: '#lightbox',
	  content: 'div.lightbox-dialog',
	  closeButton: '.lightbox-close',
	  dialogBorder: '.lightbox-dialog-border',
	  background: '#lightbox-background',
	  body: 'body'
	};
	
	/**
	 * @type {$}
	 */
	privateScope.$body = null;
	
	/**
	 * @type {$}
	 */
	privateScope.$lightboxContainer = null;
	
	/**
	 * @type {$}
	 */
	privateScope.$background = null;
	
	/**
	 * @type {$}
	 */
	privateScope.$content = null;
	
	/**
	 * @return {$}
	 */
	privateScope.$dialogBorder = null;
	
	/**
	 * Method bind private properties to DOM and bind events
	 * @return {boolean}
	 */
	privateScope.bindDom = function () {
	  if (isDomBinded) {
	    return false;
	  }
	
	  privateScope.$background = (0, _jquery2.default)(selectors.background);
	
	  (0, _jquery2.default)(document).on('keyup.lightboxEvents', privateScope.onEscButtonPress);
	  privateScope.$lightboxContainer.on('click.lightboxEvents', selectors.closeButton, privateScope.onCloseButtonClick);
	  privateScope.$lightboxContainer.on('click.lightboxEvents', function (event) {
	    event.stopPropagation();
	  });
	  privateScope.$background.on('click.lightboxEvents', privateScope.onCloseButtonClick);
	
	  isDomBinded = true;
	
	  return true;
	};
	
	privateScope.unbindDom = function () {
	  (0, _jquery2.default)(document).off('.lightboxEvents');
	  privateScope.$lightboxContainer.off('.lightboxEvents');
	  privateScope.$background.off('.lightboxEvents');
	  (0, _jquery2.default)(window).off('.lightboxEvents');
	  isDomBinded = false;
	};
	
	/**
	 * @param {Event} event
	 */
	privateScope.onCloseButtonClick = function (event) {
	  event.preventDefault();
	  publicScope.close();
	};
	
	privateScope.onEscButtonPress = function (event) {
	  if (event.keyCode === parseInt(config.get('keyCodes.escape'), 10)) {
	    publicScope.close();
	  }
	};
	
	privateScope.clear = function () {
	  privateScope.$lightboxContainer.removeAttr('class');
	
	  return publicScope;
	};
	
	privateScope.applyContent = function (html) {
	  // privateScope.$content.html(html).parent().show(0, privateScope.adjustWidth);
	  privateScope.$content.html(html).parent().show(0);
	};
	
	privateScope.applyLayout = function () {
	  privateScope.clear();
	  privateScope.$lightboxContainer.addClass(lightboxConfig.className);
	};
	
	privateScope.checkScrollbar = function () {
	  var fullWindowWidth = window.innerWidth;
	
	  if (!fullWindowWidth) {
	    var documentElementRect = document.documentElement.getBoundingClientRect();
	
	    fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
	  this.scrollbarWidth = this.measureScrollbar();
	};
	
	privateScope.setScrollbar = function () {
	  var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
	
	  this.originalBodyPad = document.body.style.paddingRight || '';
	  if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
	};
	
	privateScope.resetScrollbar = function () {
	  this.$body.css('padding-right', this.originalBodyPad);
	};
	
	privateScope.measureScrollbar = function () {
	  var outer = document.createElement('div');
	
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.msOverflowStyle = 'scrollbar';
	
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	
	  // force scrollbars
	  outer.style.overflow = 'scroll';
	
	  // add innerdiv
	  var inner = document.createElement('div');
	
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	
	  // remove divs
	  outer.parentNode.removeChild(outer);
	
	  return widthNoScroll - widthWithScroll;
	};
	
	/**
	 * @return {jQuery}
	 */
	publicScope.getContent = function () {
	  privateScope.bindDom();
	
	  return privateScope.$content;
	};
	
	/**
	 * @return {jQuery}
	 */
	publicScope.getLightboxContainer = function () {
	  privateScope.bindDom();
	
	  return privateScope.$lightboxContainer;
	};
	
	/**
	 * Method sets configuration of lightbox.
	 * Required when .open() method will be called without html parameter
	 *
	 * @param {Object} c
	 * @return {Object}
	 */
	publicScope.setConfig = function (c) {
	  lightboxConfig = _jquery2.default.extend(true, {}, c);
	
	  return publicScope;
	};
	
	/**
	 * Method closed currently opened lightbox
	 * @fires closed.lightbox
	 *
	 * @return {Object}
	 */
	publicScope.close = function () {
	  if (!isOpen) {
	    return publicScope;
	  }
	
	  privateScope.unbindDom();
	
	  privateScope.$dialogBorder.css('width', '');
	  privateScope.$lightboxContainer.hide();
	  privateScope.$background.hide();
	  privateScope.clear();
	  isOpen = false;
	
	  privateScope.$body.removeClass('lightbox-open');
	  privateScope.resetScrollbar();
	
	  if (lightboxConfig.$dialog) {
	    lightboxConfig.$dialog.find('[id]').each(function () {
	      var $el = (0, _jquery2.default)(this);
	
	      $el.prop('id', $el.prop('id').replace('_light_box_masking', ''));
	    });
	  }
	
	  _jquery2.default.publish('closed.lightbox');
	
	  if (lightboxConfig.onClose && typeof lightboxConfig.onClose === 'function') {
	    lightboxConfig.onClose();
	  }
	
	  return publicScope;
	};
	
	/**
	 * Method open lightbox and fills it with content provided in html parameter
	 * or based on lightboxConfig.$dialog configuration
	 *
	 * @param {String=} html
	 * @return {Object}
	 */
	publicScope.open = function (html) {
	  if (isOpen) {
	    return publicScope;
	  }
	
	  var $wrapper = (0, _jquery2.default)('<div />');
	
	  privateScope.$body = (0, _jquery2.default)(selectors.body);
	  privateScope.$lightboxContainer = (0, _jquery2.default)(selectors.main);
	  privateScope.$dialogBorder = privateScope.$lightboxContainer.find(selectors.dialogBorder);
	  privateScope.$lightboxContainer.find(selectors.content).html($wrapper);
	  privateScope.$content = $wrapper;
	
	  privateScope.checkScrollbar();
	  privateScope.setScrollbar();
	  privateScope.$body.addClass('lightbox-open');
	
	  if (!html) {
	    html = lightboxConfig.$dialog.html();
	
	    // changing all IDs in template element to prevent duplicating IDs on one page
	    lightboxConfig.$dialog.find('[id]').each(function () {
	      var $el = (0, _jquery2.default)(this);
	
	      $el.prop('id', $el.prop('id') + '_light_box_masking');
	    });
	  }
	
	  privateScope.applyLayout();
	  privateScope.applyContent(html);
	
	  privateScope.bindDom();
	
	  privateScope.$lightboxContainer.show();
	  privateScope.$background.show();
	
	  isOpen = true;
	
	  if (lightboxConfig.onOpen && typeof lightboxConfig.onOpen === 'function') {
	    lightboxConfig.onOpen();
	  }
	
	  (0, _customElements.updateState)();
	  (0, _customElements.rebind)(privateScope.$content);
	
	  return publicScope;
	};
	
	publicScope.isOpen = function () {
	  return isOpen;
	};
	
	function setConfig(c) {
	  return publicScope.setConfig(c);
	}
	
	function open(html) {
	  return publicScope.open(html);
	}
	
	function close() {
	  return publicScope.close();
	}
	
	function getLightboxContainer() {
	  return publicScope.getLightboxContainer();
	}
	
	function getContent() {
	  return publicScope.getContent();
	}
	
	/**
	 * @description passes lightbox to the window
	 * currently it's being used by b2b
	 * look @https://github.com/Home24/Shop-LandingPages
	 * @method exportLightBoxToWindow
	 * @returns {undefined}
	 */
	function exportLightBoxToWindow() {
	  var w = window;
	
	  w.home24 = w.home24 || {};
	  w.home24.helpers = w.home24.helpers || {};
	
	  w.home24.helpers.lightbox = publicScope;
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.setTranslations = setTranslations;
	
	var _get = __webpack_require__(30);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var translation = {};
	
	/**
	 * Check if key of object home24.translate exists and translate it
	 * @function
	 * @param {String} key text to translate
	 * @returns {String} the key translation if key exists otherwise the key
	 */
	function get(key) {
	  return (0, _get2.default)(translation, key, key);
	}
	
	function setTranslations(t) {
	  translation = t;
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialize = initialize;
	exports.reload = reload;
	exports.getRules = getRules;
	exports.exportValidationToWindow = exportValidationToWindow;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _eventEmmiter = __webpack_require__(21);
	
	var eventEmitter = _interopRequireWildcard(_eventEmmiter);
	
	var _validationView = __webpack_require__(184);
	
	var _validationView2 = _interopRequireDefault(_validationView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validationRules = {};
	
	var validation = {
	  remoteMethodDelay: 500,
	
	  /**
	   * Initialize validation for each form
	   */
	  initialize: function initialize() {
	    this.initializeValidation();
	  },
	
	  initializeValidation: function initializeValidation() {
	    var $forms = (0, _jquery2.default)(document).find('form[data-validate="true"]').filter(function () {
	      return !Boolean((0, _jquery2.default)(this).closest('.lightbox-block').length);
	    });
	
	    _underscore2.default.each($forms, function (form) {
	      new _validationView2.default({
	        el: form,
	        validationRules: validationRules
	      });
	    });
	  },
	
	  /**
	   * Reload validation for each form
	   */
	
	  reload: function reload() {
	    this.initializeValidation();
	    eventEmitter.trigger('validationReload');
	  },
	
	  /**
	   * Get generated rules
	   * @param {string|string[]} fieldName
	   * @param {string} [formValidatorId]
	   * @returns {Object}
	   */
	  getRules: function getRules(fieldName, formValidatorId) {
	    this.validationView = this.validationView || new _validationView2.default({
	      validationRules: validationRules
	    });
	
	    return this.validationView.getRules(fieldName, formValidatorId);
	  },
	
	  setDelayToRemoteMethod: function setDelayToRemoteMethod() {
	    _jquery2.default.validator.methods._remote = _jquery2.default.validator.methods.remote;
	
	    var timer = 0;
	
	    _jquery2.default.validator.methods.remote = function () {
	      clearTimeout(timer);
	
	      var args = arguments;
	
	      timer = setTimeout(_jquery2.default.proxy(function () {
	        _jquery2.default.validator.methods._remote.apply(this, args);
	      }, this), this.remoteMethodDelay);
	
	      return 'pending';
	    };
	  }
	};
	
	function initialize(rules) {
	  validationRules = rules;
	  validation.initialize();
	}
	
	function reload() {
	  return validation.reload();
	}
	
	function getRules(fieldName, formValidatorId) {
	  return validation.getRules(fieldName, formValidatorId);
	}
	
	/**
	 * @description passes lightbox to the window
	 * currently it's being used by b2b
	 * look @https://github.com/Home24/Shop-LandingPages
	 * @method exportValidationToWindow
	 * @returns {undefined}
	 */
	function exportValidationToWindow() {
	  var w = window;
	
	  w.home24 = w.home24 || {};
	
	  w.home24.validation = validation;
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _baseTracking = __webpack_require__(16);
	
	var baseTracking = _interopRequireWildcard(_baseTracking);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.View.extend(_underscore2.default.extend({
	  /**
	   * destroy backbone view, unbind all events etc.
	   */
	  destroy: function destroy() {
	    this.undelegateEvents();
	    this.stopListening();
	  }
	}, baseTracking));

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isDateValid = isDateValid;
	exports.getCookie = getCookie;
	exports.setCookie = setCookie;
	exports.rot13 = rot13;
	exports.isNumber = isNumber;
	exports.randRange = randRange;
	exports.bytesToSize = bytesToSize;
	exports.parseFilename = parseFilename;
	exports.format = format;
	exports.generateRandomString = generateRandomString;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_jquery2.default.fn.textWidth = function (text, font) {
	  if (!_jquery2.default.fn.textWidth.fakeEl) {
	    _jquery2.default.fn.textWidth.fakeEl = (0, _jquery2.default)('<span>').hide().appendTo(document.body);
	  }
	  _jquery2.default.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));
	
	  return _jquery2.default.fn.textWidth.fakeEl.width();
	};
	
	/**
	 * Check if date is valid.
	 * e.g. 30 February is not valid
	 * @param {int} day day in a month
	 * @param {int} month month
	 * @param {int} year year
	 * @return {Boolean} if date is valid returns true, if not false
	 */
	function isDateValid(day, month, year) {
	  var date = new Date(year, month - 1, day);
	
	  return date.getMonth() + 1 == month;
	}
	
	function getCookie(name) {
	  var documentCookie = document.cookie,
	      indexStart = documentCookie.indexOf(' ' + name + '='),
	      indexEnd;
	
	  if (indexStart == -1) {
	    indexStart = documentCookie.indexOf(name + '=');
	  }
	
	  if (indexStart == -1) {
	    documentCookie = null;
	  } else {
	    indexStart = documentCookie.indexOf('=', indexStart) + 1;
	    indexEnd = documentCookie.indexOf(';', indexStart);
	
	    if (indexEnd == -1) {
	      indexEnd = documentCookie.length;
	    }
	
	    documentCookie = unescape(documentCookie.substring(indexStart, indexEnd));
	  }
	
	  return documentCookie;
	}
	
	function setCookie(name, value, expireDays, path) {
	  if (!path) {
	    path = '/';
	  }
	
	  var exdate = new Date();
	
	  if (!expireDays) {
	    exdate.setTime(exdate.getTime() + 60000);
	  } else {
	    exdate.setDate(exdate.getDate() + expireDays);
	  }
	
	  var cookieValue = escape(value) + (expireDays == null ? '' : '; expires=' + exdate.toUTCString()) + '; path=' + path;
	
	  document.cookie = name + '=' + cookieValue;
	}
	
	function rot13(text) {
	  return text.replace(/[a-zA-Z]/g, function (c) {
	    return String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26);
	  });
	}
	
	function isNumber(obj) {
	  return !isNaN(parseFloat(obj));
	}
	
	function randRange(min, max) {
	  return Math.random() * (max - min) + min;
	}
	
	/**
	 * Method converts file size into human readable format
	 * @param {Number} bytes filesize
	 * @return String
	 */
	function bytesToSize(bytes) {
	  var sizes = ['Bytes', 'KB', 'MB'],
	      i;
	
	  if (bytes === 0) {
	    return 'n/a';
	  }
	
	  i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
	
	  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
	}
	
	/**
	 * Method gets filename from full path and cuts it to maxLength
	 * @param {String} filename filename
	 * @param {Number} [maxLength] maxLength
	 * @return String
	 */
	function parseFilename(filename, maxLength) {
	  if (!maxLength) {
	    maxLength = 15;
	  }
	
	  filename = filename.replace(/^.*[\\\/]/, '');
	
	  if (filename.length > maxLength) {
	    filename = filename.substr(0, maxLength) + ' ...';
	  }
	
	  return filename;
	}
	
	/**
	 * Method add format possibility to String inserted directly to string prototype
	 * as soon as method is called you could use your strings to be formatted in following way:
	 *
	 * Example:
	 * "This is me: {0} {1}".format('Chuck', 'Norris');
	 *
	 * Outuput:
	 * This is me: Chuck Norris
	 */
	function format() {
	  var args = arguments;
	
	  return args[0].replace(/{(\d+)}/g, function (match, number) {
	    number++;
	
	    return typeof args[number] !== 'undefined' ? args[number] : match;
	  });
	}
	
	/**
	 * Method for generating random string with given length and based on given dictionary
	 * @iLength {Integer} length of the output string. Default: 32
	 * @sDictionary {String} string of symbols (dictionary), based on wich random hash will be generated.
	 * @return {String} hash with selected length
	 */
	function generateRandomString(iLength, sDictionary) {
	  var text = '';
	  var length = iLength || 32;
	  var possible = sDictionary || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	  var i;
	
	  for (i = 0; i < length; i++) {
	    text += possible.charAt(Math.floor(Math.random() * possible.length));
	  }
	
	  return text;
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.executeCookieCallbacks = executeCookieCallbacks;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _storageFactory = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Method iterates over cookieCallbacks object and executes callback methods when cookiename is set
	 */
	function executeCookieCallbacks() {
	  _underscore2.default.each(this.cookieCallbacks, function (callbackName, key) {
	    var cookieData = (0, _storageFactory.getStorage)().get(key);
	    var callback = this[callbackName];
	
	    if (cookieData && _underscore2.default.isFunction(callback)) {
	      callback.call(this, cookieData);
	      (0, _storageFactory.getStorage)().unset(key);
	    }
	  }, this);
	}

/***/ },
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rebind = exports.updateState = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customElements = function () {
	  var self = {};
	  var cssClass = {
	    disabled: 'ca-disabled',
	    checked: 'ca-checked',
	    label: 'ca-label',
	    labelDisabled: 'ca-label-disabled',
	    inputSmall: 'ca-small',
	    labelSmall: 'ca-label-small'
	  };
	  var attributesToCopy = ['data-tipped', 'data-tipsy-manual', 'data-tipsy-class', 'data-tipped-pos'];
	
	  self.init = function () {
	    // not on new catalog
	    if ((0, _jquery2.default)("body[data-page='category-new']").length || (0, _jquery2.default)("body[data-page='search-new']").length) {
	      return;
	    }
	
	    // not on new pdp
	    if ((0, _jquery2.default)("body[data-page='article-new']").length) {
	      return;
	    }
	
	    (0, _jquery2.default)('input[type=checkbox], input[type=radio]').not('[data-dca=true]').not('[data-ignore=true]').not('[data-ca-done=true]').each(function () {
	      self.convert((0, _jquery2.default)(this));
	    });
	  };
	
	  /**
	   * Method synchronized disabled between real and pseudo element
	   */
	  self.updateDisabled = function () {
	    (0, _jquery2.default)('[data-ca-done=true]').each(function () {
	      var $this = (0, _jquery2.default)(this);
	      var $pseudo = $this.prev();
	      var $label = $this.siblings('label');
	
	      if ($this.is(':disabled')) {
	        $pseudo.addClass(cssClass.disabled);
	        $label.addClass(cssClass.labelDisabled);
	      } else {
	        $pseudo.removeClass(cssClass.disabled);
	        $label.removeClass(cssClass.labelDisabled);
	      }
	    });
	  };
	
	  /**
	   * @return {home24.helpers.customElements}
	   */
	  self.updateState = function () {
	    (0, _jquery2.default)('[data-ca-done=true]').each(function () {
	      var $this = (0, _jquery2.default)(this);
	      var $pseudo = $this.prev();
	
	      if ($this.is(':checked')) {
	        $pseudo.addClass(cssClass.checked);
	      } else {
	        $pseudo.removeClass(cssClass.checked);
	      }
	    });
	  };
	
	  self.rebind = function () {
	    var $scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _jquery2.default)('body');
	
	    $scope.find('[data-ca-done=true]').each(function () {
	      var $element = (0, _jquery2.default)(this);
	      var $pseudo = $element.prev();
	      var type = $element.prop('type');
	
	      switch (type) {
	        case 'checkbox':
	          $pseudo.off('click');
	          $element.off('change');
	
	          $pseudo.on('click', function () {
	            self.onPseudoCheckboxClick($pseudo, $element);
	          });
	
	          $element.on('change', function () {
	            self.onCheckboxChange($element, $pseudo);
	          });
	          break;
	
	        case 'radio':
	          $pseudo.on('click', function () {
	            self.onPseudoRadioClick($pseudo, $element);
	          });
	
	          $element.on('change', function () {
	            self.onRadioChange($element, $pseudo);
	          });
	          break;
	      }
	    });
	  };
	
	  self.convert = function ($element) {
	    var $pseudo = (0, _jquery2.default)('<div class="ca"></div>');
	    var type = $element.prop('type');
	    var $label = $element.siblings('label');
	    var i;
	    var key;
	    var value;
	    var pseudoClickCallback;
	    var elementChangeCallback;
	
	    $pseudo.addClass('ca-' + type);
	
	    if ($element.is(':disabled')) {
	      $pseudo.addClass(cssClass.disabled);
	      $label.addClass(cssClass.labelDisabled);
	    }
	
	    if ($element.is(':checked')) {
	      $pseudo.addClass(cssClass.checked);
	    }
	
	    $pseudo.attr('data-ca-value', $element.val());
	
	    /*
	     * Copy attributes to pseudo
	     */
	    for (i in attributesToCopy) {
	      if (attributesToCopy.hasOwnProperty(i)) {
	        key = attributesToCopy[i];
	        value = $element.attr(key);
	
	        if (value) {
	          $pseudo.attr(key, value);
	        }
	      }
	    }
	
	    switch (type) {
	      case 'checkbox':
	        pseudoClickCallback = 'onPseudoCheckboxClick';
	        elementChangeCallback = 'onCheckboxChange';
	        break;
	
	      case 'radio':
	        pseudoClickCallback = 'onPseudoRadioClick';
	        elementChangeCallback = 'onRadioChange';
	
	        $pseudo.attr('data-ca-name', $element.attr('name'));
	        break;
	    }
	
	    /*
	     * Assign pseudo element click event
	     */
	    $pseudo.on('click', function () {
	      self[pseudoClickCallback]($pseudo, $element);
	    });
	
	    /*
	     * Assign real element change event
	     */
	    $element.on('change', function () {
	      self[elementChangeCallback]($element, $pseudo);
	    });
	
	    $pseudo.addClass($element.prop('class'));
	
	    $element.before($pseudo);
	
	    if (type === 'checkbox') {
	      // if we just hide the checkbox <label> tag won't select checkbox on click
	      $element.css({ position: 'absolute', left: '-99999px' });
	    } else {
	      $element.addClass('is-hidden');
	    }
	
	    // add class to label
	    $label.addClass(cssClass.label);
	
	    if ($element.hasClass(cssClass.inputSmall)) {
	      $label.addClass(cssClass.labelSmall);
	    }
	
	    // mark as converted
	    $element.attr('data-ca-done', true);
	  };
	
	  self.onPseudoRadioClick = function ($currentTarget, $parent) {
	    var $form = $currentTarget.closest('form');
	
	    if (!$currentTarget.hasClass(cssClass.disabled) && !$currentTarget.hasClass(cssClass.checked)) {
	      $form.find('[data-ca-name="' + $currentTarget.attr('data-ca-name') + '"]').removeClass(cssClass.checked);
	      $currentTarget.addClass(cssClass.checked);
	      $form.find('[name="' + $currentTarget.attr('data-ca-name') + '"][value="' + $currentTarget.attr('data-ca-value') + '"]').prop('checked', true).val($currentTarget.attr('data-ca-value'));
	
	      $parent.data('internal-trigger', true);
	      $parent.trigger('change');
	    }
	  };
	
	  self.onRadioChange = function ($source, $pseudo) {
	    var $form = $source.closest('form');
	
	    if (!$source.data('internal-trigger')) {
	      $form.find('[data-ca-name="' + $source.attr('name') + '"]').removeClass(cssClass.checked);
	      $pseudo.addClass(cssClass.checked);
	    }
	    $source.data('internal-trigger', false);
	  };
	
	  self.onCheckboxChange = function ($source, $pseudo) {
	    if (!$source.data('internal-trigger')) {
	      if ($pseudo.hasClass(cssClass.checked)) {
	        $pseudo.removeClass(cssClass.checked);
	      } else {
	        $pseudo.addClass(cssClass.checked);
	      }
	    }
	    $source.data('internal-trigger', false);
	  };
	
	  self.onPseudoCheckboxClick = function ($currentTarget, $parent) {
	    if (!$currentTarget.hasClass(cssClass.disabled)) {
	      if ($currentTarget.hasClass(cssClass.checked)) {
	        $currentTarget.removeClass(cssClass.checked);
	        $parent.prop('checked', false);
	      } else {
	        $currentTarget.addClass(cssClass.checked);
	        $parent.prop('checked', true);
	      }
	      $parent.data('internal-trigger', true);
	      $parent.trigger('change');
	      $parent.focusout();
	    }
	  };
	
	  return self;
	}();
	
	customElements.init();
	
	function updateState() {
	  customElements.updateState();
	}
	function rebind() {
	  customElements.rebind();
	}
	
	exports.updateState = updateState;
	exports.rebind = rebind;

/***/ },
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.prepareCartAddObject = prepareCartAddObject;
	exports.prepareCartRemoveObject = prepareCartRemoveObject;
	exports.processGtmVariables = processGtmVariables;
	exports.extractDataBySku = extractDataBySku;
	exports.isGTMLoaded = isGTMLoaded;
	exports.prepareCartAddRemoveObject = prepareCartAddRemoveObject;
	exports.decode = decode;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _base = __webpack_require__(28);
	
	var base64 = _interopRequireWildcard(_base);
	
	var _Utils = __webpack_require__(15);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @param {Object} data
	 * @param {int=} quantity
	 * @return {Object}
	 */
	function prepareCartAddObject(data, quantity) {
	  return prepareCartAddRemoveObject(data, 'addToCart', 'add', quantity);
	}
	
	/**
	 * @param {Object} data
	 * @param {int=} quantity
	 * @return {Object}
	 */
	function prepareCartRemoveObject(data, quantity) {
	  return prepareCartAddRemoveObject(data, 'removeFromCart', 'remove', quantity);
	}
	
	/**
	 * onClick event handler responsible for converting data-gtm html attributes into cookies
	 * data-gtm is used to pass cpos, rpos and type attributes to GoogleTagManager
	 *
	 * @param {$} $currentTarget
	 */
	function processGtmVariables($currentTarget) {
	  var dataGtm = $currentTarget.data('gtm');
	  var key;
	
	  if (typeof dataGtm !== 'undefined' && dataGtm.length > 0) {
	    dataGtm = decode(dataGtm);
	
	    if ((typeof dataGtm === 'undefined' ? 'undefined' : _typeof(dataGtm)) === 'object') {
	      for (key in dataGtm) {
	        /* istanbul ignore else */
	        if (dataGtm.hasOwnProperty(key)) {
	          (0, _Utils.setCookie)(key, dataGtm[key]);
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Method extracts single article data base on SKU from trackingData array
	 * @param {Array} trackingData
	 * @param {String} sku
	 * @return {Object|boolean}
	 */
	function extractDataBySku(trackingData, sku) {
	  var i;
	
	  if (trackingData) {
	    for (i in trackingData) {
	      /* istanbul ignore else */
	      if (trackingData.hasOwnProperty(i)) {
	        if (trackingData[i].id === sku) {
	          return trackingData[i];
	        }
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Method checks if Google Tag Manager has been loaded and initialized
	 * @return {boolean}
	 */
	function isGTMLoaded() {
	  if (typeof window.dataLayer !== 'undefined') {
	    var i;
	
	    for (i in window.dataLayer) {
	      /* istanbul ignore else */
	      if (window.dataLayer.hasOwnProperty(i)) {
	        if (window.dataLayer[i].event && window.dataLayer[i].event === 'gtm.load') {
	          return true;
	        }
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * @param {Object} data
	 * @param {String} event
	 * @param {String} type
	 * @param {int=} quantity
	 * @return {{event: *, ecommerce: {}}}
	 */
	function prepareCartAddRemoveObject(data, event, type, quantity) {
	  var retVal = {
	    event: event,
	    ecommerce: {}
	  };
	  var aProducts = [];
	  var oClonedData;
	  var cartValue = 0;
	
	  retVal.ecommerce[type] = {};
	  retVal.ecommerce[type].products = [];
	
	  // pdp cart overlay case
	  if (_underscore2.default.isArray(data)) {
	    _underscore2.default.each(data, function (prod) {
	      aProducts.push(_jquery2.default.extend(true, {}, prod));
	    });
	
	    retVal.ecommerce[type].products = [aProducts[0]];
	
	    _underscore2.default.each(aProducts, function (prod) {
	      cartValue += parseFloat(prod.price) * prod.quantity;
	    });
	
	    retVal.ecommerce.cartValue = cartValue.toFixed(2);
	  } else {
	    // cart page case
	    oClonedData = _jquery2.default.extend(true, {}, data);
	
	    if (quantity) {
	      oClonedData.quantity = quantity;
	    }
	
	    aProducts.push(oClonedData);
	    retVal.ecommerce[type].products = aProducts;
	  }
	
	  return retVal;
	}
	
	/**
	 * @param {String} data
	 * @return {Object|undefined}
	 */
	function decode(data) {
	  if (data) {
	    try {
	      return _jquery2.default.parseJSON(base64.decode(data));
	    } catch (e) {
	      return undefined;
	    }
	  } else {
	    return undefined;
	  }
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trigger = trigger;
	exports.on = on;
	exports.off = off;
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventEmmiter = _underscore2.default.extend({}, _backbone2.default.Events);
	
	function trigger(ev) {
	  return eventEmmiter.trigger(ev);
	}
	
	function on(ev, cb, context) {
	  return eventEmmiter.on(ev, cb, context);
	}
	
	function off(ev, cb, context) {
	  return eventEmmiter.off(ev, cb, context);
	}

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DY_STRATEGY_IDS;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var classNames = exports.classNames = {
	  SLIDER_CONTAINER: 'qvh24__recommendations-slider',
	  SLIDER_WRAPPER: 'swiper-wrapper',
	  SLIDER_SLIDE: 'swiper-slide',
	  SLIDER_NAV_ARROW_LEFT: 'qvh24__recommendations-slider__nav-arrow-left',
	  SLIDER_NAV_ARROW_RIGHT: 'qvh24__recommendations-slider__nav-arrow-right',
	  IMAGE: 'qvh24__recommendations-slider__image',
	  TITLE: 'qvh24__recommendations-slider__title',
	  PRICE: 'qvh24__recommendations-slider__price',
	  PRICE_VAL: 'qvh24__recommendations-slider__price-val',
	  PRICE_VAL_NEW: 'qvh24__recommendations-slider__price-val-new',
	  PRICE_VAL_OLD: 'qvh24__recommendations-slider__price-val-old',
	  DELIVERY_TIME: 'qvh24__recommendations-slider__delivery-time',
	  DELIVERY_TIME_FAST: 'qvh24__recommendations-slider__delivery-time--fast'
	};
	
	var RECOMMENDATIONS_URL = exports.RECOMMENDATIONS_URL = {
	  DY: 'sliders/quickview?type=dy',
	  INHOUSE: 'sliders/quickview?type=inhouse'
	};
	
	var AB_TEST_ATTR_NAME = exports.AB_TEST_ATTR_NAME = 'data-recommendations-slider-ab-test-value';
	
	var AB_TEST_VALUE = exports.AB_TEST_VALUE = {
	  INHOUSE_SLIDER: 'a',
	  DY_SLIDER: 'b'
	};
	
	var DY_SECTION_ID = {
	  DEV: 8766762,
	  STAGING: 8768293,
	  PROD: 8766761
	};
	
	var DY_STRATEGY_IDS = exports.DY_STRATEGY_IDS = (_DY_STRATEGY_IDS = {}, _defineProperty(_DY_STRATEGY_IDS, DY_SECTION_ID.DEV, 48087), _defineProperty(_DY_STRATEGY_IDS, DY_SECTION_ID.STAGING, 48587), _defineProperty(_DY_STRATEGY_IDS, DY_SECTION_ID.PROD, 51761), _DY_STRATEGY_IDS);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppDomain = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Client = __webpack_require__(27);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppDomain = exports.AppDomain = function () {
	  function AppDomain(client) {
	    _classCallCheck(this, AppDomain);
	
	    this._client = client;
	  }
	
	  /**
	   *
	   * @returns {boolean}
	   */
	
	
	  _createClass(AppDomain, [{
	    key: 'isNL',
	    value: function isNL() {
	      return this._client.getAppDomainId() === 3;
	    }
	
	    /**
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isHome24',
	    value: function isHome24() {
	      return this._client.getGroup() === 'home24';
	    }
	
	    /**
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isFashionForHome',
	    value: function isFashionForHome() {
	      return this._client.getGroup() === 'fashionforhome';
	    }
	  }]);
	
	  return AppDomain;
	}();
	
	exports.default = new AppDomain(_Client2.default);

/***/ },
/* 24 */,
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAIN = exports.MAIN = '.page--category-level2__cms-block';
	var MAINALTERNATIVE = exports.MAINALTERNATIVE = 'dy_Global_Ribbon';
	var SLIDER = exports.SLIDER = 'swiper-container';
	var BUYBUTTON = exports.BUYBUTTON = 'qvh24-buy-button';
	var NOTSELLABLE = exports.NOTSELLABLE = 'qvh24--notSellable';
	var MAINMOBILE = exports.MAINMOBILE = '#main';
	var MAINMOBILE2 = exports.MAINMOBILE2 = 'page--category acte-page-category-mobile';
	var SWIPERUP = exports.SWIPERUP = 'qvh24--swiper-up';
	var SWIPERDOWM = exports.SWIPERDOWM = 'qvh24--swiper-down';
	var NOTIFICATION = exports.NOTIFICATION = 'qvh24--notification';
	var DATA = exports.DATA = 'quick-view-all-data';
	var SELECTEDSKUATTRIBUTE = exports.SELECTEDSKUATTRIBUTE = 'data-selected-child-sku';

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.View.extend({
	  selectors: {
	    hiddenClass: 'is-hidden'
	  },
	
	  initialize: function initialize() {
	    this.$preloader = (0, _jquery2.default)('<span class="svg-preloader js-remote-validation" />');
	  },
	
	  show: function show() {
	    this.$el.parent().prepend(this.$preloader);
	    this.$el.siblings('.icon-invalid-field, .icon-filled-field').addClass(this.selectors.hiddenClass);
	  },
	
	  hide: function hide() {
	    this.$preloader.remove();
	    this.$el.hasClass('is-invalidate') ? this.$el.siblings('.icon-invalid-field').removeClass(this.selectors.hiddenClass) : this.$el.siblings('.icon-filled-field').removeClass(this.selectors.hiddenClass);
	  }
	});

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Client = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Global client options
	 */
	var Client = exports.Client = function () {
	  /**
	   * @param {Object} information Client information
	   * @param {number} information.appDomainId Client app domain ID
	   * @param {string} information.language Client language
	   * @param {string} information.group Client group
	   *
	   * @returns {undefined}
	   */
	  function Client(information) {
	    _classCallCheck(this, Client);
	
	    this._information = information;
	  }
	
	  /**
	   * @returns {Object}
	   */
	
	
	  _createClass(Client, [{
	    key: 'getInformation',
	    value: function getInformation() {
	      return _extends({}, this._information);
	    }
	
	    /**
	     * @returns {Number}
	     */
	
	  }, {
	    key: 'getAppDomainId',
	    value: function getAppDomainId() {
	      return this._information.appDomainId;
	    }
	
	    /**
	     * @returns {string}
	     */
	
	  }, {
	    key: 'getLanguage',
	    value: function getLanguage() {
	      return this._information.language;
	    }
	
	    /**
	     * @returns {string}
	     */
	
	  }, {
	    key: 'getGroup',
	    value: function getGroup() {
	      return this._information.group;
	    }
	  }]);
	
	  return Client;
	}();
	
	exports.default = new Client((0, _jquery2.default)('#h24-client').data());

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.encode = encode;
	exports.decode = decode;
	/**
	 * UTF-8 Safe Class for encoding and decoding base64 strings
	 */
	
	var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	var _utf8_encode = function _utf8_encode(string) {
	  string = string.replace(/\r\n/g, '\n');
	  var utftext = '';
	
	  for (var n = 0; n < string.length; n++) {
	    var c = string.charCodeAt(n);
	
	    if (c < 128) {
	      utftext += String.fromCharCode(c);
	    } else if (c > 127 && c < 2048) {
	      utftext += String.fromCharCode(c >> 6 | 192);
	      utftext += String.fromCharCode(c & 63 | 128);
	    } else {
	      utftext += String.fromCharCode(c >> 12 | 224);
	      utftext += String.fromCharCode(c >> 6 & 63 | 128);
	      utftext += String.fromCharCode(c & 63 | 128);
	    }
	  }
	
	  return utftext;
	};
	
	var _utf8_decode = function _utf8_decode(utftext) {
	  var string = '';
	  var i = 0;
	  var c = 0;
	  var c1 = 0;
	  var c2 = 0;
	
	  while (i < utftext.length) {
	    c = utftext.charCodeAt(i);
	
	    if (c < 128) {
	      string += String.fromCharCode(c);
	      i++;
	    } else if (c > 191 && c < 224) {
	      c2 = utftext.charCodeAt(i + 1);
	
	      string += String.fromCharCode((c & 31) << 6 | c2 & 63);
	
	      i += 2;
	    } else {
	      c2 = utftext.charCodeAt(i + 1);
	      c3 = utftext.charCodeAt(i + 2);
	
	      string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	
	      i += 3;
	    }
	  }
	
	  return string;
	};
	
	function encode(input) {
	  var output = '',
	      chr1,
	      chr2,
	      chr3,
	      enc1,
	      enc2,
	      enc3,
	      enc4,
	      i = 0,
	      inputLength;
	
	  if (input) {
	    input = _utf8_encode(input);
	
	    inputLength = input.length;
	
	    while (i < inputLength) {
	      chr1 = input.charCodeAt(i++);
	      chr2 = input.charCodeAt(i++);
	      chr3 = input.charCodeAt(i++);
	
	      enc1 = chr1 >> 2;
	      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	      enc4 = chr3 & 63;
	
	      if (isNaN(chr2)) {
	        enc3 = enc4 = 64;
	      } else if (isNaN(chr3)) {
	        enc4 = 64;
	      }
	
	      output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	    }
	  } else {
	    output = '';
	  }
	
	  return output;
	}
	
	function decode(input) {
	  var output = '',
	      chr1,
	      chr2,
	      chr3,
	      enc1,
	      enc2,
	      enc3,
	      enc4,
	      i = 0,
	      inputLength = 0;
	
	  if (input) {
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	    inputLength = input.length;
	  }
	
	  while (i < inputLength) {
	    enc1 = _keyStr.indexOf(input.charAt(i++));
	    enc2 = _keyStr.indexOf(input.charAt(i++));
	    enc3 = _keyStr.indexOf(input.charAt(i++));
	    enc4 = _keyStr.indexOf(input.charAt(i++));
	
	    chr1 = enc1 << 2 | enc2 >> 4;
	    chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	    chr3 = (enc3 & 3) << 6 | enc4;
	
	    output = output + String.fromCharCode(chr1);
	
	    if (enc3 != 64) {
	      output = output + String.fromCharCode(chr2);
	    }
	    if (enc4 != 64) {
	      output = output + String.fromCharCode(chr3);
	    }
	  }
	
	  output = _utf8_decode(output);
	
	  return output;
	}

/***/ },
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _Utils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    index: '',
	    ownAddress: false,
	    suggestedAddress: false,
	    street: '',
	    streetNumber: '',
	    streetAdd: '',
	    zip: '',
	    city: '',
	    country: '',
	    full: ''
	  },
	
	  toString: function toString(skipStreetAdd) {
	    var streetAdd = '';
	
	    if (!skipStreetAdd) {
	      streetAdd = this.get('streetAdd') ? ' ' + this.get('streetAdd') + ',' : '';
	    }
	
	    return (0, _Utils.format)('{0}, {1},{2} {3}', this.get('zip') || '', this.get('street') || '', streetAdd, this.get('city') || '');
	  }
	});

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _addressCheckAddressModel = __webpack_require__(31);
	
	var _addressCheckAddressModel2 = _interopRequireDefault(_addressCheckAddressModel);
	
	var _addressCheckAddressParser = __webpack_require__(117);
	
	var _addressCheckAddressParser2 = _interopRequireDefault(_addressCheckAddressParser);
	
	var _addressCheckService = __webpack_require__(119);
	
	var _addressCheckService2 = _interopRequireDefault(_addressCheckService);
	
	var _addressCheckView = __webpack_require__(120);
	
	var _addressCheckView2 = _interopRequireDefault(_addressCheckView);
	
	var _translation = __webpack_require__(12);
	
	var _AddressCheckEvents = __webpack_require__(64);
	
	var _AddressCheckEvents2 = _interopRequireDefault(_AddressCheckEvents);
	
	var _addressCheckViewModel = __webpack_require__(121);
	
	var _addressCheckViewModel2 = _interopRequireDefault(_addressCheckViewModel);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change input[name=city]': '_onParentFormSubmit',
	    'change input[name=zip]': function changeInputNameZip() {
	      this._onParentFormSubmit();
	      this.fixZipForNL();
	    },
	    'change input[name=street]': '_onParentFormSubmit',
	    'change input[name=default_billing]': '_onParentFormSubmit',
	    'change input[name=default_shipping]': '_onParentFormSubmit'
	  },
	
	  isHandlerBound: false,
	
	  initialize: function initialize(options) {
	    this.$scope = options.scope;
	    this._service = new _addressCheckService2.default();
	    this._viewModel = new _addressCheckViewModel2.default();
	
	    this.bind();
	    this._insertSpinnerIntoParentForm();
	    this._hideSpinner();
	
	    // Execute it for initial datas.
	    // ex. address edit forms
	    this.fixZipForNL();
	  },
	
	  fixZipForNL: function fixZipForNL() {
	    this.$el.normalizeZipCodeForNL();
	  },
	
	  bind: function bind() {
	    this.isHandlerBound = true;
	  },
	
	  unbind: function unbind() {
	    this.isHandlerBound = false;
	  },
	
	  submitParentForm: function submitParentForm() {
	    this.unbind();
	    this.$el.submit();
	  },
	
	  _onParentFormSubmit: function _onParentFormSubmit() {
	    if (this.isHandlerBound === false) {
	      return false;
	    }
	
	    if (!this._isAddressFieldsFilled()) {
	      return false;
	    }
	
	    if (this._view) {
	      this._view.destroy();
	    }
	
	    this._showSpinner();
	    this._service.sendRequest(this._getAddressDataStringFromParentForm(), _jquery2.default.proxy(this._onRequestSucceed, this), _jquery2.default.proxy(this._onRequestFailed, this));
	
	    return false;
	  },
	
	  _insertSpinnerIntoParentForm: function _insertSpinnerIntoParentForm() {
	    var buttonsContainer = this.$el.find('.form__buttons');
	    var spinnerHtml = '<div id="address-check-spinner" class="svg-preloader pull-right"></div>';
	
	    buttonsContainer.html(spinnerHtml + buttonsContainer.html());
	  },
	
	  _showSpinner: function _showSpinner() {
	    this.$el.find('button[type=submit]').hide();
	    this.$el.find('#address-check-spinner').show();
	  },
	
	  _hideSpinner: function _hideSpinner() {
	    this.$el.find('#address-check-spinner').hide();
	    this.$el.find('button[type=submit]').show();
	  },
	
	  _onRequestSucceed: function _onRequestSucceed(data) {
	    var addresses;
	    var ownAddress = this._getOwnAddress();
	    var childViewScope;
	
	    this._hideSpinner();
	    addresses = this._parseResponse(data);
	
	    if (data.status === 'NO_ADDRESS_IN_YOUR_COUNTRY') {
	      _jquery2.default.validator.addMethod('invalid', function () {
	        return false;
	      }, (0, _translation.get)('ui.input.validation.country.wrong'));
	
	      this.$el.find('input[name=zip]').rules('add', {
	        invalid: { invalid: true }
	      });
	      this.$el.find('input[name=zip]').valid();
	      this.$el.find('input[name=zip]').valid();
	
	      return false;
	    } else {
	      this.$el.find('input[name=zip]').rules('remove', 'invalid');
	      this.$el.find('input[name=zip]').valid();
	      this.$el.find('input[name=zip]').valid();
	    }
	
	    // If no match or perfect match returned
	    if (addresses.length === 0 || addresses.length === 1 && addresses[0].get('ownAddress') === true || data.status === 'UNKNOWN_ERROR') {
	      return true;
	    }
	
	    this.tracking = new _AddressCheckEvents2.default({
	      googleResponse: _underscore2.default.pluck(data.results, 'formatted_address')
	    });
	
	    this.tracking.trackWrongAddressTyped();
	
	    // if AB test says to not display results
	    if (!registry.get('addressCheckEnabled')) {
	      return true;
	    }
	
	    this._viewModel.set({
	      addresses: addresses,
	      ownAddress: ownAddress,
	      originalResponse: data
	    });
	
	    childViewScope = this.$scope.find('.customer-address-finder').length === 1 ? this.$scope.find('.customer-address-finder')[0] : this.$scope.find('.customer-address-finder')[1];
	
	    this._view = new _addressCheckView2.default({
	      el: childViewScope,
	      parentScope: this
	    });
	
	    this._view.showDialog(this._viewModel, this._onNewAddressSelected, this);
	    this.tracking.trackAddressCheckShow();
	    this._bindEventsForTracking();
	
	    return true;
	  },
	
	  _bindEventsForTracking: function _bindEventsForTracking() {
	    this._bindTrackFormEvent();
	    this._bindTrackAddressInputsEvent();
	  },
	
	  _unbindEventsForTracking: function _unbindEventsForTracking() {
	    this.$el.off('submit.track_address_form');
	    this._getAddressInputs().off('change.tracking_address_input');
	  },
	
	  _bindTrackFormEvent: function _bindTrackFormEvent() {
	    this.$el.on('submit.track_address_form', _jquery2.default.proxy(this._onChangeTrackingFormSumbit, this));
	  },
	
	  _bindTrackAddressInputsEvent: function _bindTrackAddressInputsEvent() {
	    this._getAddressInputs().on('change.tracking_address_input', _jquery2.default.proxy(this._onChangeTrackingAddressInput, this));
	  },
	
	  _onChangeTrackingFormSumbit: function _onChangeTrackingFormSumbit() {
	    this.tracking.trackOldAddressKept();
	    this._unbindEventsForTracking();
	  },
	
	  _onChangeTrackingAddressInput: function _onChangeTrackingAddressInput() {
	    this.tracking.trackAddressNewInput();
	    this._unbindEventsForTracking();
	  },
	
	  _onNewAddressSelected: function _onNewAddressSelected(model) {
	    this.tracking.trackGoogleAddressSelected();
	    this._unbindEventsForTracking();
	    this._setDataToParentForm(model);
	  },
	
	  _getAddressInputs: function _getAddressInputs() {
	    return this.$el.find('input').filter(function (index, input) {
	      var names = ['street', 'zip', 'city'];
	
	      return _underscore2.default.contains(names, input.name);
	    });
	  },
	
	  closeSubViews: function closeSubViews() {
	    if (this._view) {
	      this._view.destroy();
	    }
	  },
	
	  _onRequestFailed: function _onRequestFailed() {
	    this._hideSpinner();
	    this.submitParentForm();
	  },
	
	  _getOwnAddress: function _getOwnAddress() {
	    var form = this.$el;
	    var model = new _addressCheckAddressModel2.default();
	
	    model.set('index', 0);
	    model.set('zip', form.find('input[name=zip]').val());
	    model.set('street', form.find('input[name=street]').val());
	    model.set('streetAdd', form.find('input[name=additional]').val());
	    model.set('city', form.find('input[name=city]').val());
	    model.set('ownAddress', true);
	    model.set('suggestedAddress', false);
	    model.set('full', model.toString());
	
	    return model;
	  },
	
	  _setDataToParentForm: function _setDataToParentForm(model) {
	    var form = this.$el;
	
	    form.find('input[name=zip]').val(model.get('zip'));
	    form.find('input[name=street]').val(model.get('street'));
	    form.find('input[name=additional]').val(model.get('streetAdd'));
	    form.find('input[name=city]').val(model.get('city'));
	
	    form.valid();
	    form.valid();
	  },
	
	  _getAddressDataStringFromParentForm: function _getAddressDataStringFromParentForm() {
	    var form = this.$el;
	    var addressType;
	
	    var isShipping = form.find('input[name=default_shipping]').prop('checked');
	    var isBilling = form.find('input[name=default_billing]').prop('checked');
	
	    switch (true) {
	      case isShipping && !isBilling:
	        addressType = 'shippingaddress';
	        break;
	
	      case !isShipping && isBilling:
	        addressType = 'billingaddress';
	        break;
	
	      default:
	        addressType = '';
	    }
	
	    return {
	      addressType: addressType,
	      street: form.find('input[name=street]').val(),
	      streetAdd: form.find('input[name=additional]').val(),
	      zip: form.find('input[name=zip]').val(),
	      city: form.find('input[name=city]').val()
	    };
	  },
	
	  _isAddressFieldsFilled: function _isAddressFieldsFilled() {
	    var form = this.$el;
	
	    return form.find('input[name=street]').val() && form.find('input[name=zip]').val() && form.find('input[name=city]').val();
	  },
	
	  _parseResponse: function _parseResponse(records) {
	    return new _addressCheckAddressParser2.default(records, this._getOwnAddress());
	  }
	});

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _PasswordQualityModel = __webpack_require__(122);
	
	var _PasswordQualityModel2 = _interopRequireDefault(_PasswordQualityModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'focus input[type=password].quality-connected': 'showWindow',
	    'blur input[type=password].quality-connected': 'hideWindow',
	    'keyup input[type=password].quality-connected': 'onKeyUp'
	  },
	
	  elements: {
	    $passwordField: null
	  },
	
	  initialize: function initialize() {
	    this.elements.$passwordField = this.$el.find('input[type=password].quality-connected');
	    this.passwordQualityModel = new _PasswordQualityModel2.default();
	
	    // rivets binding
	    this.binding = _rivets2.default.bind(this.$el.find('.js-password-quality'), {
	      viewModel: this.passwordQualityModel
	    });
	  },
	
	  showWindow: function showWindow() {
	    this.passwordQualityModel.set('showWindow', true);
	  },
	
	  hideWindow: function hideWindow() {
	    this.passwordQualityModel.set('showWindow', false);
	  },
	
	  onKeyUp: function onKeyUp() {
	    this.passwordQualityModel.check(this.elements.$passwordField.val());
	  }
	});

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _eventEmmiter = __webpack_require__(21);
	
	var eventEmitter = _interopRequireWildcard(_eventEmmiter);
	
	var _remotePreloaderView = __webpack_require__(26);
	
	var _remotePreloaderView2 = _interopRequireDefault(_remotePreloaderView);
	
	var _validationController = __webpack_require__(13);
	
	var _translation = __webpack_require__(12);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  selectors: {
	    taxId: '.js-tax-id input'
	  },
	
	  validationRules: {
	    remoteTaxId: {
	      url: '/default/validator/validateitaliantaxid',
	      type: 'GET',
	      data: {
	        id: function id() {
	          return (0, _jquery2.default)('.js-tax-id input:not(.myaccount-popup-holder .js-tax-id input)').val();
	        }
	      },
	      beforeSend: function beforeSend() {
	        this.preloader = this.preloader || new _remotePreloaderView2.default({
	          el: (0, _jquery2.default)('.js-tax-id input:not(.myaccount-popup-holder .js-tax-id input)')
	        });
	        this.preloader.show();
	      },
	      complete: function complete() {
	        this.preloader.hide();
	      }
	    }
	  },
	
	  initialize: function initialize() {
	    if (this.$el.length) {
	      this.bindUpperCaseEvent();
	
	      eventEmitter.off('validationReload').on('validationReload', this.addRulesToValidator, this);
	      (0, _validationController.reload)();
	    }
	  },
	
	  bindUpperCaseEvent: function bindUpperCaseEvent() {
	    var _this = this;
	
	    this.$el.on('keyup change', function () {
	      var upperCaseValue = _this.$el.val().toUpperCase();
	      _this.$el.val(upperCaseValue);
	    });
	  },
	
	  destroy: function destroy() {
	    this.removeRules();
	    _baseView2.default.prototype.destroy.call(this);
	  },
	
	  addRulesToValidator: function addRulesToValidator() {
	    this.$el.rules('add', {
	      required: true,
	      remote: this.validationRules.remoteTaxId,
	      pattern: false,
	      messages: {
	        remote: (0, _translation.get)('ui.input.validation.tax_id.remote.error')
	      }
	    });
	  },
	
	  removeRules: function removeRules() {
	    this.$el.rules('remove', {
	      required: false,
	      remote: false
	    });
	  }
	});

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(272);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _eventEmmiter = __webpack_require__(21);
	
	var eventEmitter = _interopRequireWildcard(_eventEmmiter);
	
	var _utils = __webpack_require__(271);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  selectors: {
	    wrapper: '.intl-tel-input',
	    clone: '.js-phone-formatter-clone'
	  },
	
	  events: {
	    change: 'onChange',
	    blur: 'onChange'
	  },
	
	  preferredCountries: ['de', 'fr', 'nl', 'at', 'ch', 'be', 'it'],
	
	  initialize: function initialize() {
	    var self = this;
	
	    if (self.$el.length === 1) {
	      self.name = self.$el.prop('name');
	      self.$clone = self.createHiddenInput();
	      self.formatCountryData();
	
	      self.intlTelInputDeferred = self.$el.intlTelInput({
	        defaultCountry: (0, _jquery2.default)('html').prop('lang').toLowerCase().split('-')[1],
	        preferredCountries: self.preferredCountries,
	        autoPlaceholder: true,
	        utilsScript: _utils2.default
	      });
	
	      self.$el.prop('name', '').closest(self.selectors.wrapper).after(self.$clone);
	
	      self.intlTelInputDeferred.done(function () {
	        self.updatePhoneNumber();
	      });
	      self.bindEvents();
	    } else {
	      self.destroy();
	    }
	  },
	
	  destroy: function destroy() {
	    if (this.$el.length === 1) {
	      this.$el.val(this.$clone.val()).prop('name', this.name).intlTelInput('destroy');
	      this.$clone.remove();
	    }
	
	    this.undelegateEvents();
	    this.$el.removeData().unbind();
	  },
	
	  bindEvents: function bindEvents() {
	    eventEmitter.on('change:telephoneField', this.updatePhoneNumber, this);
	  },
	
	  onChange: function onChange() {
	    this.$clone.val(this.$el.intlTelInput('getNumber') || this.$el.val());
	    this.$clone.trigger('blur');
	  },
	
	  createHiddenInput: function createHiddenInput() {
	    var $clone = this.$el.closest(this.selectors.wrapper).next(this.selectors.clone);
	
	    if (!$clone.length) {
	      $clone = this.$el.clone();
	      $clone.css({
	        position: 'absolute',
	        left: '-9999px'
	      });
	    }
	
	    return $clone;
	  },
	
	  updatePhoneNumber: function updatePhoneNumber() {
	    var number = this.$el.intlTelInput('getNumber');
	
	    if (number) {
	      this.$el.intlTelInput('setNumber', number);
	    }
	  },
	
	  formatCountryData: function formatCountryData() {
	    var countryData = _jquery2.default.fn.intlTelInput.getCountryData();
	
	    _jquery2.default.each(countryData, function (i, country) {
	      country.name = country.name.replace(/.+\((.+)\)/, '$1');
	    });
	  }
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _remotePreloaderView = __webpack_require__(26);
	
	var _remotePreloaderView2 = _interopRequireDefault(_remotePreloaderView);
	
	var _translation = __webpack_require__(12);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    var self = this;
	    var $input = self.$el;
	    if (self.$el.length === 1) {
	      $input.rules('add', {
	        required: true,
	        remote: {
	          url: config.get('emailValidation.url'),
	          timeout: config.get('emailValidation.timeout'),
	          method: 'POST',
	          contentType: 'application/json',
	          beforeSend: function beforeSend(jqXHR, options) {
	            self.preloader = self.preloader || new _remotePreloaderView2.default({ el: $input });
	            self.preloader.show();
	            options['data'] = JSON.stringify({ email: $input.val() });
	          },
	          complete: function complete() {
	            self.preloader.hide();
	          }
	        },
	        messages: {
	          remote: (0, _translation.get)('ui.input.validation.email.remote.error')
	        }
	      });
	    } else {
	      self.destroy();
	    }
	  },
	
	  destroy: function destroy() {
	    if (this.$el.length === 1) {
	      this.$clone.remove();
	    }
	
	    this.undelegateEvents();
	    this.$el.removeData().unbind();
	  }
	});

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @abstract
	 */
	
	exports.default = _baseView2.default.extend({
	  /**
	   * @param {String} lightboxName
	   * @param {Function} [onOpenCallback]
	   * @param {Function} [onCloseCallback]
	   */
	  openLightboxByName: function openLightboxByName(lightboxName, onOpenCallback, onCloseCallback) {
	    var lightboxOptions = this.lightboxesConfig[lightboxName];
	
	    lightboxOptions.onOpenCallback = onOpenCallback;
	    lightboxOptions.onCloseCallback = onCloseCallback;
	
	    this.openLightboxUsingOptions(lightboxOptions);
	  },
	
	  /**
	   * @param {Object} lightboxOptions
	   */
	
	  openLightboxUsingOptions: function openLightboxUsingOptions(lightboxOptions) {
	    var lightBoxView;
	
	    var onOpen = function onOpen() {
	      lightBoxView = this.createLightboxView(lightboxOptions.viewClass);
	
	      if (lightboxOptions.onOpenCallback) {
	        lightboxOptions.onOpenCallback.call(this);
	      }
	    };
	
	    var onClose = function onClose() {
	      if (lightBoxView) {
	        lightBoxView.destroy();
	      }
	
	      if (lightboxOptions.onCloseCallback) {
	        lightboxOptions.onCloseCallback.call(this);
	      }
	    };
	
	    lightbox.close().setConfig({
	      $dialog: $(lightboxOptions.selector),
	      className: lightboxOptions.className,
	      onOpen: lightboxOptions.viewClass ? $.proxy(onOpen, this) : null,
	      onClose: lightboxOptions.viewClass ? $.proxy(onClose, this) : null
	    }).open();
	  },
	
	  /**
	   * Creates view specially for handling actions inside lightbox
	   *
	   * @param {Function} ViewClass
	   */
	  createLightboxView: function createLightboxView(ViewClass) {
	    var result;
	
	    if (ViewClass) {
	      result = new ViewClass({
	        el: lightbox.getContent()
	      });
	    }
	
	    return result;
	  }
	});

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _helper = __webpack_require__(10);
	
	var commonSharedTrackingHelper = _interopRequireWildcard(_helper);
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _helper2 = __webpack_require__(20);
	
	var commonTrackingHelper = _interopRequireWildcard(_helper2);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _helper3 = __webpack_require__(63);
	
	var cartHelper = _interopRequireWildcard(_helper3);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'click #js-to-checkout-button': 'toCheckoutClick',
	    'click #js-to-cart-button': 'toCartClick',
	    'click #js-close-cart-overlay-button': 'closeCartOverlayClick'
	  },
	
	  closeCartOverlayClick: function closeCartOverlayClick() {
	    /* istanbul ignore else  */
	    if (commonTrackingHelper.isGTMLoaded()) {
	      window.dataLayer.push({
	        clicked_button: 'go to shop',
	        event: 'addToCartOverlay_clicked'
	      });
	    }
	  },
	
	  toCartClick: function toCartClick(event) {
	    /* istanbul ignore else  */
	    if (commonTrackingHelper.isGTMLoaded()) {
	      commonSharedTrackingHelper.addToDataLayerForLinks(event, {
	        clicked_button: 'go to cart',
	        event: 'addToCartOverlay_clicked'
	      });
	    }
	  },
	
	  attachExtraTracking: function attachExtraTracking() {
	    window.dataLayer.push({
	      clicked_button: 'go to checkout',
	      event: 'addToCartOverlay_clicked'
	    });
	  },
	
	  toCheckoutClick: function toCheckoutClick(event) {
	    /* istanbul ignore else  */
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var aProducts = this.getTrackingData();
	      var aProductsArr = [];
	      var cartValue = 0;
	
	      if (_underscore2.default.isArray(aProducts)) {
	        aProductsArr = aProducts;
	
	        try {
	          _underscore2.default.each(aProductsArr, function (prod) {
	            cartValue += parseFloat(prod.price) * prod.quantity;
	          });
	        } catch (e) {}
	      } else if (aProducts && _underscore2.default.isArray(aProducts.cartContent)) {
	        aProductsArr = aProducts.cartContent;
	        cartValue = aProducts.cartValue;
	      }
	
	      if (aProductsArr && aProductsArr.length > 0) {
	        this.attachExtraTracking();
	
	        commonSharedTrackingHelper.addToDataLayerForLinks(event, {
	          event: 'checkout',
	          ecommerce: {
	            checkout: {
	              actionField: { step: 1 },
	              products: aProductsArr
	            },
	            cartValue: cartValue,
	            currencyCode: registry.get('currencyCode')
	          }
	        });
	      }
	    }
	  },
	
	  getTrackingData: function getTrackingData() {
	    if (!this.trackingData) {
	      this.trackingData = cartHelper.getOverlayData();
	    }
	
	    return this.trackingData;
	  }
	});

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alternativeDIV2Provider = exports.alternativeDIVprovider = exports.getDataOptions = exports.appDomainProvider = exports.height = exports.pushQvDisplayedEvent = undefined;
	
	var _events = __webpack_require__(65);
	
	var e = _interopRequireWildcard(_events);
	
	var _selectors = __webpack_require__(25);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var DEFAULT_LOCALE = 'de_DE';
	var DEFAULT_APP_DOMAIN_ID = '1';
	
	var pushQvDisplayedEvent = exports.pushQvDisplayedEvent = function pushQvDisplayedEvent(data) {
	  dataLayer.push({
	    variation: 'a',
	    productSimpleSKU: data.smp,
	    productConfigSKU: data.cfg,
	    name: data.name,
	    price: data.price.sellPrice,
	    size: data.height,
	    productCampaigns: data.campaigns.map(function (c) {
	      return c.key;
	    }),
	    event: e.STANDARD
	  });
	};
	
	var height = exports.height = function height(selectedMvcAttributes) {
	  if (!selectedMvcAttributes) {
	    return 320;
	  }
	  switch (Object.keys(selectedMvcAttributes).length) {
	    case 2:
	      return 370;
	    case 3:
	      return 430;
	    default:
	      return 320;
	  }
	};
	
	var getLocale = function getLocale() {
	  return dataLayer ? dataLayer[0].language : DEFAULT_LOCALE;
	};
	
	var getAppDomainId = function getAppDomainId() {
	  return window.location.origin.indexOf('fashionforhome') > -1 ? 8 : appDomainId[getLocale()];
	};
	
	var appDomainProvider = exports.appDomainProvider = function appDomainProvider() {
	  var locale = getLocale();
	  var appDomain = getAppDomainId();
	  return { appDomain: appDomain, lngcode: locale };
	};
	
	var getDataOptions = exports.getDataOptions = function getDataOptions() {
	  return {
	    appDomainId: getAppDomainId(),
	    language: getLocale(),
	    url: '/shop-app/quick-view/?'
	  };
	};
	
	var appDomainId = {
	  de_DE: 1,
	  fr_FR: 2,
	  nl_NL: 3,
	  de_AT: 4,
	  de_CH: 5,
	  fr_CH: 5,
	  fr_BE: 6,
	  nl_BE: 6,
	  it_IT: 7
	};
	
	var getAltDIVKey = function getAltDIVKey(appDomain) {
	  return appDomain === 8 ? 'de_DE_FFH' : getLocale();
	};
	
	var altDIV1 = {
	  de_DE: '' + _selectors.MAINALTERNATIVE,
	  fr_FR: _selectors.MAINALTERNATIVE + '_FR',
	  nl_NL: _selectors.MAINALTERNATIVE + '_NL',
	  de_AT: _selectors.MAINALTERNATIVE + '_AT',
	  de_CH: _selectors.MAINALTERNATIVE + '_CH',
	  fr_CH: _selectors.MAINALTERNATIVE + '_CH',
	  fr_BE: _selectors.MAINALTERNATIVE + '_BE',
	  nl_BE: _selectors.MAINALTERNATIVE + '_BE',
	  it_IT: 'dy_IT_Global_Ribbon',
	  de_DE_FFH: _selectors.MAINALTERNATIVE + '_FFH'
	};
	
	var altDIV2 = {
	  de_DE: '' + _selectors.MAINALTERNATIVE,
	  fr_FR: 'dy_FR_Global_Ribbon',
	  nl_NL: _selectors.MAINALTERNATIVE + '_NL',
	  de_AT: _selectors.MAINALTERNATIVE + '_AT',
	  de_CH: _selectors.MAINALTERNATIVE + '_CH',
	  fr_CH: _selectors.MAINALTERNATIVE + '_ch_FR',
	  fr_BE: _selectors.MAINALTERNATIVE + '_BE',
	  nl_BE: _selectors.MAINALTERNATIVE + '_BE',
	  it_IT: 'dy_IT_Global_Ribbon',
	  de_DE_FFH: _selectors.MAINALTERNATIVE + '_FFH'
	};
	
	var alternativeDIVprovider = exports.alternativeDIVprovider = function alternativeDIVprovider() {
	  var _appDomainProvider = appDomainProvider(),
	      appDomain = _appDomainProvider.appDomain;
	
	  var altDIVKey = getAltDIVKey(appDomain);
	
	  return altDIV1[altDIVKey];
	};
	
	var alternativeDIV2Provider = exports.alternativeDIV2Provider = function alternativeDIV2Provider() {
	  var _appDomainProvider2 = appDomainProvider(),
	      appDomain = _appDomainProvider2.appDomain;
	
	  var altDIVKey = getAltDIVKey(appDomain);
	
	  return altDIV2[altDIVKey];
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderRecommendations = exports.conditionallyRenderAttrs = undefined;
	
	var _swiper = __webpack_require__(53);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _recommendations = __webpack_require__(22);
	
	var _recommendationsSlider = __webpack_require__(189);
	
	var _recommendationsSlider2 = _interopRequireDefault(_recommendationsSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var conditionallyRenderAttrs = exports.conditionallyRenderAttrs = function conditionallyRenderAttrs(cond, attrs) {
	  return cond ? attrs.map(function (attr) {
	    return '' + attr.name + (typeof attr.value !== 'undefined' ? '="' + attr.value + '"' : '');
	  }).join(' ') : '';
	};
	
	/**
	 *
	 * @param {string} [headline] - heading above recommendations slider
	 * @param {object} [data] - recommendations response data
	 * @param {string} [selector] - CSS selector to query document with
	 * @param {number} [slidesPerView] - how many slides to show within the viewport
	 * @param {number} [spaceBetween] - space between slides in pixels
	 * @param {string} [style=''] - CSS style for recommendations slider wrapper
	 */
	var renderRecommendations = exports.renderRecommendations = function renderRecommendations(headline, data, selector, slidesPerView, spaceBetween) {
	  var style = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	
	  var selectorNode = document.querySelector(selector);
	  var existingSliderNode = document.querySelector('.' + _recommendations.classNames.SLIDER_CONTAINER);
	  if (existingSliderNode === null && selectorNode) {
	    var sliderOptions = {
	      slidesPerView: slidesPerView,
	      spaceBetween: spaceBetween,
	      navigation: {
	        prevEl: '.' + _recommendations.classNames.SLIDER_NAV_ARROW_LEFT,
	        nextEl: '.' + _recommendations.classNames.SLIDER_NAV_ARROW_RIGHT
	      }
	    };
	    selectorNode.insertAdjacentHTML('beforeend', (0, _recommendationsSlider2.default)({ headline: headline, data: data, style: style }));
	    new _swiper2.default('.' + _recommendations.classNames.SLIDER_CONTAINER, sliderOptions);
	  } else {
	    console.error('Could not render recommendations slider since mounting element ' + selector + ' is not in the DOM.');
	  }
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (zipCode) {
	  return zipCode.replace(/([\d]{4})([\w]{2})/, '$1 $2').toUpperCase();
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onArticleAddedToCart = onArticleAddedToCart;
	
	var _registry = __webpack_require__(5);
	
	function onArticleAddedToCart(trackingData, type) {
	  if (typeof window.dataLayer !== 'undefined') {
	    var pageType = type || '';
	
	    // add pageType inside product data :/
	    if (trackingData.addedArticle && trackingData.addedArticle[0]) {
	      trackingData.addedArticle[0].dimension65 = pageType;
	      trackingData.addedArticle[0].brand = decodeURIComponent(trackingData.addedArticle[0].brand);
	    }
	
	    var dataObject = {
	      event: 'addToCart',
	      ecommerce: {
	        add: {
	          products: trackingData.addedArticle
	        },
	        cartValue: trackingData.cartValue,
	        currencyCode: (0, _registry.get)('currencyCode')
	      }
	    };
	
	    window.dataLayer.push(dataObject);
	  }
	}

/***/ },
/* 43 */,
/* 44 */,
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({});

/***/ },
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  ARTICLE: 'block-text saleTop',
	  WRAP: 'qvh24--pdp2',
	  BIG_IMAGE: 'qvh24--pic',
	  SLIDER: {
	    WRAP: 'qvh24--swiper',
	    ARROWUP: 'qvh24--swiper-up',
	    ARROWDOWN: 'qvh24--swiper-down',
	    INNERWRAP: {
	      WRAP: 'swiper-container',
	      IMG: {
	        WRAP: 'swiper-wrapper',
	        INNERWRAP: 'swiper-slide',
	        STANDARD: 'qvh24-mini-pic',
	        ACTIVE: 'qvh24-mini-pic-active gallery-qv__small-img js-quick-view__small-img gallery-qv__small-img--active'
	      }
	    }
	  },
	  DETAILS: {
	    WRAP: 'qvh24--details',
	    TITLE: {
	      HEADLINE: 'qvh24--headline article-qv__name js-quick-view__pdp-link acte-quick-view__article-name',
	      SUBLINE: 'qvh24--subline article-qv__variant'
	    },
	    STARS: {
	      WRAP: 'qvh24--stars',
	      INNER: 'qvh24--staroutside stars-empty',
	      INSIDE: 'stars-full',
	      RATING: 'article-qv__ranking-amount'
	    },
	    PRICE: {
	      WRAP: 'qvh24--pricewrap article__price-wrap article-qv__price-wrap',
	      NORMAL: 'article__price',
	      STRIKE: 'article__price  article__price--new',
	      DISCOUNT: 'article__price-old'
	    },
	    DELIVERY: {
	      NORMAL: 'qvh24--lieferzeitwrap article-qv__delivery ',
	      FAST: 'qvh24--lieferzeitwrap article-qv__delivery  article__delivery--fast '
	    },
	    BUTTONS: {
	      WRAP: 'qvh24--buttons-wrap',
	      ADD_TO_CART: 'qvh24--buy-button button button--primary button--big js-add-to-cart-button acte-quick-view__add-to-cart',
	      GO_TO_PRODUCTPAGE: 'qvh24--product-page-button button js-quick-view__pdp-link acte-quick-view__product-details'
	    },
	    OPTIONS: {
	      WRAPHEADER: 'mvc-qv__item acte-quick-view__mvc-item',
	      LABEL: 'mvc-qv__label',
	      WRAPOPTIONS: 'select-primary select--full-width',
	      SELECT: 'qvh24--select acte-quick-view__mvc-item-select'
	    }
	  },
	  NOTIFICATION: {
	    WRAP: 'quick-view__change-notification quick-view__change-notification--active',
	    IMG: 'quick-view__change-notification__icon',
	    INNER: 'quick-view__change-notification__content'
	  }
	};

/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var lng = {
	  de: {
	    BUY: 'In den Warenkorb',
	    PDP: 'Produktdetails ansehen',
	    DISCLAIMER: 'Preise inkl. gesetzlicher Umsatzsteuer und Versandkosten',
	    UVP: 'UVP',
	    NOTSELLABLE: 'Deine Auswahl ist leider nicht verfügbar. Wir haben daher die ähnlichste Variante gewählt.',
	    DELIVERY: 'Lieferzeit',
	    VALUE_PACK: 'Preisersparnis im Set gegenüber Einzelkauf',
	    RECOMMENDATIONS_HEADLINE: 'Das könnte dir auch gefallen'
	  },
	  fr: {
	    BUY: 'Ajouter au panier',
	    PDP: 'Voir la fiche produit',
	    DISCLAIMER: 'Tous les prix incluent la TVA et les frais de livraison',
	    UVP: 'PVC',
	    NOTSELLABLE: "Votre sélection n'est malheureusement pas disponible. Voici le produit le plus similaire.",
	    DELIVERY: 'Livré sous',
	    VALUE_PACK: "Par rapport à un achat à l'unité, vous économisez",
	    RECOMMENDATIONS_HEADLINE: 'Vous aimerez aussi...'
	  },
	  it: {
	    BUY: 'Nel carrello',
	    PDP: 'Vai alla scheda prodotto',
	    DISCLAIMER: 'Tutti i prezzi sono in euro (€) e includono Iva e spese di consegna',
	    UVP: '',
	    NOTSELLABLE: "ll prodotto da te selezionato non e' al momento disponibile. Abbiamo selezionato per te i prodotti piu' simili.",
	    DELIVERY: 'Consegna',
	    VALUE_PACK: 'Acquistando in set invece che per unità, risparmi',
	    RECOMMENDATIONS_HEADLINE: 'Potrebbe piacerti anche questo'
	  },
	  nl: {
	    BUY: 'In de winkelwagen',
	    PDP: 'Bekijk productgegevens',
	    DISCLAIMER: "Alle prijzen in euro's (€), inclusief BTW en verzendkosten",
	    UVP: 'Adviesprijs',
	    NOTSELLABLE: 'Je keuze is helaas niet beschikbaar. We hebben de variant uitgekozen die er het meeste op lijkt.',
	    DELIVERY: 'Levertijd',
	    VALUE_PACK: 'Als je een set i.p.v. een enkel artikel koopt, bespaar je',
	    RECOMMENDATIONS_HEADLINE: 'Dit vind je misschien ook leuk'
	  }
	};
	
	var lngprovider = exports.lngprovider = function lngprovider(lngcode) {
	  var code = lngcode.split('_')[0];
	  return lng[code] ? lng[code] : false;
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._getTrackingData = _getTrackingData;
	exports.addressSendTrackingData = addressSendTrackingData;
	exports.indexSendTrackingData = indexSendTrackingData;
	exports.paymentSendTrackingData = paymentSendTrackingData;
	exports.successSendTrackingData = successSendTrackingData;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _registry = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getTrackingData() {
	  return (0, _registry.get)('trackingData');
	}
	
	function addressSendTrackingData() {
	  var trackingData = _getTrackingData();
	
	  if (trackingData && trackingData.length > 0 && typeof window.dataLayer !== 'undefined') {
	    window.dataLayer.push({
	      event: 'checkout',
	      ecommerce: {
	        checkout: {
	          actionField: {
	            step: 2
	          }
	        },
	        products: trackingData
	      }
	    });
	  }
	}
	
	function indexSendTrackingData() {
	  var trackingData = _getTrackingData();
	
	  if (trackingData && trackingData.length > 0 && typeof window.dataLayer !== 'undefined') {
	    window.dataLayer.push({
	      event: 'checkout',
	      ecommerce: {
	        checkout: {
	          actionField: {
	            step: 4
	          },
	          products: trackingData
	        }
	      }
	    });
	  }
	}
	
	function paymentSendTrackingData() {
	  var trackingData = _getTrackingData();
	
	  if (trackingData && trackingData.length > 0 && typeof window.dataLayer !== 'undefined') {
	    window.dataLayer.push({
	      event: 'checkout',
	      ecommerce: {
	        checkout: {
	          actionField: {
	            step: 3
	          },
	          products: trackingData
	        }
	      }
	    });
	  }
	}
	
	function successSendTrackingData() {
	  var productData = _getTrackingData();
	  var currencyCode;
	  var i;
	
	  if (productData && productData.order && productData.products && typeof window.dataLayer !== 'undefined') {
	    var oClonedData = _jquery2.default.extend(true, {}, productData);
	
	    // cleanup
	
	    for (i in oClonedData.products) {
	      /* istanbul ignore else */
	      if (oClonedData.products.hasOwnProperty(i)) {
	        if (oClonedData.products[i].currencyCode) {
	          currencyCode = oClonedData.products[i].currencyCode;
	        }
	
	        delete oClonedData.products[i].currencyCode;
	      }
	    }
	
	    window.dataLayer.push({
	      ecommerce: {
	        currencyCode: currencyCode,
	        purchase: {
	          actionField: oClonedData.order,
	          products: oClonedData.products
	        }
	      }
	    });
	  }
	}

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.show = show;
	exports.hideAll = hideAll;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Usage:
	 * 1. Add .data-tipped class to the element you want to have as a tooltip trigger
	 * 2. Specify content as a value for a attribute data-tipped
	 *
	 * Options
	 * data-tipped-pos  - position of the tooltip (top/left/right/bottom). Default: bottom
	 * data-tipped-trigger - event that should cause a tooltip show action (hover/click). Default: hover
	 *
	 * Options for the popover
	 * data-tipsy-class - class that will be added to the tootlip
	 * data-tipsy-manual - add it if tooltip should be shown and hidden manually
	 */
	// TODO:
	
	var w = window;
	
	w.home24 = w.home24 || {};
	
	w.home24.dataTipped = function () {
	  var self = {};
	
	  self.$tooltip = null;
	
	  // public API
	  self.init = function () {
	    var $dataTipped = (0, _jquery2.default)('.data-tipped');
	
	    if (!$dataTipped.length) {
	      return;
	    }
	
	    var $dataTippedWithEvents = $dataTipped.not('[data-tipsy-manual=true]');
	
	    // noinspection JSJQueryEfficiency
	    if ((0, _jquery2.default)('.simple-tooltip').length === 0) {
	      (0, _jquery2.default)('body').prepend((0, _jquery2.default)('<div class="simple-tooltip"><div class="tipsy-arrow"><div class="tipsy-arrow-after"></div></div><div class="tipsy-inner"></div></div>'));
	    }
	
	    // noinspection JSJQueryEfficiency
	    self.$tooltip = (0, _jquery2.default)('.simple-tooltip');
	
	    // unbind previous events if exist
	    self.$tooltip.off('.data-tipped').on('mouseover-not-touch.data-tipped', self._onTipTextMouseOver).on('mouseleave-not-touch.data-tipped', self._onTipTextMouseLeave);
	
	    $dataTippedWithEvents.each(self._attachEvents);
	  };
	
	  self.show = function (item) {
	    self._showOnElement(item);
	  };
	
	  self.hideAll = function () {
	    self.$tooltip.fadeOut('fast');
	    self._removeDocumentEvents();
	    (0, _jquery2.default)('.data-tipped').data('shown', false);
	  };
	
	  self.hide = function () {
	    self._hide();
	  };
	
	  // Private methods
	
	  self._attachEvents = function (index, element) {
	    var $element = (0, _jquery2.default)(element);
	    var trigger = $element.attr('data-tipped-trigger') || 'hover';
	
	    // unbind previous events if exist
	    $element.off('.data-tipped');
	
	    // for desktop
	    if (trigger === 'hover') {
	      $element.on('mouseenter-not-touch.data-tipped', self._show).on('mouseleave-not-touch.data-tipped', self._hide);
	    }
	
	    if (trigger === 'click') {
	      $element.on('click.data-tipped', self._onClick);
	    }
	
	    // for tablet
	    $element.on('touchend.data-tipped', self._onClick);
	  };
	
	  self._mouseIsOverTip = false;
	
	  self._onTipTextMouseOver = function () {
	    self._mouseIsOverTip = true;
	  };
	
	  self._onTipTextMouseLeave = function () {
	    w.home24.dataTipped.hideAll();
	    self._mouseIsOverTip = false;
	  };
	
	  self._onClick = function (event) {
	    var item = (0, _jquery2.default)(event.currentTarget);
	
	    // in case if user clicks on the element while tooltip is already shown
	    if (self._isShown(item)) {
	      return;
	    }
	
	    self._show(event);
	    setTimeout(function () {
	      self._addDocumentEvents();
	    }, 0);
	  };
	
	  self._isShown = function (item) {
	    return item.data('shown');
	  };
	
	  self._show = function (ev) {
	    var item = (0, _jquery2.default)(ev.currentTarget);
	
	    // for touch devices
	    if (!self._isShown(item)) {
	      ev.preventDefault();
	    }
	
	    clearTimeout(self.timeout);
	    self.hideAll();
	
	    self._$lastEl = item;
	
	    self._showOnElement(item);
	  };
	
	  // noinspection JSUndeclaredVariable
	  self._showOnElement = function (item) {
	    var tPos = item.offset();
	    var isShown = item.data('shown');
	    var pos = item.data('tippedPos') || 'bottom';
	    var targetWidth;
	    var targetHeight;
	    var tipWidth;
	    var tipHeight;
	    var addClass = item.data('tipsyClass');
	
	    if (!item.hasClass('data-tipped')) {
	      return;
	    }
	
	    if (!isShown) {
	      self.$tooltip.stop().hide();
	      self.$tooltip.removeClass('top right bottom left wide narrow red green auto-width');
	      if (addClass) {
	        self.$tooltip.addClass(addClass);
	      }
	
	      self.$tooltip.find('.tipsy-inner').html(item.data('tipped'));
	
	      targetWidth = item.width();
	      targetHeight = item.height();
	
	      tipWidth = self.$tooltip.width();
	      tipHeight = self.$tooltip.height();
	
	      switch (pos) {
	        case 'top':
	          self.$tooltip.css({
	            top: tPos.top - tipHeight - 2,
	            left: tPos.left - Math.floor(tipWidth / 2) + Math.floor(targetWidth / 2)
	          });
	          break;
	        case 'right':
	          if (item.text().length > 0) {
	            targetWidth = item.textWidth();
	          }
	          self.$tooltip.css({
	            top: tPos.top - Math.floor(tipHeight / 2) + Math.floor(targetHeight / 2),
	            left: tPos.left + targetWidth + 2
	          });
	          break;
	        case 'bottom':
	          self.$tooltip.css({
	            top: tPos.top + targetHeight + 2,
	            left: tPos.left - Math.floor(tipWidth / 2) + Math.floor(targetWidth / 2) <= 0 ? 5 : tPos.left - Math.floor(tipWidth / 2) + Math.floor(targetWidth / 2)
	          });
	          break;
	        case 'left':
	          self.$tooltip.css({
	            top: tPos.top - Math.floor(tipHeight / 2) + Math.floor(targetHeight / 2),
	            left: tPos.left - tipWidth - 2
	          });
	          break;
	      }
	
	      self.$tooltip.addClass(pos);
	
	      self.$tooltip.fadeIn('fast');
	      item.data('shown', true);
	    }
	  };
	
	  self._$lastEl = null;
	
	  self._addDocumentEvents = function () {
	    (0, _jquery2.default)(document).on('touchend.data-tipped click.data-tipped', self._onDocumentEvent);
	  };
	
	  self._onDocumentEvent = function (event) {
	    var $target = (0, _jquery2.default)(event.target);
	    var isInsideTooltip = !!$target.closest(self.$tooltip, self.$tooltip).length;
	
	    if (isInsideTooltip) {
	      return;
	    }
	
	    event.preventDefault();
	    self._removeDocumentEvents();
	    self._hide(event);
	  };
	
	  self._removeDocumentEvents = function () {
	    (0, _jquery2.default)(document).off('.data-tipped');
	  };
	
	  self._hide = function (ev) {
	    var timeout = ev.type === 'touchend' ? 0 : config.getInt('general.touchDelay');
	
	    self.timeout = setTimeout(function () {
	      if (self._$lastEl && !self._mouseIsOverTip) {
	        self.$tooltip.fadeOut('fast');
	        self._$lastEl.data('shown', false);
	        self._$lastEl = null;
	      }
	    }, timeout);
	  };
	
	  return self;
	}();
	
	w.home24.dataTipped.init();
	
	function init() {
	  return w.home24.dataTipped.init();
	}
	
	function show(item) {
	  return w.home24.dataTipped.show(item);
	}
	
	function hideAll() {
	  return w.home24.dataTipped.hideAll();
	}

/***/ },
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./translation-1-de_DE.js": 78,
		"./translation-2-fr_FR.js": 79,
		"./translation-3-nl_NL.js": 80,
		"./translation-4-de_AT.js": 81,
		"./translation-5-de_CH.js": 82,
		"./translation-5-fr_CH.js": 83,
		"./translation-6-fr_BE.js": 84,
		"./translation-6-nl_BE.js": 85,
		"./translation-7-it_IT.js": 86,
		"./translation-8-de_DE.js": 87
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 54;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _cartOverlayView = __webpack_require__(115);
	
	var cartOverlayView = _interopRequireWildcard(_cartOverlayView);
	
	var _cartManager = __webpack_require__(114);
	
	var _cartManager2 = _interopRequireDefault(_cartManager);
	
	var _cart = __webpack_require__(42);
	
	var _CartOverlayEvents = __webpack_require__(38);
	
	var _CartOverlayEvents2 = _interopRequireDefault(_CartOverlayEvents);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.View.extend({
	  initialize: function initialize(options) {
	    this.options = options;
	
	    _underscore2.default.bindAll(this, 'onAddToCartInit', 'onOverlayClose');
	
	    _jquery2.default.subscribe('addToCartInit.shopApp:cart', this.onAddToCartInit);
	    _jquery2.default.subscribe('addToCartInit.PdpApp:cart', this.onAddToCartInit);
	    _jquery2.default.subscribe('closed.shopApp:dialog', this.onOverlayClose);
	    _jquery2.default.subscribe('closed.PdpApp:dialog', this.onOverlayClose);
	  },
	
	  trackingCartOverlay: null,
	
	  onAddToCartInit: function onAddToCartInit(event, data) {
	    // initialize cart overlay
	    cartOverlayView.init();
	
	    var cartManager = new _cartManager2.default();
	
	    cartManager.setSku(data.sku).setQuantity(data.quantity || 1).onLoad().onSuccess(_underscore2.default.bind(this.onAddToCartSuccess, this)).onError(_underscore2.default.bind(this.onAddToCartFailure, this));
	
	    if (data.assemblyService) {
	      cartManager.setAssemblyService(data.assemblyService.sku);
	    }
	
	    cartManager.run();
	  },
	
	  onAddToCartSuccess: function onAddToCartSuccess(data) {
	    _jquery2.default.publish('addToCartSuccess.shopApp:cart', data.html);
	    _jquery2.default.publish('addToCartSuccess.PdpApp:cart', data.html);
	    cartOverlayView.updateCartItemsCount(data.cartItemsCount);
	
	    // tracking
	    if (_typeof(data.trackingData) === 'object') {
	      (0, _cart.onArticleAddedToCart)(data.trackingData, this.options.pageType);
	
	      // should be destroyed after quick view overlay closed
	      this.trackingCartOverlay = new _CartOverlayEvents2.default({
	        el: (0, _jquery2.default)('.pdp-cart-success__content')
	      });
	    }
	  },
	
	  onAddToCartFailure: function onAddToCartFailure(textStatus, errorThrown) {
	    _jquery2.default.publish('addToCartError.shopApp:cart', errorThrown);
	    _jquery2.default.publish('addToCartError.PdpApp:cart', errorThrown);
	  },
	
	  onOverlayClose: function onOverlayClose() {
	    if (this.trackingCartOverlay) {
	      this.trackingCartOverlay.destroy();
	      this.trackingCartOverlay = null;
	    }
	  },
	
	  destroy: function destroy() {
	    _jquery2.default.unsubscribe('addToCartInit.shopApp:cart', this.onAddToCartInit);
	    _jquery2.default.unsubscribe('addToCartInit.PdpApp:cart', this.onAddToCartInit);
	    _jquery2.default.unsubscribe('closed.shopApp:dialog', this.onOverlayClose);
	    _jquery2.default.unsubscribe('closed.PdpApp:dialog', this.onOverlayClose);
	  }
	});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _eventEmmiter = __webpack_require__(21);
	
	var eventEmitter = _interopRequireWildcard(_eventEmmiter);
	
	var _remotePreloaderView = __webpack_require__(26);
	
	var _remotePreloaderView2 = _interopRequireDefault(_remotePreloaderView);
	
	var _translation = __webpack_require__(12);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  validationRules: {
	    remoteVat: {
	      url: '/default/validator/validatecompanyid',
	      type: 'GET',
	      data: {
	        id: function id() {
	          return (0, _jquery2.default)('.js-company-vat-number input:not(.myaccount-popup-holder .js-company-vat-number input)').val();
	        }
	      },
	      beforeSend: function beforeSend() {
	        this.preloader = this.preloader || new _remotePreloaderView2.default({
	          el: (0, _jquery2.default)(this).find('.js-company-vat-number input')
	        });
	        this.preloader.show();
	      },
	      complete: function complete() {
	        this.preloader.hide();
	      }
	    }
	  },
	
	  initializeModel: function initializeModel(model) {
	    model.set({
	      combineValues: Boolean(this.$el.find(this.selectors.combinedVatFieldsInput).val()),
	      mandatoryRegisterNumber: registry.get('mandatoryRegisterNumber'),
	      mandatoryHolderNumber: registry.get('mandatoryHolderNumber'),
	      showRegisterNumberField: !this.$el.find(this.selectors.registrationNumberWrapper).hasClass(this.selectors.hiddenClass),
	      showCompanyHolderField: !this.$el.find(this.selectors.companyHolderWrapper).hasClass(this.selectors.hiddenClass)
	    });
	  },
	
	  triggerChanges: function triggerChanges(model) {
	    model.trigger('change:showRegisterNumberField', model, model.get('showRegisterNumberField'));
	    model.trigger('change:showCompanyHolderField', model, model.get('showCompanyHolderField'));
	  },
	
	  bindEvents: function bindEvents(model) {
	    eventEmitter.on('validationReload', this.addRulesToValidator, this);
	    model.on('change:showRegisterNumberField', this.onShowRegisterNumberFieldChange, this);
	    model.on('change:showCompanyHolderField', this.onShowCompanyHolderField, this);
	  },
	
	  unbindEvents: function unbindEvents(model) {
	    eventEmitter.off('validationReload', this.addRulesToValidator, this);
	    model.off('change:showRegisterNumberField', this.onShowRegisterNumberFieldChange, this);
	    model.off('change:showCompanyHolderField', this.onShowCompanyHolderField, this);
	  },
	
	  addRulesToValidator: function addRulesToValidator() {
	    this.$vatNumberField.rules('add', {
	      required: true,
	      remote: this.validationRules.remoteVat,
	      messages: {
	        remote: (0, _translation.get)('ui.input.validation.vat_number.remote.error')
	      }
	    });
	  },
	
	  onShowRegisterNumberFieldChange: function onShowRegisterNumberFieldChange(model, value) {
	    if (value) {
	      this.$registrationNumber.rules('add', { required: true });
	      this.$registrationNumber.attr('data-validate', 'true').data('validate', true);
	    } else {
	      this.$registrationNumber.rules('remove', 'required');
	      this.$registrationNumber.attr('data-validate', 'false').data('validate', true);
	    }
	  },
	
	  onShowCompanyHolderField: function onShowCompanyHolderField(model, value) {
	    if (value) {
	      this.$companyHolder.rules('add', { required: true });
	      this.$companyHolder.attr('data-validate', 'true').data('validate', true);
	    } else {
	      this.$companyHolder.rules('remove', 'required');
	      this.$companyHolder.attr('data-validate', 'false').data('validate', true);
	    }
	  }
	});

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    combineValues: false,
	    mandatoryRegisterNumber: [],
	    mandatoryHolderNumber: [],
	
	    showRegisterNumberField: false,
	    showCompanyHolderField: false,
	
	    companyLegalForm: '',
	    vatNumber: '',
	    registrationNumber: '',
	    companyHolder: ''
	  },
	
	  initialize: function initialize() {
	    this.bindEvents();
	  },
	
	  bindEvents: function bindEvents() {
	    this.on('change:companyLegalForm', this.onChangeCompanyLegalForm);
	    this.on('change:vatNumber', this.onVatNumberChange);
	    this.on('change:registrationNumber', this.onChangeRegistrationNumber);
	  },
	
	  onChangeRegistrationNumber: function onChangeRegistrationNumber(model, value) {
	    model.set('registrationNumber', value.replace(/ /g, ''));
	  },
	
	  onChangeCompanyLegalForm: function onChangeCompanyLegalForm(model, value) {
	    model.set('showRegisterNumberField', model.get('combineValues') === false && _underscore2.default.indexOf(model.get('mandatoryRegisterNumber'), value) !== -1);
	    model.set('showCompanyHolderField', _underscore2.default.indexOf(model.get('mandatoryHolderNumber'), value) !== -1);
	  },
	
	  onVatNumberChange: function onVatNumberChange(model, value) {
	    var trimmedValue = value.replace(/ /g, '').toUpperCase();
	
	    model.set('vatNumber', trimmedValue);
	    if (model.get('combineValues')) {
	      model.set('registrationNumber', trimmedValue);
	    }
	  }
	});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    customerCompanyValue: '',
	    fieldSelected: 'company',
	    inputValue: '',
	    hiddenInputValue: ''
	  },
	
	  initialize: function initialize() {
	    this.on('change:fieldSelected', this.changeHiddenInputValue);
	  },
	
	  changeHiddenInputValue: function changeHiddenInputValue(model, value) {
	    var hiddenInputValue = false;
	
	    switch (value) {
	      case 'company':
	        hiddenInputValue = model.get('customerCompanyValue');
	        break;
	
	      case 'input':
	        hiddenInputValue = model.get('inputValue');
	        break;
	    }
	
	    if (hiddenInputValue !== false) {
	      model.set('hiddenInputValue', hiddenInputValue);
	    }
	  }
	});

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _dataTipped = __webpack_require__(49);
	
	var dataTipped = _interopRequireWildcard(_dataTipped);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change [type="radio"]': 'onRadioButtonChange',
	    'focus .js-input-b2b-company': 'onInputFocus',
	    'change .js-input-b2b-company': 'onInputChange'
	  },
	
	  selectors: {
	    hiddenInput: '.js-input-b2b-value',
	    hiddenInputCustomerCompany: '.js-input-b2b-customer-company',
	    input: '.js-input-b2b-company',
	    radio: '[type="radio"]',
	    inputsetClass: 'js-inputset'
	  },
	
	  initialize: function initialize() {
	    if (this.$el.hasClass(this.selectors.inputsetClass)) {
	      this.$hiddenInput = this.$el.find(this.selectors.hiddenInput);
	      this.$input = this.$el.find(this.selectors.input);
	      this.$radioGroup = this.$el.find(this.selectors.radio);
	
	      this.model.set({
	        customerCompanyValue: this.$el.find(this.selectors.hiddenInputCustomerCompany).val(),
	        fieldSelected: this.$radioGroup.filter('[checked="checked"]').val(),
	        inputValue: this.$input.val(),
	        hiddenInputValue: this.$hiddenInput.val()
	      });
	      this.bindEvents();
	      dataTipped.init();
	    }
	  },
	
	  bindEvents: function bindEvents() {
	    this.listenTo(this.model, 'change:hiddenInputValue', this.onValueChange);
	  },
	
	  onRadioButtonChange: function onRadioButtonChange(e) {
	    this.model.set('fieldSelected', (0, _jquery2.default)(e.target).val());
	  },
	
	  onInputFocus: function onInputFocus() {
	    this.$radioGroup.filter('[value="input"]').trigger('change');
	  },
	
	  onInputChange: function onInputChange() {
	    var value = this.$input.val();
	
	    this.model.set({
	      inputValue: value,
	      hiddenInputValue: value
	    });
	  },
	
	  onValueChange: function onValueChange(model, value) {
	    this.$hiddenInput.val(value);
	    this.$hiddenInput.valid();
	  }
	});

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    // do not init if cart is empty
	    if (this.$('.js-cart-is-empty').length > 0) {
	      return;
	    }
	
	    this.binding = _rivets2.default.bind(this.el, {
	      eventHandlers: this
	    });
	  },
	
	  rivetsEventHandlers: ['removeArticle', 'changeQuantity', 'submitParentForm'],
	
	  removeArticle: function removeArticle(event) {
	    this.submitParentForm(event);
	  },
	
	  changeQuantity: function changeQuantity(event) {
	    this.submitParentForm(event);
	  },
	
	  formSubmitEnabled: true,
	
	  submitParentForm: function submitParentForm(event) {
	    var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	
	    if (this.formSubmitEnabled) {
	      $currentTarget.parent().submit();
	    }
	
	    this.formSubmitEnabled = false;
	  }
	});

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _italianTaxId = __webpack_require__(34);
	
	var _italianTaxId2 = _interopRequireDefault(_italianTaxId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'submit .js-register-form-private': 'onRegisterPrivateCustomerSubmit'
	  },
	
	  selectors: {
	    taxId: '.js-tax-id input'
	  },
	
	  initialize: function initialize() {
	    this.$taxId = this.$el.find(this.selectors.taxId);
	
	    if (this.$taxId) {
	      this.taxId = new _italianTaxId2.default({
	        el: this.$taxId
	      });
	    }
	
	    this.setupRivetsBindings();
	    this.bindEvents();
	
	    var formModel = this.model;
	
	    formModel.get('form').trigger('change:accountType', formModel, formModel.get('accountType'));
	  },
	
	  bindEvents: function bindEvents() {
	    if (this.$taxId.length) {
	      this.listenTo(this.model.get('form'), 'change:showTaxId', this.onShowTaxId, this);
	    }
	  },
	
	  setupRivetsBindings: function setupRivetsBindings() {
	    _rivets2.default.bind(this.$el, {
	      viewModel: this.model
	    });
	  },
	
	  onRegisterPrivateCustomerSubmit: function onRegisterPrivateCustomerSubmit() {
	    this.removeCompanyFromPrivateCustomer();
	  },
	
	  removeCompanyFromPrivateCustomer: function removeCompanyFromPrivateCustomer() {
	    var formModel = this.model.get('form');
	    var isPrivateCustomer = !formModel.get('showBusinessForm');
	
	    if (isPrivateCustomer) {
	      formModel.set('company', '');
	    }
	  },
	
	  onShowTaxId: function onShowTaxId(model, value) {
	    if (this.$taxId) {
	      this.$taxId.attr('data-validate', value);
	    }
	  }
	});

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _base = __webpack_require__(28);
	
	var _storageFactory = __webpack_require__(7);
	
	var _CartOverlayEvents = __webpack_require__(38);
	
	var _CartOverlayEvents2 = _interopRequireDefault(_CartOverlayEvents);
	
	var _helper = __webpack_require__(20);
	
	var commonTrackingHelper = _interopRequireWildcard(_helper);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CartOverlayEvents2.default.extend({
	  events: {
	    'change .cart-article-quantity': 'onQuantityChange',
	    'click .cart-remove-button': 'onRemoveClick',
	    'click #js-to-checkout-button': 'toCheckoutClick'
	  },
	
	  cookieCallbacks: {
	    GtmOnCartQuantityChange: 'afterQuantityChange',
	    GtmOnRemovedFromCart: 'afterRemoveClick'
	  },
	
	  initialize: function initialize() {},
	
	  attachExtraTracking: function attachExtraTracking() {},
	
	  getTrackingData: function getTrackingData() {
	    var trackingData = registry.get('trackingData');
	
	    return _underscore2.default.isArray(trackingData) ? trackingData : trackingData.cartContent;
	  },
	
	  onRemoveClick: function onRemoveClick(event) {
	    var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	
	    try {
	      var articleTrackingData = commonTrackingHelper.extractDataBySku(this.getTrackingData(), $currentTarget.closest('form').find('[name="key[]"]').val().split(';')[1]);
	
	      if (articleTrackingData !== false) {
	        (0, _storageFactory.getStorage)().set('GtmOnRemovedFromCart', (0, _base.encode)(JSON.stringify(articleTrackingData)));
	      }
	    } catch (ignore) {}
	  },
	
	  onQuantityChange: function onQuantityChange(event) {
	    var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	
	    try {
	      var sku = $currentTarget.closest('form').find('[name="sku[]"]').val().split(';')[1];
	      var articleTrackingData = commonTrackingHelper.extractDataBySku(this.getTrackingData(), sku);
	      var currentQuantity = articleTrackingData.quantity;
	      var newQuantity = parseInt($currentTarget.find('option:selected').text(), 10);
	      var dataContent = {};
	
	      dataContent.oldQuantity = currentQuantity;
	      dataContent.newQuantity = newQuantity;
	      dataContent.sku = sku;
	
	      if (currentQuantity && newQuantity) {
	        (0, _storageFactory.getStorage)().set('GtmOnCartQuantityChange', (0, _base.encode)(JSON.stringify(dataContent)));
	      }
	    } catch (ignore) {}
	  },
	
	  /**
	   * Callback executed when article has been removed from cart
	   * @see REBOOT-14889
	   * @param {String} sValue
	   */
	  afterRemoveClick: function afterRemoveClick(sValue) {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push(commonTrackingHelper.prepareCartRemoveObject(commonTrackingHelper.decode(sValue)));
	    }
	  },
	
	  /**
	   * Callback for BaseTracking:executeCookieCallbacks executed when user changes cart quantity
	   * and article
	   * @param sValue
	   */
	  afterQuantityChange: function afterQuantityChange(sValue) {
	    if (typeof window.dataLayer !== 'undefined') {
	      var oPassedData = commonTrackingHelper.decode(sValue);
	      var oArticleData = commonTrackingHelper.extractDataBySku(registry.get('trackingData').cartContent, oPassedData.sku);
	      var iQuantityDifference = oPassedData.newQuantity - oPassedData.oldQuantity;
	
	      if (iQuantityDifference > 0) {
	        window.dataLayer.push(commonTrackingHelper.prepareCartAddObject(oArticleData, iQuantityDifference));
	      } else {
	        window.dataLayer.push(commonTrackingHelper.prepareCartRemoveObject(oArticleData, Math.abs(iQuantityDifference)));
	      }
	    }
	  }
	});

/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setOverlayData = setOverlayData;
	exports.getOverlayData = getOverlayData;
	exports.pushAddToCartOverlayEvent = pushAddToCartOverlayEvent;
	var overlayData = [];
	
	function setOverlayData(data) {
	  overlayData = data;
	}
	
	function getOverlayData() {
	  return overlayData;
	}
	
	function pushAddToCartOverlayEvent() {
	  window.dataLayer.push({
	    event: 'addToCartOverlay'
	  });
	}

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _helper = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  initialize: function initialize(options) {
	    if (!options) {
	      throw new Error('Tracking options are required');
	    }
	
	    this.googleResponse = options.googleResponse;
	    this.pageType = this._getPageType();
	  },
	
	  _getPageType: function _getPageType() {
	    var pageData = (0, _helper.getCurrentDataLayer)();
	    var pageType;
	
	    if (pageData.pageLevel && pageData.pageLevel === 'checkout_login') {
	      pageType = 'Checkout';
	    } else {
	      pageType = pageData.pageType;
	    }
	
	    return pageType;
	  },
	
	  trackWrongAddressTyped: function trackWrongAddressTyped() {
	    this.push('address_wrong');
	  },
	
	  trackAddressCheckShow: function trackAddressCheckShow() {
	    this.push('address_check');
	  },
	
	  trackGoogleAddressSelected: function trackGoogleAddressSelected() {
	    this.push('address_accepted');
	  },
	
	  trackAddressNewInput: function trackAddressNewInput() {
	    this.push('address_new_input');
	  },
	
	  trackOldAddressKept: function trackOldAddressKept() {
	    this.push('address_old_confirmed');
	  },
	
	  push: function push(event) {
	    if (typeof window.dataLayer === 'undefined') {
	      return;
	    }
	
	    var dataObj = { event: event };
	    var address = this.googleResponse;
	    var prevPage = this.pageType;
	
	    if (prevPage) {
	      dataObj.prevPage = prevPage;
	    }
	
	    if (address) {
	      dataObj.address_error = address;
	    }
	
	    window.dataLayer.push(dataObj);
	  }
	});

/***/ },
/* 65 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STANDARD = exports.STANDARD = 'qvh24inlineqv';
	var ADDTOCART = exports.ADDTOCART = 'addToCart_qvh24';

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trackDYORecommendations = exports.isRecommendationsResponseDYO = exports.getRecommendationsData = undefined;
	
	__webpack_require__(284);
	
	var _config = __webpack_require__(4);
	
	var _recommendations = __webpack_require__(22);
	
	/**
	 * @description
	 * Create fetch request for fetching recommendations
	 *
	 * @param {String} [url] - relative url
	 *
	 * @returns {Promise}
	 */
	var createFetchRequest = function createFetchRequest(url) {
	  return fetch((0, _config.getBaseUrl)() + '/' + url, {
	    headers: {
	      'x-requested-with': 'XMLHttpRequest'
	    }
	  }).then(function (res) {
	    return res.json();
	  });
	};
	
	/**
	 * @description
	 * Retrieve recommendations either from our endpoint or dynamic yields according to AB test value
	 *
	 * @param {String} [productIdentifier] - product sku
	 * @param {String} [langCode] - language code
	 *
	 * @returns {Promise} List of recommendations
	 */
	var getRecommendationsData = exports.getRecommendationsData = function getRecommendationsData(productIdentifier, langCode) {
	  return new Promise(function (resolve, reject) {
	    var currentABTestValue = document.querySelector('[' + _recommendations.AB_TEST_ATTR_NAME + ']').getAttribute(_recommendations.AB_TEST_ATTR_NAME);
	
	    var handleFetchResponse = function handleFetchResponse(response) {
	      if (response.success && response.success === false) {
	        return reject(response.message);
	      }
	      resolve(response);
	    };
	
	    switch (currentABTestValue) {
	      case _recommendations.AB_TEST_VALUE.INHOUSE_SLIDER:
	        var url = _recommendations.RECOMMENDATIONS_URL.INHOUSE + '&sku=' + productIdentifier;
	        createFetchRequest(url).then(handleFetchResponse).catch(function (err) {
	          return reject(err);
	        });
	        break;
	      case _recommendations.AB_TEST_VALUE.DY_SLIDER:
	        if (!_recommendations.DY_STRATEGY_IDS[DY.scsec]) {
	          return reject('DY strategy could not be found by section ' + DY.scsec + '.');
	        }
	
	        DYO.recommendationWidgetData(_recommendations.DY_STRATEGY_IDS[DY.scsec], {
	          context: {
	            lng: langCode,
	            type: 'PRODUCT',
	            data: [productIdentifier]
	          }
	        }, function (err, data) {
	          if (err) {
	            reject(err);
	          } else if (data.slots.length > 0) {
	            var skus = data.slots.map(function (slot) {
	              return slot.item.sku;
	            });
	            var _url = '' + _recommendations.RECOMMENDATIONS_URL.DY + skus.map(function (sku) {
	              return '&skus[]=' + sku;
	            }).join('');
	            createFetchRequest(_url).then(handleFetchResponse).catch(function (err) {
	              return reject(err);
	            });
	          }
	        });
	        break;
	      default:
	        resolve(null);
	    }
	  });
	};
	
	/**
	 * Returns boolean value whether a given response is from DYO.recommendationWidgetData
	 * @param {Object} response data for recommendations slider
	 */
	var isRecommendationsResponseDYO = exports.isRecommendationsResponseDYO = function isRecommendationsResponseDYO(_ref) {
	  var wId = _ref.wId,
	      fId = _ref.fId;
	  return [wId, fId].every(function (prop) {
	    return typeof prop === 'number';
	  });
	};
	
	/**
	 * Tracks DYO recommendations element queried from the existing DOM
	 */
	var trackDYORecommendations = exports.trackDYORecommendations = function trackDYORecommendations() {
	  var recommendationsSliderNode = document.querySelector('.' + _recommendations.classNames.SLIDER_CONTAINER);
	  if (!recommendationsSliderNode) {
	    console.error('DY Slider: Element .' + _recommendations.classNames.SLIDER_CONTAINER + ' could not be found in the DOM.');
	  } else {
	    DYO.recommendations.registerElements(recommendationsSliderNode);
	  }
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AppDomain = __webpack_require__(23);
	
	var _AppDomain2 = _interopRequireDefault(_AppDomain);
	
	var _normalizers = __webpack_require__(41);
	
	var _normalizers2 = _interopRequireDefault(_normalizers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * jQuery plugin to normalizes zip code value for Netherlands.
	 * This is required to update old zip code in wrong shape.
	 */
	_jquery2.default.fn.normalizeZipCodeForNL = function () {
	  if (_AppDomain2.default.isNL()) {
	    var $zipInput = this.find('input[name=zip]');
	    var zipCode = $zipInput.val() || '';
	    var normalizedZipCode = (0, _normalizers2.default)(zipCode);
	
	    $zipInput.val(normalizedZipCode);
	  }
	
	  return this;
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _capitalize = __webpack_require__(230);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _helper = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var smartBanner = {
	  init: function init() {
	    (0, _jquery2.default)('.js-smart-banner-container').click(function (event) {
	      var linkAction = event.target.dataset.linkAction;
	
	      // It should prevent default anchor behavior in order to fire
	      // GTM event. So, after the event being fired, it redirects to adjust
	
	      (0, _helper.addToDataLayerForLinks)(event, {
	        event: 'smartbannerClicked_' + (0, _capitalize2.default)(linkAction)
	      });
	    });
	
	    return this;
	  }
	};
	
	function init() {
	  return smartBanner.init();
	}

/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = validateIBAN;
	function validateIBAN(value) {
	  // remove spaces and to upper case
	  var iban = value.replace(/ /g, '').toUpperCase(),
	      ibancheckdigits = '',
	      leadingZeroes = true,
	      cRest = '',
	      cOperator = '',
	      countrycode,
	      ibancheck,
	      charAt,
	      cChar,
	      bbanpattern,
	      bbancountrypatterns,
	      ibanregexp,
	      i,
	      p;
	
	  // check the country code and find the country specific format
	  countrycode = iban.substring(0, 2);
	  bbancountrypatterns = {
	    AL: '\\d{8}[\\dA-Z]{16}',
	    AD: '\\d{8}[\\dA-Z]{12}',
	    AT: '\\d{16}',
	    AZ: '[\\dA-Z]{4}\\d{20}',
	    BE: '\\d{12}',
	    BH: '[A-Z]{4}[\\dA-Z]{14}',
	    BA: '\\d{16}',
	    BR: '\\d{23}[A-Z][\\dA-Z]',
	    BG: '[A-Z]{4}\\d{6}[\\dA-Z]{8}',
	    CR: '\\d{17}',
	    HR: '\\d{17}',
	    CY: '\\d{8}[\\dA-Z]{16}',
	    CZ: '\\d{20}',
	    DK: '\\d{14}',
	    DO: '[A-Z]{4}\\d{20}',
	    EE: '\\d{16}',
	    FO: '\\d{14}',
	    FI: '\\d{14}',
	    FR: '\\d{10}[\\dA-Z]{11}\\d{2}',
	    GE: '[\\dA-Z]{2}\\d{16}',
	    DE: '\\d{18}',
	    GI: '[A-Z]{4}[\\dA-Z]{15}',
	    GR: '\\d{7}[\\dA-Z]{16}',
	    GL: '\\d{14}',
	    GT: '[\\dA-Z]{4}[\\dA-Z]{20}',
	    HU: '\\d{24}',
	    IS: '\\d{22}',
	    IE: '[\\dA-Z]{4}\\d{14}',
	    IL: '\\d{19}',
	    IT: '[A-Z]\\d{10}[\\dA-Z]{12}',
	    KZ: '\\d{3}[\\dA-Z]{13}',
	    KW: '[A-Z]{4}[\\dA-Z]{22}',
	    LV: '[A-Z]{4}[\\dA-Z]{13}',
	    LB: '\\d{4}[\\dA-Z]{20}',
	    LI: '\\d{5}[\\dA-Z]{12}',
	    LT: '\\d{16}',
	    LU: '\\d{3}[\\dA-Z]{13}',
	    MK: '\\d{3}[\\dA-Z]{10}\\d{2}',
	    MT: '[A-Z]{4}\\d{5}[\\dA-Z]{18}',
	    MR: '\\d{23}',
	    MU: '[A-Z]{4}\\d{19}[A-Z]{3}',
	    MC: '\\d{10}[\\dA-Z]{11}\\d{2}',
	    MD: '[\\dA-Z]{2}\\d{18}',
	    ME: '\\d{18}',
	    NL: '[A-Z]{4}\\d{10}',
	    NO: '\\d{11}',
	    PK: '[\\dA-Z]{4}\\d{16}',
	    PS: '[\\dA-Z]{4}\\d{21}',
	    PL: '\\d{24}',
	    PT: '\\d{21}',
	    RO: '[A-Z]{4}[\\dA-Z]{16}',
	    SM: '[A-Z]\\d{10}[\\dA-Z]{12}',
	    SA: '\\d{2}[\\dA-Z]{18}',
	    RS: '\\d{18}',
	    SK: '\\d{20}',
	    SI: '\\d{15}',
	    ES: '\\d{20}',
	    SE: '\\d{20}',
	    CH: '\\d{5}[\\dA-Z]{12}',
	    TN: '\\d{20}',
	    TR: '\\d{5}[\\dA-Z]{17}',
	    AE: '\\d{3}\\d{16}',
	    GB: '[A-Z]{4}\\d{14}',
	    VG: '[\\dA-Z]{4}\\d{16}'
	  };
	
	  bbanpattern = bbancountrypatterns[countrycode];
	  // As new countries will start using IBAN in the
	  // future, we only check if the countrycode is known.
	  // This prevents false negatives, while almost all
	  // false positives introduced by this, will be caught
	  // by the checksum validation below anyway.
	  // Strict checking should return FALSE for unknown
	  // countries.
	  if (typeof bbanpattern !== 'undefined') {
	    ibanregexp = new RegExp('^[A-Z]{2}\\d{2}' + bbanpattern + '$', '');
	    if (!ibanregexp.test(iban)) {
	      return false; // invalid country specific format
	    }
	  }
	
	  // now check the checksum, first convert to digits
	  ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
	  for (i = 0; i < ibancheck.length; i++) {
	    charAt = ibancheck.charAt(i);
	    if (charAt !== '0') {
	      leadingZeroes = false;
	    }
	    if (!leadingZeroes) {
	      ibancheckdigits += '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(charAt);
	    }
	  }
	
	  // calculate the result of: ibancheckdigits % 97
	  for (p = 0; p < ibancheckdigits.length; p++) {
	    cChar = ibancheckdigits.charAt(p);
	    cOperator = '' + cRest + '' + cChar;
	    cRest = cOperator % 97;
	  }
	  return cRest === 1;
	}

/***/ },
/* 70 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unset = unset;
	exports.get = get;
	exports.set = set;
	/**
	 * localStorage with expire wrapper
	 */
	
	var localStorage = window.localStorage;
	
	/**
	 * Method unsets value in localStorage
	 */
	function unset(key) {
	  localStorage.removeItem(key);
	}
	
	/**
	 * Method gets value from localStorage
	 * @param key
	 */
	function get(key) {
	  if (!localStorage[key]) {
	    return null;
	  }
	
	  var object = JSON.parse(localStorage[key]);
	
	  if (object.timestamp === null || new Date().getTime() < object.timestamp) {
	    return object.value;
	  }
	
	  return null;
	}
	
	/**
	 * Method sets value in local storage
	 *
	 * @param {String} key
	 * @param {*} value
	 * @param {Number=} expire in seconds
	 */
	function set(key, value, expire) {
	  var object;
	
	  if (!expire) {
	    object = {
	      value: value,
	      timestamp: null
	    };
	  } else {
	    object = {
	      value: value,
	      timestamp: new Date().getTime() + expire * 1000
	    };
	  }
	
	  localStorage[key] = JSON.stringify(object);
	}

/***/ },
/* 71 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.set = set;
	exports.unset = unset;
	var storage = {};
	
	/**
	 * Method gets value from memory
	 * @param key
	 */
	function get(key) {
	  return storage[key];
	}
	
	/**
	 * Method sets value in memory
	 *
	 * @param key
	 * @param value
	 * @param expire is ignored
	 */
	function set(key, value) {
	  storage[key] = value;
	}
	
	function unset(key) {
	  storage[key] = null;
	}

/***/ },
/* 72 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.set = set;
	var instances = {};
	
	function get(name) {
	  return instances[name];
	}
	
	function set(name, instance) {
	  instances[name] = instance;
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(210);
	
	__webpack_require__(209);
	
	__webpack_require__(211);
	
	__webpack_require__(208);
	
	__webpack_require__(207);

/***/ },
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(10, function (require) {
	      resolve(__webpack_require__(103));
	    });
	  });
	}

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(9, function (require) {
	      resolve(__webpack_require__(104));
	    });
	  });
	}

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(8, function (require) {
	      resolve(__webpack_require__(105));
	    });
	  });
	}

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(7, function (require) {
	      resolve(__webpack_require__(106));
	    });
	  });
	}

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(6, function (require) {
	      resolve(__webpack_require__(107));
	    });
	  });
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(5, function (require) {
	      resolve(__webpack_require__(108));
	    });
	  });
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(4, function (require) {
	      resolve(__webpack_require__(109));
	    });
	  });
	}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(3, function (require) {
	      resolve(__webpack_require__(110));
	    });
	  });
	}

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(2, function (require) {
	      resolve(__webpack_require__(111));
	    });
	  });
	}

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      resolve(__webpack_require__(112));
	    });
	  });
	}

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	      resolve(__webpack_require__(113));
	    });
	  });
	}

/***/ },
/* 88 */,
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeEventListenerToBuyButton = undefined;
	
	var _events = __webpack_require__(65);
	
	var checkoutUrl = function checkoutUrl(lng) {
	  if (lng.indexOf('CH') > -1 || lng.indexOf('BE') > -1) {
	    if (lng.indexOf('de') > -1) {
	      return '/de';
	    } else if (lng.indexOf('fr') > -1) {
	      return '/fr';
	    }
	    return '/nl';
	  }
	  return '';
	};
	
	function buy(cfg, smp, lng) {
	  var url = checkoutUrl(lng);
	  return $.post(url + '/checkout/cart/add', {
	    sku: [cfg + ';' + smp],
	    qty: 1
	  }).then(function (res) {
	    $.publish('update.header:cart', res.cartItemsCount);
	    window.location.pathname = url + '/checkout/cart';
	    return 'ADDED';
	  });
	}
	
	var removeEventListenerToBuyButton = exports.removeEventListenerToBuyButton = function removeEventListenerToBuyButton(selector) {
	  var element = document.getElementById(selector);
	  $(element).off();
	};
	
	var addEventListenerToBuyButton = function addEventListenerToBuyButton(_ref) {
	  var selector = _ref.selector,
	      cfg = _ref.cfg,
	      smp = _ref.smp,
	      price = _ref.price,
	      name = _ref.name,
	      variant = _ref.variant,
	      currencyCode = _ref.currencyCode,
	      lng = _ref.lng;
	
	  var element = document.getElementById(selector);
	  element.addEventListener('click', function () {
	    buy(cfg, smp, lng).then(function () {
	      dataLayer.push({
	        event: _events.ADDTOCART,
	        ecommerce: {
	          currencyCode: currencyCode,
	          add: {
	            products: [{
	              name: name,
	              id: smp,
	              price: price,
	              brand: '',
	              category: '',
	              dimension65: 'inline_qv',
	              variant: variant,
	              quantity: 1
	            }]
	          }
	        }
	      });
	    });
	  });
	};
	
	exports.default = addEventListenerToBuyButton;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getArticleData = getArticleData;
	
	var _helpers = __webpack_require__(39);
	
	var _selectors = __webpack_require__(25);
	
	function getArticleData() {
	  var _appDomainProvider = (0, _helpers.appDomainProvider)(),
	      lngcode = _appDomainProvider.lngcode;
	
	  var dataElement = document.getElementById(_selectors.DATA);
	  if (!dataElement) {
	    return {};
	  }
	  var object = Object.assign({ lngcode: lngcode }, JSON.parse(dataElement.innerHTML));
	  var selectedChildSku = dataElement.getAttribute(_selectors.SELECTEDSKUATTRIBUTE);
	  var childrenAsArray = Object.keys(object.children).map(function (child) {
	    return object.children[child];
	  });
	  var selectedChild = childrenAsArray.find(function (child) {
	    return child.sku === selectedChildSku;
	  });
	
	  var arr = Object.keys(object.children);
	  var otherSkus = {};
	  arr.forEach(function (name) {
	    otherSkus[name] = {
	      sku: object.children[name].sku,
	      isSellable: object.children[name].isSellable,
	      selectedMvcAttributes: object.children[name].selectedMvcAttributes
	    };
	  });
	  var preferedSimple = arr.find(function (key) {
	    return object.children[key].sku === selectedChild.sku;
	  });
	  return {
	    lngcode: lngcode,
	    defaultSimple: preferedSimple,
	    cfg: object.parent.sku,
	    isSellable: selectedChild.isSellable,
	    smp: selectedChild.sku,
	    stars: {
	      isVisible: object.parent.rating.isVisible,
	      amount: object.parent.rating.amountOfReviews,
	      valueInPercentage: object.parent.rating.valueInPercentage
	    },
	    name: selectedChild.name,
	    variantName: selectedChild.variantName,
	    url: selectedChild.url,
	    price: {
	      sellPrice: selectedChild.price.sellPrice.single,
	      trackingPrice: selectedChild.price.trackingPrice.single,
	      isReduced: selectedChild.price.isReduced,
	      originalPrice: selectedChild.price.originalPrice === null ? null : selectedChild.price.originalPrice.single,
	      priceDifference: selectedChild.price.priceDifference,
	      isRecommended: selectedChild.price.isRecommended,
	      currency: selectedChild.price.currency
	    },
	    isValuePack: selectedChild.labels && selectedChild.labels.some(function (label) {
	      return label === 'valuePack';
	    }),
	    delivery: {
	      isFastDelivery: selectedChild.delivery.isFastDelivery,
	      translated: selectedChild.delivery.translated
	    },
	    images: selectedChild.images,
	    mvcAttributes: object.mvcAttributes,
	    selectedMvcAttributes: selectedChild.selectedMvcAttributes,
	    campaigns: selectedChild.campaigns && selectedChild.campaigns.length > 0 ? selectedChild.campaigns : [],
	    otherSkus: otherSkus
	  };
	}

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.add = add;
	exports.remove = remove;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WishlistService() {
	  this.urls = {
	    add: config.getBaseUrl() + '/myaccount/wishlist/add',
	    remove: config.getBaseUrl() + '/myaccount/wishlist/remove'
	  };
	
	  _jquery2.default.subscribe('add.wishlistService', this.onAdd.bind(this));
	  _jquery2.default.subscribe('remove.wishlistService', this.onRemove.bind(this));
	}
	
	WishlistService.prototype = {
	  /**
	   * add sku to wishlist
	   * @param sku
	   * @returns Promise
	   */
	  add: function add(sku) {
	    return this._send('add', sku);
	  },
	
	  /**
	   * remove sku from wishlist
	   * @param sku
	   * @returns Promise
	   */
	  remove: function remove(sku) {
	    return this._send('remove', sku);
	  },
	
	  onAdd: function onAdd(e, data) {
	    this._send('add', data.sku);
	  },
	
	  onRemove: function onRemove(e, data) {
	    return this._send('remove', data.sku);
	  },
	
	  _send: function _send(action, sku) {
	    return this._sendAjax(action, sku).done(function (data) {
	      if (data && _underscore2.default.isNumber(data.wishlistItemsCount)) {
	        _jquery2.default.publish('update.wishlist:counter', data);
	      }
	
	      if (action === 'add') {
	        _jquery2.default.publish('added.wishlistService', { sku: sku });
	      } else if (action === 'remove') {
	        _jquery2.default.publish('removed.wishlistService', { sku: sku });
	      }
	
	      return data;
	    });
	  },
	
	  _sendAjax: function _sendAjax(action, sku) {
	    return _jquery2.default.ajax({
	      method: 'POST',
	      url: this.urls[action],
	      dataType: 'json',
	      data: {
	        sku: sku
	      }
	    });
	  }
	};
	
	var wishlistService = new WishlistService();
	
	function add(sku) {
	  return wishlistService.add(sku);
	}
	
	function remove(sku) {
	  return wishlistService.remove(sku);
	}

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasTouch = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var touch = {
	  /**
	   * @type {Object}
	   */
	  selectors: {
	    linksToDisable: 'a[data-disable-href-touch=true]'
	  },
	
	  $body: null,
	
	  init: function init() {
	    var self = this;
	
	    this.$body = (0, _jquery2.default)('body');
	    this.hasTouch = this.hasTouchFunc();
	
	    for (var eventName, newEventName, i = 0, len = this.addNotTouchEvents.length; i < len; i++) {
	      eventName = this.addNotTouchEvents[i];
	      newEventName = this.addNotTouchEvents[i] + '-not-touch';
	
	      _jquery2.default.event.special[newEventName] = {
	        delegateType: eventName,
	        bindType: eventName,
	        handle: function handle(event) {
	          var handleObj = event.handleObj;
	          var ret = null;
	
	          if (!self.isLastEventTouch) {
	            ret = handleObj.handler.apply(this, arguments);
	          }
	
	          return ret;
	        }
	      };
	    }
	
	    // mouseenter and mouseleave are special $ events
	    // We need to modify them in other way
	    _jquery2.default.event.special['mouseenter-not-touch'] = {
	      bindType: 'mouseover',
	      delegateType: 'mouseover',
	      handle: function handle() {
	        var ret = null;
	
	        if (!self.isLastEventTouch) {
	          ret = _jquery2.default.event.special.mouseenter.handle.apply(this, arguments);
	        }
	
	        return ret;
	      }
	    };
	
	    _jquery2.default.event.special['mouseleave-not-touch'] = {
	      bindType: 'mouseout',
	      delegateType: 'mouseout',
	      handle: function handle() {
	        var ret = null;
	
	        if (!self.isLastEventTouch) {
	          ret = _jquery2.default.event.special.mouseleave.handle.apply(this, arguments);
	        }
	
	        return ret;
	      }
	    };
	
	    if (this.hasTouch) {
	      this.$body.on('mousemove', _jquery2.default.proxy(this.mouseEventHappened, this));
	      this.$body.on('touchstart.bodyTouch', _jquery2.default.proxy(this.touchEventHappened, this));
	      this.touchEventHappened();
	    } else {
	      this.$body.addClass('is-desktop');
	    }
	  },
	  mouseEventHappened: function mouseEventHappened() {
	    this.$body.on('touchstart.bodyTouch', _jquery2.default.proxy(this.touchEventHappened, this));
	    this.timesMousemoveCalled++;
	    if (this.isLastEventTouch && this.timesMousemoveCalled > 2) {
	      this.$body.off('click', this.selectors.linksToDisable, this.disableHrefOnTouch);
	      this.$body.addClass('is-desktop');
	      this.isLastEventTouch = false;
	    }
	  },
	
	  touchEventHappened: function touchEventHappened() {
	    if (!this.isLastEventTouch) {
	      this.$body.on('click', this.selectors.linksToDisable, this.disableHrefOnTouch);
	      this.$body.removeClass('is-desktop');
	    }
	    this.isLastEventTouch = true;
	    this.timesMousemoveCalled = 0;
	    this.$body.off('.bodyTouch');
	  },
	
	  disableHrefOnTouch: function disableHrefOnTouch(e) {
	    // call e.preventDefault(); to prevent redirection on link
	    e.preventDefault();
	
	    return false;
	  },
	
	  hasTouchFunc: function hasTouchFunc() {
	    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	  },
	
	  hasTouch: false,
	
	  isLastEventTouch: false,
	
	  addNotTouchEvents: ['mouseover', 'mousemove', 'mousedown', 'mouseup', 'click', 'mouseout'],
	
	  timesMousemoveCalled: 0
	};
	
	touch.init();
	
	var hasTouch = exports.hasTouch = touch.hasTouch;

/***/ },
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./validation-1.js": 234,
		"./validation-2.js": 235,
		"./validation-3.js": 236,
		"./validation-4.js": 237,
		"./validation-5.js": 238,
		"./validation-6.js": 239,
		"./validation-7.js": 240,
		"./validation-8.js": 241
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 102;


/***/ },
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CartManager;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * cart manager
	 * single place to add products to cart
	 */
	function CartManager() {
	  this._sku = [];
	  this._quantity = 1;
	  this._assemblyServiceSku = '';
	
	  this._onLoadCallback = function () {};
	  this._onSuccessCallback = function () {};
	  this._onErrorCallback = function () {};
	}
	
	CartManager.prototype = {
	  _ajaxUrl: config.getBaseUrl() + '/checkout/cart/add',
	
	  setSku: function setSku(sku) {
	    if (_underscore2.default.isArray(sku)) {
	      this._sku = sku;
	    } else {
	      this._sku.push(sku);
	    }
	
	    return this;
	  },
	
	  setQuantity: function setQuantity(quantity) {
	    this._quantity = parseInt(quantity, 10);
	
	    return this;
	  },
	
	  setAssemblyService: function setAssemblyService(assemblyServiceSku) {
	    this._assemblyServiceSku = assemblyServiceSku;
	
	    return this;
	  },
	
	  onLoad: function onLoad(onLoadCallback) {
	    if (typeof onLoadCallback === 'function') {
	      this._onLoadCallback = onLoadCallback;
	    }
	
	    return this;
	  },
	
	  onSuccess: function onSuccess(onSuccessCallback) {
	    if (typeof onSuccessCallback === 'function') {
	      this._onSuccessCallback = onSuccessCallback;
	    }
	
	    return this;
	  },
	
	  onError: function onError(onErrorCallback) {
	    if (typeof onErrorCallback === 'function') {
	      this._onErrorCallback = onErrorCallback;
	    }
	
	    return this;
	  },
	
	  run: function run() {
	    var that = this;
	    var data;
	
	    that._onLoadCallback();
	
	    data = that._prepareData();
	
	    _jquery2.default.ajax({
	      type: 'POST',
	      url: this._ajaxUrl,
	      data: data,
	      success: function success(d) {
	        that._onSuccessCallback(d);
	      },
	      error: function error(jqXHR, textStatus, errorThrown) {
	        that._onErrorCallback(textStatus, errorThrown);
	      }
	    });
	
	    return this;
	  },
	
	  _prepareData: function _prepareData() {
	    var data = {
	      sku: this._sku,
	      qty: this._quantity
	    };
	
	    if (this._assemblyServiceSku !== '') {
	      data['options[assembly_service]'] = this._assemblyServiceSku;
	    }
	
	    return data;
	  }
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.updateCartItemsCount = updateCartItemsCount;
	exports.init = init;
	exports.showLoadingOverlay = showLoadingOverlay;
	exports.hideLoadingOverlay = hideLoadingOverlay;
	exports.showSuccessOverlay = showSuccessOverlay;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	var _helper = __webpack_require__(63);
	
	var cartHelper = _interopRequireWildcard(_helper);
	
	var _CartOverlayEvents = __webpack_require__(38);
	
	var _CartOverlayEvents2 = _interopRequireDefault(_CartOverlayEvents);
	
	var _cart = __webpack_require__(42);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * shows overlay and results of adding to cart
	 */
	
	var selectors = {
	  ajaxOverlay: '#ajaxOverlay',
	  closeButton: '#js-close-cart-overlay-button'
	};
	
	var $scope = (0, _jquery2.default)('body');
	var $ajaxOverlay;
	var trackingCartOverlay;
	var trackingPixelsAdded = false;
	
	/**
	 * Add ThreatMetrix pixel
	 */
	var addTrackingPixels = function addTrackingPixels() {
	  var trackingPixelsHtml = registry.get('trackingPixelsHtml');
	
	  if (typeof trackingPixelsHtml === 'string') {
	    $scope.append(trackingPixelsHtml);
	  }
	};
	
	/**
	 * show lightbox with html returned from server
	 * @param data
	 */
	var showSuccessLightbox = function showSuccessLightbox(data) {
	  lightbox.setConfig({
	    className: 'pdp-cart-success',
	    onClose: function onClose() {
	      if (trackingCartOverlay) {
	        trackingCartOverlay.destroy();
	        trackingCartOverlay = null;
	      }
	    },
	    repositionOnScreenResize: true
	  }).open(data);
	
	  $scope.find(selectors.closeButton).off('click').on('click', function (event) {
	    event.preventDefault();
	    lightbox.close();
	  });
	
	  if (trackingPixelsAdded === false) {
	    addTrackingPixels();
	    trackingPixelsAdded = true;
	  }
	};
	
	/**
	 * Update number of items in cart in header icon
	 * @param {int} number
	 */
	function updateCartItemsCount(number) {
	  _jquery2.default.publish('update.header:cart', number);
	}
	
	function init($newScope) {
	  if ($newScope && $newScope instanceof _jquery2.default) {
	    $scope = $newScope;
	  }
	  $ajaxOverlay = $scope.find(selectors.ajaxOverlay);
	  trackingPixelsAdded = false;
	}
	
	function showLoadingOverlay() {
	  $ajaxOverlay.show();
	}
	
	function hideLoadingOverlay() {
	  $ajaxOverlay.hide();
	}
	
	function showSuccessOverlay(data) {
	  hideLoadingOverlay();
	
	  if (typeof data.html === 'string' && data.html.length > 0) {
	    showSuccessLightbox(data.html);
	  }
	
	  /** @namespace data.cartItemsCount */
	  if (typeof data.cartItemsCount === 'number') {
	    updateCartItemsCount(data.cartItemsCount);
	  }
	
	  /**
	   * @see REBOOT-14888
	   */
	  if (_typeof(data.trackingData) === 'object') {
	    cartHelper.setOverlayData(data.trackingData);
	    (0, _cart.onArticleAddedToCart)(data.trackingData, 'pdp_product');
	    cartHelper.pushAddToCartOverlayEvent();
	
	    trackingCartOverlay = new _CartOverlayEvents2.default({
	      el: lightbox.getLightboxContainer()
	    });
	  }
	}

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fill = exports.empty = undefined;
	exports.initalRender = initalRender;
	exports.reRender = reRender;
	
	var _app = __webpack_require__(289);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _selectors = __webpack_require__(25);
	
	var s = _interopRequireWildcard(_selectors);
	
	var _classNamesSwiper = __webpack_require__(46);
	
	var _classNamesSwiper2 = _interopRequireDefault(_classNamesSwiper);
	
	var _getArticleData = __webpack_require__(90);
	
	var _addAllListeners = __webpack_require__(252);
	
	var _pictures = __webpack_require__(254);
	
	var _options = __webpack_require__(253);
	
	var _buy = __webpack_require__(89);
	
	var _helpers = __webpack_require__(39);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var empty = exports.empty = function empty(selector, selector2, selector3) {
	  var el = document.querySelector(selector) || document.getElementById(selector) || document.getElementById(selector2) || document.getElementById(selector3);
	  el.innerHTML = '';
	};
	
	var fill = exports.fill = function fill(selector, selector2, selector3, div) {
	  var el = document.querySelector(selector) || document.getElementById(selector) || document.getElementById(selector2) || document.getElementById(selector3);
	  el.innerHTML = div;
	};
	
	function initalRender(data, selector, selector2, selector3) {
	  empty(selector, selector2, selector3);
	  var div = (0, _app2.default)({
	    data: data
	  });
	  fill(selector, selector2, selector3, div);
	}
	
	function reRender(selectedChildSku) {
	  document.getElementById(_selectors.DATA).setAttribute(_selectors.SELECTEDSKUATTRIBUTE, selectedChildSku);
	  var articleData = (0, _getArticleData.getArticleData)();
	  (0, _pictures.removeEventlistenerPictures)();
	  (0, _options.removeEventListenerToOptions)();
	  (0, _buy.removeEventListenerToBuyButton)(s.BUYBUTTON);
	  initalRender(articleData, '.' + _classNamesSwiper2.default.WRAP, (0, _helpers.alternativeDIVprovider)(), (0, _helpers.alternativeDIV2Provider)());
	  (0, _addAllListeners.addAllListener)(articleData);
	}
	
	exports.default = initalRender;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = AddressCheckAddressParser;
	
	var _addressCheckAddressModel = __webpack_require__(31);
	
	var _addressCheckAddressModel2 = _interopRequireDefault(_addressCheckAddressModel);
	
	var _Utils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddressCheckAddressParser(data, ownAddress) {
	  var models = [];
	  var me = this;
	
	  if (!data || data.status === 'ZERO_RESULTS' || data.status === 'UNKNOWN_ERROR' || data.results.length === 0) {
	    return models;
	  }
	  data.results.forEach(function (record) {
	    models.push(me.decoupler(record, ownAddress));
	  });
	
	  return models;
	}
	
	AddressCheckAddressParser.prototype = {
	  _googleAddressHierarchy: {
	    place_id: 'index',
	    formatted_address: 'full',
	    partial_match: 'suggestedAddress',
	    address_components: {
	      route: 'street',
	      street_number: 'streetNumber',
	      postal_code: 'zip',
	      locality: 'city',
	      country: 'country'
	    }
	  },
	
	  decoupler: function decoupler(record, ownAddress) {
	    var matrix = this._googleAddressHierarchy;
	    var key;
	    var type;
	    var streetNumberFirst;
	    var address = new _addressCheckAddressModel2.default();
	
	    for (key in matrix) {
	      if (!matrix.hasOwnProperty(key)) {
	        continue;
	      }
	
	      if (typeof matrix[key] === 'string') {
	        address.set(matrix[key], record[key]);
	      } else if (_typeof(matrix[key]) === 'object') {
	        var types = matrix[key];
	        var components = this._componentsGrabber(record[key]);
	
	        for (type in types) {
	          if (!types.hasOwnProperty(type)) {
	            continue;
	          }
	          address.set(types[type], components[type]);
	        }
	      }
	    }
	
	    streetNumberFirst = address.get('full').indexOf(address.get('streetNumber')) === 0;
	
	    address.set('street', (0, _Utils.format)('{0} {1}', streetNumberFirst ? address.get('streetNumber') : address.get('street'), streetNumberFirst ? address.get('street') : address.get('streetNumber')));
	    address.set('full', address.toString());
	    if (ownAddress) {
	      address.set('ownAddress', address.get('full') === ownAddress.get('full'));
	    } else {
	      address.set('ownAddress', !address.get('suggestedAddress'));
	    }
	
	    return address;
	  },
	
	  _componentsGrabber: function _componentsGrabber(componenstArr) {
	    var components = {};
	    var c;
	
	    componenstArr.forEach(function (component) {
	      for (c in component.types) {
	        if (!component.types.hasOwnProperty(c)) {
	          continue;
	        }
	        components[component.types[c]] = component.long_name;
	      }
	    });
	
	    return components;
	  }
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PopOver;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Create the defaults once
	var helper = 'popOver';
	var helperClass = 'popover-container';
	var defaults = {
	  placement: 'bottom',
	  width: 'auto',
	  height: 'auto',
	  template: '.' + helperClass,
	  parentEl: (0, _jquery2.default)('body'),
	  closeable: false
	};
	var initialHtml = (0, _jquery2.default)('.' + helperClass).html();
	
	function PopOver($element, options) {
	  this.$element = $element;
	  this.options = _jquery2.default.extend({}, defaults, options);
	  this.$el = this.options.parentEl;
	  this._uniqueId = +new Date();
	}
	
	PopOver.prototype = {
	  hide: function hide() {
	    if (this.$target) {
	      this.$target.removeClass('in').hide();
	    }
	    if (initialHtml && initialHtml !== '') {
	      this.$el.find('.' + helperClass).html(initialHtml);
	    }
	  },
	
	  show: function show() {
	    var $target = this.getTarget().addClass(helperClass);
	
	    $target.show();
	    this.displayContent();
	  },
	
	  displayContent: function displayContent() {
	    var elementPos = this.getElementPosition();
	    var $target = this.getTarget().addClass(helperClass);
	    var targetWidth;
	    var targetHeight;
	    var placement;
	
	    $target.detach().css({
	      top: -1999,
	      left: -1999,
	      display: 'block'
	    });
	
	    $target.appendTo(this.$el);
	    targetWidth = $target[0].offsetWidth;
	    targetHeight = $target[0].offsetHeight;
	    placement = this.getPlacement(elementPos);
	
	    var postionInfo = this.getTargetPosition(elementPos, placement, targetWidth, targetHeight);
	
	    this.$target.css(postionInfo.position).addClass(placement).addClass('in');
	
	    var $arrow = this.$target.find('.arrow');
	
	    $arrow.removeAttr('style');
	  },
	
	  getTriggerElement: function getTriggerElement() {
	    return this.$element;
	  },
	
	  getTarget: function getTarget() {
	    if (!this.$target) {
	      var id = helper + this._uniqueId;
	
	      this.$target = this.$el.find(this.options.template).attr('id', id).data('trigger-element', this.getTriggerElement());
	      this.getTriggerElement().attr('data-target', id);
	    }
	
	    return this.$target;
	  },
	
	  getPlacement: function getPlacement() {
	    var placement = this.$element.data('placement') || this.options.placement;
	
	    return placement;
	  },
	
	  getElementPosition: function getElementPosition() {
	    return _jquery2.default.extend({}, this.$element.offset(), {
	      width: this.$element[0].offsetWidth,
	      height: this.$element[0].offsetHeight
	    });
	  },
	
	  getTargetPosition: function getTargetPosition(elementPos, placement, targetWidth, targetHeight) {
	    var pos = elementPos;
	    var position = {};
	
	    switch (placement) {
	      case 'bottom':
	        position = {
	          top: pos.top + pos.height,
	          left: pos.left + pos.width / 2 - targetWidth / 2
	        };
	        break;
	      case 'top':
	        position = {
	          top: pos.top - targetHeight,
	          left: pos.left + pos.width / 2 - targetWidth / 2
	        };
	        break;
	      case 'right':
	        position = {
	          top: pos.top + pos.height / 2 - targetHeight / 2,
	          left: pos.left + pos.width
	        };
	        break;
	
	      case 'left':
	      default:
	        position = {
	          top: pos.top - 15,
	          left: pos.left - targetWidth
	        };
	        break;
	    }
	
	    return {
	      position: position
	    };
	  }
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AddressCheckService;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AddressCheckService(url) {
	  var baseUrl = config.getBaseUrl() + '/myaccount/addresscheck/check';
	
	  this._config = {
	    url: url || baseUrl
	  };
	}
	
	AddressCheckService.prototype = {
	  sendRequest: function sendRequest(addressArray, successHandler, failureFailure) {
	    _jquery2.default.ajax({
	      url: this._config.url,
	      data: addressArray,
	      dataType: 'json',
	      success: successHandler,
	      error: failureFailure
	    });
	  }
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _addressCheckAddressModel = __webpack_require__(31);
	
	var _addressCheckAddressModel2 = _interopRequireDefault(_addressCheckAddressModel);
	
	var _addressCheckPopOverView = __webpack_require__(118);
	
	var _addressCheckPopOverView2 = _interopRequireDefault(_addressCheckPopOverView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  selectors: {},
	
	  events: {
	    'click .address-finder-list li': 'onClickNewAddressItem',
	    'click .close': 'onClickCloseIcon'
	  },
	
	  viewModel: null,
	
	  initialize: function initialize(options) {
	    this.viewModel = options.viewModel;
	    this.addressCheckPopover = new _addressCheckPopOverView2.default(options.parentScope.$el.find('[name=street]'), { placement: 'bottom' });
	  },
	
	  destroy: function destroy() {
	    // COMPLETELY UNBIND THE VIEW
	    if (this._rivetsView) {
	      this._rivetsView.unbind();
	    }
	    this.undelegateEvents();
	    this.$el.removeData().unbind();
	    this.stopListening();
	    this.remove();
	    this.hideAddressFinderPopup();
	  },
	
	  showDialog: function showDialog(viewModel, callback, scope) {
	    this.viewModel = viewModel;
	    this.parentCallback = callback;
	    this.parentScope = scope;
	    this.viewModel.set('addresses', this._highlightDifferencesInFullAddresses(viewModel.get('addresses'), viewModel.get('ownAddress')));
	
	    if (!this._rivetsView) {
	      this._rivetsView = _rivets2.default.bind(this.$el, {
	        model: this.viewModel
	      });
	    }
	
	    this.addressCheckPopover.show();
	  },
	  onClickNewAddressItem: function onClickNewAddressItem(e) {
	    var selectedRecord = $(e.currentTarget);
	
	    this.parentCallback.call(this.parentScope, this.getSelectedAddress(selectedRecord));
	    this.addressCheckPopover.hide();
	  },
	
	  onClickCloseIcon: function onClickCloseIcon() {
	    this.hideAddressFinderPopup();
	  },
	
	  hideAddressFinderPopup: function hideAddressFinderPopup() {
	    if (this.addressCheckPopover) {
	      this.addressCheckPopover.hide();
	    }
	  },
	
	  getSelectedAddress: function getSelectedAddress(selectedRecord) {
	    return this._getAddress(selectedRecord);
	  },
	
	  _getAddress: function _getAddress(selectedRecord) {
	    return new _addressCheckAddressModel2.default({
	      street: selectedRecord.find('[name=street]').text().trim(),
	      streetAdd: selectedRecord.find('[name=streetAdd]').text().trim(),
	      zip: selectedRecord.find('[name=zip]').text().trim(),
	      city: selectedRecord.find('[name=city]').text().trim()
	    });
	  },
	
	  _highlightDifferencesInFullAddresses: function _highlightDifferencesInFullAddresses(addresses, ownAddress) {
	    var i;
	    var length;
	    var c;
	    var address;
	    var compareKey;
	    var component;
	    var compareKeys = ['street', 'streetAdd', 'zip', 'city'];
	
	    for (i = 0, length = addresses.length; i < length; i++) {
	      address = addresses[i];
	
	      for (c = 0; c < compareKeys.length; c++) {
	        compareKey = compareKeys[c];
	        component = address.get(compareKey);
	
	        // compare each component (representation value of compareKey) with own address
	        if (component !== ownAddress.get(compareKey)) {
	          address.set(compareKey, address.get(compareKey).replace(component, '<span class="corrected">' + component + '</span>'));
	        } else {
	          address.set(compareKey, address.get(compareKey));
	        }
	      }
	    }
	
	    return addresses;
	  }
	});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  addresses: [],
	  ownAddress: {},
	  originalResponse: [],
	
	  findByIndex: function findByIndex(index) {
	    var foundItem = false;
	
	    this.get('addresses').forEach(function (item) {
	      if (item.get('index') === index) {
	        foundItem = item;
	
	        return false;
	      }
	    });
	
	    return foundItem;
	  }
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    showWindow: false,
	    securityLevelClass: '',
	    securityLevel: 0,
	    minQuantity: false,
	    minChars: false,
	    minNumber: false,
	    classPrefix: 'level-',
	    passwordLength: {
	      minimum: 6,
	      better: 8,
	      medium: 8,
	      safety: 12
	    },
	    minPasswordLength: 6
	  },
	
	  initialize: function initialize() {
	    this.set('securityLevelClass', this.get('classPrefix') + this.get('securityLevel'));
	  },
	
	  /**
	   * Check password quality with rules and update model
	   *
	   * @param {String} string
	   */
	  check: function check(string) {
	    /**
	     * 1 - Min. 6 characters entered
	     * 2 - At least 1 number included
	     * 3 - At least 1 letter included
	     */
	    var securityLevel = this.getSecurityLevel(string, this.get('passwordLength'));
	    var securityLevelClass = this.get('classPrefix') + securityLevel;
	
	    this.set('securityLevel', securityLevel);
	    this.set('minQuantity', string.length >= this.get('minPasswordLength'));
	    this.set('minChars', /[a-z]/i.test(string));
	    this.set('minNumber', /[0-9]/.test(string));
	    this.set('securityLevelClass', securityLevelClass);
	  },
	
	  /**
	   * Get security level of a password
	   *
	   * @param {String} string
	   * @param {Number} passwordLength
	   * @return (Number) security level, one of: [ 1=bad, 2=sufficient, 3=good, 4=excellent ]
	   */
	  getSecurityLevel: function getSecurityLevel(string, passwordLength) {
	    var level = 0;
	
	    if (!_underscore2.default.isEmpty(string)) {
	      var hasLowercase = string.match(/[a-z]/g) ? true : false;
	      var hasUppercase = string.match(/[A-Z]/g) ? true : false;
	      var hasCharacter = hasLowercase || hasUppercase;
	      var hasUpperLower = hasLowercase && hasUppercase;
	      var hasNumber = string.match(/[0-9]/g) ? true : false;
	      var hasSpecialChars = string.match(/[[\§\$\%\&\/\\\[\]\}\ß\?\.\-\_\"\!]/g) ? true : false;
	      var hasMinLength = string.length >= passwordLength.minimum;
	      var hasBetterLength = string.length >= passwordLength.better;
	      var hasMediumLength = string.length >= passwordLength.medium;
	      var hasSafetyLength = string.length >= passwordLength.safety;
	
	      // not long enough or either letter or number not present
	      if (!(hasMinLength && hasCharacter && hasNumber)) {
	        // level 1, failed
	        level = 1;
	      } else {
	        // sufficient or better levels
	        // ==> sufficient(Level 2)
	        level = 2;
	
	        // ==> good (Level 3)
	        level += hasMediumLength || hasUpperLower || hasSpecialChars ? 1 : 0;
	
	        // ==> excellent (Level 4)
	        level += hasSafetyLength || hasBetterLength && (hasUpperLower || hasSpecialChars) ? 1 : 0;
	      }
	    }
	
	    return level;
	  }
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  /**
	   * @type {$[]}
	   */
	  $teasers: [],
	
	  /**
	   * @type {int}
	   */
	  activeTeaser: 0,
	
	  /**
	   * @type {bool}
	   */
	  blockTransition: false,
	
	  /**
	   * @type {int}
	   */
	  timeout: 0,
	
	  /**
	   * @type {int}
	   */
	  timeoutDelay: config.getInt('marketing.teaser.sliding.intervals.slide'),
	
	  /**
	   * @type {int}
	   */
	  touchStartX: 0,
	
	  /**
	   * @type {Number}
	   */
	  minTouchDistance: config.getInt('marketing.teaser.sliding.touch.distance'),
	
	  initialize: function initialize() {
	    this.preInit();
	
	    if (this.$el.data('timeout-delay')) {
	      this.timeoutDelay = parseInt(this.$el.data('timeout-delay'), 10);
	    }
	
	    this.$teasers = this.$('.iframe[data-external-url], .teaser-element');
	
	    if (this.$teasers.length > 0) {
	      this.seedTeaser();
	
	      this.$teasers.hide();
	      this.$teasers.eq(this.activeTeaser).show();
	    }
	
	    if (this.$teasers.length > 1) {
	      this.$el.on('mouseenter', _jquery2.default.proxy(this.onMouseEnter, this)).on('mouseleave', _jquery2.default.proxy(this.onMouseLeave, this));
	
	      this.restartTimer();
	    } else {
	      this.toGlobalFallback();
	    }
	
	    this.postInit();
	
	    (0, _jquery2.default)(window).on('AdBlockDetected', _jquery2.default.proxy(this.onAdBlockDetected, this));
	  },
	
	  cancelTimer: function cancelTimer() {
	    if (this.timeout) {
	      window.clearInterval(this.timeout);
	    }
	  },
	
	  restartTimer: function restartTimer() {
	    this.cancelTimer();
	    this.timeout = window.setInterval(_jquery2.default.proxy(this.onTimeout, this), this.timeoutDelay);
	  },
	
	  /**
	   * This pre-hook is executed before constructor logic
	   */
	  preInit: function preInit() {},
	
	  /**
	   * This post-hook is executed after constructor logic
	   */
	  postInit: function postInit() {},
	
	  seedTeaser: function seedTeaser() {
	    this.activeTeaser = 0;
	  },
	
	  /**
	   * Handler executed every time adblock is detected.
	   */
	  onAdBlockDetected: function onAdBlockDetected() {
	    if (this.$('.content>.fallback').length > 0) {
	      this.cancelTimer();
	      this.toGlobalFallback();
	    }
	  },
	
	  onMouseEnter: function onMouseEnter() {
	    this.blockTransition = true;
	  },
	
	  onMouseLeave: function onMouseLeave() {
	    this.blockTransition = false;
	  },
	
	  toGlobalFallback: function toGlobalFallback() {},
	
	  postFadeTo: function postFadeTo() {},
	
	  getNextTeaser: function getNextTeaser() {
	    var newActive = this.activeTeaser + 1;
	
	    if (newActive >= this.$teasers.length) {
	      newActive = 0;
	    }
	
	    return newActive;
	  },
	
	  getPrevTeaser: function getPrevTeaser() {
	    var newActive = this.activeTeaser - 1;
	
	    if (newActive < 0) {
	      newActive = this.$teasers.length - 1;
	    }
	
	    return newActive;
	  },
	
	  /**
	   * On touchstart handler for .content element inside teaser
	   * @param {event} event
	   */
	  onTouchStart: function onTouchStart(event) {
	    /*
	     * In case of touch, abort all timing events, since they will interfere with touches
	     */
	    if (this.timeout) {
	      window.clearInterval(this.timeout);
	    }
	    this.touchStartX = Math.round(event.originalEvent.touches[0].pageX);
	  },
	
	  /**
	   * On touchend handler for .content element inside teaser
	   * @param {event} event
	   */
	  onTouchEnd: function onTouchEnd(event) {
	    var iTouchDistance = event.originalEvent.changedTouches[0].pageX - this.touchStartX;
	
	    if (Math.abs(iTouchDistance) > this.minTouchDistance) {
	      if (iTouchDistance > 0) {
	        this.fadeTo(this.getPrevTeaser());
	        this.restartTimer();
	      } else {
	        this.fadeTo(this.getNextTeaser());
	        this.restartTimer();
	      }
	    }
	  }
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    if (this.$el.length > 0) {
	      lightbox.setConfig({
	        $dialog: this.$el,
	        className: 'alternative-country-box'
	      }).open();
	    }
	  }
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileoverview To display easter egg branding information in console log
	 */
	(function () {
	  var _$$data = (0, _jquery2.default)('#h24-client').data(),
	      appDomainId = _$$data.appDomainId;
	
	  var consoleAlias = window.console;
	
	  if (!consoleAlias || !consoleAlias.log || appDomainId === 8) {
	    return undefined;
	  }
	  var message = '%c\n                                                             \n                                                                \n                            `..------..`                        \n                      `-:/+oooooooooooooo+/:-`                  \n                  `-/+oooooooooooooooooooooooo+/-`              \n                -/oooooooooooooooooooooooooooooooo/-            \n             `:+oooooooooooooooooooooooooooooooooooo+:`         \n            -+oooooooooooooooooooooooooooooooooooooooo+-        \n          `+ooooooooooooooooooooooooooo:..-ooooooo+/oooo/`      \n         .ooooooo+/:-...-:+oooooooooo+`    +oooo+.  `oooo+.     \n        -ooooo+:.    `     :oooooooo+`    `oooo+`    +ooooo.    \n       .oooo+-    -/oo+`    /oooooo+`     /oooo-     +oooooo.   \n       +oooo/-.--+ooooo:    .oooooo.     -oooo+     -ooooooo+   \n      -oooooooooooooooo.    .ooooo:     .ooooo-     +oooooooo-  \n      +ooooooooooooooo/     :oooo+     `+oooo+     .ooooooooo/  \n      ooooooooooooooo+`    `ooooo-     /ooooo:     -:--..-:+oo  \n     `oooooooooooooo+`    `+oooo+     `++//:-`     .-::://:+oo` \n      ooooooooooooo/     `+ooooo+         `..     .ooooooooooo  \n      +ooooooooooo:     `+ooooooo+:::://+ooo:     /oooooooooo+  \n      -oooooooooo-     `+ooooooooooooooooooo.     +oooooooooo-  \n       +ooooooo+.     .+oooooooooooooooooooo`    .oooooooooo+   \n       .oooooo+`     .ooooooooooooooooooooo+     /oooooooooo.   \n        -ooooo.     -ooo++//:-...``.-:+oooo/    .oooooooooo-    \n         -oooo.     ```    ``.------../oooo+   -oooooooooo.     \n          `+ooo+:----::/++oooooooooooooooooo++oooooooooo+`      \n            -ooooooooooooooooooooooooooooooooooooooooo+-        \n             `:+oooooooooooooooooooooooooooooooooooo+:`         \n                -+oooooooooooooooooooooooooooooooo/-            \n                  `-/oooooooooooooooooooooooooo/-`              \n                      .-:++oooooooooooooo+/:-.                  \n                           ``..------..``                       \n                                                                \n%c\n _       _         _                 _\n( )  _  ( )       ( )               ( )     _        _\n| | ( ) | |   __  |/  _ __   __     | |__  (_) _ __ (_)  ___     __\n| | | | | | /\'__`\\   ( \'__)/\'__`\\   |  _ `\\| |( \'__)| |/\' _ `\\ /\'_ `\\\n| (_/ \\_) |(  ___/   | |  (  ___/   | | | || || |   | || ( ) |( (_) |\n`\\___x___/\'`\\____)   (_)  `\\____)   (_) (_)(_)(_)   (_)(_) (_)`\\__  |\n                                                              ( )_) |\n                                                               \\___/\'\n\nCheck out the open positions in our Berlin office at %chttp://www.home24.de/jobs%c\n\n\n';
	
	  consoleAlias.log(message, 'color: #f5674c', 'color: #354044', 'color: #f5674c', 'color: #354044');
	
	  return undefined;
	})();

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * message about cookie policy
	 */
	exports.default = _baseView2.default.extend({
	  events: {
	    'click .js-cookie-message__button': 'onCloseClick'
	  },
	
	  onCloseClick: function onCloseClick(event) {
	    _jquery2.default.ajax({
	      type: 'GET',
	      url: (0, _jquery2.default)(event.currentTarget).data('href')
	    });
	    this.$el.addClass('is-hidden');
	  }
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HelpAreaChat;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HelpAreaChat() {
	  this.$container = (0, _jquery2.default)('.js-helparea-container');
	  this.template = (0, _jquery2.default)('.js-helparea-template').html();
	  this.chatTitleTemplate = (0, _jquery2.default)('.js-helparea-title-template').html();
	
	  this.snapEngage = window.SnapEngage;
	  this.snapEngageChat = window.SnapEngageChat;
	
	  this.setSettingsToChat();
	  this.bindEvents();
	
	  if (!this.snapEngage.isChatInProgess()) {
	    this.showChatButton();
	  }
	}
	
	_jquery2.default.extend(HelpAreaChat.prototype, {
	  bindEvents: function bindEvents() {
	    this.snapEngage.setCallback('Open', this.onChatOpen.bind(this));
	    this.snapEngage.setCallback('OpenProactive', this.onChatOpenProactive.bind(this));
	    this.snapEngage.setCallback('Close', this.onChatClose.bind(this));
	    this.snapEngage.setCallback('MessageSubmit', this.onMessageSubmit.bind(this));
	    this.snapEngage.setCallback('StartChat', this.onStartChat.bind(this));
	    this.snapEngage.setCallback('ChatMessageSent', this.onChatMessageSent.bind(this));
	    this.snapEngage.setCallback('ChatMessageReceived', this.onChatMessageReceived.bind(this));
	    this.snapEngage.setCallback('StartCallme', this.onStartCall.bind(this));
	  },
	  setSettingsToChat: function setSettingsToChat() {
	    this.snapEngage.allowProactiveChat(true);
	    this.snapEngage.allowChatSound(true);
	    this.snapEngageChat.setTitle(this.chatTitleTemplate);
	  },
	
	  showChatButton: function showChatButton() {
	    this.$container.html(this.template);
	    this.$container.find('.js-helparea-chat').on('click', this.snapEngage.startLink);
	  },
	  hideChatButton: function hideChatButton() {
	    this.$container.empty();
	  },
	
	  remove: function remove() {
	    this.showChatButton();
	  },
	
	  onChatOpen: function onChatOpen() {
	    this.hideChatButton();
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatOpen',
	      event: 'ChatMessageOpen'
	    });
	  },
	  onChatOpenProactive: function onChatOpenProactive() {
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatProactive',
	      event: 'ChatProactive'
	    });
	  },
	  onChatClose: function onChatClose(elementClosed) {
	    this.showChatButton();
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatClose',
	      eventLabel: elementClosed,
	      event: 'CloseChat'
	    });
	  },
	  onMessageSubmit: function onMessageSubmit() {
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatMessageSubmit',
	      event: 'ChatMessageSubmit'
	    });
	  },
	  onStartChat: function onStartChat(email, msg, type) {
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatStart',
	      eventLabel: type,
	      event: 'ChatStart'
	    });
	  },
	  onChatMessageSent: function onChatMessageSent() {
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatMessageSent',
	      event: 'ChatMessageSent'
	    });
	  },
	  onChatMessageReceived: function onChatMessageReceived() {
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatMessageReceived',
	      event: 'ChatMessageReceived'
	    });
	  },
	  onStartCall: function onStartCall() {
	    this.pushToDataLayer({
	      eventCategory: 'Chat',
	      eventAction: 'ChatCallme',
	      event: 'ChatCallme'
	    });
	  },
	  pushToDataLayer: function pushToDataLayer(event) {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push(event);
	    }
	  }
	});

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HelpAreaFallback;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HelpAreaFallback() {
	  this.$container = (0, _jquery2.default)('.js-helparea-container');
	  this.$template = (0, _jquery2.default)((0, _jquery2.default)('.js-helparea-fallback-template').html());
	  this.toggleFallbackWindow = this.toggleFallbackWindow.bind(this);
	  this.closeFallbackWindow = this.closeFallbackWindow.bind(this);
	
	  this.showFallbackButton();
	}
	
	_jquery2.default.extend(HelpAreaFallback.prototype, {
	  showFallbackButton: function showFallbackButton() {
	    (0, _jquery2.default)('body').on('click', this.$template, this.toggleFallbackWindow);
	    this.$container.on('click', '.js-helparea-close', this.closeFallbackWindow);
	
	    this.$container.html(this.$template);
	  },
	
	  toggleFallbackWindow: function toggleFallbackWindow(e) {
	    if (this.$template.has(e.target).length === 0 && !this.$template.is(e.target)) {
	      this.$template.removeClass('helparea__wrapper--active');
	    } else {
	      this.$template.addClass('helparea__wrapper--active');
	    }
	  },
	
	  closeFallbackWindow: function closeFallbackWindow(e) {
	    e.stopPropagation();
	
	    this.$template.removeClass('helparea__wrapper--active');
	  }
	});

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = HelpArea;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	var _chat = __webpack_require__(127);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _fallback = __webpack_require__(128);
	
	var _fallback2 = _interopRequireDefault(_fallback);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HelpArea() {
	  this.onLoad = this.onLoad.bind(this);
	  this.snapEngageID = registry.get('snapEngageID');
	  this.timeoutId = null;
	
	  if (this.snapEngageID) {
	    var url = config.get('snapEngage.url').replace('%1', this.snapEngageID);
	
	    _jquery2.default.getScript(url).done(this.onLoad);
	  } else {
	    this.showFallback();
	  }
	}
	
	_jquery2.default.extend(HelpArea.prototype, {
	  onLoad: function onLoad() {
	    var self = this;
	
	    window.SnapEngage.getAgentStatusAsync(function (online) {
	      if (online) {
	        self.showChat();
	      } else {
	        self.showFallback();
	      }
	    });
	  },
	
	  showChat: function showChat() {
	    this.helpAreaChat = new _chat2.default();
	  },
	
	  showFallback: function showFallback() {
	    if (this.isFallbackEnabled()) {
	      this.helpAreaFallback = new _fallback2.default({
	        $container: this.$container,
	        template: this.fallbackTemplate
	      });
	    }
	  },
	
	  isFallbackEnabled: function isFallbackEnabled() {
	    return registry.get('currentLayout') !== 'checkout';
	  }
	});

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bootstrapper = __webpack_require__(8);
	
	var _cookieMessageView = __webpack_require__(126);
	
	var _cookieMessageView2 = _interopRequireDefault(_cookieMessageView);
	
	var _alternativeCountryView = __webpack_require__(124);
	
	var _alternativeCountryView2 = _interopRequireDefault(_alternativeCountryView);
	
	var _newsletterView = __webpack_require__(132);
	
	var _newsletterView2 = _interopRequireDefault(_newsletterView);
	
	var _mainmenu = __webpack_require__(204);
	
	var _mainmenu2 = _interopRequireDefault(_mainmenu);
	
	var _helparea = __webpack_require__(129);
	
	var _helparea2 = _interopRequireDefault(_helparea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 register bootstrap function
	 */
	(0, _bootstrapper.register)(null, function () {
	  new _cookieMessageView2.default({
	    el: $('.cookies-msg')
	  });
	
	  new _alternativeCountryView2.default({
	    el: $('#alternative-country-box')
	  });
	
	  new _newsletterView2.default({
	    el: $('.footer-wrapper')
	  });
	
	  new _mainmenu2.default();
	  new _helparea2.default();
	});

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.uncloakElement = uncloakElement;
	exports.onCloakedMapAreaMouseOver = onCloakedMapAreaMouseOver;
	exports.onCloakedButtonsClick = onCloakedButtonsClick;
	exports.decodeUrl = decodeUrl;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(28);
	
	var _location = __webpack_require__(202);
	
	var _helper = __webpack_require__(20);
	
	var _trackingInstances = __webpack_require__(72);
	
	var trackingInstances = _interopRequireWildcard(_trackingInstances);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dynamicAnchorsAttribute = 'data-dma';
	var selectors = {
	  cloakedElements: 'span[data-dma], div[data-dma]',
	  cloakedButtons: 'button[data-dma]',
	  cloackedMapAreas: '.ma-container'
	};
	
	function init($scope) {
	  if (!$scope) {
	    $scope = (0, _jquery2.default)(document);
	  }
	
	  $scope.on('mousemove.links touch.links touchend.links', selectors.cloakedElements, uncloakElement);
	  $scope.find(selectors.cloackedMapAreas).on('mousemove.links touchend.links', onCloakedMapAreaMouseOver);
	  $scope.find(selectors.cloakedButtons).on('click', onCloakedButtonsClick);
	}
	
	/**
	 * Method wraps element with cloaked url with <a> and propagates all needed events to it
	 * Used with click and touch
	 *
	 * @param {Object} target
	 */
	function uncloakElement(target) {
	  var $currentTarget = target.currentTarget ? (0, _jquery2.default)(target.currentTarget) : (0, _jquery2.default)(target);
	  var dataGtm;
	  var dataGtmBind;
	  var $newElement;
	  var targetAttribute;
	  var touchAttribute;
	  var nofollowAttribute;
	
	  // noinspection JSUnresolvedVariable
	  $currentTarget.off('mousemove.links');
	
	  if (!$currentTarget.attr('href') && !$currentTarget.attr('data-dma-done')) {
	    $currentTarget.attr('data-dma-done', true);
	
	    $newElement = (0, _jquery2.default)('<a></a>');
	    targetAttribute = $currentTarget.attr('data-target');
	    touchAttribute = $currentTarget.attr('data-disable-href-touch');
	    nofollowAttribute = $currentTarget.attr('data-nofollow');
	
	    $newElement.attr('href', decodeUrl($currentTarget.attr(dynamicAnchorsAttribute)));
	    $newElement.attr('class', $currentTarget.attr('class'));
	    $currentTarget.addClass('dma');
	
	    if (targetAttribute) {
	      $newElement.attr('target', targetAttribute);
	    }
	
	    if (touchAttribute) {
	      $newElement.attr('data-disable-href-touch', touchAttribute);
	    }
	
	    if (nofollowAttribute) {
	      $newElement.attr('rel', 'nofollow');
	    }
	
	    $currentTarget.wrap($newElement);
	
	    dataGtm = $currentTarget.attr('data-gtm');
	    dataGtmBind = $currentTarget.attr('data-gtm-bind');
	
	    if (dataGtm !== undefined && dataGtm.length > 0) {
	      $currentTarget.parent().attr('data-gtm', dataGtm).bind('click', function () {
	        (0, _helper.processGtmVariables)((0, _jquery2.default)(this));
	      });
	    }
	
	    if (dataGtmBind !== undefined && dataGtmBind.length > 0) {
	      trackingInstances.get('articleEvents').bindEvents($currentTarget.parent(), dataGtmBind);
	    }
	  }
	}
	
	function onCloakedMapAreaMouseOver(event) {
	  var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	
	  $currentTarget.off('mousemove.links');
	
	  // noinspection JSLint
	  var htmlContent = $currentTarget.html();
	
	  // can happen that attribute data-um doesn't exist
	  var mapName = $currentTarget.find('img').attr('data-um') || '';
	  var mapArea = htmlContent.replace(/data-dmam="(.*?)"/g, function (match, link) {
	    return 'href="' + decodeUrl(link) + '"';
	  }).replace('data-um=', 'usemap=').replace(/<\/span>/gi, '').replace(/<span /gi, '<area ').replace(/data-/gi, '').replace(/<div class="?ma-definition"?.*?>/gi, '<map name="' + mapName.substring(1) + '">').replace(/<\/div>/gi, '</map>');
	
	  $currentTarget.html(mapArea);
	}
	
	function onCloakedButtonsClick(event) {
	  (0, _location.redirect)(decodeUrl((0, _jquery2.default)(event.currentTarget).attr('data-dma')));
	}
	
	/**
	 * decode formated form of a input
	 *
	 * @param {String} input string to decode
	 * @return {String}
	 */
	function decodeUrl(input) {
	  return (0, _base.decode)(input);
	}
	
	init();

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(227);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _validationController = __webpack_require__(13);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'click .footer-subscribe__gift-label': 'onNewsletterLinkClick'
	  },
	
	  initialize: function initialize() {
	    this.$('.newsletter-input').placeholder();
	
	    if (window.location.hash === '#newsletter') {
	      this.showLightbox();
	    }
	  },
	
	  onNewsletterLinkClick: function onNewsletterLinkClick(event) {
	    event.preventDefault();
	    this.showLightbox();
	  },
	
	  showLightbox: function showLightbox() {
	    lightbox.setConfig({
	      $dialog: this.$('.newsletter'),
	      className: 'newsletter'
	    }).open();
	
	    (0, _validationController.reload)();
	  }
	});

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(278);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    this.$clone = this.$el.clone();
	    this.$placeholder = (0, _jquery2.default)(document.createElement('div')).append(this.$clone).addClass('js-sticky-placeholder').insertBefore(this.$el);
	    this.sticky = false;
	    this.toggleScrollListener();
	    this.bindResizeListener();
	  },
	  toggleScrollListener: function toggleScrollListener() {
	    if ((0, _jquery2.default)(window).width() < 768) {
	      this.bindScrollListener();
	    } else {
	      this.unbindScrollListener();
	      this.disableStickyness();
	    }
	  },
	  bindScrollListener: function bindScrollListener() {
	    (0, _jquery2.default)(window).off('scroll.stickybottom').on('scroll.stickybottom', (0, _lodash.throttle)(this.toggleStickyness.bind(this), 16)).trigger('scroll.stickybottom');
	  },
	  unbindScrollListener: function unbindScrollListener() {
	    (0, _jquery2.default)(window).off('scroll.stickybottom');
	  },
	  bindResizeListener: function bindResizeListener() {
	    (0, _jquery2.default)(window).on('resize.stickybottom', (0, _lodash.throttle)(this.toggleScrollListener.bind(this), 16));
	  },
	  toggleStickyness: function toggleStickyness() {
	    var $window = (0, _jquery2.default)(window);
	    var windowScroll = $window.scrollTop();
	    // $window.height() gives incorrect value on mobile devices
	    var windowHeight = window.innerHeight;
	    if (this.sticky) {
	      var placeholderOffsetTop = this.$placeholder.offset().top;
	      var placeholderOuterHeight = this.$placeholder.outerHeight();
	      var placeholderStickyOffset = placeholderOffsetTop + placeholderOuterHeight - windowHeight;
	      if (placeholderStickyOffset < windowScroll) {
	        this.disableStickyness();
	      }
	    } else {
	      var elOffsetTop = this.$el.offset().top;
	      var elOuterHeight = this.$el.outerHeight();
	      var elStickyOffset = elOffsetTop + elOuterHeight - windowHeight;
	      if (elStickyOffset >= windowScroll) {
	        this.enableStickyness();
	      }
	    }
	  },
	  enableStickyness: function enableStickyness() {
	    this.sticky = true;
	    this.$placeholder.addClass('js-sticky-placeholder--active');
	    this.$el.addClass('fixed-to-bottom');
	  },
	  disableStickyness: function disableStickyness() {
	    this.sticky = false;
	    this.$placeholder.removeClass('js-sticky-placeholder--active');
	    this.$el.removeClass('fixed-to-bottom');
	  }
	});

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bootstrapper = __webpack_require__(8);
	
	var _cartView = __webpack_require__(60);
	
	var _cartView2 = _interopRequireDefault(_cartView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('cart', function () {
	  new _cartView2.default({
	    el: $('#cart-main')
	  });
	});

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    requireTaxid: ''
	  },
	
	  initialize: function initialize() {
	    this.on('change:requireTaxid', this.onRequireTaxIdChange, this);
	  },
	
	  onRequireTaxIdChange: function onRequireTaxIdChange(model, value) {
	    model.set('showTaxId', value === '1');
	  }
	});

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _inputsetB2bCompanyModel = __webpack_require__(58);
	
	var _inputsetB2bCompanyModel2 = _interopRequireDefault(_inputsetB2bCompanyModel);
	
	var _inputsetB2bCompanyView = __webpack_require__(59);
	
	var _inputsetB2bCompanyView2 = _interopRequireDefault(_inputsetB2bCompanyView);
	
	var _addressCheckViewController = __webpack_require__(32);
	
	var _addressCheckViewController2 = _interopRequireDefault(_addressCheckViewController);
	
	var _italianTaxId = __webpack_require__(34);
	
	var _italianTaxId2 = _interopRequireDefault(_italianTaxId);
	
	var _phoneNumberFormatterView = __webpack_require__(35);
	
	var _phoneNumberFormatterView2 = _interopRequireDefault(_phoneNumberFormatterView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    new _inputsetB2bCompanyView2.default({
	      el: (0, _jquery2.default)('.js-inputset-b2b-company')[0],
	      model: new _inputsetB2bCompanyModel2.default()
	    });
	
	    new _phoneNumberFormatterView2.default({
	      el: (0, _jquery2.default)('[name="telephone"]')
	    });
	
	    new _addressCheckViewController2.default({
	      el: (0, _jquery2.default)('form.myaccount-address'),
	      scope: (0, _jquery2.default)('body')
	    });
	
	    this.$taxId = (0, _jquery2.default)('.js-tax-id input');
	
	    if (this.$taxId.length) {
	      new _italianTaxId2.default({
	        el: this.$taxId
	      });
	    }
	
	    this.setupRivetsBindings();
	    this.bindEvents();
	  },
	
	  bindEvents: function bindEvents() {
	    if (this.$taxId.length) {
	      this.listenTo(this.model, 'change:showTaxId', this.onShowTaxId, this);
	    }
	  },
	
	  setupRivetsBindings: function setupRivetsBindings() {
	    _rivets2.default.bind(this.$el, {
	      viewModel: this.model
	    });
	  },
	
	  onShowTaxId: function onShowTaxId(model, value) {
	    if (this.$taxId) {
	      this.$taxId.attr('data-validate', value);
	    }
	  }
	});

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _validationController = __webpack_require__(13);
	
	var _translation = __webpack_require__(12);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _cartView = __webpack_require__(60);
	
	var _cartView2 = _interopRequireDefault(_cartView);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _checkoutAddressModel = __webpack_require__(135);
	
	var _checkoutAddressModel2 = _interopRequireDefault(_checkoutAddressModel);
	
	var _checkoutAddressView = __webpack_require__(136);
	
	var _checkoutAddressView2 = _interopRequireDefault(_checkoutAddressView);
	
	var _indexView = __webpack_require__(138);
	
	var _indexView2 = _interopRequireDefault(_indexView);
	
	var _paymentCreditCardView = __webpack_require__(139);
	
	var _paymentCreditCardView2 = _interopRequireDefault(_paymentCreditCardView);
	
	var _paymentInstallmentModel = __webpack_require__(141);
	
	var _paymentInstallmentModel2 = _interopRequireDefault(_paymentInstallmentModel);
	
	var _paymentInstallmentView = __webpack_require__(142);
	
	var _paymentInstallmentView2 = _interopRequireDefault(_paymentInstallmentView);
	
	var _paymentInstallmentAfterPayView = __webpack_require__(140);
	
	var _paymentInstallmentAfterPayView2 = _interopRequireDefault(_paymentInstallmentAfterPayView);
	
	var _paymentModel = __webpack_require__(143);
	
	var _paymentModel2 = _interopRequireDefault(_paymentModel);
	
	var _paymentPostfinanceView = __webpack_require__(144);
	
	var _paymentPostfinanceView2 = _interopRequireDefault(_paymentPostfinanceView);
	
	var _paymentValidationView = __webpack_require__(145);
	
	var _paymentValidationView2 = _interopRequireDefault(_paymentValidationView);
	
	var _paymentView = __webpack_require__(146);
	
	var _paymentView2 = _interopRequireDefault(_paymentView);
	
	var _stickyBottomView = __webpack_require__(133);
	
	var _stickyBottomView2 = _interopRequireDefault(_stickyBottomView);
	
	var _AppDomain = __webpack_require__(23);
	
	var _AppDomain2 = _interopRequireDefault(_AppDomain);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentModel = void 0;
	var installmentModel = void 0;
	
	/*
	 Payment index specific content
	 */
	(0, _bootstrapper.register)('checkout-index', function () {
	  new _cartView2.default({
	    el: $('#checkout-main')
	  });
	
	  new _indexView2.default({
	    el: $('.checkout-index-page')
	  });
	
	  var $takeOrderBox = $('#CheckoutTakeOrderBox');
	
	  if ($takeOrderBox.length > 0) {
	    new _stickyBottomView2.default({
	      el: $takeOrderBox
	    });
	  }
	});
	
	var PAYONE_ERROR_ATTRIBUTE = 'data-payone-error-id';
	
	var PAYMENT_METHODS = {
	  CREDITCARD: 'CREDITCARD',
	  MISTERCASH: 'MISTERCASH'
	};
	
	var PAYONE_SELECTORS = {
	  CREDITCARD: {
	    cardtype: 'creditcard_cardtype_field',
	    cardpan: 'creditcard_cardpan',
	    cardcvc2: 'creditcard_cardcvc2',
	    cardexpiremonth: 'creditcard_cardexpiremonth',
	    cardexpireyear: 'creditcard_cardexpireyear'
	  },
	  MISTERCASH: {
	    cardtype: 'mistercash_cardtype_field',
	    cardpan: 'mistercash_cardpan',
	    cardexpiremonth: 'mistercash_cardexpiremonth',
	    cardexpireyear: 'mistercash_cardexpireyear'
	  }
	};
	
	function clearForm(paymentMethodName) {
	  var selectors = PAYONE_SELECTORS[paymentMethodName] || {};
	
	  _underscore2.default.each(selectors, function (selector) {
	    $('#' + selector).empty();
	  });
	}
	
	function _getCreditCardBaseInputStyle() {
	  if (_AppDomain2.default.isFashionForHome()) {
	    return 'border: 1px solid #bec4c4;margin: 0;font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 0;-moz-border-radius: 0;-ms-border-radius: 0;-o-border-radius: 0;border-radius: 0;display: block;padding: 0 10px;line-height: 38px;line-height: 1em;height: 38px;width: 100%;-webkit-appearance: none;';
	  }
	
	  return 'border: 1px solid #bec4c4;margin: 0;font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 3px;-moz-border-radius: 3px;-ms-border-radius: 3px;-o-border-radius: 3px;border-radius: 3px;display: block;padding: 0 10px;line-height: 38px;line-height: 1em;height: 38px;width: 100%;-webkit-appearance: none;';
	}
	
	/**
	 * Returns description, for select element, based on current theme.
	 *
	 * @param {Object} options
	 * @returns {String}
	 */
	function getSelectStyle() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$width = options.width,
	      width = _options$width === undefined ? '100%' : _options$width;
	
	
	  if (_AppDomain2.default.isFashionForHome()) {
	    // NOTE this one will have no flat border due limitations on the iFrame.
	    return 'height: 38px; width: ' + width + '; padding-left: 6px; padding-right: 6px; font-size: 14px; font-family: "proxima-nova", Arial; color: #2c3638; background-color: #fff; border: 1px solid #565d60; border-radius: 0; outline: none; -webkit-transition: all .2s ease-in-out; transition: all .2s ease-in-out;';
	  }
	
	  return 'border: 1px solid #bec4c4;margin: 0;font-family: Arial,Helvetica,sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 3px;-moz-border-radius: 3px;-ms-border-radius: 3px;-o-border-radius: 3px;border-radius: 3px;background-color: #fff;padding: 5px;line-height: 34px;height: 34px;width: ' + width + ';display: block;padding: 0 0 0 5px;line-height: 38px;line-height: 1em;height: 38px;';
	}
	
	function initCreditcardForm(language) {
	  var $paymentForm = $('.payment');
	  var iframes;
	  var payoneSettings = registry.get('PayoneSettings') || {};
	  var requestSettings = payoneSettings.request;
	  var availableCardTypes = getCardTypes(PAYMENT_METHODS.CREDITCARD);
	
	  var fieldsConfig = {
	    fields: {
	      cardtype: {
	        selector: PAYONE_SELECTORS.CREDITCARD.cardtype,
	        cardtypes: availableCardTypes,
	        style: getSelectStyle({ width: '100%' })
	      },
	      cardpan: {
	        selector: PAYONE_SELECTORS.CREDITCARD.cardpan,
	        type: 'text',
	        iframe: {
	          width: '100%'
	        }
	      },
	      cardcvc2: {
	        selector: PAYONE_SELECTORS.CREDITCARD.cardcvc2,
	        type: 'password',
	        size: '4',
	        maxlength: '4'
	      },
	      cardexpiremonth: {
	        selector: PAYONE_SELECTORS.CREDITCARD.cardexpiremonth,
	        type: 'select',
	        size: '2',
	        maxlength: '2',
	        iframe: {
	          width: '50%'
	        }
	      },
	      cardexpireyear: {
	        selector: PAYONE_SELECTORS.CREDITCARD.cardexpireyear,
	        type: 'select',
	        iframe: {
	          width: '50%'
	        }
	      }
	    },
	    defaultStyle: {
	      input: _getCreditCardBaseInputStyle(),
	      select: getSelectStyle({ width: '95%' }),
	      iframe: {
	        height: '38px',
	        width: '100%'
	      }
	    },
	    language: window.Payone.ClientApi.Language[language]
	  };
	
	  clearForm(PAYMENT_METHODS.CREDITCARD);
	
	  iframes = new window.Payone.ClientApi.HostedIFrames(fieldsConfig, requestSettings);
	
	  $paymentForm.on('submit', function () {
	    var isCreditcardSelected = paymentModel.get('paymentMethod') === PAYMENT_METHODS.CREDITCARD;
	    var isCreditcardFormVisible = paymentModel.get('creditCardFormVisible');
	
	    if (!(isCreditcardSelected && isCreditcardFormVisible)) return true;
	
	    if (iframes.isComplete() && $paymentForm.valid()) {
	      $paymentForm.find('button[type="submit"]').prop('disabled', true);
	      clearFormError();
	      iframes.creditCardCheck('checkCreditCardCallback');
	    } else {
	      showEmptyFormError();
	    }
	
	    return false;
	  });
	
	  window.checkCreditCardCallback = function (response) {
	    $paymentForm.find('button[type="submit"]').prop('disabled', false);
	    if (response.status === 'VALID') {
	      $('#creditcard_pseudocardpan').val(response.pseudocardpan);
	      $('#creditcard_truncatedcardpan').val(response.truncatedcardpan);
	      $('#creditcard_cardexpiredate').val(response.cardexpiredate);
	      $('#creditcard_cardtype').val(response.cardtype);
	
	      $paymentForm.off('submit');
	      $paymentForm.submit();
	    } else {
	      showFormError(response.errormessage, response.errorcode);
	    }
	  };
	}
	
	function initMisterCashForm(language) {
	  var $paymentForm = $('.payment');
	  var iframes;
	  var payoneSettings = registry.get('PayoneSettings') || {};
	  var requestSettings = payoneSettings.request;
	  var availableCardTypes = getCardTypes(PAYMENT_METHODS.MISTERCASH);
	
	  var fieldsConfig = {
	    fields: {
	      cardtype: {
	        cardtypes: availableCardTypes,
	        selector: PAYONE_SELECTORS.MISTERCASH.cardtype,
	        iframe: {
	          width: '1px',
	          height: '1px'
	        }
	      },
	      cardpan: {
	        selector: PAYONE_SELECTORS.MISTERCASH.cardpan,
	        type: 'text',
	        iframe: {
	          width: '100%'
	        }
	      },
	      cardexpiremonth: {
	        selector: PAYONE_SELECTORS.MISTERCASH.cardexpiremonth,
	        type: 'select',
	        size: '2',
	        maxlength: '2',
	        iframe: {
	          width: '60px'
	        }
	      },
	      cardexpireyear: {
	        selector: PAYONE_SELECTORS.MISTERCASH.cardexpireyear,
	        type: 'select',
	        iframe: {
	          width: '100px'
	        }
	      }
	    },
	    defaultStyle: {
	      input: 'border: 1px solid #bec4c4;margin: 0;font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #2c3638;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-border-radius: 3px;-moz-border-radius: 3px;-ms-border-radius: 3px;-o-border-radius: 3px;border-radius: 3px;display: block;padding: 0 10px;line-height: 38px;line-height: 1em;height: 38px;width: 100%;-webkit-appearance: none;',
	      select: getSelectStyle({ width: '95%' }),
	      iframe: {
	        height: '38px',
	        width: '100%'
	      }
	    },
	    language: window.Payone.ClientApi.Language[language]
	  };
	
	  clearForm(PAYMENT_METHODS.MISTERCASH);
	
	  iframes = new window.Payone.ClientApi.HostedIFrames(fieldsConfig, requestSettings);
	
	  $paymentForm.on('submit', function () {
	    var isMisterCashSelected = paymentModel.get('paymentMethod') === PAYMENT_METHODS.MISTERCASH;
	
	    if (!isMisterCashSelected) return true;
	
	    if (iframes.isComplete()) {
	      $paymentForm.find('button[type="submit"]').prop('disabled', true);
	      clearFormError();
	      iframes.creditCardCheck('checkMistercashCallback');
	    } else {
	      showEmptyFormError();
	    }
	
	    return false;
	  });
	
	  window.checkMistercashCallback = function (response) {
	    $paymentForm.find('button[type="submit"]').prop('disabled', false);
	    if (response.status === 'VALID') {
	      $('#mistercash_pseudocardpan').val(response.pseudocardpan);
	      $('#mistercash_truncatedcardpan').val(response.truncatedcardpan);
	      $('#mistercash_cardexpiredate').val(response.cardexpiredate);
	      $('#mistercash_cardtype').val(response.cardtype);
	
	      $paymentForm.off('submit');
	      $paymentForm.submit();
	    } else {
	      showFormError(response.errormessage, response.errorcode);
	    }
	  };
	}
	
	function setPayoneTranslations(language) {
	  window.Payone.ClientApi.Language[language].placeholders = {
	    cardpan: (0, _translation.get)('ui.checkout.cardNumber'),
	    cvc: (0, _translation.get)('ui.checkout.securityCode'),
	    expireMonth: (0, _translation.get)('ui.checkout.expirationMonth'),
	    expireYear: (0, _translation.get)('ui.checkout.expirationYear')
	  };
	}
	
	function getCardTypes(paymentMethodName) {
	  var payoneSettings = registry.get('PayoneSettings');
	
	  try {
	    return payoneSettings.config[paymentMethodName].cardtypes;
	  } catch (e) {
	    throw new Error('Card types for ' + paymentMethodName + 'payment method is not configured');
	  }
	}
	
	function showFormError(errorMessage, errorId) {
	  var $errorOutput = $('#errorOutput');
	
	  clearFormError();
	
	  if (errorId) {
	    $errorOutput.attr(PAYONE_ERROR_ATTRIBUTE, errorId);
	  }
	
	  $errorOutput.html(errorMessage);
	  $(window).scrollTop($errorOutput.offset().top);
	}
	
	function showEmptyFormError() {
	  showFormError((0, _translation.get)('ui.checkout.error.general'));
	}
	
	function clearFormError() {
	  var $errorOutput = $('#errorOutput');
	
	  $errorOutput.html('');
	  $errorOutput.removeAttr(PAYONE_ERROR_ATTRIBUTE);
	}
	
	/*
	 Payment page specific content
	 */
	(0, _bootstrapper.register)('checkout-payment', function () {
	  var pageLanguage = $('html').attr('lang').match(/(\w+)-/)[1];
	
	  var $creditCardContainer = $('.payment-creditcard');
	  var $postFinanceContainer = $('.js-payment-postfinance');
	  var $installmentContainer = $('.payment-installment-purchase');
	  var $installmentAfterPayContainer = $('.payment-installment-afterpay');
	  var $paymentForm = $('.payment');
	
	  paymentModel = new _paymentModel2.default({
	    creditCardInfo: registry.get('creditCardInfo')
	  });
	
	  if (typeof window.Payone !== 'undefined') {
	    setPayoneTranslations(pageLanguage);
	
	    paymentModel.on('change:paymentMethod', function (model, value) {
	      clearFormError();
	      $paymentForm.find('button[type="submit"]').prop('disabled', false);
	
	      if (value === PAYMENT_METHODS.CREDITCARD) {
	        initCreditcardForm(pageLanguage);
	      } else if (value === PAYMENT_METHODS.MISTERCASH) {
	        initMisterCashForm(pageLanguage);
	      }
	    });
	  }
	
	  new _paymentView2.default({
	    el: $('.checkout-payment-page'),
	    model: paymentModel
	  });
	
	  if ($creditCardContainer.length > 0) {
	    new _paymentCreditCardView2.default({
	      el: $creditCardContainer,
	      model: paymentModel
	    });
	  }
	
	  if ($postFinanceContainer.length > 0) {
	    new _paymentPostfinanceView2.default({
	      el: $postFinanceContainer,
	      model: paymentModel
	    });
	  }
	
	  if ($installmentContainer.length > 0) {
	    installmentModel = new _paymentInstallmentModel2.default({
	      installmentCalculations: registry.get('installmentPurchaseCalculation')
	    });
	
	    new _paymentInstallmentView2.default({
	      el: $installmentContainer,
	      model: installmentModel
	    });
	  }
	
	  if ($installmentAfterPayContainer.length > 0) {
	    new _paymentInstallmentAfterPayView2.default({
	      el: $installmentAfterPayContainer,
	      model: paymentModel
	    });
	  }
	
	  new _paymentValidationView2.default({
	    el: $paymentForm,
	    model: paymentModel
	  });
	
	  var $takeOrderBox = $('#CheckoutTakeOrderBox');
	  if ($takeOrderBox.length > 0) {
	    new _stickyBottomView2.default({
	      el: $takeOrderBox
	    });
	  }
	});
	
	(0, _bootstrapper.register)('checkout-address', function () {
	  new _checkoutAddressView2.default({
	    el: $('.myaccount-address'),
	    model: new _checkoutAddressModel2.default()
	  });
	
	  var $takeOrderBox = $('#CheckoutTakeOrderBox');
	  if ($takeOrderBox.length > 0) {
	    new _stickyBottomView2.default({
	      el: $takeOrderBox
	    });
	  }
	
	  (0, _validationController.reload)();
	});

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'submit .takeorder': 'onFormSubmit'
	  },
	
	  wasFormSend: false,
	
	  onFormSubmit: function onFormSubmit() {
	    if (this.wasFormSend) {
	      return false;
	    }
	    this.wasFormSend = true;
	
	    return true;
	  }
	});

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change [name="payment[creditcard_select]"]': 'onCreditCardChange'
	  },
	
	  selectors: {
	    creditCardRadios: '[name="payment[creditcard_select]"]'
	  },
	
	  initialize: function initialize() {
	    /*
	         Bind rivets
	         */
	    this.binding = _rivets2.default.bind(this.el, {
	      model: this.model
	    });
	
	    /*
	         Handle initial state
	         */
	    this.updatePaymentModelFromView();
	  },
	
	  onCreditCardChange: function onCreditCardChange() {
	    this.updatePaymentModelFromView();
	  },
	
	  updatePaymentModelFromView: function updatePaymentModelFromView() {
	    var $currentRadio = this.$(this.selectors.creditCardRadios).filter(':checked');
	    var cardId;
	    var currentCreditCardType;
	
	    if ($currentRadio.length > 0) {
	      cardId = parseInt($currentRadio.val(), 10);
	
	      if (cardId > 0) {
	        currentCreditCardType = $currentRadio.data('type');
	      } else {
	        currentCreditCardType = null;
	      }
	    } else {
	      cardId = 0;
	    }
	
	    this.model.set({
	      creditCard: cardId,
	      currentCreditCardType: currentCreditCardType
	    });
	  }
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change input[name="payment[installment_afterpay_profile_no]"]': 'showInstallmentDetail',
	    'keyup #payment_installment_afterpay_iban': 'normalizeIbanField',
	    'change #payment_installment_afterpay_iban': 'normalizeIbanField'
	  },
	
	  afterPayBLZUrl: 'https://cdn.afterpay.io/online-services/bank-lookup',
	
	  normalizeIbanField: function normalizeIbanField(event) {
	    var IBAN_REGEX = /^[a-zA-Z]{1,2}\d{0,20}$/;
	    var $iban = (0, _jquery2.default)(event.target);
	    var normalizedIban = $iban.val().replace(/\s/, '').toUpperCase();
	
	    if (normalizedIban.length === 0) {
	      this.model.set('iban', '');
	    }
	
	    if (IBAN_REGEX.test(normalizedIban) === true) {
	      this.model.set('iban', normalizedIban);
	    }
	
	    var iban = this.model.get('iban');
	    $iban.val(iban);
	    this.calculateBankNumber(iban);
	  },
	  calculateBankNumber: function calculateBankNumber(iban) {
	    var IBAN_REGEX = /^[A-Z]{2}\d{20}$/;
	
	    if (IBAN_REGEX.test(iban) === false) return;
	
	    var $submitButton = (0, _jquery2.default)('.payment_submit_button');
	    var $inputWrapper = (0, _jquery2.default)('#payment_installment_afterpay_iban').closest('.input-wrapper');
	    var $bic = (0, _jquery2.default)('#payment_installment_afterpay_bic');
	
	    var country = iban.substr(0, 2).toUpperCase();
	    var end = NaN;
	
	    //check country logic
	    switch (country) {
	      case 'BE':
	        //BEpp bbbk kkkk kkkk
	        end = 2;
	        break;
	      case 'BG':
	        //BGpp bbbb ssss ddkk kkkk kk
	        end = 3;
	        break;
	      case 'DK':
	        //DKpp bbbb kkkk kkkk kk
	        end = 4;
	        break;
	      case 'DE':
	        //DEpp bbbb bbbb kkkk kkkk kk
	        end = 8;
	        break;
	      case 'EE':
	        //EEpp bbkk kkkk kkkk kkkk
	        end = 2;
	        break;
	      case 'FI':
	        //FIpp bbbb bbkk kkkk kP
	        end = 6;
	        break;
	      case 'FR':
	        //FRpp bbbb bsss sskk kkkk kkkk kPP
	        end = 5;
	        break;
	      case 'GR':
	        //GRpp bbb bbbb kkkk kkkk kkkk kkkk
	        end = 7;
	        break;
	      case 'IE':
	        //IEpp bbbb ssss sskk kkkk kkkk
	        end = 4;
	        break;
	      case 'IS':
	        //ISpp bbbb kkkk kkkk xxxx xxxx xx
	        end = 4;
	        break;
	      case 'IT':
	        //ITpp xxxx xxxx xxxx xxxx xxxxx xxx
	        end = 0;
	        break;
	    }
	
	    if (isNaN(end)) return;
	
	    //cut of bank number
	    var blz = iban.substr(4, end);
	
	    _jquery2.default.ajax({
	      url: this.afterPayBLZUrl + '/' + country + '/' + blz,
	      type: 'GET',
	      beforeSend: function beforeSend() {
	        $inputWrapper.prepend((0, _jquery2.default)('<span class="svg-preloader js-remote-validation"></span>'));
	        $submitButton.prop('disabled', true);
	      },
	      complete: function complete(_ref) {
	        var responseJSON = _ref.responseJSON;
	
	        if (Boolean(responseJSON.bic)) {
	          $bic.val(responseJSON.bic);
	        }
	        (0, _jquery2.default)('.js-remote-validation').remove();
	        $submitButton.prop('disabled', false);
	      }
	    });
	  },
	  showInstallmentDetail: function showInstallmentDetail(event) {
	    var profileNo = event.target.value;
	
	    this.$el.find('.js-payment-installment-afterpay-detail').addClass('is-hidden').filter('[data-installment-afterpay-profile-no="' + profileNo + '"]').removeClass('is-hidden');
	  }
	});

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    installmentCalculations: {}
	  },
	
	  /**
	   * @param {int} iNUmberOfRates
	   */
	  load: function load(iNUmberOfRates) {
	    this.set(this.get('installmentCalculations')[iNUmberOfRates]);
	  }
	});

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change [name="payment[installment_purchase_number_of_months]"]': 'updateModel',
	    'click #installmentDetails': 'onDetailsClick',
	    'click .more-label': 'onMoreLabelClick'
	  },
	
	  initialize: function initialize() {
	    /*
	         Bind rivets
	         */
	    this.binding = _rivets2.default.bind(this.el, {
	      installment: this.model
	    });
	
	    this.updateModel();
	  },
	
	  updateModel: function updateModel() {
	    this.model.load(this.$('[name="payment[installment_purchase_number_of_months]"]').val());
	  },
	
	  onDetailsClick: function onDetailsClick() {
	    lightbox.setConfig({
	      $dialog: this.$('#finance-details'),
	      className: 'finance-details'
	    }).open();
	  },
	
	  onMoreLabelClick: function onMoreLabelClick() {
	    this.$('.more-content').removeClass('is-hidden');
	  }
	});

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    paymentMethod: null,
	    creditCard: 0,
	    creditCardFormVisible: true,
	    pfcDescriptionVisible: true,
	    allowedCreditCardTypes: [],
	    show3DSecure: false,
	    '3dSecure': {},
	    currentCreditCardType: null,
	    creditCardInfo: {},
	    iban: ''
	  },
	
	  initialize: function initialize() {
	    var creditCardInfo = this.get('creditCardInfo');
	
	    this.set({
	      allowedCreditCardTypes: _underscore2.default.pluck(creditCardInfo, 'type'),
	      '3dSecure': _underscore2.default.reduce(creditCardInfo, function (memo, el) {
	        memo[el.type] = Boolean(el.is3dSecureUsed);
	
	        return memo;
	      }, {})
	    });
	
	    this.on('change:creditCard', this.onCreditCardChange);
	  },
	
	  onCreditCardChange: function onCreditCardChange(model) {
	    model.set({
	      creditCardFormVisible: model.get('creditCard') === 0
	    });
	
	    if (model.get('creditCardFormVisible')) {
	      model.set({
	        show3dSecure: true
	      });
	    } else {
	      model.set({
	        show3dSecure: Boolean(model.get('3dSecure')[model.get('currentCreditCardType')])
	      });
	    }
	  }
	});

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change [name="payment[onlinebanktransfertype]"]': 'onRadioChange'
	  },
	
	  initialize: function initialize() {
	    /*
	         Bind rivets
	         */
	    this.binding = _rivets2.default.bind(this.el, {
	      model: this.model
	    });
	  },
	
	  onRadioChange: function onRadioChange() {
	    this.model.set({
	      pfcDescriptionVisible: this.$('[name="payment[onlinebanktransfertype]"]:checked').val() === 'PFC'
	    });
	  }
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _validationController = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    this.bindValidation();
	
	    if (this.$('#payment_installment_afterpay_iban').length > 0) {
	      this.listenTo(this.model, 'change:paymentMethod', this.handleIbanValidation.bind(this));
	      this.model.trigger('change:paymentMethod');
	    }
	  },
	
	  handleIbanValidation: function handleIbanValidation() {
	    var ibanField = this.$('#payment_installment_afterpay_iban');
	
	    if (this.model.get('paymentMethod') === 'INSTALLMENT_AFTERPAY') {
	      ibanField.rules('add', {
	        required: true,
	        iban: true
	      });
	      ibanField.attr('data-validate', true).data('validate', true);
	    } else {
	      ibanField.rules('remove');
	      ibanField.attr('data-validate', false).data('validate', false);
	    }
	  },
	
	  bindValidation: function bindValidation() {
	    var self = this;
	    var model = self.model.toJSON();
	    var $fields = this.$el.find('input, select').not('.is-hidden, [type="hidden"]');
	
	    _underscore2.default.each($fields, function (field) {
	      var fieldName = field.name.match(/\[.*]/g)[0].slice(1, -1);
	      var rules = (0, _validationController.getRules)(fieldName);
	      var $field = $(field);
	
	      if ($field.closest('.is-hidden').length === 0) {
	        $field.rules('add', self.collectRulesForField(fieldName, !_underscore2.default.isEmpty(rules), model));
	      } else {
	        $field.rules('remove');
	      }
	
	      $field.validate();
	    });
	  },
	
	  collectRulesForField: function collectRulesForField(fieldName, isApplyRequired, model) {
	    var rules = {};
	
	    if (isApplyRequired) {
	      rules['error.required'] = {
	        rule: function rule() {
	          if (model.creditCardFormVisible === true) {
	            return true;
	          }
	
	          return false;
	        },
	        validationType: 'error',
	        validationMethod: 'required'
	      };
	    }
	
	    if (fieldName === 'eps') {
	      rules['error.required'] = {
	        rule: '#payment_eps:checked',
	        validationType: 'error',
	        validationMethod: 'required'
	      };
	    }
	
	    return rules;
	  }
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _customElements = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change [name="payment[method]"]': 'onUserPaymentMethodChange'
	  },
	
	  selectors: {
	    content: '.checkout-frame',
	    paymentMethodRadios: '[name="payment[method]"]',
	    ibanField: '#payment_installment_afterpay_iban',
	    nextButton: '.acte-payment-next-btn',
	    installmentAfterpayOption: '#payment_installment_afterpay'
	  },
	
	  initialize: function initialize() {
	    /*
	        Setup listeners
	         */
	    this.listenTo(this.model, 'change:paymentMethod', this.onPaymentMethodChange);
	
	    this.updatePaymentModelFromView();
	  },
	
	  updatePaymentModelFromView: function updatePaymentModelFromView() {
	    this.model.set({
	      paymentMethod: this.$(this.selectors.paymentMethodRadios).filter(':checked').val()
	    });
	  },
	
	  onPaymentMethodChange: function onPaymentMethodChange() {
	    this.showCurrentPaymentMethod();
	    // for stickyBottomView to recalculate
	    (0, _jquery2.default)(window).trigger('resize.stickybottom');
	  },
	
	  showCurrentPaymentMethod: function showCurrentPaymentMethod() {
	    this.$(this.selectors.content).addClass('is-hidden');
	    this.$(this.selectors.paymentMethodRadios + '[value="' + this.model.get('paymentMethod') + '"]').prop('checked', true).closest('.checkout-payment-box').find('.checkout-frame').removeClass('is-hidden');
	    (0, _customElements.updateState)();
	  },
	
	  onUserPaymentMethodChange: function onUserPaymentMethodChange() {
	    this.updatePaymentModelFromView();
	  }
	});

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _businessSpecificFormModel = __webpack_require__(57);
	
	var _businessSpecificFormModel2 = _interopRequireDefault(_businessSpecificFormModel);
	
	var _registerFormPrivateCustomerView = __webpack_require__(61);
	
	var _registerFormPrivateCustomerView2 = _interopRequireDefault(_registerFormPrivateCustomerView);
	
	var _PasswordQualityView = __webpack_require__(33);
	
	var _PasswordQualityView2 = _interopRequireDefault(_PasswordQualityView);
	
	var _phoneNumberFormatterView = __webpack_require__(35);
	
	var _phoneNumberFormatterView2 = _interopRequireDefault(_phoneNumberFormatterView);
	
	var _remoteEmailValidation = __webpack_require__(36);
	
	var _remoteEmailValidation2 = _interopRequireDefault(_remoteEmailValidation);
	
	var _loginView = __webpack_require__(148);
	
	var _loginView2 = _interopRequireDefault(_loginView);
	
	var _registerFormBusinessCustomerView = __webpack_require__(149);
	
	var _registerFormBusinessCustomerView2 = _interopRequireDefault(_registerFormBusinessCustomerView);
	
	var _registerFormModel = __webpack_require__(150);
	
	var _registerFormModel2 = _interopRequireDefault(_registerFormModel);
	
	var _registerFormViewModel = __webpack_require__(151);
	
	var _registerFormViewModel2 = _interopRequireDefault(_registerFormViewModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('login', function () {
	  var $loginPage = (0, _jquery2.default)('#checkout-login');
	  var $blockFull = $loginPage.find('#checkout-registration-block-full');
	  var viewModel = new _registerFormViewModel2.default({
	    form: new _registerFormModel2.default(),
	    businessForm: new _businessSpecificFormModel2.default()
	  });
	  var form = viewModel.get('form');
	
	  function getAccountType(model) {
	    return model.attributes.accountType === 'business' ? 'business' : 'private';
	  }
	
	  function getField(model, name) {
	    return $blockFull.find('.js-register-form-' + getAccountType(model) + ' input[name="' + name + '"]');
	  }
	
	  function checkField($field, name, validate) {
	    /*
	     * Handle autocomplete - browser build-in autocomplete doesn't trigger
	     * value change event or update backbone data model.
	     * Here we're handling two cases of autocomplete:
	     * 1. `change:accountType` event which is triggered on view initialize:
	     * we are checking if backbone model is not up-to-date with field value.
	     * 2. Autocomplete when we're focusing email/password field and browser
	     * show a popup to execute autocomplete - then we're manually executing
	     * validation on another autofilled field.
	     */
	    if ($field.val().length > 0) {
	      if (!form.get(name)) {
	        validate = true;
	        form.set(name, $field.val());
	      }
	      validate && $field.valid();
	    }
	  }
	
	  function ensureValidator($field) {
	    var isRuleAdded = 'error.remote' in $field.rules();
	
	    // If you try to add these rules directly you face with weird bugs on business form.
	    // Life is too short
	    if (!isRuleAdded) {
	      new _remoteEmailValidation2.default({ el: $field });
	    }
	  }
	
	  function onFormSwitch(model) {
	    var $email = getField(model, 'email');
	
	    ensureValidator($email);
	
	    checkField($email, 'email', true);
	    checkField(getField(model, 'password'), 'password', true);
	  }
	
	  function onCredentialsChange(model) {
	    checkField(getField(model, 'email'), 'email');
	    checkField(getField(model, 'password'), 'password');
	  }
	
	  form.on('change:accountType', onFormSwitch, undefined);
	  form.on('change:email', onCredentialsChange, undefined);
	  form.on('change:password', onCredentialsChange, undefined);
	
	  new _loginView2.default({
	    el: $loginPage
	  });
	
	  $blockFull.find('form').each(function () {
	    new _PasswordQualityView2.default({
	      el: this
	    });
	  });
	
	  $blockFull.find('[name="telephone"]').each(function () {
	    new _phoneNumberFormatterView2.default({
	      el: this
	    });
	  });
	
	  if ($blockFull.hasClass('js-registration-b2b')) {
	    new _registerFormBusinessCustomerView2.default({
	      el: $blockFull,
	      model: viewModel
	    });
	  } else {
	    new _registerFormPrivateCustomerView2.default({
	      el: $blockFull,
	      model: viewModel
	    });
	  }
	});

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _addressCheckViewController = __webpack_require__(32);
	
	var _addressCheckViewController2 = _interopRequireDefault(_addressCheckViewController);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'click .js-open-registration': 'showRegisterForm',
	    'click .js-forgot-password': 'onForgotPasswordClick'
	  },
	
	  selectors: {
	    blockIntro: '#checkout-registration-block-intro',
	    blockFull: '#checkout-registration-block-full',
	    lightboxDialogForgotPassword: '#myaccount-forgot-pswd'
	  },
	
	  lightboxConfig: {
	    $dialog: null,
	    className: 'myaccount-password-lightbox-spacer'
	  },
	
	  initialize: function initialize(options) {
	    /* istanbul ignore else */
	    if (options.scope) {
	      this.$scope = options.scope;
	    } else {
	      this.$scope = (0, _jquery2.default)('body');
	    }
	  },
	
	  showRegisterForm: function showRegisterForm() {
	    new _addressCheckViewController2.default({
	      el: (0, _jquery2.default)('#view2'),
	      scope: this.$scope
	    });
	
	    new _addressCheckViewController2.default({
	      el: (0, _jquery2.default)('#view3'),
	      scope: this.$scope
	    });
	
	    this.$(this.selectors.blockIntro).addClass('is-hidden');
	    this.$(this.selectors.blockFull).removeClass('is-hidden');
	  },
	
	  onForgotPasswordClick: function onForgotPasswordClick(event) {
	    event.preventDefault();
	
	    this.lightboxConfig.$dialog = this.$scope.find(this.selectors.lightboxDialogForgotPassword);
	
	    /* istanbul ignore else */
	    if (this.lightboxConfig.$dialog.length > 0) {
	      lightbox.setConfig(this.lightboxConfig);
	      lightbox.open();
	    }
	  }
	});

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _eventEmmiter = __webpack_require__(21);
	
	var eventEmitter = _interopRequireWildcard(_eventEmmiter);
	
	var _validationController = __webpack_require__(13);
	
	var _businessSpecificBaseView = __webpack_require__(56);
	
	var _businessSpecificBaseView2 = _interopRequireDefault(_businessSpecificBaseView);
	
	var _registerFormPrivateCustomerView = __webpack_require__(61);
	
	var _registerFormPrivateCustomerView2 = _interopRequireDefault(_registerFormPrivateCustomerView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _businessSpecificBaseView2.default.extend(_registerFormPrivateCustomerView2.default).extend({
	  events: _jquery2.default.extend({}, _registerFormPrivateCustomerView2.default.prototype.events, {
	    'blur [name="telephone"]': 'onTelephoneFieldChange'
	  }),
	
	  selectors: {
	    legalForm: '.js-company-legal-form select',
	    registrationNumberWrapper: '.js-registration-number',
	    companyHolderWrapper: '.js-registration-company-holder',
	    combinedVatFieldsInput: '.js-combined-vat-fields',
	    vatNumberField: '.js-company-vat-number input',
	    hiddenClass: 'is-hidden'
	  },
	
	  initialize: function initialize() {
	    (0, _validationController.reload)();
	    this.$registrationNumber = this.$el.find(this.selectors.registrationNumberWrapper).find('input');
	    this.$companyHolder = this.$el.find(this.selectors.companyHolderWrapper).find('input');
	    this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);
	
	    var businessSpecificModel = this.model.get('businessForm');
	
	    this.$registrationNumber = this.$el.find(this.selectors.registrationNumberWrapper).find('input');
	    this.$companyHolder = this.$el.find(this.selectors.companyHolderWrapper).find('input');
	    this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);
	
	    this.initializeModel(businessSpecificModel);
	    this.addRulesToValidator();
	    this.bindEvents(businessSpecificModel);
	    this.triggerChanges(businessSpecificModel);
	    this.setupRivetsBindings();
	  },
	
	  onRegisterPrivateCustomerSubmit: _registerFormPrivateCustomerView2.default.prototype.onRegisterPrivateCustomerSubmit,
	  removeCompanyFromPrivateCustomer: _registerFormPrivateCustomerView2.default.prototype.removeCompanyFromPrivateCustomer,
	
	  setupRivetsBindings: function setupRivetsBindings() {
	    _rivets2.default.bind(this.$el, {
	      viewModel: this.model
	    });
	  },
	
	  onTelephoneFieldChange: function onTelephoneFieldChange() {
	    eventEmitter.trigger('change:telephoneField');
	  },
	
	  destroy: function destroy() {
	    eventEmitter.off('validationReload', this.addRulesToValidator, this);
	    _baseView2.default.prototype.destroy.call(this);
	  }
	});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _AppDomain = __webpack_require__(23);
	
	var _AppDomain2 = _interopRequireDefault(_AppDomain);
	
	var _normalizers = __webpack_require__(41);
	
	var _normalizers2 = _interopRequireDefault(_normalizers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    accountType: '',
	    showBusinessForm: '',
	    gender: '',
	    city: '',
	    company: '',
	    firstname: '',
	    lastname: '',
	    shippingAddressSimilar: '',
	    street: '',
	    streetAdd: '',
	    telephone: '',
	    zip: '',
	    email: '',
	    password: '',
	    password_quality: '',
	    accept_agb: '',
	    subscribe_to_newsletter: '',
	    requireTaxid: ''
	  },
	
	  initialize: function initialize() {
	    this.bindEvents();
	  },
	
	  bindEvents: function bindEvents() {
	    this.on('change:accountType', this.onAccountTypeChange, this);
	    this.on('change:requireTaxid', this.onRequireTaxIdChange, this);
	    this.on('change:zip', this.fixZipForNL, this);
	  },
	
	  onAccountTypeChange: function onAccountTypeChange(model, value) {
	    if (value !== 'business') {
	      model.set('gender', value);
	      model.set('showBusinessForm', false);
	    } else {
	      model.set('showBusinessForm', true);
	    }
	  },
	
	  onRequireTaxIdChange: function onRequireTaxIdChange(model, value) {
	    model.set('showTaxId', value === '1');
	  },
	
	  fixZipForNL: function fixZipForNL(model, value) {
	    if (_AppDomain2.default.isNL()) {
	      model.set('zip', (0, _normalizers2.default)(value));
	    }
	  }
	});

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    form: null,
	    businessForm: null
	  }
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _addToCart = __webpack_require__(55);
	
	var _addToCart2 = _interopRequireDefault(_addToCart);
	
	var _PasswordQualityView = __webpack_require__(33);
	
	var _PasswordQualityView2 = _interopRequireDefault(_PasswordQualityView);
	
	var _MainView = __webpack_require__(157);
	
	var _MainView2 = _interopRequireDefault(_MainView);
	
	var _OrderListView = __webpack_require__(153);
	
	var _OrderListView2 = _interopRequireDefault(_OrderListView);
	
	var _PreventionModel = __webpack_require__(154);
	
	var _PreventionModel2 = _interopRequireDefault(_PreventionModel);
	
	var _PreventionView = __webpack_require__(155);
	
	var _PreventionView2 = _interopRequireDefault(_PreventionView);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('myaccount-profile', function () {
	  new _MainView2.default({
	    el: (0, _jquery2.default)('#myaccount-wrapper')
	  });
	});
	
	/*
	register bootstrap for
	 */
	(0, _bootstrapper.register)('myaccount-orders', function () {
	  var $element = (0, _jquery2.default)('#reclamation-success-popup');
	
	  if ($element.length > 0) {
	    lightbox.setConfig({
	      $dialog: $element,
	      className: 'reclamation-success-popup'
	    }).open();
	  }
	
	  new _OrderListView2.default({
	    el: (0, _jquery2.default)('#myaccount-main')
	  });
	});
	
	(0, _bootstrapper.register)('myaccount-prevention', function () {
	  var $preventionPage = (0, _jquery2.default)('#prevention-page');
	
	  if ($preventionPage.length > 0) {
	    new _PreventionView2.default({
	      el: $preventionPage,
	      model: new _PreventionModel2.default()
	    });
	  }
	});
	
	(0, _bootstrapper.register)('wishlist', function () {
	  new _addToCart2.default({
	    pageType: 'wishlist'
	  });
	});
	
	(0, _bootstrapper.register)('reset-password', function () {
	  new _PasswordQualityView2.default({
	    el: (0, _jquery2.default)('.myaccount-login-reset')
	  });
	});

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'change .myaccount-select-form select': 'onActionChange',
	    'focus .myaccount-select-form select': 'onActionFocus',
	    'click .js-b2b-cancellation-button': 'onB2bCancelButtonClick',
	    'click .js-ffh-cancellation-button': 'onFfhCancelButtonClick'
	  },
	
	  /**
	   * Submit form and go to reclamation FTTC2 process
	   * @param {Event} e
	   */
	  onActionChange: function onActionChange(e) {
	    var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	    var nodeId = $currentTarget.val();
	
	    switch (nodeId) {
	      case 'b2bCancel':
	        this.openCancellationLightBox((0, _jquery2.default)('.js-b2b-order-cancellation'), 'b2b-order-cancellation');
	        break;
	
	      case 'ffhCancel':
	        this.openCancellationLightBox((0, _jquery2.default)('.js-ffh-order-cancellation'), 'ffh-order-cancellation');
	        break;
	
	      case 'retryPayment':
	        var orderNumber = $currentTarget.closest('form').find('[name="order_number"]').val();
	        this.goToRetryPaymentPage(orderNumber);
	        break;
	
	      default:
	        (0, _jquery2.default)(e.currentTarget).closest('form').submit();
	        break;
	    }
	  },
	
	  /**
	   * By default it is not possible to track a change on a select box
	   * if the same value has been selected. The solution is to select first element of the
	   * select box on select box focus. This makes sure that
	   * every selection (beside the first option) will trigger onchange event on select box.
	   *
	   * @param {Event} e javascript event object
	   */
	  onActionFocus: function onActionFocus(e) {
	    (0, _jquery2.default)(e.currentTarget).children(':first-child').prop('selected', 'selected');
	  },
	
	  onB2bCancelButtonClick: function onB2bCancelButtonClick(e) {
	    e.preventDefault();
	
	    this.openCancellationLightBox((0, _jquery2.default)('.js-b2b-order-cancellation'), 'b2b-order-cancellation');
	  },
	
	  onFfhCancelButtonClick: function onFfhCancelButtonClick(e) {
	    e.preventDefault();
	
	    this.openCancellationLightBox((0, _jquery2.default)('.js-ffh-order-cancellation'), 'ffh-order-cancellation');
	  },
	
	  openCancellationLightBox: function openCancellationLightBox($el, className) {
	    lightbox.setConfig({
	      $dialog: $el,
	      className: className
	    }).open();
	  },
	
	  goToRetryPaymentPage: function goToRetryPaymentPage(orderNumber) {
	    window.location.href = (0, _config.getBaseUrl)() + '/checkout/notification/retry/id/' + orderNumber;
	  }
	});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseModel = __webpack_require__(45);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseModel2.default.extend({
	  defaults: {
	    ajaxUrl: ''
	  },
	
	  onBeforeSend: function onBeforeSend() {
	    this.trigger('showAjaxOverlay');
	  },
	
	  onSuccess: function onSuccess(data) {
	    this.set(data);
	  },
	
	  onError: function onError() {
	    throw new Error('Prevention Page: Update of prices failed');
	  },
	
	  onComplete: function onComplete() {
	    this.trigger('hideAjaxOverlay');
	  },
	
	  sendForm: function sendForm(formData) {
	    _jquery2.default.ajax({
	      url: this.get('ajaxUrl'),
	      type: 'POST',
	      data: formData,
	      beforeSend: _jquery2.default.proxy(this.onBeforeSend, this),
	      success: _jquery2.default.proxy(this.onSuccess, this),
	      error: _jquery2.default.proxy(this.onError, this),
	      complete: _jquery2.default.proxy(this.onComplete, this)
	    });
	  }
	});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _customElements = __webpack_require__(18);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  selectors: {
	    formId: '#prevention-form',
	    ajaxOverlayId: '#ajaxOverlay',
	    statusCheckboxClass: '.js-prevention__status-checkbox',
	    quantitySelectClass: '.js-prevention__quantity-select',
	    rowClass: '.js-prevention__item-row'
	  },
	
	  events: {
	    'click .js-prevention__reject': 'onReject',
	    'click .js-prevention__accept': 'onAccept',
	    'change .js-prevention__status-checkbox': 'onStatusChanged',
	    'change .js-prevention__quantity-select': 'onQuantityChanged'
	  },
	
	  elements: {
	    $form: null,
	    $ajaxOverlay: null
	  },
	
	  isRivetsBindingInitialized: false,
	
	  initialize: function initialize() {
	    this.elements.$form = this.$el.find(this.selectors.formId);
	    this.elements.$ajaxOverlay = (0, _jquery2.default)(this.selectors.ajaxOverlayId);
	
	    this.model.set('ajaxUrl', this.elements.$form.data('ajaxUrl'));
	
	    this.listenTo(this.model, 'showAjaxOverlay', this.showAjaxOverlay);
	    this.listenTo(this.model, 'hideAjaxOverlay', this.hideAjaxOverlay);
	    this.listenTo(this.model, 'change', this.setupRivetsBindings);
	  },
	
	  setupRivetsBindings: function setupRivetsBindings() {
	    if (!this.isRivetsBindingInitialized) {
	      this.isRivetsBindingInitialized = true;
	
	      this.binding = _rivets2.default.bind(this.$el, {
	        model: this.model
	      });
	    }
	  },
	
	  onAccept: function onAccept() {
	    this.elements.$form.submit();
	  },
	
	  onReject: function onReject(event) {
	    event.preventDefault();
	
	    this.elements.$form.find(this.selectors.quantitySelectClass).val(0);
	    this.elements.$form.find(this.selectors.statusCheckboxClass).prop('checked', false);
	    (0, _customElements.updateState)();
	
	    this.elements.$form.submit();
	  },
	
	  onStatusChanged: function onStatusChanged(event) {
	    var $checkbox = (0, _jquery2.default)(event.currentTarget);
	    var $quantitySelect = $checkbox.parents(this.selectors.rowClass).find(this.selectors.quantitySelectClass);
	
	    if ($checkbox.prop('checked')) {
	      $quantitySelect.val($quantitySelect.find('option').last().val());
	    } else {
	      $quantitySelect.val(0);
	    }
	
	    this.model.sendForm(this.elements.$form.serialize());
	  },
	
	  onQuantityChanged: function onQuantityChanged(event) {
	    var $select = (0, _jquery2.default)(event.currentTarget);
	    var $statusCheckbox = $select.parents(this.selectors.rowClass).find(this.selectors.statusCheckboxClass);
	
	    $statusCheckbox.prop('checked', $select.val() !== '0');
	
	    (0, _customElements.updateState)();
	    this.model.sendForm(this.elements.$form.serialize());
	  },
	
	  showAjaxOverlay: function showAjaxOverlay() {
	    this.elements.$ajaxOverlay.show();
	  },
	
	  hideAjaxOverlay: function hideAjaxOverlay() {
	    this.elements.$ajaxOverlay.hide();
	  }
	});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _customElements = __webpack_require__(18);
	
	var _addressCheckViewController = __webpack_require__(32);
	
	var _addressCheckViewController2 = _interopRequireDefault(_addressCheckViewController);
	
	var _addressFormView = __webpack_require__(161);
	
	var _addressFormView2 = _interopRequireDefault(_addressFormView);
	
	var _BaseView = __webpack_require__(37);
	
	var _BaseView2 = _interopRequireDefault(_BaseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseView2.default.extend({
	  events: {
	    'click .edit-address-btn': 'onEditAddressButtonClick',
	    'click .js-myaccount-address-new': 'onNewAddressButtonClick',
	    'change [id^=myaccount-bill-address-], [id^=myaccount-delivery-address-]': 'onCheckboxChange'
	  },
	
	  lightboxesConfig: {
	    newAddressLightbox: {
	      selector: '.js-new-address-lightbox',
	      className: 'myaccount-address-lightbox-spacer',
	      viewClass: _addressFormView2.default
	    }
	  },
	
	  /**
	   * @param {Event} event
	   */
	  onNewAddressButtonClick: function onNewAddressButtonClick(event) {
	    var addressCheck = null;
	
	    event.preventDefault();
	
	    this.openLightboxByName('newAddressLightbox', null, function () {
	      if (addressCheck) {
	        addressCheck.closeSubViews();
	      }
	    });
	
	    addressCheck = new _addressCheckViewController2.default({
	      el: $('#new_address-message-box form'),
	      scope: $('body')
	    });
	  },
	
	  /**
	   * @param {Event} event
	   */
	  onEditAddressButtonClick: function onEditAddressButtonClick(event) {
	    event.preventDefault();
	
	    var addressCheck = null;
	    var lightboxId = '#' + $(event.currentTarget).prop('id') + '-message-lightbox';
	
	    this.openLightboxUsingOptions({
	      selector: lightboxId,
	      className: 'myaccount-address-lightbox-spacer',
	      viewClass: _addressFormView2.default
	    }, function () {
	      if (addressCheck) {
	        addressCheck.closeSubViews();
	      }
	    });
	
	    addressCheck = new _addressCheckViewController2.default({
	      el: $('.lightbox-dialog form[class=myaccount-contact-form]'),
	      scope: $('body')
	    });
	  },
	
	  onCheckboxChange: function onCheckboxChange(event) {
	    var checkBoxType = event.currentTarget.id.split('-');
	    var $otherCheckedCheckboxes = this.$el.find('[id^=' + checkBoxType[0] + '-' + checkBoxType[1] + '-' + checkBoxType[2] + ']' + ':checked').not('#' + event.currentTarget.id);
	
	    // if selected
	    if (event.currentTarget.checked === true) {
	      // unselect others
	      $otherCheckedCheckboxes.prop('checked', false);
	    } else {
	      // if the only one selected
	      if ($otherCheckedCheckboxes.length === 0) {
	        // do not allow to uncheck it
	        this.$el.find('#' + event.currentTarget.id).prop('checked', true);
	      }
	    }
	
	    (0, _customElements.updateState)();
	  }
	});

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validationController = __webpack_require__(13);
	
	var validation = _interopRequireWildcard(_validationController);
	
	var _BaseView = __webpack_require__(37);
	
	var _BaseView2 = _interopRequireDefault(_BaseView);
	
	var _ChangeListOfAddressesView = __webpack_require__(156);
	
	var _ChangeListOfAddressesView2 = _interopRequireDefault(_ChangeListOfAddressesView);
	
	var _PersonalInformationBusinessCustomerView = __webpack_require__(158);
	
	var _PersonalInformationBusinessCustomerView2 = _interopRequireDefault(_PersonalInformationBusinessCustomerView);
	
	var _PersonalInformationView = __webpack_require__(159);
	
	var _PersonalInformationView2 = _interopRequireDefault(_PersonalInformationView);
	
	var _PasswordQualityView = __webpack_require__(33);
	
	var _PasswordQualityView2 = _interopRequireDefault(_PasswordQualityView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = _BaseView2.default.extend({
	  events: {
	    'click #myaccount-change-pswd-btn': 'onChangePasswordButtonClick',
	    'click #myaccount-personal-info-btn': 'onChangePersonalInfoButtonClick',
	    'click #myaccount-list-addresses-btn': 'onChangeListOfAddressesButtonClick'
	  },
	
	  lightboxesConfig: {
	    changePasswordLightbox: {
	      selector: '.js-password-lightbox',
	      className: 'myaccount-pswd-lightbox-spacer',
	      viewClass: _PasswordQualityView2.default
	    },
	    changePersonalInfoLightbox: {
	      selector: '#details-lightbox',
	      className: 'myaccount-personal-details-lightbox-spacer',
	      viewClass: $('#details-lightbox').find('.js-b2b-form').length ? _PersonalInformationBusinessCustomerView2.default : _PersonalInformationView2.default
	    },
	    changeListOfAddressesLightbox: {
	      selector: '#list-addresses-lightbox',
	      className: 'myaccount-addresslist-lightbox-spacer',
	      viewClass: _ChangeListOfAddressesView2.default
	    }
	  },
	
	  initialize: function initialize() {
	    if (window.location.hash === '#edit.data') {
	      this.openLightboxByName('changePersonalInfoLightbox');
	    }
	
	    if (window.location.hash === '#address.book') {
	      this.openLightboxByName('changeListOfAddressesLightbox');
	    }
	  },
	
	  onChangePasswordButtonClick: function onChangePasswordButtonClick(event) {
	    event.preventDefault();
	    this.openLightboxByName('changePasswordLightbox', $.proxy(validation.reload, validation));
	  },
	
	  onChangePersonalInfoButtonClick: function onChangePersonalInfoButtonClick(event) {
	    event.preventDefault();
	    this.openLightboxByName('changePersonalInfoLightbox');
	  },
	
	  onChangeListOfAddressesButtonClick: function onChangeListOfAddressesButtonClick(event) {
	    event.preventDefault();
	    this.openLightboxByName('changeListOfAddressesLightbox');
	  }
	});

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _validationController = __webpack_require__(13);
	
	var _businessSpecificBaseView = __webpack_require__(56);
	
	var _businessSpecificBaseView2 = _interopRequireDefault(_businessSpecificBaseView);
	
	var _businessSpecificFormModel = __webpack_require__(57);
	
	var _businessSpecificFormModel2 = _interopRequireDefault(_businessSpecificFormModel);
	
	var _remoteEmailValidation = __webpack_require__(36);
	
	var _remoteEmailValidation2 = _interopRequireDefault(_remoteEmailValidation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _businessSpecificBaseView2.default.extend({
	  selectors: {
	    legalForm: '.js-company-legal-form select',
	    registrationNumberWrapper: '.js-registration-number',
	    companyHolderWrapper: '.js-registration-company-holder',
	    combinedVatFieldsInput: '.js-combined-vat-fields',
	    vatNumberField: '.js-company-vat-number input',
	    hiddenClass: 'is-hidden'
	  },
	
	  initialize: function initialize() {
	    this.model = new _businessSpecificFormModel2.default();
	
	    this.$registrationNumber = this.$el.find(this.selectors.registrationNumberWrapper).find('input');
	    this.$companyHolder = this.$el.find(this.selectors.companyHolderWrapper).find('input');
	    this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);
	
	    this.$registrationNumber = this.$el.find(this.selectors.registrationNumberWrapper).find('input');
	    this.$companyHolder = this.$el.find(this.selectors.companyHolderWrapper).find('input');
	    this.$vatNumberField = this.$el.find(this.selectors.vatNumberField);
	
	    this.initializeModel(this.model);
	    this.bindEvents(this.model);
	
	    (0, _validationController.reload)();
	
	    this.triggerChanges(this.model);
	    this.setupRivetsBindings();
	
	    var $email = this.$('[name="email"]');
	
	    if ($email.length > 0) {
	      new _remoteEmailValidation2.default({
	        el: $email
	      });
	    }
	  },
	
	  setupRivetsBindings: function setupRivetsBindings() {
	    _rivets2.default.bind(this.$el, {
	      businessCustomer: this.model
	    });
	  },
	
	  destroy: function destroy() {
	    this.unbindEvents(this.model);
	    _backbone2.default.View.prototype.remove.call(this);
	  }
	});

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _remoteEmailValidation = __webpack_require__(36);
	
	var _remoteEmailValidation2 = _interopRequireDefault(_remoteEmailValidation);
	
	var _validationController = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    (0, _validationController.reload)();
	
	    var $email = this.$('[name="email"]');
	
	    if ($email.length > 0) {
	      new _remoteEmailValidation2.default({
	        el: $email
	      });
	    }
	  }
	});

/***/ },
/* 160 */
135,
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _validationController = __webpack_require__(13);
	
	var _inputsetB2bCompanyModel = __webpack_require__(58);
	
	var _inputsetB2bCompanyModel2 = _interopRequireDefault(_inputsetB2bCompanyModel);
	
	var _inputsetB2bCompanyView = __webpack_require__(59);
	
	var _inputsetB2bCompanyView2 = _interopRequireDefault(_inputsetB2bCompanyView);
	
	var _italianTaxId = __webpack_require__(34);
	
	var _italianTaxId2 = _interopRequireDefault(_italianTaxId);
	
	var _phoneNumberFormatterView = __webpack_require__(35);
	
	var _phoneNumberFormatterView2 = _interopRequireDefault(_phoneNumberFormatterView);
	
	var _addressFormModel = __webpack_require__(160);
	
	var _addressFormModel2 = _interopRequireDefault(_addressFormModel);
	
	var _BaseView = __webpack_require__(37);
	
	var _BaseView2 = _interopRequireDefault(_BaseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseView2.default.extend({
	  selectors: {
	    companyInputset: '.js-inputset-b2b-company',
	    defaultBillingAddressCheckboxWrapper: '.js-address-form-billing-address-checkbox-wrapper',
	    defaultBillingAddressCheckbox: '.js-address-form-billing-address-checkbox',
	    phoneField: '[name="telephone"]',
	    hiddenClass: 'is-hidden',
	    taxId: '.js-tax-id input'
	  },
	
	  events: {
	    'change .js-address-form-billing-address-checkbox': 'onCheckboxChange'
	  },
	
	  initialize: function initialize(options) {
	    /* istanbul ignore else */
	    if (options && options.scope) {
	      this.$scope = options.scope;
	    } else {
	      this.$scope = (0, _jquery2.default)('body');
	    }
	
	    this.model = new _addressFormModel2.default();
	    this.inputsetB2bCompanyModel = new _inputsetB2bCompanyModel2.default();
	
	    this.$defaultBillingAddressCheckboxWrapper = this.$el.find(this.selectors.defaultBillingAddressCheckboxWrapper);
	    this.$defaultBillingAddressCheckbox = this.$el.find(this.selectors.defaultBillingAddressCheckbox);
	    this.inputsetB2bCompanyModel.set('isCheckedBillingAddressCheckbox', Boolean(this.$defaultBillingAddressCheckbox.prop('checked')));
	
	    new _inputsetB2bCompanyView2.default({
	      el: this.$el.find(this.selectors.companyInputset),
	      model: this.inputsetB2bCompanyModel
	    });
	
	    new _phoneNumberFormatterView2.default({
	      el: this.$el.find(this.selectors.phoneField)
	    });
	
	    this.$taxId = this.$el.find(this.selectors.taxId);
	
	    if (this.$taxId) {
	      this.taxId = new _italianTaxId2.default({
	        el: this.$taxId
	      });
	    }
	
	    this.setupRivetsBindings();
	    this.bindEvents();
	    (0, _validationController.reload)();
	  },
	
	  bindEvents: function bindEvents() {
	    this.listenTo(this.inputsetB2bCompanyModel, 'change:hiddenInputValue', this.onChangeValue, this);
	    if (this.$taxId.length) {
	      this.listenTo(this.model, 'change:showTaxId', this.onShowTaxId, this);
	    }
	  },
	
	  setupRivetsBindings: function setupRivetsBindings() {
	    _rivets2.default.bind(this.$el, {
	      viewModel: this.model
	    });
	  },
	
	  onChangeValue: function onChangeValue(model, value) {
	    if (value === model.get('customerCompanyValue')) {
	      this.showCheckbox();
	    } else {
	      this.hideCheckbox();
	    }
	  },
	
	  onCheckboxChange: function onCheckboxChange(e) {
	    this.inputsetB2bCompanyModel.set('isCheckedBillingAddressCheckbox', Boolean((0, _jquery2.default)(e.target).prop('checked')));
	  },
	
	  showCheckbox: function showCheckbox() {
	    this.$defaultBillingAddressCheckboxWrapper.removeClass(this.selectors.hiddenClass);
	    this.$defaultBillingAddressCheckbox.prop('checked', this.inputsetB2bCompanyModel.get('isCheckedBillingAddressCheckbox'));
	  },
	
	  hideCheckbox: function hideCheckbox() {
	    this.$defaultBillingAddressCheckboxWrapper.addClass(this.selectors.hiddenClass);
	    this.$defaultBillingAddressCheckbox.prop('checked', false);
	  },
	
	  onShowTaxId: function onShowTaxId(model, value) {
	    if (this.$taxId) {
	      this.$taxId.attr('data-validate', value);
	    }
	  }
	});

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _customElements = __webpack_require__(18);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_rivets2.default.binders['background-image'] = function (el, value) {
	  if (value) {
	    if (value === 'none') {
	      el.style.backgroundImage = 'none';
	    } else {
	      el.style.backgroundImage = "url('" + value + "')";
	    }
	  }
	};
	
	_rivets2.default.binders['custom-checked'] = {
	  publishes: true,
	  priority: 2000,
	  bind: function bind(el) {
	    _rivets2.default._.Util.bindEvent(el, 'change', this.publish);
	  },
	  unbind: function unbind(el) {
	    _rivets2.default._.Util.bindEvent(el, 'change', this.publish);
	  },
	  routine: function routine(el, value) {
	    if (el.type === 'radio') {
	      el.checked = (el.value != null ? el.value.toString() : 0) === (value != null ? value.toString() : 0);
	    } else {
	      el.checked = Boolean(value);
	    }
	
	    (0, _customElements.updateState)();
	
	    return el.checked;
	  }
	};
	
	_rivets2.default.binders.width = function (el, value) {
	  el.style.width = value + 'px';
	};
	
	_rivets2.default.binders.left = function (el, value) {
	  if (value !== undefined && value !== null && value !== '') {
	    el.style.left = value + 'px';
	  } else {
	    el.style.left = '';
	  }
	};
	
	_rivets2.default.binders.show = function (el, value) {
	  var $el = (0, _jquery2.default)(el);
	
	  if (value) {
	    $el.removeClass('is-hidden');
	  } else {
	    $el.addClass('is-hidden');
	  }
	};
	
	_rivets2.default.binders.hide = function (el, value) {
	  var $el = (0, _jquery2.default)(el);
	
	  if (value) {
	    $el.addClass('is-hidden');
	  } else {
	    $el.removeClass('is-hidden');
	  }
	};
	
	_rivets2.default.binders.addclass = function (el, value) {
	  if (el.addedClass) {
	    (0, _jquery2.default)(el).removeClass(el.addedClass);
	    delete el.addedClass;
	  }
	
	  if (value) {
	    (0, _jquery2.default)(el).addClass(value);
	    el.addedClass = value;
	  }
	};
	_rivets2.default.binders['value-soft'] = {
	  publishes: true,
	  priority: 3000,
	  bind: function bind(el) {
	    this.valueSoftInitialized = false;
	    _rivets2.default._.Util.bindEvent(el, el.tagName === 'SELECT' ? 'change' : 'input', this.publish);
	  },
	  unbind: function unbind(el) {
	    _rivets2.default._.Util.unBindEvent(el, el.tagName === 'SELECT' ? 'change' : 'input', this.publish);
	  },
	  routine: function routine(el, value) {
	    if (el.value && !this.valueSoftInitialized) {
	      this.valueSoftInitialized = true;
	      _rivets2.default.binders.value.routine(el, el.value);
	    } else {
	      _rivets2.default.binders.value.routine(el, value);
	    }
	  }
	};
	_rivets2.default.binders['checked-soft'] = {
	  publishes: true,
	  priority: 3001,
	  bind: function bind(el) {
	    _rivets2.default._.Util.bindEvent(el, 'change', this.publish);
	  },
	  unbind: function unbind(el) {
	    _rivets2.default._.Util.unBindEvent(el, 'change', this.publish);
	  },
	  routine: function routine(el, value) {
	    if (el.checked && !el.checkedSoftInitialized) {
	      var self = this;
	      var binders = self.view.select(function (b) {
	        return b.keypath === self.keypath;
	      });
	
	      _jquery2.default.each(binders, function (i) {
	        binders[i].el.checkedSoftInitialized = true;
	      });
	
	      this.publish();
	      _rivets2.default.binders['custom-checked'].routine(el, el.value);
	    } else {
	      _rivets2.default.binders['custom-checked'].routine(el, value);
	    }
	  }
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	__webpack_require__(282);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_rivets2.default.configure({
	  prefix: 'data-bind'
	});

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_rivets2.default.formatters.log = function (value) {
	  console.log('Logging in formatter');
	  console.log(value);
	
	  return value;
	};
	
	_rivets2.default.formatters.length = function (value) {
	  return value.length;
	};
	
	_rivets2.default.formatters.objToArray = function (obj) {
	  return _underscore2.default.values(obj);
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * fix to make two way data-binding work in IE7 an IE8
	 */
	
	/* jshint ignore:start */
	
	/* istanbul ignore next */
	var __indexOf = [].indexOf || function (item) {
	  for (var i = 0, l = this.length; i < l; i++) {
	    if (i in this && this[i] === item) return i;
	  }
	  return -1;
	};
	
	/* istanbul ignore next */
	_rivets2.default.binders.value = {
	  publishes: true,
	  bind: function bind(el) {
	    this.event = el.tagName === 'SELECT' ? 'change' : 'textchange';
	    return $(el).on(this.event, this.publish);
	  },
	  unbind: function unbind(el) {
	    return $(el).off(this.event, this.publish);
	  },
	  routine: function routine(el, value) {
	    var o, _i, _len, _ref, _ref1, _ref2, _results;
	    if (window.$ != null) {
	      el = $(el);
	      if ((value != null ? value.toString() : void 0) !== ((_ref = el.val()) != null ? _ref.toString() : void 0)) {
	        return el.val(value != null ? value : '');
	      }
	    } else {
	      if (el.type === 'select-multiple') {
	        if (value != null) {
	          _results = [];
	          for (_i = 0, _len = el.length; _i < _len; _i++) {
	            o = el[_i];
	            _results.push(o.selected = (_ref1 = o.value, __indexOf.call(value, _ref1) >= 0));
	          }
	          return _results;
	        }
	      } else if ((value != null ? value.toString() : void 0) !== ((_ref2 = el.value) != null ? _ref2.toString() : void 0)) {
	        return el.value = value != null ? value : '';
	      }
	    }
	  }
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CartEvents = __webpack_require__(62);
	
	var _CartEvents2 = _interopRequireDefault(_CartEvents);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('cart', function () {
	  var cartEvents = new _CartEvents2.default({
	    el: $('body')
	  });
	
	  $(document).ready(function () {
	    cartEvents.executeCookieCallbacks();
	  });
	});

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storageFactory = __webpack_require__(7);
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'click [data-role="event-change-address"]': 'onAddressChange',
	    'submit form.myaccount-address': 'onAddressChange'
	  },
	
	  cookieCallbacks: {
	    GtmOnAddressChanged: 'afterAddressChanged'
	  },
	
	  onAddressChange: function onAddressChange() {
	    (0, _storageFactory.getStorage)().set('GtmOnAddressChanged', 1);
	  },
	
	  /**
	   * Callback executed after user changes address on checkout address page
	   */
	  afterAddressChanged: function afterAddressChanged() {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push({
	        event: 'checkoutOption',
	        ecommerce: {
	          checkout_option: {
	            actionField: {
	              step: 2,
	              option: 'change_address'
	            }
	          }
	        }
	      });
	    }
	  }
	});

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'click .checkout-buy': 'onBuyClick'
	  },
	
	  onBuyClick: function onBuyClick() {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push({
	        event: 'buy_clicked'
	      });
	    }
	  }
	});

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LoginEvents;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _storageFactory = __webpack_require__(7);
	
	var _baseTracking = __webpack_require__(16);
	
	var baseTracking = _interopRequireWildcard(_baseTracking);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * tracking for login/register, but only if part of checkout process
	 */
	function LoginEvents(options) {
	  this.$el = options.$el;
	  this.initialize();
	}
	
	LoginEvents.prototype = _underscore2.default.extend({}, baseTracking, {
	  cookieCallbacks: {
	    GtmOnLoginClicked: 'afterLoginClicked',
	    GtmOnRegisterClicked: 'afterRegisterClicked'
	  },
	
	  initialize: function initialize() {
	    this.$el.find('.js-login-form').on('submit', _jquery2.default.proxy(this.onLoginFormSubmit, this));
	    this.$el.find('.js-register-form-private, .js-register-form-business').on('submit', _jquery2.default.proxy(this.onRegisterFormSubmit, this));
	  },
	
	  isInCheckout: function isInCheckout() {
	    return registry.get('currentLayout') === 'checkout';
	  },
	
	  onLoginFormSubmit: function onLoginFormSubmit() {
	    if (this.isInCheckout()) {
	      (0, _storageFactory.getStorage)().set('GtmOnLoginClicked', 1);
	    }
	  },
	
	  onRegisterFormSubmit: function onRegisterFormSubmit() {
	    if (this.isInCheckout()) {
	      (0, _storageFactory.getStorage)().set('GtmOnRegisterClicked', 1);
	    }
	  },
	
	  afterLoginClicked: function afterLoginClicked() {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push({
	        event: 'checkoutOption',
	        ecommerce: {
	          checkout_option: {
	            actionField: {
	              step: 1,
	              option: 'login'
	            }
	          }
	        }
	      });
	    }
	  },
	
	  afterRegisterClicked: function afterRegisterClicked() {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push({
	        event: 'checkoutOption',
	        ecommerce: {
	          checkout_option: {
	            actionField: {
	              step: 1,
	              option: 'register'
	            }
	          }
	        }
	      });
	    }
	  }
	});

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _helper = __webpack_require__(20);
	
	var commonTrackingHelper = _interopRequireWildcard(_helper);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'change #trusted-shops': 'onTrustedShopsChange',
	    'change [name="payment[method]"]': 'onUserPaymentMethodChange'
	  },
	
	  onTrustedShopsChange: function onTrustedShopsChange(event) {
	    var oTrackingData = registry.get('trustedShopTrackingData');
	
	    if (oTrackingData && typeof window.dataLayer !== 'undefined') {
	      if ((0, _jquery2.default)(event.currentTarget).is(':checked')) {
	        window.dataLayer.push(commonTrackingHelper.prepareCartAddObject(oTrackingData, 1));
	      } else {
	        window.dataLayer.push(commonTrackingHelper.prepareCartRemoveObject(oTrackingData, 1));
	      }
	    }
	  },
	
	  onUserPaymentMethodChange: function onUserPaymentMethodChange() {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push({
	        event: 'checkoutOption',
	        ecommerce: {
	          checkout_option: {
	            actionField: {
	              step: 3,
	              option: this.$('[name="payment[method]"]').filter(':checked').val()
	            }
	          }
	        }
	      });
	    }
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _helper = __webpack_require__(48);
	
	var checkoutTrackingHelper = _interopRequireWildcard(_helper);
	
	var _CartEvents = __webpack_require__(62);
	
	var _CartEvents2 = _interopRequireDefault(_CartEvents);
	
	var _Address = __webpack_require__(167);
	
	var _Address2 = _interopRequireDefault(_Address);
	
	var _Index = __webpack_require__(168);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _LoginEvents = __webpack_require__(169);
	
	var _LoginEvents2 = _interopRequireDefault(_LoginEvents);
	
	var _Payment = __webpack_require__(170);
	
	var _Payment2 = _interopRequireDefault(_Payment);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)(null, function () {
	  var login = new _LoginEvents2.default({
	    $el: (0, _jquery2.default)('body')
	  });
	
	  (0, _jquery2.default)(document).ready(function () {
	    login.executeCookieCallbacks();
	  });
	});
	
	(0, _bootstrapper.register)('checkout-index', function () {
	  var $page = (0, _jquery2.default)('.checkout-index-page');
	
	  var cartEvents = new _CartEvents2.default({
	    el: $page
	  });
	
	  var addressEvents = new _Address2.default({
	    el: (0, _jquery2.default)('.checkout-address-page')
	  });
	
	  new _Index2.default({
	    el: $page
	  });
	
	  (0, _jquery2.default)(document).ready(function () {
	    checkoutTrackingHelper.addressSendTrackingData();
	    checkoutTrackingHelper.paymentSendTrackingData();
	    checkoutTrackingHelper.indexSendTrackingData();
	
	    cartEvents.executeCookieCallbacks();
	    addressEvents.executeCookieCallbacks();
	  });
	});
	
	(0, _bootstrapper.register)('checkout-payment', function () {
	  new _Payment2.default({
	    el: (0, _jquery2.default)('.checkout-payment-page')
	  });
	
	  var addressEvents = new _Address2.default({
	    el: (0, _jquery2.default)('.checkout-address-page')
	  });
	
	  (0, _jquery2.default)(document).ready(function () {
	    checkoutTrackingHelper.paymentSendTrackingData();
	
	    addressEvents.executeCookieCallbacks();
	  });
	});
	
	(0, _bootstrapper.register)('checkout-address', function () {
	  /*
	     Process all tracking for checkout address page
	     */
	  var addressEvents = new _Address2.default({
	    el: (0, _jquery2.default)('.checkout-address-page')
	  });
	
	  (0, _jquery2.default)(document).ready(function () {
	    checkoutTrackingHelper.addressSendTrackingData();
	
	    addressEvents.executeCookieCallbacks();
	  });
	});
	
	(0, _bootstrapper.register)('success', function () {
	  (0, _jquery2.default)(document).ready(function () {
	    checkoutTrackingHelper.successSendTrackingData();
	  });
	});

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _storageFactory = __webpack_require__(7);
	
	var _helper = __webpack_require__(10);
	
	var _helper2 = __webpack_require__(20);
	
	var commonTrackingHelper = _interopRequireWildcard(_helper2);
	
	var _Utils = __webpack_require__(15);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	var _appearQueue = __webpack_require__(177);
	
	__webpack_require__(206);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'click a[data-gtm]': 'onDataGtmClick'
	  },
	
	  cookieCallbacks: {
	    GtmOnArticleClicked: 'afterClick'
	  },
	
	  onDataGtmClick: function onDataGtmClick(event) {
	    commonTrackingHelper.processGtmVariables((0, _jquery2.default)(event.currentTarget));
	  },
	
	  initialize: function initialize() {
	    this.bindAllEvents();
	    this.cleanupGtmCookies();
	  },
	
	  /**
	   * Method unset cookies created by commonTrackingHelper.processGtmVariables after request is processed
	   */
	  cleanupGtmCookies: function cleanupGtmCookies() {
	    var i;
	    var gtmCookieNames = config.get('tracking.gtm.cookieNames');
	
	    for (i in gtmCookieNames) {
	      /* istanbul ignore else */
	      if (gtmCookieNames.hasOwnProperty(i)) {
	        (0, _Utils.setCookie)(gtmCookieNames[i], '', -1);
	      }
	    }
	  },
	
	  bindAllEvents: function bindAllEvents() {
	    var context = this;
	
	    this.$('[data-gtm-bind]').each(function () {
	      var $this = (0, _jquery2.default)(this);
	
	      if (!$this.data('gtmBinded')) {
	        context.bindEvents($this);
	      }
	    });
	  },
	
	  setModel: function setModel(model) {
	    this.model = model;
	  },
	
	  bindEvents: function bindEvents($element, sEvents) {
	    var aEvents;
	    var i;
	    var sCurrentEvent;
	
	    if (!sEvents) {
	      sEvents = $element.data('gtmBind');
	    }
	
	    if (!sEvents) {
	      return false;
	    }
	
	    aEvents = sEvents.split(',');
	
	    for (i in aEvents) {
	      /* istanbul ignore else */
	      if (aEvents.hasOwnProperty(i)) {
	        sCurrentEvent = aEvents[i];
	
	        switch (sCurrentEvent) {
	          case 'appear':
	            $element.appear(_jquery2.default.proxy(this.onAppear, this));
	            break;
	
	          case 'click':
	          default:
	            $element.on('click', _jquery2.default.proxy(this.onClick, this));
	            break;
	        }
	      }
	    }
	
	    $element.attr('data-gtm-binded', true);
	
	    return true;
	  },
	
	  getEventSource: function getEventSource($element) {
	    var source = $element.data('gtmEventSource');
	    var categoryName;
	    var currentDataLayer = (0, _helper.getCurrentDataLayer)();
	
	    if (!source) {
	      source = $element.closest('[data-gtm-event-source]').data('gtmEventSource');
	    }
	
	    if (currentDataLayer) {
	      // add category name if available
	      categoryName = currentDataLayer.pageProdGroup;
	
	      if (categoryName) {
	        // ie. 'Catalog - Möbel'
	        source = source + ' - ' + categoryName;
	      }
	    }
	
	    return source;
	  },
	
	  /**
	   * Callback method for event when article appears in a viewport (is visible)
	   */
	  onAppear: function onAppear(event) {
	    var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	    var source = this.getEventSource($currentTarget);
	    var trackingData;
	
	    trackingData = this.getTrackingData($currentTarget);
	
	    if (!_underscore2.default.isEmpty(trackingData) && source) {
	      trackingData.list = source;
	      (0, _appearQueue.setCurrencyCode)(trackingData.currencyCode);
	      delete trackingData.currencyCode;
	      (0, _appearQueue.push)(trackingData);
	    }
	  },
	
	  onClick: function onClick(event) {
	    var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	    var trackingData = this.getTrackingData($currentTarget);
	    var toBeStored = {
	      position: trackingData.position,
	      source: this.getEventSource($currentTarget)
	    };
	
	    (0, _storageFactory.getStorage)().set('GtmOnArticleClicked', toBeStored);
	  },
	
	  getTrackingData: function getTrackingData($element) {
	    var sku;
	
	    // reboot way with base64 encoded data attribute
	    if ($element.data('tracking')) {
	      return commonTrackingHelper.decode($element.data('tracking'));
	    }
	
	    // shop-app way with data as JSON in Registry (list-view)
	    if (registry.get('listView.trackingData')) {
	      sku = $element.data('sku');
	
	      return registry.get('listView.trackingData')[sku];
	    }
	
	    // shop-app way with data as JSON in Registry (wishlist)
	    if (registry.get('wishlist.trackingData')) {
	      sku = $element.data('sku');
	
	      return registry.get('wishlist.trackingData')[sku];
	    }
	
	    return false;
	  },
	
	  /**
	   * Callback for BaseTracking:executeCookieCallbacks executed when user enters PDP after clicking on
	   * and article
	   * @param storedTrackingData
	   */
	  afterClick: function afterClick(storedTrackingData) {
	    if (_typeof(window.dataLayer) === 'object' && this.model) {
	      var skuData = registry.get('trackingData');
	      var oData = {};
	
	      skuData = skuData[this.model.get('simpleSku')];
	
	      if (skuData && skuData.id) {
	        oData = {
	          name: skuData.name,
	          id: skuData.id,
	          price: skuData.price,
	          brand: skuData.brand,
	          category: skuData.category,
	          variant: skuData.variant,
	          dimension64: skuData.dimension64
	        };
	
	        if (storedTrackingData.position) {
	          oData.position = storedTrackingData.position;
	        }
	
	        window.dataLayer.push({
	          event: 'productClick',
	          ecommerce: {
	            click: {
	              actionField: {
	                list: storedTrackingData.source
	              },
	              products: [oData]
	            }
	          }
	        });
	      }
	    }
	  }
	});

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _storageFactory = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'click [data-helparea]': 'onHelpareaClick'
	  },
	
	  cookieCallbacks: {
	    GtmContactRequest: 'afterContactRequest',
	    GtmHelpareaEnter: 'afterHelpareaEnter'
	  },
	
	  onHelpareaClick: function onHelpareaClick(event) {
	    (0, _storageFactory.getStorage)().set('GtmHelpareaEnter', (0, _jquery2.default)(event.currentTarget).data('helparea'));
	  },
	
	  afterContactRequest: function afterContactRequest(sValue) {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push({
	        eventCategory: 'Customer Service',
	        eventAction: 'Contact Request',
	        eventLabel: sValue,
	        event: 'Help'
	      });
	    }
	  },
	
	  afterHelpareaEnter: function afterHelpareaEnter(sValue) {
	    if (typeof window.dataLayer !== 'undefined') {
	      var event = {
	        eventCategory: 'Customer Service',
	        event: 'Help'
	      };
	
	      switch (sValue) {
	        case 'Header':
	          event.eventAction = 'Header';
	          event.eventLabel = 'Customer Service';
	          break;
	
	        case 'Widget':
	          event.eventAction = 'Widget';
	          event.eventLabel = 'Help Area';
	          break;
	
	        case 'FAQ':
	          event.eventAction = 'Footer';
	          event.eventLabel = 'FAQ';
	          break;
	
	        case 'Contact':
	          event.eventAction = 'Footer';
	          event.eventLabel = 'Contact';
	          break;
	
	        default:
	          /*
	                    When any other value was there, quit this method
	                     */
	          return;
	      }
	
	      window.dataLayer.push(event);
	    }
	  }
	});

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _storageFactory = __webpack_require__(7);
	
	var _helper = __webpack_require__(10);
	
	var commonTrackingHelper = _interopRequireWildcard(_helper);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * see http://jira.home24.de/browse/REBOOT-16507 for details
	 * after click on navigation link a cookie with proper data will be set
	 * and on next page cookie content will be pushed to dataLayer
	 */
	exports.default = _baseView2.default.extend({
	  events: {
	    'click .navigation a': 'onTopNavigationClick',
	    'click .sub-menu-2-filters a': 'onTopManualClick',
	    'click .js-navigation-track-side a': 'onSideNavigationClick',
	    'click .breadcrumbs a': 'onBreadcrumbClick',
	    'click .js-navigation-track-visual a': 'onVisualNavigationClick',
	    'click .js-navigation-track a, .js-navigation-track area': 'onNavigationTrackClick',
	    'filter-submit .ui-input-rangeslider': 'onRangeFilterSubmit',
	    'change .js-navigation-track-filter-left-checkbox input[type=checkbox]': 'onFilterCheckboxChange',
	    'change .js-navigation-track-filter-left-select select': 'onFilterSelectChange',
	    'change .js-navigation-track-filter-top-select select': 'onTopFilterSelectChange',
	    'click .js-navigation-track-b2b-footer': 'onB2BFooterLinkClick',
	    'click .cms-b2b-teaser__button': 'onB2BTeaserButtonClick',
	    'click .single-product-view a': 'onTopsellerClick',
	    'click .cms-b2b-contacts__email': 'onB2BContactsEmailClick',
	    'click .js-assortment-category': 'onB2BAssortmentCategoryClick',
	    'click .js-top-icons': 'onTopIconClick',
	    'click .js-header-login-link': 'onHeaderLoginLinkClick'
	  },
	
	  // object that is pushed to dataLayer
	  data: {},
	
	  // name of cookie where data will be stored
	  cookieName: 'GtmOnNavigation',
	
	  initialize: function initialize() {
	    this.readCookie();
	    this.setDefaultData();
	  },
	
	  setDefaultData: function setDefaultData() {
	    this.data = {
	      current_page: [location.protocol, '//', location.host, location.pathname].join(''),
	      current_page_type: commonTrackingHelper.getCurrentDataLayer().pageType,
	      current_page_level: registry.get('categoryLevel') ? registry.get('categoryLevel') : 0,
	
	      // which navigation the user has clicked on
	      click_position: '',
	
	      // name shown the user clicked on
	      click_name: '',
	
	      // is set after page reload
	      click_destination_level: '',
	      event: 'Navi_click'
	    };
	  },
	
	  // universal method for CMS_Blocks
	  onNavigationTrackClick: function onNavigationTrackClick(event) {
	    var $container = (0, _jquery2.default)(event.currentTarget).closest('.js-navigation-track');
	    var clickPositionValue = $container.data('tracking-click-position');
	    var currentTagName = event.currentTarget.tagName;
	    var sClickName = $container.data('tracking-click-name');
	
	    /* istanbul ignore else */
	    if (['A', 'AREA'].indexOf(currentTagName) !== -1) {
	      this.setClickPosition(clickPositionValue, event.currentTarget);
	      this.setClickName(event.target, sClickName);
	      this.setCookie();
	    }
	  },
	
	  onTopFilterSelectChange: function onTopFilterSelectChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	
	    this.data.click_position = 'FilterTop' + $cT.closest('.js-navigation-track-filter-top-select').data('filter-position');
	    this.data.click_name = $cT.attr('name') + '_' + $cT.find(':selected').data('value');
	    this.setCookie();
	  },
	
	  onFilterSelectChange: function onFilterSelectChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	
	    this.data.click_position = 'FilterSide' + $cT.closest('.js-navigation-track-filter-left-select').data('filter-position');
	    this.data.click_name = $cT.attr('name') + '_' + $cT.find(':selected').data('value');
	    this.setCookie();
	  },
	
	  onB2BFooterLinkClick: function onB2BFooterLinkClick(ev) {
	    this.data.click_destination_level = 'b2b';
	    this.data.click_name = 'Geschaeftskunden';
	    this.data.click_position = 'footer';
	
	    commonTrackingHelper.addToDataLayerForLinks(ev, this.data);
	  },
	
	  onB2BTeaserButtonClick: function onB2BTeaserButtonClick(ev) {
	    this.data.click_destination_level = '10';
	    this.data.click_name = 'kostenlos_anmelden';
	    this.data.click_position = 'Top Teaser';
	
	    commonTrackingHelper.addToDataLayerForLinks(ev, this.data);
	  },
	
	  // REBOOT-20192
	  onTopsellerClick: function onTopsellerClick(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	
	    this.data.click_destination_level = '6';
	    this.data.click_name = $cT.find('.name').attr('data-tip-title');
	    this.data.click_position = 'Top Seller Teaser';
	    this.setCookie();
	  },
	
	  // REBOOT-20191
	  onB2BContactsEmailClick: function onB2BContactsEmailClick() {
	    this.data.click_destination_level = 'Email_form';
	    this.data.click_name = 'Kontakt';
	    this.data.click_position = 'Kontakt';
	    this.pushData(this.data);
	  },
	
	  // REBOOT-20190
	  onB2BAssortmentCategoryClick: function onB2BAssortmentCategoryClick(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	
	    this.data.click_destination_level = '2';
	    this.data.click_name = $cT.find('.cms-b2b-link__title').text();
	    this.data.click_position = 'Sortiment Teaser';
	    this.setCookie();
	  },
	
	  onFilterCheckboxChange: function onFilterCheckboxChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	
	    this.data.click_position = 'FilterSide' + $cT.closest('.js-navigation-track-filter-left-checkbox').data('filter-position');
	    this.data.click_name = $cT.data('name') + '_' + $cT.data('value');
	    this.setCookie();
	  },
	
	  onRangeFilterSubmit: function onRangeFilterSubmit(event, data) {
	    this.data.click_position = 'FilterSide' + data.filterPosition;
	    this.data.click_name = data.name + '_' + data.min + '-' + data.max;
	    this.setCookie();
	  },
	
	  onTopNavigationClick: function onTopNavigationClick(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	
	    this.data.click_position = 'Top';
	    this.setClickName(event.currentTarget);
	
	    /*
	         In case of 3nd level, override click_name to attach 2nd level name in front
	         */
	    if ($cT.hasClass('element')) {
	      this.data.click_name = $cT.closest('.navigation-cell').find('.header').last().text() + ' | ' + this.data.click_name;
	    }
	
	    this.setCookie();
	  },
	
	  onTopManualClick: function onTopManualClick() {
	    this.data.click_position = 'TopManual';
	    this.setClickName('');
	    this.setCookie();
	  },
	
	  onSideNavigationClick: function onSideNavigationClick(event) {
	    this.data.click_position = 'Side';
	
	    this.setClickName(event.currentTarget);
	    this.setCookie();
	  },
	
	  onBreadcrumbClick: function onBreadcrumbClick(event) {
	    this.data.click_position = 'Breadcrumb';
	
	    this.setClickName(event.currentTarget);
	    this.setCookie();
	  },
	
	  onTopIconClick: function onTopIconClick(event) {
	    this.data.click_position = 'Top';
	    this.data.click_name = _jquery2.default.trim((0, _jquery2.default)(event.currentTarget).find('.sprite-with-caption__caption').text());
	
	    commonTrackingHelper.addToDataLayerForLinks(event, _underscore2.default.clone(this.data));
	  },
	
	  onHeaderLoginLinkClick: function onHeaderLoginLinkClick(event) {
	    this.data.click_position = 'Top';
	    this.data.click_name = event.currentTarget.text.trim();
	
	    commonTrackingHelper.addToDataLayerForLinks(event, _underscore2.default.clone(this.data));
	  },
	
	  /**
	   * @param {String} clickPositionValue
	   * @param {Object=} currentTarget
	   */
	  setClickPosition: function setClickPosition(clickPositionValue, currentTarget) {
	    var $currentTarget = (0, _jquery2.default)(currentTarget);
	
	    if ($currentTarget.data('tracking-click-position')) {
	      this.data.click_position = $currentTarget.data('tracking-click-position');
	    } else {
	      this.data.click_position = clickPositionValue;
	    }
	  },
	
	  onVisualNavigationClick: function onVisualNavigationClick(event) {
	    this.setClickPosition('Visual', event.currentTarget);
	    this.setClickName(event.currentTarget);
	    this.setCookie();
	  },
	
	  /**
	   * @param {Object} currentTarget
	   * @param {String=} providedClickName
	   */
	  setClickName: function setClickName(currentTarget, providedClickName) {
	    var $currentTarget = (0, _jquery2.default)(currentTarget);
	    var clickName = _jquery2.default.trim($currentTarget.text());
	
	    if ($currentTarget.data('tracking-click-name')) {
	      this.data.click_name = $currentTarget.data('tracking-click-name');
	    } else if (providedClickName && providedClickName.length > 0) {
	      this.data.click_name = providedClickName;
	    } else if (clickName && clickName.length > 0) {
	      this.data.click_name = clickName;
	    } else {
	      this.data.click_name = 'CMS';
	    }
	  },
	
	  setCookie: function setCookie() {
	    (0, _storageFactory.getStorage)().set(this.cookieName, JSON.stringify(this.data));
	  },
	
	  readCookie: function readCookie() {
	    var cookieValue = (0, _storageFactory.getStorage)().get(this.cookieName);
	
	    if (cookieValue) {
	      this.pushData(_jquery2.default.parseJSON(cookieValue));
	    }
	  },
	
	  pushData: function pushData(data) {
	    var clickDestination;
	    var categoryLevel;
	    var pageName = (0, _jquery2.default)('body').data('page');
	
	    // check if on any level of catalog
	    categoryLevel = registry.get('categoryLevel');
	
	    if (typeof categoryLevel !== 'undefined') {
	      clickDestination = categoryLevel;
	    }
	
	    // check if on PDP
	    if (pageName === 'article') {
	      clickDestination = 6;
	    }
	
	    // check if homepage
	    if (pageName === 'index') {
	      clickDestination = 0;
	    }
	
	    if (data.click_destination_level === '' && typeof clickDestination !== 'undefined') {
	      data.click_destination_level = clickDestination;
	    }
	
	    window.dataLayer.push(data);
	    this.clearCookie();
	  },
	
	  clearCookie: function clearCookie() {
	    (0, _storageFactory.getStorage)().unset(this.cookieName);
	  }
	});

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _storageFactory = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'submit form': 'onFormSubmit'
	  },
	
	  cookieCallbacks: {
	    SearchEvent: 'afterSearchEvent'
	  },
	
	  initialize: function initialize() {
	    this.executeCookieCallbacks();
	  },
	
	  onFormSubmit: function onFormSubmit() {
	    (0, _storageFactory.getStorage)().set('SearchEvent', 1);
	  },
	
	  afterSearchEvent: function afterSearchEvent(sData) {
	    if (typeof window.dataLayer !== 'undefined' && sData == 1) {
	      window.dataLayer.push({
	        event: 'Internal Search'
	      });
	    }
	  }
	});

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _helper = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'click .js-usp-track-link': 'trackLinkClick'
	  },
	
	  trackLinkClick: function trackLinkClick(clickEvent) {
	    var anchorElement = clickEvent.target;
	
	    var textContent = anchorElement.textContent;
	    var innerText = anchorElement.innerText;
	    var targetUrl = anchorElement.pathname;
	    var labelIdentifier = anchorElement.getAttribute('data-track-identifier');
	    var listIndex = Number(anchorElement.getAttribute('data-track-list-index'));
	    var listLength = Number(anchorElement.getAttribute('data-track-list-length'));
	
	    // see: http://perfectionkills.com/the-poor-misunderstood-innerText/
	    var label = (textContent || innerText || '').trim();
	
	    var gtmData = {
	      event: 'headerTracking',
	      eventCategory: 'link',
	      eventAction: 'click',
	      eventData: {
	        placement: 'uspBar',
	        label: label,
	        labelIdentifier: labelIdentifier,
	        targetUrl: targetUrl,
	        listIndex: listIndex,
	        listLength: listLength
	      }
	    };
	
	    (0, _helper.addToDataLayerForLinks)(clickEvent, gtmData);
	  }
	});

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppearQueue = AppearQueue;
	exports.setCurrencyCode = setCurrencyCode;
	exports.push = push;
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function AppearQueue() {
	  var queue = [];
	  var currencyCode = '';
	
	  // noinspection JSUnusedGlobalSymbols
	  this.self = {
	    /**
	     * Method set current currency symbol for whole queue
	     * @param {String} value
	     */
	    setCurrencyCode: function setCurrencyCode(value) {
	      currencyCode = value;
	    },
	    getQueue: function getQueue() {
	      return queue;
	    },
	
	    /**
	     * Method initializes queue, starts interval timer
	     */
	    init: function init() {
	      (function (that) {
	        setInterval(function () {
	          that.checkQueue();
	        }, config.getInt('tracking.appearQueueInterval'));
	      })(this);
	    },
	
	    /**
	     * Push article appearance into queue
	     * @param {Object} oData
	     */
	    push: function push(oData) {
	      queue.push(oData);
	    },
	
	    checkQueue: function checkQueue() {
	      if (queue.length > 0) {
	        this.pushQueue();
	      }
	    },
	
	    pushQueue: function pushQueue() {
	      var tmpQueue;
	      var retVal = {};
	
	      // noinspection JSUnresolvedVariable
	      if (typeof window.dataLayer !== 'undefined') {
	        tmpQueue = queue;
	        queue = [];
	
	        retVal.event = 'productImpressions';
	        retVal.ecommerce = {};
	        retVal.ecommerce.currencyCode = currencyCode;
	        retVal.ecommerce.impressions = tmpQueue;
	
	        // noinspection JSUnresolvedVariable
	        window.dataLayer.push(retVal);
	      }
	    }
	  };
	}
	
	/**
	 * Queue used for grouping article appearance events and passing them to Google Tag Manager
	 * @see REBOOT-14809
	 */
	
	var object = new AppearQueue();
	
	object.self.init();
	
	function setCurrencyCode(value) {
	  return object.self.setCurrencyCode(value);
	}
	function push(oData) {
	  return object.self.push(oData);
	}

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _AddressCheckEvents = __webpack_require__(64);
	
	var _AddressCheckEvents2 = _interopRequireDefault(_AddressCheckEvents);
	
	var _HelpareaEvents = __webpack_require__(173);
	
	var _HelpareaEvents2 = _interopRequireDefault(_HelpareaEvents);
	
	var _ArticleEvents = __webpack_require__(172);
	
	var _ArticleEvents2 = _interopRequireDefault(_ArticleEvents);
	
	var _UspEvents = __webpack_require__(176);
	
	var _UspEvents2 = _interopRequireDefault(_UspEvents);
	
	var _Navigation = __webpack_require__(174);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _SearchField = __webpack_require__(175);
	
	var _SearchField2 = _interopRequireDefault(_SearchField);
	
	var _trackingInstances = __webpack_require__(72);
	
	var trackingInstances = _interopRequireWildcard(_trackingInstances);
	
	var _smartBanner = __webpack_require__(68);
	
	var smartBanner = _interopRequireWildcard(_smartBanner);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)(null, function () {
	  var $body = (0, _jquery2.default)('body');
	
	  trackingInstances.set('helpareaEvents', new _HelpareaEvents2.default({
	    el: $body
	  }));
	
	  trackingInstances.set('addressCheckEvents', new _AddressCheckEvents2.default({
	    el: $body
	  }));
	
	  (0, _jquery2.default)(document).ready(function () {
	    smartBanner.init();
	
	    trackingInstances.set('articleEvents', new _ArticleEvents2.default({ el: $body }));
	
	    trackingInstances.set('uspEvents', new _UspEvents2.default({ el: $body }));
	
	    trackingInstances.get('helpareaEvents').executeCookieCallbacks();
	
	    _underscore2.default.each((0, _jquery2.default)('.search-block'), function (el) {
	      new _SearchField2.default({ el: el });
	    });
	
	    if (typeof window.dataLayer !== 'undefined') {
	      new _Navigation2.default({ el: (0, _jquery2.default)('body') });
	    }
	  });
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.executeCookieCallbacks = executeCookieCallbacks;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _storageFactory = __webpack_require__(7);
	
	var _baseTracking = __webpack_require__(16);
	
	var baseTracking = _interopRequireWildcard(_baseTracking);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * tracking of forgot password events
	 */
	
	var eventNamespace = '.tracking';
	
	var forgotPassword = _underscore2.default.extend({
	  init: function init() {
	    (0, _jquery2.default)('.js-forgot-password').on(this.getEventName('click'), _underscore2.default.bind(this.onForgotPasswordClicked, this));
	
	    (0, _jquery2.default)('#lightbox').on(this.getEventName('click'), '.js-back-button', _underscore2.default.bind(this.onBackButtonClicked, this)).on(this.getEventName('submit'), '.js-forgot-password-form', _underscore2.default.bind(this.onForgotPasswordSubmitted, this));
	
	    _jquery2.default.subscribe('closed.lightbox', _jquery2.default.proxy(this.onPopupClosed, this));
	
	    return this;
	  },
	
	  getEventName: function getEventName(name) {
	    return name + eventNamespace;
	  },
	
	  destroy: function destroy() {
	    (0, _jquery2.default)('#lightbox').off(eventNamespace);
	    (0, _jquery2.default)('.js-forgot-password').off(eventNamespace);
	    _jquery2.default.unsubscribe('closed.lightbox');
	    this.closedByBackButton = false;
	  },
	
	  cookieCallbacks: {
	    GtmOnForgotPassword: 'afterEmailChecked'
	  },
	
	  /**
	   * flag explains that forgot password popup was closed by click on back button(Zurück)
	   */
	  closedByBackButton: false,
	
	  setCookie: function setCookie(data) {
	    (0, _storageFactory.getStorage)().set('GtmOnForgotPassword', data);
	  },
	
	  onForgotPasswordClicked: function onForgotPasswordClicked() {
	    this.pushEvent({
	      event: 'pass_forgotten_viewed'
	    });
	  },
	
	  onForgotPasswordSubmitted: function onForgotPasswordSubmitted() {
	    this.setCookie({
	      event: 'pass_forgotten_clicked',
	      action: 'requested'
	    });
	  },
	
	  onPopupClosed: function onPopupClosed() {
	    if (!this.closedByBackButton) {
	      this.pushEvent({
	        event: 'pass_forgotten_clicked',
	        action: 'close'
	      });
	    }
	
	    this.closedByBackButton = false;
	  },
	
	  onBackButtonClicked: function onBackButtonClicked() {
	    this.closedByBackButton = true;
	
	    this.pushEvent({
	      event: 'pass_forgotten_clicked',
	      action: 'back'
	    });
	  },
	
	  pushEvent: function pushEvent(event) {
	    if (typeof window.dataLayer !== 'undefined') {
	      window.dataLayer.push(event);
	    }
	  },
	
	  getServerResponse: function getServerResponse() {
	    var $message = (0, _jquery2.default)('.messages').find('.error, .success');
	
	    return $message.text();
	  },
	
	  afterEmailChecked: function afterEmailChecked(cookieValue) {
	    var message = this.getServerResponse();
	
	    if (message) {
	      cookieValue.message = message;
	      this.pushEvent(cookieValue);
	    }
	  }
	}, baseTracking);
	
	function init() {
	  return forgotPassword.init();
	}
	
	function executeCookieCallbacks() {
	  return forgotPassword.executeCookieCallbacks();
	}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.executeCookieCallbacks = executeCookieCallbacks;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _storageFactory = __webpack_require__(7);
	
	var _baseTracking = __webpack_require__(16);
	
	var baseTracking = _interopRequireWildcard(_baseTracking);
	
	var _helper = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * tracking of success/failed registration
	 */
	
	var storage = (0, _storageFactory.getStorage)();
	var $el = (0, _jquery2.default)('body');
	var $form;
	
	var login = _underscore2.default.extend({
	  cookieCallbacks: {
	    GtmOnLoginPageLoginSuccess: 'afterLogin'
	  },
	
	  init: function init() {
	    $form = $el.find('.js-login-form');
	    $form.on('submit.loginEvents', _underscore2.default.bind(this.onLoginFormSubmit, this));
	  },
	
	  onLoginFormSubmit: function onLoginFormSubmit() {
	    var validator = $form.validate();
	
	    if (validator.valid()) {
	      storage.set('GtmOnLoginPageLoginSuccess', 1);
	    }
	  },
	
	  afterLogin: function afterLogin() {
	    // are we on next page after login?
	    // check if no server side validation errors
	    if (this.areServerSideErrors()) {
	      this.onServerLoginFailed();
	    } else {
	      // all fine from the server
	      this.onLoginSuccess();
	    }
	  },
	
	  onLoginSuccess: function onLoginSuccess() {
	    var data = (0, _helper.getCurrentDataLayer)();
	
	    window.dataLayer.push({
	      event: 'login',
	
	      // female or male
	      gender: data.visitorDemographicInfo ? data.visitorDemographicInfo.slice(0, 1) : '',
	      customer_type: data.visitorAccountType
	    });
	  },
	
	  getErrors: function getErrors() {
	    return $el.find('.messages').find('.error');
	  },
	
	  areServerSideErrors: function areServerSideErrors() {
	    return this.getErrors().length;
	  },
	
	  onServerLoginFailed: function onServerLoginFailed() {
	    var dataLayerObject = {
	      event: 'log_failed'
	    };
	
	    // read server side errors
	    dataLayerObject.err_text = this.getErrors().map(function (index, element) {
	      return {
	        name: 'email_pw',
	        message: (0, _jquery2.default)(element).text()
	      };
	    }).get();
	
	    window.dataLayer.push(dataLayerObject);
	  },
	
	  destroy: function destroy() {
	    $form.off('.loginEvents');
	  }
	}, baseTracking);
	
	function init() {
	  return login.init();
	}
	
	function executeCookieCallbacks() {
	  return login.executeCookieCallbacks();
	}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.executeCookieCallbacks = executeCookieCallbacks;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _storageFactory = __webpack_require__(7);
	
	var _baseTracking = __webpack_require__(16);
	
	var baseTracking = _interopRequireWildcard(_baseTracking);
	
	__webpack_require__(98);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * tracking of success/failed registration
	 */
	
	var storage = (0, _storageFactory.getStorage)();
	var $el = (0, _jquery2.default)('body');
	var $forms;
	
	var register = _underscore2.default.extend({
	  setCookie: function setCookie(data) {
	    storage.set('GtmOnLoginPageRegisterSuccess', data);
	  },
	
	  cookieCallbacks: {
	    GtmOnLoginPageRegisterSuccess: 'afterRegistration'
	  },
	
	  init: function init() {
	    $el.find('.js-open-registration').on('click', _jquery2.default.proxy(this.onRegisterFormOpenButtonClick, this));
	    $forms = $el.find('.js-register-form-private, .js-register-form-business');
	    $forms.on('submit.registerEvents', _jquery2.default.proxy(this.onRegisterFormSubmit, this));
	  },
	
	  onRegisterFormSubmit: function onRegisterFormSubmit(event) {
	    var $form = (0, _jquery2.default)(event.currentTarget);
	    var validator = $form.validate();
	
	    if (validator.valid()) {
	      this.onRegistrationSuccess($form);
	    } else {
	      this.onRegistrationFailed($form, validator);
	    }
	  },
	
	  onRegistrationFailed: function onRegistrationFailed($form, validator) {
	    var dataLayerObject = {
	      event: 'reg_failed',
	      err_text: []
	    };
	
	    // serialize error messages
	    validator.errorList.forEach(function (item) {
	      dataLayerObject.err_text.push({
	        name: item.element.name,
	        message: item.message
	      });
	    });
	
	    window.dataLayer.push(dataLayerObject);
	  },
	
	  onRegistrationSuccess: function onRegistrationSuccess($form) {
	    // gather data
	    var dataLayerObject = {
	      event: 'register',
	      gender: $form.find('[name="prefix"]').filter(':checked').val(),
	      customer_type: $form.find('[name="customer_type"]').val(),
	      newsletter: $form.find('[name="subscribe_to_newsletter"]').is(':checked')
	    };
	
	    this.setCookie(dataLayerObject);
	  },
	
	  onRegisterFormOpenButtonClick: function onRegisterFormOpenButtonClick(event) {
	    window.dataLayer.push({
	      event: 'register_button',
	      button: event.currentTarget.innerHTML.trim()
	    });
	  },
	
	  afterRegistration: function afterRegistration(cookieValue) {
	    // are we on next page after registration?
	    // check if no server side validation errors
	    if (this.areServerSideErrors()) {
	      this.onServerRegistrationFailed();
	    } else {
	      // all fine from the server
	      window.dataLayer.push(cookieValue);
	    }
	  },
	
	  getErrors: function getErrors() {
	    return $el.find('.messages').find('.error');
	  },
	
	  areServerSideErrors: function areServerSideErrors() {
	    return this.getErrors().length;
	  },
	
	  onServerRegistrationFailed: function onServerRegistrationFailed() {
	    var dataLayerObject = {
	      event: 'reg_failed',
	      err_text: []
	    };
	
	    // read server side errors
	    this.getErrors().each(function (index, element) {
	      dataLayerObject.err_text.push({
	        name: 'serverError',
	        message: (0, _jquery2.default)(element).text()
	      });
	    });
	
	    window.dataLayer.push(dataLayerObject);
	  },
	
	  destroy: function destroy() {
	    $forms.off('.registerEvents');
	  }
	}, baseTracking);
	
	function init() {
	  return register.init();
	}
	
	function executeCookieCallbacks() {
	  return register.executeCookieCallbacks();
	}

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _forgotPassword = __webpack_require__(179);
	
	var forgotPasswordEvents = _interopRequireWildcard(_forgotPassword);
	
	var _login = __webpack_require__(180);
	
	var loginEvents = _interopRequireWildcard(_login);
	
	var _register = __webpack_require__(181);
	
	var registerEvents = _interopRequireWildcard(_register);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('login', function () {
	  registerEvents.init();
	  loginEvents.init();
	  forgotPasswordEvents.init();
	
	  (0, _jquery2.default)(document).ready(function () {
	    forgotPasswordEvents.executeCookieCallbacks();
	  });
	});
	
	(0, _bootstrapper.register)(null, function () {
	  (0, _jquery2.default)(document).ready(function () {
	    registerEvents.executeCookieCallbacks();
	    loginEvents.executeCookieCallbacks();
	  });
	});

/***/ },
/* 183 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pushAddToWishlistEvent = pushAddToWishlistEvent;
	exports.pushRemoveFromWishlistEvent = pushRemoveFromWishlistEvent;
	function pushAddToWishlistEvent(data, pageType) {
	  window.dataLayer.push({
	    productSku: data.sku,
	    productPrice: data.price,
	    productBrand: data.brand,
	    productCategory: data.category,
	    event: 'addToWL',
	    dimension65: pageType
	  });
	}
	
	function pushRemoveFromWishlistEvent(data, pageType) {
	  window.dataLayer.push({
	    productSku: data.sku,
	    productPrice: data.price,
	    event: 'removeFromWL',
	    dimension65: pageType
	  });
	}

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	__webpack_require__(98);
	
	var _translation = __webpack_require__(12);
	
	var _validateIBAN = __webpack_require__(69);
	
	var _validateIBAN2 = _interopRequireDefault(_validateIBAN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Client-side validation based on jquery.validation plugin
	 *
	 * https://github.com/Home24/jquery-validation
	 * Documentation: http://jqueryvalidation.org/documentation/
	 *
	 * The difference between original library and fork by home24:
	 *      - multiple error types
	 *          rule example:
	 *              "email": { - field name
	 *                  "warning.pattern": { - rule name
	 *                      "rule": "/^[a-z0-9_-]+([.|+][a-z0-9_-]+)*[@][a-z0-9-]+([.][a-z0-9-]+)*[.]([a-z]{2,}|xn--[a-z0-9]+)$/i", - rule
	 *                      "validationType": "warning", - rule type
	 *                      "validationMethod": "pattern" - validation method
	 *                  }
	 *              }
	 *              or just:
	 *              "email": { - field name
	 *                  "pattern" : "/^[a-z0-9_-]+([.|+][a-z0-9_-]+)*[@][a-z0-9-]+([.][a-z0-9-]+)*[.]([a-z]{2,}|xn--[a-z0-9]+)$/i" - validation method: rule
	 *              }
	 *              by default rules have error type.
	 *          message example:
	 *              "email": {
	 *                  "error.maxLength": "Der Eintrag ist zu lang, bitte geben Sie höchstens {0} Zeichen ein."
	 *              }
	 *              or:
	 *              "email": {
	 *                  "maxLength": "Der Eintrag ist zu lang, bitte geben Sie höchstens {0} Zeichen ein."
	 *              }
	 *      - extend errorClass for custom error type.
	 *          By default it is string like:
	 *              errorClass: 'error'
	 *          Using with multiple error types:
	 *              errorClass: {
	 *                  error: 'error' - class for default error type
	 *                  warning: 'error--new-warning-class'
	 *              }
	 *
	 *      - disabled email validation use pattern rule instead
	 *      - changed remote method
	 *          expect answer from server like
	 *              {"valid": true} or {"valid": false}
	 *              it is possible to send error custom message with server answer
	 *              {
	 *                  "valid": false,
	 *                  "message": "error message"
	 *              }
	 *
	 */
	
	exports.default = _backbone2.default.View.extend({
	  selectors: {
	    inputFields: 'input, textarea, select',
	    ignore: '[type="submit"], [type="hidden"]:not([data-validate="true"]), [data-validate="false"], .warning',
	    inputGroup: '.ui-input-group',
	    inputGroupSet: '.ui-input-group__set',
	    inputLabel: '.input-label, label:not(.ca-label)',
	    inputCustomLabel: '.ca-label',
	    inputFilledIcon: '.icon-filled-field',
	    inputInvalidIcon: '.icon-invalid-field',
	    valid: '.valid',
	    invalidate: '.is-invalidate',
	    errorClass: 'is-invalidate error-message',
	    warningClass: 'warning-message',
	    errorLabelClass: 'error-label',
	    hiddenClass: 'is-hidden'
	  },
	
	  /**
	   * Filter for available rules on client side. Prevent applying non-existing rule to validator
	   */
	  availableRules: {
	    error: ['minLength', 'maxLength', 'pattern', 'blacklist', 'blacklistPattern', 'required', 'email', 'matchesInput', 'remote'],
	    warning: ['minLength', 'maxLength', 'pattern', 'blacklist', 'blacklistPattern', 'required', 'email', 'matchesInput']
	  },
	
	  translation: {},
	
	  validationRules: {},
	
	  formValidatorId: null,
	
	  fieldNames: [],
	
	  initialize: function initialize(_ref) {
	    var validationRules = _ref.validationRules;
	
	    _jquery2.default.validator.addMethod('iban', _validateIBAN2.default, (0, _translation.get)('ui.input.validate.iban'));
	
	    this.validationRules = validationRules;
	    this.translation = _jquery2.default.extend(true, {}, (0, _translation.get)('ui.input.validation'));
	    this.removeOldValidator();
	    this.formValidatorId = this.checkFormValidatorId(this.$el);
	    this.fieldNames = this.getFieldNames(this.$el);
	
	    var defaultOnkeyup = _jquery2.default.validator.defaults.onkeyup;
	
	    _jquery2.default.validator.setDefaults({
	      onkeyup: function onkeyup(element, event) {
	        if ((0, _jquery2.default)(element).data('validation-keyup') === false) {
	          return;
	        }
	
	        defaultOnkeyup.apply(this, arguments);
	      }
	    });
	
	    var rules = this.generateRules(this.fieldNames, _jquery2.default.extend(true, {}, validationRules), this.availableRules, this.formValidatorId);
	
	    var messages = this.generateMessages(rules);
	
	    _jquery2.default.extend(_jquery2.default.validator.messages, this.getDefaultMessages());
	    this.validator = this.$el.validate({
	      onfocusout: this.onFocusOut,
	      onchange: this.onFocusOut,
	      errorClass: {
	        error: this.selectors.errorClass,
	        warning: this.selectors.warningClass
	      },
	      errorElement: 'div',
	      rules: rules,
	      messages: messages,
	      submitHandler: _jquery2.default.proxy(this.submitHandler, this),
	      errorPlacement: _jquery2.default.proxy(this.errorPlacement, this),
	      success: _jquery2.default.proxy(this.successHandler, this),
	      ignore: this.selectors.ignore
	    });
	  },
	
	  successHandler: function successHandler($error, element) {
	    var $element = (0, _jquery2.default)(element);
	    var $inputGroup = $error.closest(this.selectors.inputGroup);
	    var $customLabel = $inputGroup.find(this.selectors.inputCustomLabel);
	    var $label = $inputGroup.find(this.selectors.inputLabel);
	    var $inputGroupSet = $inputGroup.find(this.selectors.inputGroupSet);
	
	    $error.remove();
	
	    if ($customLabel.length) {
	      $label = $label.add($customLabel);
	    }
	
	    if (!($inputGroupSet.length && $inputGroupSet.find(this.selectors.invalidate).not($element).length)) {
	      $label.removeClass(this.selectors.errorLabelClass);
	    }
	
	    // if (!($inputGroupSet.length && $inputGroupSet.find(this.selectors.valid).not($element).length === 0) && $element.val().length) {
	    //     $element.siblings(this.selectors.inputFilledIcon).removeClass(this.selectors.hiddenClass);
	    // }
	    if ($element.val().length) {
	      $element.siblings(this.selectors.inputFilledIcon).removeClass(this.selectors.hiddenClass);
	
	      $element.siblings(this.selectors.inputInvalidIcon).addClass(this.selectors.hiddenClass);
	    }
	  },
	
	  errorPlacement: function errorPlacement($error, $element) {
	    var $inputGroup = $element.closest(this.selectors.inputGroup);
	    var $label = $inputGroup.find(this.selectors.inputLabel).eq(0);
	    var $customLabel = $inputGroup.find(this.selectors.inputCustomLabel);
	
	    if ($customLabel.length && !$label.length) {
	      $inputGroup.prepend($error);
	      $customLabel.addClass(this.selectors.errorLabelClass);
	    } else {
	      if ($label.length) {
	        $label.addClass(this.selectors.errorLabelClass).after($error);
	      } else {
	        $inputGroup.prepend($error);
	      }
	    }
	
	    $element.siblings(this.selectors.inputFilledIcon).addClass(this.selectors.hiddenClass);
	
	    $element.siblings(this.selectors.inputInvalidIcon).removeClass(this.selectors.hiddenClass);
	  },
	
	  onFocusOut: function onFocusOut(element) {
	    (0, _jquery2.default)(element).valid();
	  },
	
	  /**
	   * Get form validator id
	   * @param {$} $form
	   * @returns {string|Null}
	   */
	  checkFormValidatorId: function checkFormValidatorId($form) {
	    return $form.data('formvalidatorid') || null;
	  },
	
	  /**
	   * Get form field names
	   * @param {$} $form
	   * @returns {Array}
	   */
	  getFieldNames: function getFieldNames($form) {
	    var fieldNames = [];
	    var $fields = $form.find(this.selectors.inputFields).not(this.selectors.ignore);
	
	    _underscore2.default.each($fields, function (field) {
	      fieldNames.push(field.name);
	    });
	
	    return fieldNames;
	  },
	
	  /**
	   * Generate rules from config for jQueryValidation Plugin
	   *
	   * @param {Array} fieldNames
	   * @param {Object} validationRules
	   * @param {Object} availableRules
	   * @param {string} formValidatorId
	   * @returns {Object}
	   *
	   * Example
	   * {
	   *  "email": {
	   *      "error.maxLength": {
	   *          "rule": "255",
	   *          "validationType": "error",
	   *          "validationMethod": "maxLength"
	   *      },
	   *      "warning.pattern": {
	   *          "rule": "/^[a-z0-9_-]+([.|+][a-z0-9_-]+)*[@][a-z0-9-]+([.][a-z0-9-]+)*[.]([a-z]{2,}|xn--[a-z0-9]+)$/i",
	   *          "validationType": "warning",
	   *          "validationMethod": "pattern"
	   *      },
	   *      "error.required": {
	   *          "rule": true,
	   *          "validationType": "error",
	   *          "validationMethod": "required"
	   *      }
	   *  }
	   * }
	   */
	  generateRules: function generateRules(fieldNames, validationRules, availableRules, formValidatorId) {
	    var self = this;
	    var generatedRules = {};
	
	    _underscore2.default.each(fieldNames, function (fieldName) {
	      var fieldRules = validationRules[fieldName];
	
	      if (fieldRules) {
	        var generatedFieldRules = {};
	
	        if (formValidatorId && fieldRules[formValidatorId]) {
	          fieldRules = _jquery2.default.extend(true, {}, fieldRules, fieldRules[formValidatorId]);
	        }
	
	        _underscore2.default.each(availableRules, function (rules, errorType) {
	          if (errorType === 'error') {
	            _jquery2.default.extend(generatedFieldRules, self.convertRulesNames(self.convertRulesFromConfig(fieldRules, rules), errorType));
	          } else {
	            if (fieldRules[errorType]) {
	              _jquery2.default.extend(generatedFieldRules, self.convertRulesNames(self.convertRulesFromConfig(fieldRules[errorType], rules), errorType));
	            }
	          }
	        });
	
	        generatedRules[fieldName] = generatedFieldRules;
	      }
	    });
	
	    return generatedRules;
	  },
	
	  /**
	   * Convert rules to jQueryValidation format
	   *
	   * @param {Object} rules
	   * @param {Object} errorRules
	   * @returns {Object}
	   */
	  convertRulesFromConfig: function convertRulesFromConfig(rules, errorRules) {
	    if ('required' in rules) {
	      rules.required = rules.required.length > 1 ? rules.required : Boolean(rules.required);
	    }
	
	    if ('testEmpty' in rules) {
	      rules.required = true;
	    }
	
	    if (rules.blacklistPattern) {
	      rules.blacklistPattern = {
	        patterns: rules.blacklistPattern
	      };
	    }
	
	    if (rules.blacklist) {
	      rules.blacklist = {
	        patterns: rules.blacklist,
	        filterPattern: rules.filterPatternBeforeBlacklist || null
	      };
	    }
	
	    if (rules.options && rules.options.matchesInput) {
	      var id = this.$el.attr('id');
	
	      if (!id) {
	        id = this.cid;
	        this.$el.prop('id', id);
	      }
	
	      rules.matchesInput = '#' + id + ' ' + rules.options.matchesInput;
	    }
	
	    return _underscore2.default.pick(rules, errorRules);
	  },
	
	  /**
	   *  Add errorType prefix to rules
	   *
	   * @param {Object} rules
	   * @param {string} errorType
	   * @returns {Object}
	   */
	  convertRulesNames: function convertRulesNames(rules, errorType) {
	    var convertedRules = {};
	
	    _underscore2.default.each(rules, function (rule, validationMethod) {
	      convertedRules[errorType + '.' + validationMethod] = {
	        rule: rule,
	        validationType: errorType,
	        validationMethod: validationMethod
	      };
	    });
	
	    return convertedRules;
	  },
	
	  getDefaultMessages: function getDefaultMessages() {
	    return {
	      required: this.translation.standardMessages.required,
	      minLength: this.translation.standardMessages.minLength,
	      maxLength: this.translation.standardMessages.maxLength,
	      blacklist: this.translation.standardMessages.blacklist,
	      blacklistPattern: this.translation.standardMessages.blacklistPattern,
	      pattern: this.translation.standardMessages.pattern
	    };
	  },
	
	  /**
	   * Generate translations for jQueryValidation Plugin
	   *
	   * @param {Object} generatedRules
	   * @returns {Object}
	   *
	   * Example
	   *  {
	   *      "email": {
	   *          "error.maxLength": "Der Eintrag ist zu lang, bitte geben Sie höchstens {0} Zeichen ein.",
	   *          "warning.pattern": "Die Email Adresse ist ungültig, bitte korrigieren Sie die Eingabe.",
	   *          "error.required": "Dies ist ein Pflichtfeld."
	   *      }
	   *  }
	   */
	  generateMessages: function generateMessages(generatedRules) {
	    var generatedMessages = {};
	    var self = this;
	
	    _underscore2.default.each(generatedRules, function (generatedRule, fieldName) {
	      generatedMessages[fieldName] = {};
	
	      _underscore2.default.each(generatedRule, function (value) {
	        generatedMessages[fieldName][value.validationType + '.' + value.validationMethod] = self.getMessage(value.validationMethod, fieldName, value.validationType);
	      });
	    });
	
	    return generatedMessages;
	  },
	
	  /**
	   * Get translated message for specific form, specific field
	   *
	   * @param {string} propertyName
	   * @param {string} fieldName
	   * @param {string} errorType
	   * @returns {Boolean|Object}
	   */
	  getMessage: function getMessage(propertyName, fieldName, errorType) {
	    var result = false;
	
	    if (this.translation[fieldName]) {
	      result = this.getFieldSpecificMessage(propertyName, errorType, this.translation[fieldName], this.formValidatorId);
	    }
	
	    if (result === false && !_underscore2.default.isUndefined(this.translation.standardMessages[propertyName])) {
	      result = this.convertMessage(this.translation.standardMessages[propertyName]);
	    }
	
	    return result;
	  },
	
	  /**
	   * Get a translated message for a field.
	   * @param {string} propertyName
	   * @param {string} errorType
	   * @param {Object} translationObj
	   * @param {string} formValidatorId
	   * @returns {Boolean|string}
	   */
	  getFieldSpecificMessage: function getFieldSpecificMessage(propertyName, errorType, translationObj, formValidatorId) {
	    if (formValidatorId && translationObj[formValidatorId] && translationObj[formValidatorId][propertyName] && translationObj[formValidatorId][propertyName][errorType]) {
	      return this.convertMessage(translationObj[formValidatorId][propertyName][errorType]);
	    }
	
	    if (translationObj[propertyName]) {
	      if (translationObj[propertyName][errorType]) {
	        return this.convertMessage(translationObj[propertyName][errorType]);
	      }
	
	      return false;
	    } else if (translationObj.options && translationObj.options[propertyName]) {
	      return this.convertMessage(translationObj.options[propertyName][errorType]);
	    }
	
	    return false;
	  },
	
	  /**
	   * Convert variable in a message for jQueryValidation Plugin
	   * @param {string} message
	   * @returns {string}
	   */
	  convertMessage: function convertMessage(message) {
	    var i = 0;
	
	    return message.replace(/%\w*%/g, function () {
	      return '{' + i++ + '}';
	    });
	  },
	
	  removeOldValidator: function removeOldValidator() {
	    _jquery2.default.removeData(this.el, 'validator');
	  },
	
	  /**
	   * Return rules
	   * @public
	   * @param {string|string[]} fieldName
	   * @param {string} [formValidatorId]
	   * @returns {Object}
	   */
	  getRules: function getRules(fieldName, formValidatorId) {
	    var rules = this.generateRules(_underscore2.default.isArray(fieldName) ? fieldName : [fieldName], _jquery2.default.extend(true, {}, this.validationRules), this.availableRules, formValidatorId);
	    var messages = this.generateMessages(rules);
	
	    _underscore2.default.each(rules, function (value, key) {
	      rules[key].messages = messages[key];
	    });
	
	    return rules;
	  }
	});

/***/ },
/* 185 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Delivery = exports.Delivery = function Delivery(_ref) {
	  var className = _ref.className,
	      isFastDelivery = _ref.isFastDelivery,
	      DELIVERY = _ref.DELIVERY,
	      translated = _ref.translated;
	
	  return "\n<div class=\"" + (isFastDelivery ? className.DETAILS.DELIVERY.FAST : className.DETAILS.DELIVERY.NORMAL) + "\">\n    " + DELIVERY + ": " + translated + "\n</div>\n  ";
	};
	
	exports.default = Delivery;

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Price = exports.Price = function Price(_ref) {
	  var className = _ref.className,
	      currency = _ref.currency,
	      isReduced = _ref.isReduced,
	      isRecommended = _ref.isRecommended,
	      isValuePack = _ref.isValuePack,
	      sellPrice = _ref.sellPrice,
	      originalPrice = _ref.originalPrice,
	      priceDifference = _ref.priceDifference,
	      translations = _ref.translations;
	
	  var currencySign = currency === 'CHF' ? ' CHF' : '\u20AC';
	  var uvp = isRecommended ? translations.UVP : '';
	  var discountPrice = '\n<div class="' + className.DETAILS.PRICE.DISCOUNT + '"> ' + uvp + ' ' + originalPrice + currencySign + '</div>\n  ';
	  var priceDiffElement = '<div>' + translations.VALUE_PACK + ': <strong>' + priceDifference + ' ' + currencySign + '</strong></div>';
	
	  return '\n<div class="' + className.DETAILS.PRICE.WRAP + '">\n    <div class="' + (isReduced ? className.DETAILS.PRICE.STRIKE : className.DETAILS.PRICE.NORMAL) + '">' + sellPrice + currencySign + '</div>\n    ' + (isReduced ? discountPrice : '') + '\n</div>\n' + (isValuePack && isReduced ? priceDiffElement : '') + '\n  ';
	};
	
	exports.default = Price;

/***/ },
/* 187 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Title = exports.Title = function Title(_ref) {
	  var className = _ref.className,
	      url = _ref.url,
	      headline = _ref.headline,
	      subline = _ref.subline;
	
	  return "\n<div>\n    <a class=\"" + className.DETAILS.TITLE.HEADLINE + "\" href=\"" + url + "\">" + headline + "</a>\n    <div class=\"" + className.DETAILS.TITLE.SUBLINE + "\">" + subline + "</div>\n</div>\n  ";
	};
	
	exports.default = Title;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RecommendationSlide = undefined;
	
	var _recommendations = __webpack_require__(22);
	
	var _renderer = __webpack_require__(40);
	
	var RecommendationSlide = exports.RecommendationSlide = function RecommendationSlide(_ref, slideIndex, isDYOSlider) {
	  var recommendationId = _ref.recommendationId,
	      sku = _ref.sku,
	      parentSku = _ref.parentSku,
	      name = _ref.name,
	      url = _ref.url,
	      image = _ref.image,
	      price = _ref.price,
	      deliveryDetails = _ref.deliveryDetails;
	  return '\n<div\n  class="' + _recommendations.classNames.SLIDER_SLIDE + '"\n  ' + (0, _renderer.conditionallyRenderAttrs)(isDYOSlider, [{ name: 'data-dy-product-id', value: sku }]) + '\n  ' + (0, _renderer.conditionallyRenderAttrs)(!isDYOSlider, [{ name: 'data-sku', value: sku }, { name: 'data-parent-sku', value: parentSku }, { name: 'data-gtm-bind-click' }, { name: 'data-position', value: slideIndex }, { name: 'data-recommendation-id', value: recommendationId }]) + '\n>\n  <a href="' + url + '">\n    <span class="' + _recommendations.classNames.IMAGE + '">\n      <img src="' + image.src + '" alt="' + image.alt + '" width="180" height="180">\n    </span>\n    <span class="' + _recommendations.classNames.TITLE + '">\n      ' + name + '\n    </span>\n    <span class="' + _recommendations.classNames.PRICE + '">\n      <span class="' + (price.isReduced ? _recommendations.classNames.PRICE_VAL_NEW : '') + '">\n        ' + price.sellPrice + '\n      </span>\n      ' + (price.showRegularPrice && price.originalPrice ? '<span class="' + _recommendations.classNames.PRICE_VAL_OLD + '">' + price.originalPrice + '</span>' : '') + '\n    </span>\n    <span class="' + _recommendations.classNames.DELIVERY_TIME + ' ' + (deliveryDetails.isFastDelivery ? _recommendations.classNames.DELIVERY_TIME_FAST : '') + '">\n      ' + deliveryDetails.deliveryTime + '\n    </span>\n  </a>\n</div>\n';
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recommendations = __webpack_require__(22);
	
	var _renderer = __webpack_require__(40);
	
	var _recommendations2 = __webpack_require__(66);
	
	var _recommendationsSlide = __webpack_require__(188);
	
	var RecommendationsSlider = function RecommendationsSlider(_ref) {
	  var headline = _ref.headline,
	      data = _ref.data,
	      style = _ref.style;
	
	  var isDYOSlider = (0, _recommendations2.isRecommendationsResponseDYO)(data);
	
	  return data.items && data.items.length > 0 ? '\n  <div style="' + style + '">\n    <div\n      class="' + _recommendations.classNames.SLIDER_CONTAINER + '"\n      ' + (0, _renderer.conditionallyRenderAttrs)(isDYOSlider, [{ name: 'id', value: data.wId }, { name: 'data-dy-widget-id', value: data.wId }, { name: 'data-dy-feed-id', value: data.fId }]) + '\n      ' + (0, _renderer.conditionallyRenderAttrs)(!isDYOSlider, [{
	    name: 'data-gtm-event-source',
	    value: 'Inline QuickView Recommendations Slider'
	  }]) + '\n    >\n      <h3>' + headline + '</h3>\n      <div\n        class="' + _recommendations.classNames.SLIDER_WRAPPER + '"\n        ' + (0, _renderer.conditionallyRenderAttrs)(isDYOSlider, [{
	    name: 'data-dy-strategy-id',
	    value: data.strId
	  }]) + '\n      >\n        ' + data.items.map(function (rec, i) {
	    return (0, _recommendationsSlide.RecommendationSlide)(rec, i, isDYOSlider);
	  }).join(' ') + '\n      </div>\n      <div class="' + _recommendations.classNames.SLIDER_NAV_ARROW_LEFT + '"></div>\n      <div class="' + _recommendations.classNames.SLIDER_NAV_ARROW_RIGHT + '"></div>\n    </div>\n  </div>' : '';
	};
	
	exports.default = RecommendationsSlider;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.attachInhouseRecommendationsTracking = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _storageFactory = __webpack_require__(7);
	
	var _recommendations = __webpack_require__(22);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var trackingDataAttrsMap = {
	  sku: 'data-sku',
	  position: 'data-position',
	  recommendationId: 'data-recommendation-id'
	};
	var storageKey = 'GtmOnArticleClicked';
	
	var getElemByClassName = function getElemByClassName(cn) {
	  return document.querySelector('.' + cn);
	};
	
	var getTrackingData = function getTrackingData(target) {
	  var data = Object.keys(trackingDataAttrsMap).reduce(function (attr, key) {
	    return _extends({}, attr, _defineProperty({}, key, target.getAttribute(trackingDataAttrsMap[key])));
	  }, {});
	  data.source = getElemByClassName(_recommendations.classNames.SLIDER_CONTAINER).getAttribute('data-gtm-event-source');
	  return data;
	};
	
	var storeTrackingData = function storeTrackingData(data) {
	  var storage = (0, _storageFactory.getStorage)();
	  storage.set(storageKey, data);
	};
	
	var handleRecommendationClick = function handleRecommendationClick(_ref) {
	  var currentTarget = _ref.currentTarget;
	
	  var trackingData = getTrackingData(currentTarget);
	  storeTrackingData(trackingData);
	};
	
	var attachInhouseRecommendationsTracking = exports.attachInhouseRecommendationsTracking = function attachInhouseRecommendationsTracking() {
	  var recNodes = Array.from(document.querySelectorAll('.' + _recommendations.classNames.SLIDER_CONTAINER + ' [data-gtm-bind-click]'));
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = Array.from(recNodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var recNode = _step.value;
	
	      recNode.addEventListener('click', handleRecommendationClick);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	};

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.addClientIdToDeepLink = addClientIdToDeepLink;
	
	var _queryString = __webpack_require__(279);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @description adds `clientId` info from Google Analytics into `deep_link` parameter from an url
	 * @param url {String}
	 * @param clientId {String}
	 * @returns {String} if the input url have `deep_link` parameter, adds clientId on that;
	 *                   otherwise returns the same url
	 */
	function addClientIdToDeepLink(url, clientId) {
	  var _url$split = url.split('?'),
	      _url$split2 = _slicedToArray(_url$split, 2),
	      urlBase = _url$split2[0],
	      urlParams = _url$split2[1];
	
	  var params = _queryString2.default.parse(urlParams);
	
	  if (!params.deep_link) {
	    return url;
	  }
	
	  var _params$deep_link$spl = params.deep_link.split('?'),
	      _params$deep_link$spl2 = _slicedToArray(_params$deep_link$spl, 2),
	      deepLink = _params$deep_link$spl2[0],
	      deepLinkParams = _params$deep_link$spl2[1];
	
	  if (deepLinkParams) {
	    var deepLinkParamsObject = _extends({}, _queryString2.default.parse(deepLinkParams), {
	      clientid: clientId
	    });
	
	    var newParams = _extends({}, params, {
	      deep_link: deepLink + '?' + _queryString2.default.stringify(deepLinkParamsObject)
	    });
	
	    return urlBase + '?' + _queryString2.default.stringify(newParams);
	  }
	
	  params.deep_link += '?clientid=' + clientId;
	
	  return urlBase + '?' + _queryString2.default.stringify(params);
	}

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ravenJs = __webpack_require__(280);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _process$env = ({"NODE_ENV":"production","ENV":"live","ASSETS_HASH":"16c6467"}),
	    environment = _process$env.ENV,
	    release = _process$env.ASSETS_HASH;
	
	
	if (environment !== 'docker') {
	  var shopRebootDsn = 'https://4a7c39feab8b475aa16a2ccc5d09641f@sentry.io/1407539';
	  var sentryProjects = {
	    plp: {
	      regex: /(kategorie|categorie|categoria)/,
	      dsn: 'https://8c0a5ff1ff80420e997611de619ff86d@sentry.io/1407543'
	    },
	    pdp: {
	      regex: /(produkt|product|article|prodotto)/,
	      dsn: 'https://ad5539bf2a48438ba221504319f4f9e6@sentry.io/1407541'
	    },
	    'cart-and-checkout': {
	      regex: /(checkout)/,
	      dsn: 'https://37fbe9f5eceb45f88a26b9eca06b2740@sentry.io/1407546'
	    },
	    'my-account': {
	      regex: /(meinkundenkonto|mon-compte|mijnaccount|ilmioaccount|myaccount|artikelauswahl|anfragegrund|info|success|artikelkeuze|aanvraagreden|scelta-articolo|motivo-richiesta|selectionarticle|objetrequete)/,
	      dsn: 'https://20772ae30c774eefad5d58de06ce01ae@sentry.io/1407547'
	    },
	    help: {
	      regex: /(hilfebereich|aide-faq|assistentie|assistenza)/,
	      dsn: 'https://1d6554983c604db0930ca2a35ac76b0e@sentry.io/1407548'
	    }
	  };
	  var url = window.location.href;
	
	  var sentryProjectDsn = shopRebootDsn; // default sentry project
	  for (var key in sentryProjects) {
	    if (url.match(sentryProjects[key].regex)) {
	      sentryProjectDsn = sentryProjects[key].dsn;
	      break;
	    }
	  }
	  _ravenJs2.default.config(sentryProjectDsn, {
	    release: release,
	    environment: environment
	  }).install();
	}

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindListenersToSlidingMenu = bindListenersToSlidingMenu;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sliding menu is the new mobile navigation for Global Navigation project,
	 * a.k.a Header Footer Navigation.
	 *
	 * This new navigation is triggered via touch on burger icon and dispatch some
	 * events that are used for preventing scroll
	 *
	 * @return {undefined}
	 */
	function bindListenersToSlidingMenu() {
	  (0, _jquery2.default)(document).ready(function () {
	    var $html = (0, _jquery2.default)('html');
	
	    _jquery2.default.subscribe('mobile-navigation:menu-opened', function () {
	      $html.addClass('prevent-scrolling');
	    });
	
	    _jquery2.default.subscribe('mobile-navigation:menu-closed', function () {
	      $html.removeClass('prevent-scrolling');
	    });
	  });
	}

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jsCookie = __webpack_require__(273);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _deepLink = __webpack_require__(191);
	
	var _client = __webpack_require__(196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * smart banner, client side logic
	 */
	var smartBanner = {
	  selectors: {
	    parent: '.js-smart-banner',
	    closeButton: '.js-smart-banner-close',
	    buttons: '.js-smart-banner-button'
	  },
	
	  cookieKeys: {
	    userClosedBanner: 'userClosedBanner'
	  },
	
	  constants: {
	    daysHiddenAfterUserClosesBanner: 7
	  },
	
	  /**
	   * @description bind events and display banner on initilization
	   * @returns {undefined}
	   */
	  init: function init() {
	    this.$parent = (0, _jquery2.default)(this.selectors.parent);
	    this.bindEvents();
	    this.displayBanner();
	  },
	
	  /**
	   * @description Bind event on click, add listener that listens to a DY event, which adds a cookie for testing.
	   * @returns {undefined}
	   */
	  bindEvents: function bindEvents() {
	    var _this = this;
	
	    (0, _jquery2.default)(this.selectors.closeButton).on('click', _jquery2.default.proxy(this.onClose, this));
	    document.addEventListener('dy:smartbanner_test', function () {
	      _this.displayBanner();
	    });
	  },
	
	  /**
	   * @description Hide Banner, Set the cookie
	   * @param {Event} event is used to prevent default functionality
	   * @returns {undefined}
	   */
	  onClose: function onClose(event) {
	    event.preventDefault();
	    this.hide();
	    this.setCookieBannerClosed();
	  },
	
	  /**
	   * @description Hide banner
	   * @returns {undefined}
	   */
	  hide: function hide() {
	    this.$parent.addClass('is-hidden');
	  },
	
	  /**
	   * @description Show banner
	   * @returns {undefined}
	   */
	  show: function show() {
	    this.$parent.removeClass('is-hidden');
	  },
	
	  /**
	   * @description get clientId from Google Analytics and then add it to `deep_link` parameter on button's URL
	   * @returns {undefined}
	   */
	  addAnalyticsClientIdToDeepLink: function addAnalyticsClientIdToDeepLink() {
	    var _this2 = this;
	
	    _client.client.getClientId().then(function (clientId) {
	      _this2.$parent.find(_this2.selectors.buttons).each(function (index, button) {
	        button.href = (0, _deepLink.addClientIdToDeepLink)(button.href, clientId);
	      });
	
	      return clientId;
	    });
	  },
	
	  /**
	   * @description Set cookie for closed banned by user with an expiration date
	   * @returns {undefined}
	   */
	  setCookieBannerClosed: function setCookieBannerClosed() {
	    _jsCookie2.default.set(this.cookieKeys.userClosedBanner, true, {
	      expires: this.constants.daysHiddenAfterUserClosesBanner
	    });
	  },
	
	  /**
	   * @description Check if the cookie for the closed banner exists.
	   * @returns {Boolean}
	   */
	  hasUserClosed: function hasUserClosed() {
	    return !!_jsCookie2.default.get(this.cookieKeys.userClosedBanner);
	  },
	
	  /**
	   * @description Check if the banner is supposed to be shown. If so, show it.
	   * Otherwise keep it hidden.
	   * @returns {undefined}
	   */
	  displayBanner: function displayBanner() {
	    if (!this.hasUserClosed()) {
	      this.show();
	      this.addAnalyticsClientIdToDeepLink();
	    }
	  }
	};
	
	function init() {
	  if ((0, _jquery2.default)(smartBanner.selectors.parent).length > 0) {
	    smartBanner.init();
	  }
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.destroy = destroy;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _Utils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectors = {
	  countBadge: '.js-header__wishlist-articles-count'
	};
	
	var cssClasses = {
	  hidden: 'is-hidden'
	};
	
	var $cartCountBadge;
	var currentTimestamp = 0;
	
	function init() {
	  $cartCountBadge = (0, _jquery2.default)(selectors.countBadge);
	  _jquery2.default.subscribe('update.wishlist:counter', updateCounter);
	}
	
	function destroy() {
	  _jquery2.default.unsubscribe('.wishlist:counter');
	}
	
	function updateCounter(event, data) {
	  if (!isLatest(data.changed)) {
	    return;
	  }
	
	  // update timestamp
	  currentTimestamp = data.changed;
	
	  // set cookie
	  (0, _Utils.setCookie)('wishlistItemsCount', data.wishlistItemsCount);
	
	  // update counter
	  $cartCountBadge.text(data.wishlistItemsCount);
	
	  if (data.wishlistItemsCount === 0) {
	    toggleBadge(true);
	  } else {
	    toggleBadge(false);
	  }
	}
	
	function toggleBadge(bool) {
	  $cartCountBadge.toggleClass(cssClasses.hidden, bool);
	}
	
	function isLatest(newTimestamp) {
	  return currentTimestamp < newTimestamp;
	}

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.client = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.runWhenGoogleAnalyticsIsLoaded = runWhenGoogleAnalyticsIsLoaded;
	exports.analyticsClient = analyticsClient;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Singletone client to be used across the app; it will cache `clientId` value
	var client = exports.client = analyticsClient();
	
	/**
	 * @description runs a callback function when Google Analytics object is defined
	 * @param callback {Function} function to be executed when `ga` is available on `window`.
	 *                            Receives the tracker as parameter.
	 */
	function runWhenGoogleAnalyticsIsLoaded(callback) {
	  if (window.ga && window.ga.create) {
	    callback(window.ga);
	  } else {
	    setTimeout(function () {
	      runWhenGoogleAnalyticsIsLoaded(callback);
	    }, 500);
	  }
	}
	
	/**
	 * @description
	 * @returns {Object} with `getClientId` function
	 */
	function analyticsClient() {
	  var clientId = null;
	
	  return {
	    /**
	     * @description get clientId from Google Analytics tracker.
	     * @returns {Promise} that gives the clientId value
	     */
	    getClientId: function getClientId() {
	      var promise = _jquery2.default.Deferred();
	
	      if (clientId !== null) {
	        promise.resolve(clientId);
	      }
	
	      runWhenGoogleAnalyticsIsLoaded(function (_ga) {
	        _ga(function () {
	          var _ga$getAll = _ga.getAll(),
	              _ga$getAll2 = _slicedToArray(_ga$getAll, 1),
	              firstTracker = _ga$getAll2[0];
	
	          clientId = firstTracker.get('clientId');
	
	          promise.resolve(clientId);
	        });
	      });
	
	      return promise;
	    }
	  };
	}

/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getOrderItemData = getOrderItemData;
	/**
	 * return dataLayer's eventData for every order item tracking tag
	 * @param {jQuery} $orderItem - top div of order item
	 * @return {Object} order Item eventData
	 */
	function getOrderItemData($orderItem) {
	  var basicOrderData = {
	    placement: 'My Order page',
	    label: $.trim($orderItem.find('.js-order-item-label').text()),
	    labelIdentifier: 'Item_Info',
	    orderId: $orderItem.closest('.js-order').data('order-id'),
	    itemId: $orderItem.data('sku'),
	    orderType: $orderItem.data('order-type')
	  };
	
	  var $orderItemInfo = $orderItem.find('.js-order-item-info');
	  var $spareParts = $orderItem.find('.js-spare-part-status');
	
	  var itemStatus = $orderItemInfo.data('item-status');
	  var deliveryType = $orderItemInfo.data('delivery-type');
	
	  var exchangeStatus = $orderItem.find('.js-exchange-status').data('item-status');
	
	  var hasExchange = exchangeStatus !== undefined;
	  var hasReturn = deliveryType === 'return';
	  var hasSpareParts = $spareParts.length > 0;
	
	  if (hasSpareParts) {
	    return _extends({}, basicOrderData, {
	      itemStatus: $spareParts.toArray().map(function (el) {
	        return el.dataset['itemStatus'];
	      }),
	      lastOrderType: $orderItem.data('last-order-type')
	    });
	  }
	
	  if (hasExchange) {
	    return _extends({}, basicOrderData, {
	      itemStatus: hasReturn ? {
	        return: itemStatus,
	        exchange: exchangeStatus
	      } : exchangeStatus
	    });
	  }
	
	  return _extends({}, basicOrderData, {
	    itemStatus: itemStatus
	  });
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Model = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _storageFactory = __webpack_require__(7);
	
	var _helper = __webpack_require__(10);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PageVisit = function () {
	  function PageVisit(model) {
	    _classCallCheck(this, PageVisit);
	
	    this.model = model;
	    this.onClick = this.onClick.bind(this);
	  }
	
	  _createClass(PageVisit, [{
	    key: 'setupEvents',
	    value: function setupEvents() {
	      (0, _jquery2.default)('#pdp-app-root').on('click', '[data-gtm-bind-click]', this.onClick);
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	      var dataAttributes = $currentTarget.data();
	
	      this.storeTrackingData({
	        sku: dataAttributes.sku,
	        position: dataAttributes.position,
	        recommendationId: dataAttributes.recommendationId,
	        source: this.getEventSource($currentTarget)
	      });
	    }
	
	    // This method must be present to be identified as a tracker. Usually you
	    // extend a base-tracking, but in our case we want a different
	    // implementation.
	
	  }, {
	    key: 'executeCookieCallbacks',
	    value: function executeCookieCallbacks() {
	      var storedTrackingData = this.popStoredTrackingData();
	      var trackingData = this.model.get('trackingData');
	
	      if (!trackingData) {
	        return;
	      }
	
	      var recommendationId = storedTrackingData.recommendationId;
	
	      this.pushClickToDataLayer(_extends({}, trackingData, {
	        recommendationId: recommendationId ? recommendationId : null,
	        position: storedTrackingData.position,
	        source: storedTrackingData.source
	      }));
	
	      _jquery2.default.post((0, _config.getBaseUrl)() + '/article/recordvisit', {
	        sku: trackingData.sku,
	        recommendationId: storedTrackingData.recommendationId
	      });
	    }
	  }, {
	    key: 'pushClickToDataLayer',
	    value: function pushClickToDataLayer(trackingData) {
	      if (_typeof(window.dataLayer) !== 'object') {
	        return;
	      }
	
	      var productData = {
	        name: trackingData.name,
	        id: trackingData.sku,
	        price: trackingData.price,
	        brand: trackingData.brand,
	        category: trackingData.category,
	        variant: trackingData.variant,
	        dimension64: trackingData.deliveryTime,
	        position: trackingData.position
	      };
	
	      if (trackingData.productCampaigns) {
	        productData.productCampaigns = trackingData.productCampaigns;
	      }
	
	      if (trackingData.recommendationId) {
	        productData.recommendationID = trackingData.recommendationId;
	      }
	
	      window.dataLayer.push({
	        event: 'productClick',
	        ecommerce: {
	          click: {
	            actionField: {
	              list: trackingData.source
	            },
	            products: [productData]
	          }
	        }
	      });
	    }
	  }, {
	    key: 'storeTrackingData',
	    value: function storeTrackingData(data) {
	      var storage = (0, _storageFactory.getStorage)();
	      storage.set('GtmOnArticleClicked', data);
	    }
	  }, {
	    key: 'popStoredTrackingData',
	    value: function popStoredTrackingData() {
	      var storage = (0, _storageFactory.getStorage)();
	      var storedTrackingData = storage.get('GtmOnArticleClicked');
	
	      if (storedTrackingData) {
	        storage.unset('GtmOnArticleClicked');
	      }
	
	      return storedTrackingData || {};
	    }
	  }, {
	    key: 'getEventSource',
	    value: function getEventSource($element) {
	      var source = $element.data('gtmEventSource') || $element.closest('[data-gtm-event-source]').data('gtmEventSource');
	
	      // add category name if available
	      var categoryName = (0, _helper.getCurrentDataLayer)().pageProdGroup;
	
	      if (categoryName) {
	        // ie. 'Catalog - Möbel'
	        source = source + ' - ' + categoryName;
	      }
	
	      return source;
	    }
	  }]);
	
	  return PageVisit;
	}();
	
	// Backbone.Model is also compatible with this Model
	
	
	var Model = exports.Model = function () {
	  function Model() {
	    var vals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Model);
	
	    this.vals = vals;
	  }
	
	  _createClass(Model, [{
	    key: 'set',
	    value: function set(vals) {
	      this.vals = _extends({}, this.vals, vals);
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      return this.vals[key];
	    }
	  }]);
	
	  return Model;
	}();
	
	exports.default = PageVisit;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WishlistButtonView;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _wishlistService = __webpack_require__(91);
	
	var wishlistService = _interopRequireWildcard(_wishlistService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectors = {
	  wishlistButton: '.js-wishlist-button',
	  wishlistIconClass: 'wishlist-icon',
	  wishlistIconActiveClass: 'wishlist-icon--active',
	  wishlistIconInactiveClass: 'wishlist-icon--inactive'
	};
	
	function WishlistButtonView() {
	  _underscore2.default.bindAll(this, 'onClick');
	
	  this.$container = (0, _jquery2.default)('body');
	  this.inRequestElements = [];
	  this.initialize();
	}
	
	WishlistButtonView.prototype = {
	  initialize: function initialize() {
	    this.$container.on('click touchend', selectors.wishlistButton, this.onClick);
	  },
	
	  destroy: function destroy() {
	    this.$container.off('click touchend', this.onClick);
	  },
	
	  onClick: function onClick(event) {
	    event.preventDefault();
	
	    var $clickedEl = (0, _jquery2.default)(event.currentTarget);
	
	    // jquery caches the attribute value if retrieved with .data()
	    var sku = $clickedEl.attr('data-sku');
	    var $iconEl = this.getIconElement($clickedEl);
	    var action;
	    var promise;
	
	    if (this.checkInProgress($iconEl)) {
	      return;
	    }
	
	    if (this.isActive($iconEl)) {
	      action = 'remove';
	      promise = wishlistService.remove(sku);
	    } else {
	      action = 'add';
	      promise = wishlistService.add(sku);
	    }
	
	    promise.done(_underscore2.default.bind(this.onSuccess, this, sku, action));
	    promise.fail(_underscore2.default.bind(this.onFail, this, $iconEl));
	    promise.always(_underscore2.default.bind(this.onRequestFinish, this, $iconEl));
	
	    // for better UX set the new state now and validate the response later
	    this.toggleButtonState($iconEl);
	  },
	
	  // check what was clicked, button with icon inside or icon directly
	  getIconElement: function getIconElement($clickedEl) {
	    var result;
	
	    if ($clickedEl.hasClass(selectors.wishlistIconClass)) {
	      result = $clickedEl;
	    } else {
	      result = $clickedEl.find('.' + selectors.wishlistIconClass);
	    }
	
	    return result;
	  },
	
	  isActive: function isActive($el) {
	    return $el.hasClass(selectors.wishlistIconActiveClass);
	  },
	
	  checkInProgress: function checkInProgress($el) {
	    var el = $el[0];
	    var index = this.inRequestElements.indexOf(el);
	
	    if (~index) {
	      return true;
	    }
	
	    this.inRequestElements.push(el);
	
	    return false;
	  },
	
	  onRequestFinish: function onRequestFinish($el) {
	    var el = $el[0];
	    var index = this.inRequestElements.indexOf(el);
	
	    if (~index) {
	      this.inRequestElements.splice(index, 1);
	    }
	  },
	
	  onSuccess: function onSuccess(sku, action) {
	    if (action === 'add') {
	      _jquery2.default.publish('added.wishlist', { sku: sku });
	    } else if (action === 'remove') {
	      _jquery2.default.publish('removed.wishlist', { sku: sku });
	    }
	  },
	
	  onFail: function onFail($el) {
	    this.toggleButtonState($el);
	  },
	
	  toggleButtonState: function toggleButtonState($el) {
	    if (this.isActive($el)) {
	      $el.removeClass(selectors.wishlistIconActiveClass);
	      $el.addClass(selectors.wishlistIconInactiveClass);
	    } else {
	      $el.addClass(selectors.wishlistIconActiveClass);
	      $el.removeClass(selectors.wishlistIconInactiveClass);
	    }
	  }
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * menu-aim is a $ plugin for dropdown menus that can differentiate
	 * between a user trying hover over a dropdown item vs trying to navigate into
	 * a submenu's contents.
	 *
	 * menu-aim assumes that you have are using a menu with submenus that expand
	 * to the menu's right. It will fire events when the user's mouse enters a new
	 * dropdown item *and* when that item is being intentionally hovered over.
	 *
	 * __________________________
	 * | Monkeys  >|   Gorilla  |
	 * | Gorillas >|   Content  |
	 * | Chimps   >|   Here     |
	 * |___________|____________|
	 *
	 * In the above example, "Gorillas" is selected and its submenu content is
	 * being shown on the right. Imagine that the user's cursor is hovering over
	 * "Gorillas." When they move their mouse into the "Gorilla Content" area, they
	 * may briefly hover over "Chimps." This shouldn't close the "Gorilla Content"
	 * area.
	 *
	 * This problem is normally solved using timeouts and delays. menu-aim tries to
	 * solve this by detecting the direction of the user's mouse movement. This can
	 * make for quicker transitions when navigating up and down the menu. The
	 * experience is hopefully similar to amazon.com/'s "Shop by Department"
	 * dropdown.
	 *
	 * Use like so:
	 *
	 *      $("#menu").menuAim({
	 *          activate: $.noop,  // fired on row activation
	 *          deactivate: $.noop  // fired on row deactivation
	 *      });
	 *
	 *  ...to receive events when a menu's row has been purposefully (de)activated.
	 *
	 * The following options can be passed to menuAim. All functions execute with
	 * the relevant row's HTML element as the execution context ('this'):
	 *
	 *      .menuAim({
	 *          // Function to call when a row is purposefully activated. Use this
	 *          // to show a submenu's content for the activated row.
	 *          activate: function() {},
	 *
	 *          // Function to call when a row is deactivated.
	 *          deactivate: function() {},
	 *
	 *          // Function to call when mouse enters a menu row. Entering a row
	 *          // does not mean the row has been activated, as the user may be
	 *          // mousing over to a submenu.
	 *          enter: function() {},
	 *
	 *          // Function to call when mouse exits a menu row.
	 *          exit: function() {},
	 *
	 *          // Selector for identifying which elements in the menu are rows
	 *          // that can trigger the above events. Defaults to "> li".
	 *          rowSelector: "> li",
	 *
	 *          // You may have some menu rows that aren't submenus and therefore
	 *          // shouldn't ever need to "activate." If so, filter submenu rows w/
	 *          // this selector. Defaults to "*" (all elements).
	 *          submenuSelector: "*",
	 *
	 *          // Direction the submenu opens relative to the main menu. Can be
	 *          // left, right, above, or below. Defaults to "right".
	 *          submenuDirection: "right"
	 *      });
	 *
	 * https://github.com/kamens/$-menu-aim
	 */
	
	var MenuAim = function () {
	  function MenuAim(config) {
	    _classCallCheck(this, MenuAim);
	
	    this.MOUSE_LOCS_TRACKED = 3;
	    this.DELAY = 100;
	    this.selectors = {};
	
	    this.init(config || {});
	  }
	
	  /**
	   * @param {String} selectorId
	   */
	
	
	  _createClass(MenuAim, [{
	    key: 'getSelectorById',
	    value: function getSelectorById(selectorId) {
	      if (!_underscore2.default.isUndefined(this.selectors[selectorId])) {
	        return this.selectors[selectorId];
	      }
	
	      return false;
	    }
	
	    /**
	     * @param {String} selectorId
	     * @return {Object[]|Object|$}
	     */
	
	  }, {
	    key: 'getElementBySelectorById',
	    value: function getElementBySelectorById(selectorId) {
	      return (0, _jquery2.default)(this.selectors[selectorId]);
	    }
	  }, {
	    key: 'init',
	    value: function init(config) {
	      if (!config && !config.menuSelector) {
	        throw 'MenuAim target is not defined';
	      }
	
	      this.$menu = (0, _jquery2.default)(config.menuSelector);
	      this.$parent = (0, _jquery2.default)(config.parentSelector);
	      this.activeRow = null;
	      this.mouseLocs = [];
	      this.lastDelayLoc = null;
	      this.timeoutId = null;
	      this.options = _jquery2.default.extend({
	        rowSelector: config.menuSelector + '> li',
	        submenuDirection: 'right',
	        tolerance: 45, // bigger = more forgivey when entering submenu
	        enter: _jquery2.default.noop,
	        exit: _jquery2.default.noop,
	        activate: _jquery2.default.noop,
	        deactivate: _jquery2.default.noop,
	        exitMenu: _jquery2.default.noop
	      }, config.options);
	
	      this.$menu.on('mouseleave-not-touch', _jquery2.default.proxy(this.mouseleaveMenu, this));
	
	      this.$parent.on('touchend', this.options.rowSelector, _jquery2.default.proxy(this.toggleSubmenu, this)).on('mouseenter-not-touch', this.options.rowSelector, _jquery2.default.proxy(this.mouseenterRow, this)).on('mouseleave-not-touch', this.options.rowSelector, _jquery2.default.proxy(this.mouseleaveRow, this)).on('click-not-touch', this.options.rowSelector, _jquery2.default.proxy(this.clickRow, this));
	
	      this.$parent.on('mouseenter-not-touch', this.options.submenuSelector, _jquery2.default.proxy(this.mouseenterSubMenu, this)).on('mouseleave-not-touch', this.options.submenuSelector, _jquery2.default.proxy(this.mouseleaveSubMenu, this));
	
	      this.$parent.on('mousemove', _jquery2.default.proxy(this.mousemoveDocument, this));
	    }
	
	    /**
	     * Keep track of the last few locations of the mouse.
	     */
	
	  }, {
	    key: 'mousemoveDocument',
	    value: function mousemoveDocument(e) {
	      this.mouseLocs.push({ x: e.pageX, y: e.pageY });
	
	      if (this.mouseLocs.length > this.MOUSE_LOCS_TRACKED) {
	        this.mouseLocs.shift();
	      }
	    }
	
	    /**
	     * Cancel possible row activations when leaving the menu entirely
	     */
	
	  }, {
	    key: 'mouseleaveMenu',
	    value: function mouseleaveMenu(event) {
	      var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	
	      if (this.timeoutId) {
	        window.clearTimeout(this.timeoutId);
	      }
	
	      // If exitMenu is supplied and returns true, deactivate the
	      // currently active row on menu exit.
	      if (this.options.exitMenu($currentTarget, event)) {
	        if (this.activeRow) {
	          this.options.deactivate(this.activeRow);
	        }
	
	        this.activeRow = null;
	      }
	    }
	  }, {
	    key: 'toggleSubmenu',
	    value: function toggleSubmenu(event) {
	      var $currentTarget = (0, _jquery2.default)(event.currentTarget),
	          possiblyPreventDefault = function possiblyPreventDefault(needPrevent) {
	        if (needPrevent) {
	          event.preventDefault();
	        }
	      };
	
	      if ($currentTarget.hasClass('active')) {
	        event.preventDefault();
	        this.options.exit($currentTarget);
	        this.options.deactivate(this.activeRow);
	        this.activeRow.removeClass('active');
	      } else {
	        if (this.activeRow) {
	          this.activeRow.removeClass('active');
	        }
	        this.options.enter($currentTarget);
	        this.activate($currentTarget, possiblyPreventDefault);
	        this.activeRow.addClass('active');
	      }
	    }
	
	    /**
	     * Trigger a possible row activation whenever entering a new row.
	     */
	
	  }, {
	    key: 'mouseenterRow',
	    value: function mouseenterRow(event) {
	      var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	
	      if (this.timeoutId) {
	        // Cancel any previous activation delays
	        window.clearTimeout(this.timeoutId);
	      }
	
	      this.options.enter($currentTarget);
	      this.possiblyActivate($currentTarget);
	    }
	  }, {
	    key: 'mouseleaveRow',
	    value: function mouseleaveRow(event) {
	      var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	      this.options.exit($currentTarget);
	    }
	  }, {
	    key: 'mouseenterSubMenu',
	    value: function mouseenterSubMenu(event) {
	      this.currentTarget = (0, _jquery2.default)(event.currentTarget);
	    }
	  }, {
	    key: 'mouseleaveSubMenu',
	    value: function mouseleaveSubMenu() {
	      this.currentTarget = null;
	    }
	
	    /*
	     * Immediately activate a row if the user clicks on it.
	     */
	
	  }, {
	    key: 'clickRow',
	    value: function clickRow(event) {
	      var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	      this.activate($currentTarget);
	    }
	
	    /**
	     * Activate a menu row.
	     * 'callback' is optional
	     */
	
	  }, {
	    key: 'activate',
	    value: function activate(row, callback) {
	      if (row == this.activeRow || (0, _jquery2.default)(this.currentTarget).is(this.options.submenuSelector)) {
	        return;
	      }
	
	      if (this.activeRow) {
	        this.options.deactivate(this.activeRow);
	      }
	
	      this.options.activate(row, callback);
	      this.activeRow = row;
	    }
	
	    /**
	     * Possibly activate a menu row. If mouse movement indicates that we
	     * shouldn't activate yet because user may be trying to enter
	     * a submenu's content, then delay and check again later.
	     */
	
	  }, {
	    key: 'possiblyActivate',
	    value: function possiblyActivate(row) {
	      var me = this,
	          delay = this.activationDelay();
	
	      if (delay) {
	        me.timeoutId = window.setTimeout(function () {
	          me.possiblyActivate(row);
	        }, delay);
	      } else {
	        this.activate(row);
	      }
	    }
	
	    /**
	     * Return the amount of time that should be used as a delay before the
	     * currently hovered row is activated.
	     *
	     * Returns 0 if the activation should happen immediately. Otherwise,
	     * returns the number of milliseconds that should be delayed before
	     * checking again to see if the row should be activated.
	     */
	
	  }, {
	    key: 'activationDelay',
	    value: function activationDelay() {
	      if (!this.activeRow) {
	        // If there is no other submenu row already active, then
	        // go ahead and activate immediately.
	        return 0;
	      }
	
	      var offset = this.$menu.offset(),
	          upperLeft = {
	        x: offset.left,
	        y: offset.top - this.options.tolerance
	      },
	          upperRight = {
	        x: offset.left + this.$menu.outerWidth(),
	        y: upperLeft.y
	      },
	          lowerLeft = {
	        x: offset.left,
	        y: offset.top + this.$menu.outerHeight() + this.options.tolerance
	      },
	          lowerRight = {
	        x: offset.left + this.$menu.outerWidth(),
	        y: lowerLeft.y
	      },
	          loc = this.mouseLocs[this.mouseLocs.length - 1],
	          prevLoc = this.mouseLocs[0];
	
	      if (!loc) {
	        return 0;
	      }
	
	      if (!prevLoc) {
	        prevLoc = loc;
	      }
	
	      if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x || prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
	        // If the previous mouse location was outside of the entire
	        // menu's bounds, immediately activate.
	        return 0;
	      }
	
	      if (this.lastDelayLoc && loc.x == this.lastDelayLoc.x && loc.y == this.lastDelayLoc.y) {
	        // If the mouse hasn't moved since the last time we checked
	        // for activation status, immediately activate.
	        return 0;
	      }
	
	      // Detect if the user is moving towards the currently activated
	      // submenu.
	      //
	      // If the mouse is heading relatively clearly towards
	      // the submenu's content, we should wait and give the user more
	      // time before activating a new row. If the mouse is heading
	      // elsewhere, we can immediately activate a new row.
	      //
	      // We detect this by calculating the slope formed between the
	      // current mouse location and the upper/lower right points of
	      // the menu. We do the same for the previous mouse location.
	      // If the current mouse location's slopes are
	      // increasing/decreasing appropriately compared to the
	      // previous's, we know the user is moving toward the submenu.
	      //
	      // Note that since the y-axis increases as the cursor moves
	      // down the screen, we are looking for the slope between the
	      // cursor and the upper right corner to decrease over time, not
	      // increase (somewhat counterintuitively).
	      function slope(a, b) {
	        return (b.y - a.y) / (b.x - a.x);
	      }
	
	      var decreasingCorner = upperRight,
	          increasingCorner = lowerRight;
	
	      // Our expectations for decreasing or increasing slope values
	      // depends on which direction the submenu opens relative to the
	      // main menu. By default, if the menu opens on the right, we
	      // expect the slope between the cursor and the upper right
	      // corner to decrease over time, as explained above. If the
	      // submenu opens in a different direction, we change our slope
	      // expectations.
	      if (this.options.submenuDirection == 'left') {
	        decreasingCorner = lowerLeft;
	        increasingCorner = upperLeft;
	      } else if (this.options.submenuDirection == 'below') {
	        decreasingCorner = lowerRight;
	        increasingCorner = lowerLeft;
	      } else if (this.options.submenuDirection == 'above') {
	        decreasingCorner = upperLeft;
	        increasingCorner = upperRight;
	      }
	
	      var decreasingSlope = slope(loc, decreasingCorner),
	          increasingSlope = slope(loc, increasingCorner),
	          prevDecreasingSlope = slope(prevLoc, decreasingCorner),
	          prevIncreasingSlope = slope(prevLoc, increasingCorner);
	
	      if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
	        // Mouse is moving from previous location towards the
	        // currently activated submenu. Delay before activating a
	        // new menu row, because user may be moving into submenu.
	        this.lastDelayLoc = loc;
	        return this.DELAY;
	      }
	
	      this.lastDelayLoc = null;
	      return 0;
	    }
	  }]);
	
	  return MenuAim;
	}();
	
	exports.default = MenuAim;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.update = update;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function update(data) {
	  var $scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _jquery2.default)(document);
	
	  $scope.find('[data-bind]').each(function () {
	    var $this = (0, _jquery2.default)(this);
	    var key = $this.data('bind');
	    var split = key.split('.');
	    var i;
	    var clonedData = _jquery2.default.extend(true, {}, data);
	    var localKey;
	    var maxLevel = split.length - 1;
	
	    for (i in split) {
	      /* istanbul ignore else */
	      if (split.hasOwnProperty(i)) {
	        localKey = split[i];
	
	        if (typeof clonedData[localKey] !== 'undefined') {
	          if (i === maxLevel) {
	            $this.html(clonedData[localKey]);
	          } else {
	            clonedData = clonedData[localKey];
	          }
	        }
	      }
	    }
	  });
	}

/***/ },
/* 202 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.redirect = redirect;
	/**
	 *
	 * @param {String} url
	 * @param {Boolean=} isFullUrl
	 */
	
	function redirect(url, isFullUrl) {
	  if (isFullUrl) {
	    window.location = url;
	  } else {
	    window.location.href = url;
	  }
	}

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setSubMenuHeight = setSubMenuHeight;
	exports.setSubmenuVerticalPosition = setSubmenuVerticalPosition;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// make sub navigation wider for new pages (new grid)
	var columnWidth = (0, _jquery2.default)("[data-page$='-new']").length ? 193.6 : 192;
	
	/**
	 * @see REBOOT-15193
	 */
	function setSubMenuHeight() {
	  var $placeholder = (0, _jquery2.default)('#main-sub-menu');
	  var $rows = $placeholder.find('.navigation--rows');
	  var $teaser = $placeholder.find('.navigation--teaser img');
	  var rowsHeight = $rows.outerHeight();
	  var teaserHeight = $teaser.height() + 3;
	
	  if (rowsHeight > teaserHeight) {
	    $placeholder.height(rowsHeight);
	  } else {
	    $placeholder.height(teaserHeight);
	  }
	
	  $rows.find('.navigation--row').each(function () {
	    var $row = (0, _jquery2.default)(this);
	    var height = -1;
	
	    /*
	     * Find max height of cells
	     */
	    $row.find('.navigation--cell-wrapper').each(function () {
	      var $cell = (0, _jquery2.default)(this);
	      var cellHeight = $cell.height();
	
	      if (cellHeight > height) {
	        height = cellHeight;
	      }
	    });
	
	    $row.find('.navigation--cell-wrapper').height(height);
	  });
	}
	
	function setSubmenuVerticalPosition(arrowX) {
	  var $subMenu = (0, _jquery2.default)('#main-sub-menu');
	  var $arrow = $subMenu.find('>.arrow');
	  var iArrowGrid = Math.floor(arrowX / 192);
	  var iMenuWidth = 0;
	  var iLeftColumn;
	  var iOffset;
	
	  if ($subMenu.find('.navigation--teaser').length > 0) {
	    iMenuWidth++;
	  }
	
	  iMenuWidth += $subMenu.find('.navigation--row:first .navigation--cell-wrapper').length;
	
	  /*
	     When I have width, alter view to match
	     */
	  $subMenu.width(columnWidth * iMenuWidth);
	  $subMenu.find('.navigation--row').width(columnWidth * iMenuWidth);
	
	  iLeftColumn = Math.round(iArrowGrid + 1 - iMenuWidth / 2);
	
	  if (iLeftColumn < 0) {
	    iLeftColumn = 0;
	  }
	  if (iLeftColumn + iMenuWidth > 5) {
	    iLeftColumn = 5 - iMenuWidth;
	  }
	
	  if (iLeftColumn > iArrowGrid) {
	    iLeftColumn = iArrowGrid;
	  }
	
	  iOffset = columnWidth * iLeftColumn;
	
	  $subMenu.css('left', iOffset + 'px');
	  $arrow.css('left', arrowX - iOffset + 'px');
	}

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _menuAim = __webpack_require__(200);
	
	var _menuAim2 = _interopRequireDefault(_menuAim);
	
	var _storageFactory = __webpack_require__(7);
	
	var _links = __webpack_require__(131);
	
	var _mainmenuLayout = __webpack_require__(203);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Page Main Menu
	 */
	var MainMenu = function () {
	  function MainMenu(c) {
	    _classCallCheck(this, MainMenu);
	
	    this.selectors = {
	      topNavContainer: 'div.main-navigation-wrapper',
	      topNavLinks: 'ul.main-navigation a.js-top-nav-link',
	      topNavItems: 'ul.main-navigation>li',
	      subMenu: '#main-sub-menu',
	      subMenuArrow: '#main-sub-menu>.arrow',
	      subMenuContentPlaceholder: '#main-sub-menu-placeholder',
	      subMenuTemplate: '.sub-menu-template',
	      subMenuLinks: '#main-sub-menu ul.sub-menu-list li>a, #main-sub-menu ul.sub-menu-list li>span',
	      subMenuItems: 'ul.sub-menu-list>li',
	      subMenu2: '#main-sub-menu-2',
	      subMenu2Template: '.sub-menu-2-template',
	      subMenu2Mock: '#main-sub-menu-2-mock',
	      subMenu2Indicator: '#main-sub-menu-2-mock .loading-indicator',
	      transparentOverflow: '.screen-transparent-overflow'
	    };
	
	    this.openMenuDelay = 200;
	    this.$currentTarget = null;
	
	    this.arrowX = 0;
	
	    this.init(c || {});
	  }
	
	  /**
	   * @param {String} selectorId
	   */
	
	  _createClass(MainMenu, [{
	    key: 'getSelectorById',
	    value: function getSelectorById(selectorId) {
	      if (!_underscore2.default.isUndefined(this.selectors[selectorId])) {
	        return this.selectors[selectorId];
	      }
	
	      return false;
	    }
	
	    /**
	     * @param {String} selectorId
	     * @return {Object[]|Object|$}
	     */
	
	  }, {
	    key: 'getElementBySelectorById',
	    value: function getElementBySelectorById(selectorId) {
	      return (0, _jquery2.default)(this.selectors[selectorId]);
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      new _menuAim2.default({
	        parentSelector: this.getElementBySelectorById('topNavContainer'),
	        menuSelector: this.getElementBySelectorById('subMenu'),
	        options: {
	          // Function to call when a row is purposefully activated. Use this
	          // to show a submenu's content for the activated row.
	          activate: _jquery2.default.proxy(this.onSubMenuItemActivate, this),
	
	          // Function to call when a row is deactivated.
	          deactivate: _jquery2.default.proxy(this.onSubMenuItemDeactivate, this),
	
	          // Function to call when mouse exits the entire menu. If this returns
	          // true, the current row's deactivation event and callback function
	          // will be fired. Otherwise, if this isn't supplied or it returns
	          // false, the currently activated row will stay activated when the
	          // mouse leaves the menu entirely.
	          exitMenu: _jquery2.default.proxy(this.onExitMenu, this),
	
	          // Selector for identifying which elements in the menu are rows
	          // that can trigger the above events. Defaults to "> li".
	          rowSelector: this.getSelectorById('subMenuLinks'),
	          submenuSelector: this.getSelectorById('subMenu2'),
	
	          // Direction the submenu opens relative to the main menu. This
	          // controls which direction is "forgiving" as the user moves their
	          // cursor from the main menu into the submenu. Can be one of "right",
	          // "left", "above", or "below". Defaults to "right".
	          submenuDirection: 'right'
	        }
	      });
	
	      this.req = null;
	      this.storage = (0, _storageFactory.getStorage)('memoryStorage');
	      this.menuContainerWidth = this.getElementBySelectorById('topNavContainer').width();
	      this.subMenuArrowWidth = this.getElementBySelectorById('subMenuArrow').outerWidth();
	      this.menuWidth = this.getElementBySelectorById('subMenuContentPlaceholder').outerWidth();
	      this.menuWidthExpanded = this.menuWidth;
	      this.ajaxUrl = config.getBaseUrl() + '/category/get-categories/id/';
	      this.rowItemTimer = null;
	      this.rowItemDelay = config.getInt('navigation.hoverDelay');
	
	      this.getElementBySelectorById('topNavLinks').on('touchend', _jquery2.default.proxy(this.switchNavMenu, this));
	
	      this.getElementBySelectorById('topNavLinks').on('mouseenter-not-touch', _jquery2.default.proxy(this.triggerOpenMenu, this));
	
	      this.getElementBySelectorById('topNavContainer').on('mouseleave-not-touch', _jquery2.default.proxy(this.triggerCloseMenu, this));
	
	      this.getElementBySelectorById('topNavContainer').find('.top.home').on('mouseenter-not-touch', _jquery2.default.proxy(this.onExitMenu, this));
	
	      this.getElementBySelectorById('transparentOverflow').on('touchend', _jquery2.default.proxy(this.touchCloseMenu, this));
	    }
	  }, {
	    key: 'touchCloseMenu',
	    value: function touchCloseMenu(event) {
	      event.preventDefault();
	
	      this.triggerCloseMenu(event);
	    }
	  }, {
	    key: 'switchNavMenu',
	    value: function switchNavMenu(event) {
	      if ((0, _jquery2.default)(event.currentTarget).parent(this.getSelectorById('topNavItems')).hasClass('active')) {
	        this.triggerCloseMenu(event);
	      } else {
	        this.triggerOpenMenu(event);
	      }
	    }
	  }, {
	    key: 'triggerOpenMenu',
	    value: function triggerOpenMenu(event) {
	      var self = this;
	
	      var openMenu = function openMenu() {
	        self.$currentTarget = (0, _jquery2.default)(event.currentTarget);
	        self.showSubMenu(self.$currentTarget, event);
	        self.$currentTarget.parent(self.getSelectorById('topNavItems')).addClass('active');
	      };
	
	      if (self.$currentTarget) {
	        self.$currentTarget.parent(self.getSelectorById('topNavItems')).removeClass('active');
	        openMenu();
	      } else {
	        clearTimeout(self.openMenuTimeout);
	        self.openMenuTimeout = setTimeout(openMenu, self.openMenuDelay);
	      }
	    }
	  }, {
	    key: 'triggerCloseMenu',
	    value: function triggerCloseMenu(event) {
	      var $toElement;
	
	      if (event.toElement) {
	        $toElement = (0, _jquery2.default)(event.toElement);
	      }
	
	      if (!$toElement || !$toElement.is(this.getSelectorById('subMenu')) && !$toElement.parent(this.getSelectorById('subMenu')).length > 0) {
	        this.onExitMenu(null, event);
	      }
	
	      if (this.openMenuTimeout) {
	        clearTimeout(this.openMenuTimeout);
	      }
	      this.$currentTarget = null;
	
	      this.getElementBySelectorById('transparentOverflow').hide();
	    }
	
	    /**
	     *'callback' is optional
	     */
	
	  }, {
	    key: 'onSubMenuItemActivate',
	    value: function onSubMenuItemActivate(row, callback) {
	      var $row = (0, _jquery2.default)(row);
	      var hasSubCategories = $row.data('hasSubCategories') ? $row.data('hasSubCategories') : $row.children('[data-selector]').data('hasSubCategories');
	      var categoryId = $row.data('categoryId') ? $row.data('categoryId') : $row.children('[data-selector]').data('categoryId');
	
	      if (hasSubCategories) {
	        this.showSubMenu2((0, _jquery2.default)(row), categoryId);
	      }
	
	      if (callback) {
	        callback(hasSubCategories);
	      }
	    }
	  }, {
	    key: 'onSubMenuItemDeactivate',
	    value: function onSubMenuItemDeactivate() {
	      clearTimeout(this.rowItemTimer);
	      this.hideSubMenu2();
	    }
	  }, {
	    key: 'onExitMenu',
	    value: function onExitMenu(target, event) {
	      if (!event) {
	        return;
	      }
	
	      clearTimeout(this.openMenuTimeout);
	
	      event.preventDefault();
	
	      var $toElement;
	
	      if (event.toElement) {
	        $toElement = (0, _jquery2.default)(event.toElement);
	      }
	
	      if (!$toElement || !$toElement.is(this.getSelectorById('topNavContainer')) && !$toElement.parent(this.getSelectorById('topNavContainer')).length > 0) {
	        this.hideSubMenu();
	
	        if (this.$currentTarget) {
	          this.$currentTarget.parent(this.getSelectorById('topNavItems')).removeClass('active');
	        }
	      }
	    }
	  }, {
	    key: 'showSubMenu',
	    value: function showSubMenu($menuItem, event) {
	      var $subMenu = this.getElementBySelectorById('subMenu');
	      var $subMenu2 = this.getElementBySelectorById('subMenu2');
	      var $template = $menuItem.parent(this.getSelectorById('topNavItems')).find(this.getSelectorById('subMenuTemplate'));
	      var templateHtml = $template.html() || '';
	      var $contentPlaceholder = this.getElementBySelectorById('subMenuContentPlaceholder');
	
	      this.tweakPosition = false;
	      this.hideSubMenu2();
	      $contentPlaceholder.html(templateHtml);
	
	      // TODO: ms edge hover fix, https://jira.home24.de/browse/REBOOT-21216
	      this._uncloakLinks($contentPlaceholder);
	
	      if (templateHtml.length > 0) {
	        event.preventDefault();
	
	        this.getElementBySelectorById('transparentOverflow').show();
	        this._positionMenu($menuItem);
	        $subMenu.show();
	
	        /**
	         * @see REBOOT-15193
	         */
	        if ($subMenu.hasClass('navigation--full')) {
	          (0, _mainmenuLayout.setSubMenuHeight)();
	          (0, _mainmenuLayout.setSubmenuVerticalPosition)(this.arrowX);
	        }
	
	        if (!$menuItem.parent('li').hasClass('show-two-columns')) {
	          $subMenu2.addClass('show-one-column');
	          $subMenu2.removeClass('show-two-columns');
	        } else {
	          $subMenu2.removeClass('show-one-column');
	          $subMenu2.addClass('show-two-columns');
	        }
	
	        this.$lastMenuItem = $menuItem;
	      } else {
	        $subMenu.hide();
	      }
	    }
	  }, {
	    key: 'hideSubMenu',
	    value: function hideSubMenu() {
	      this.getElementBySelectorById('subMenuContentPlaceholder').html('');
	      this.getElementBySelectorById('subMenu').hide();
	      this.getElementBySelectorById('subMenu2').hide();
	      this.abortRequest();
	    }
	  }, {
	    key: 'showSubMenu2',
	    value: function showSubMenu2($subMenuItem, categoryId) {
	      var me = this;
	      var $subMenu = me.getElementBySelectorById('subMenu');
	      var $subMenu2 = me.getElementBySelectorById('subMenu2');
	      var mockWidth = parseFloat($subMenu2.css('width')) || $subMenu2.width();
	      var submenuTemplate;
	
	      me.abortRequest();
	
	      me.getElementBySelectorById('subMenu2Mock').stop(true).css({
	        width: 0,
	        height: $subMenu.height() - 5,
	        display: 'block'
	      }).animate({
	        width: mockWidth
	      }, 75, function () {
	        me.getElementBySelectorById('subMenu2Indicator').show();
	      }).css({ overflow: 'visible' });
	
	      $subMenu2.html('');
	
	      submenuTemplate = me.storage.get(categoryId);
	
	      if (submenuTemplate) {
	        me._renderTemplate(submenuTemplate, $subMenu, $subMenuItem, $subMenu2);
	      } else {
	        me.rowItemTimer = setTimeout(function () {
	          me.req = _jquery2.default.ajax({
	            method: 'GET',
	            url: me.ajaxUrl + categoryId,
	            dataType: 'json'
	          }).fail(function () {
	            me.getElementBySelectorById('subMenu2Mock').css({
	              width: 0,
	              height: 0,
	              display: 'none'
	            }).stop(true);
	            me.hideSubMenu2();
	          }).done(function (data) {
	            if (_jquery2.default.isPlainObject(data) && data.content) {
	              me.storage.set(categoryId, data.content);
	              me._renderTemplate(data.content, $subMenu, $subMenuItem, $subMenu2);
	            } else {
	              return;
	            }
	            me.req = null;
	          });
	        }, me.rowItemDelay);
	      }
	    }
	  }, {
	    key: 'hideSubMenu2',
	    value: function hideSubMenu2() {
	      if (!this.tweakPosition) {
	        this.getElementBySelectorById('subMenu').find(' li>a.active').removeClass('active');
	        this.abortRequest();
	        this.getElementBySelectorById('subMenu2').hide().html('');
	      }
	      this.tweakPosition = false;
	    }
	  }, {
	    key: 'abortRequest',
	    value: function abortRequest() {
	      this.getElementBySelectorById('subMenu2Indicator').hide();
	      this.getElementBySelectorById('subMenu2Mock').css({
	        width: 0,
	        height: 0,
	        display: 'none'
	      }).stop(true);
	    }
	  }, {
	    key: '_positionMenu',
	    value: function _positionMenu($menuItem) {
	      var $subMenu = this.getElementBySelectorById('subMenu');
	      var $subMenuArrow = this.getElementBySelectorById('subMenuArrow');
	      var menuItemX = $menuItem.position().left;
	      var menuItemWidth = $menuItem.outerWidth();
	      var x;
	      var arrowX;
	
	      x = menuItemX + (menuItemWidth - this.menuWidth) / 2;
	
	      if (x < 0) {
	        // left menu point
	        x = 0;
	        arrowX = menuItemX + (menuItemWidth - this.subMenuArrowWidth) / 2;
	      } else if (x >= this.menuContainerWidth - this.menuWidth) {
	        // menu points in the middle
	        x = this.menuContainerWidth - this.menuWidth - 3;
	        arrowX = menuItemX - x + (menuItemWidth - this.subMenuArrowWidth) / 2;
	      } else {
	        // right menu point
	        arrowX = (this.menuWidth - this.subMenuArrowWidth) / 2;
	      }
	
	      /**
	       * @see REBOOT-15193
	       */
	      if (!$subMenu.hasClass('navigation--full')) {
	        $subMenu.css('left', x);
	      } else {
	        arrowX = arrowX + x;
	      }
	
	      this.arrowX = arrowX;
	
	      $subMenuArrow.css('left', arrowX);
	    }
	  }, {
	    key: '_renderTemplate',
	    value: function _renderTemplate(templateHtml, $subMenu, $subMenuItem, $subMenu2) {
	      var $subMenuArrow = this.getElementBySelectorById('subMenuArrow');
	      var newX;
	
	      $subMenu.find(' li>a.active').removeClass('active');
	      $subMenuItem.addClass('active');
	
	      $subMenu2.html(templateHtml);
	      this.menuWidthExpanded = this.menuWidth + $subMenu2.outerWidth() + (parseFloat($subMenu.css('border-left-width')) || 1) + (parseFloat($subMenu.css('border-right-width')) || 1);
	
	      if (templateHtml.length > 0) {
	        var x = $subMenu.position().left;
	
	        if (x + this.menuWidthExpanded >= this.menuContainerWidth) {
	          this.tweakPosition = true;
	          newX = this.menuContainerWidth - this.menuWidthExpanded;
	          $subMenu.css('left', newX);
	          $subMenuArrow.css('left', this.$lastMenuItem.position().left - newX + (this.$lastMenuItem.outerWidth() - this.subMenuArrowWidth) / 2);
	        }
	
	        this.getElementBySelectorById('subMenu2Mock').css({
	          width: 0,
	          height: 0,
	          display: 'none'
	        }).stop(true);
	        $subMenu2.show();
	      } else {
	        this.hideSubMenu2();
	      }
	    }
	
	    // TODO: ms edge hover fix, https://jira.home24.de/browse/REBOOT-21216
	
	  }, {
	    key: '_uncloakLinks',
	    value: function _uncloakLinks($template) {
	      $template.find('span[data-dma], div[data-dma]').each(function () {
	        var $link = (0, _jquery2.default)(this);
	
	        (0, _links.uncloakElement)($link);
	      });
	    }
	  }]);
	
	  return MainMenu;
	}();
	
	exports.default = MainMenu;

/***/ },
/* 205 */
/***/ function(module, exports) {

	'use strict';
	
	var _ems_url = document.location;
	var _ems_tracking_image = (_ems_url.protocol == 'https:' ? 'https:' : 'http:') + '//www.emarsys.net/upages/ti.php';
	var _ems_hash = _ems_url.hash.substring(1);
	var _ems_session_timeout = 1800; // session cookie timeout in seconds
	var _ems_campaign_timeout = 60 * 24 * 3600; // campaign cookie timeout in seconds
	var _ems_domain = document.domain; // default domain to track. should be changed for 3rd party shopping cart
	var _ems_never = 'Tue, 31 Dec 2030 23:59:59 GMT';
	var _ems_tracking_param = 'emst'; // parameter added in redirect
	
	var _ems_customer = '';
	var _ems_visitor = '';
	var _ems_session = '';
	var _ems_campaign = '';
	
	var _ems_debug = 0;
	
	function ems_Debug() {
	  var msg = '_ems_url: ' + escape(_ems_url) + '\n' + '_ems_tracking_image: ' + escape(_ems_tracking_image) + '\n' + '_ems_hash: ' + escape(_ems_hash) + '\n' + '_ems_session_timeout: ' + escape(_ems_session_timeout) + '\n' + '_ems_campaign_timeout: ' + escape(_ems_campaign_timeout) + '\n' + '_ems_domain: ' + escape(_ems_domain) + '\n' + '_ems_never: ' + escape(_ems_never) + '\n' + '_ems_tracking_param: ' + escape(_ems_tracking_param) + '\n' + '_ems_customer: ' + escape(_ems_customer) + '\n' + '_ems_visitor: ' + escape(_ems_visitor) + '\n' + '_ems_session: ' + escape(_ems_session) + '\n' + '_ems_campaign: ' + escape(_ems_campaign) + '\n';
	
	  alert(msg);
	}
	
	function emsSetEnv(_ems_env) {
	  _ems_tracking_image = (_ems_url.protocol == 'https:' ? 'https:' : 'http:') + '//' + _ems_env + '.emarsys.net/upages/ti.php';
	}
	
	function emsTracking(customer, domain) {
	  if (customer) {
	    _ems_customer = customer;
	  }
	
	  if (domain) {
	    _ems_domain = domain;
	  }
	
	  if (_ems_url.protocol == 'file:') {
	    return;
	  }
	
	  var _ems_date = new Date();
	
	  // generate unique domain hash
	  domain_hash = DJBHash(_ems_domain.substring(0, 4) == 'www.' ? _ems_domain.substring(4, _ems_domain.length) : _ems_domain);
	
	  // get session unique id from cookie, or generate a new one
	  _ems_session = _ems_getCookie('_ems_session=' + domain_hash + '.');
	  if (_ems_session == '') {
	    if (_ems_debug) alert('creating new session cookie');
	
	    _ems_session = Math.round(Math.random() * 1073741824);
	
	    // set session cookie
	    var d = new Date(_ems_date.getTime() + _ems_session_timeout * 1000);
	
	    document.cookie = '_ems_session=' + domain_hash + '.' + _ems_session + ';path=/;domain=.' + _ems_domain + ';expires=' + d.toGMTString() + ';';
	  }
	
	  // get visitor unique id from cookie, or use session's id
	  _ems_visitor = _ems_getCookie('_ems_visitor=' + domain_hash + '.');
	  if (_ems_visitor == '') {
	    if (_ems_debug) alert('creating new visitor cookie');
	
	    _ems_visitor = _ems_session;
	
	    // set visitor cookie
	    document.cookie = '_ems_visitor=' + domain_hash + '.' + _ems_visitor + ';path=/;domain=.' + _ems_domain + ';'; // expires="+_ems_never+";";
	  }
	
	  // get campaign identifier from url or from cookie
	  _ems_campaign = _ems_getParam(document.location.search, _ems_tracking_param);
	  if (_ems_campaign == '') {
	    _ems_campaign = _ems_getCookie('_ems_campaign=' + domain_hash + '.');
	  } else {
	    // set campaign cookie
	
	    if (_ems_debug) alert('creating new campaign cookie');
	
	    var d = new Date(_ems_date.getTime() + _ems_campaign_timeout * 1000);
	
	    document.cookie = '_ems_campaign=' + domain_hash + '.' + _ems_campaign + ';path=/;domain=.' + _ems_domain + ';expires=' + d.toGMTString() + ';';
	  }
	
	  // _ems_Tick();
	}
	
	function _ems_Tick() {
	  var t = 'ems_customer=' + _ems_escape(_ems_customer) + '&ems_visitor=' + _ems_escape(_ems_visitor) + '&ems_session=' + _ems_escape(_ems_session) + '&ems_campaign=' + _ems_escape(_ems_campaign) + '&ems_page=' + _ems_escape(document.location.pathname + _ems_StripParam(document.location.search, _ems_tracking_param));
	  var image = new Image();
	
	  image.src = _ems_tracking_image + '?' + t;
	}
	
	function _ems_StripParam(search, param) {
	  if (search.indexOf(param + '=') > 0) {
	    value = _ems_getParam(search, param);
	
	    search = search.substr(0, search.indexOf(param)) + search.substr(search.indexOf(param) + param.length + value.length + 2, search.length);
	
	    if (search.substr(search.length - 1, 1) == '&') {
	      search = search.substr(0, search.length - 1);
	    }
	  }
	
	  return search == '?' ? '' : search;
	}
	
	function emsSubmitOrder() {
	  // no point in sending order to emarsys if customer or user are unknown to emarsys
	  if (_ems_customer == '' || _ems_campaign == '') {
	    return;
	  }
	
	  ems_items = document.getElementsByName('ems_items[]'); // expecting an array, ie. <input type=hidden name="ems_items[]"> for every item
	
	  var p = 'ems_customer=' + _ems_escape(_ems_customer) + '&ems_session=' + _ems_escape(_ems_session) + '&ems_visitor=' + _ems_escape(_ems_visitor) + '&ems_campaign=' + _ems_escape(_ems_campaign) + '&ems_action=purchase';
	
	  order_fields = new Array('order', 'total', 'tax', 'shipping', 'city', 'country');
	  for (var i = 0; i < order_fields.length; i++) {
	    if (eval('document.emsform.' + order_fields[i])) {
	      p += '&' + order_fields[i] + '=' + eval('document.emsform.' + order_fields[i] + '.value');
	    }
	  }
	
	  item_fields = new Array('code', 'category', 'productname', 'price', 'quantity');
	  for (var j = 0; j < ems_items.length; j++) {
	    var item_values = ems_items[j].value.split(';');
	
	    for (var i = 0; i < item_fields.length; i++) {
	      p += '&' + item_fields[i] + '[]=' + (item_values.length > i ? item_values[i] : '');
	    }
	  }
	
	  var image = new Image();
	
	  image.src = _ems_tracking_image + '?' + p;
	
	  if (_ems_debug) alert('image.src=' + image.src);
	}
	
	function _ems_getParam(search, name) {
	  if (search.charAt(0) == '?') {
	    search = search.substring(1, search.length);
	  }
	
	  params = search.split('&');
	  for (var i = 0; i < params.length; i++) {
	    param = params[i].split('=');
	    if (param[0] == name) {
	      return param[1];
	    }
	  }
	
	  return '';
	}
	
	function _ems_getCookie(str) {
	  var i = document.cookie.indexOf(str);
	
	  if (i >= 0) {
	    var start = i + str.length;
	    var end = document.cookie.indexOf(';', start);
	
	    if (end == -1) {
	      end = document.cookie.length;
	    }
	
	    return document.cookie.substring(start, end);
	  }
	
	  return '';
	}
	
	function DJBHash(d) {
	  var hash = 5381;
	
	  for (var i = 0; i < d.length; i++) {
	    var c = parseInt(d.charCodeAt(i));
	
	    hash = (hash << 5) + hash + c;
	  }
	
	  return hash & 0x7fffffff;
	}
	
	function _ems_escape(s) {
	  return typeof encodeURIComponent === 'function' ? encodeURIComponent(s) : escape(s);
	}

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * jQuery.appear http://code.google.com/p/jquery-appear/ Copyright (c) 2009 Michael Hixson Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	 */
	
	_jquery2.default.fn.appear = function (fn, options) {
	  var settings = _jquery2.default.extend({
	    // arbitrary data to pass to fn
	    data: undefined,
	
	    // call fn only on the first appear?
	    one: true
	  }, options);
	
	  return this.each(function () {
	    var t = (0, _jquery2.default)(this);
	
	    // whether the element is currently visible
	    t.appeared = false;
	
	    if (!fn) {
	      // trigger the custom event
	      t.trigger('appear', settings.data);
	
	      return;
	    }
	
	    var w = (0, _jquery2.default)(window);
	
	    // fires the appear event when appropriate
	    var check = function check() {
	      // is the element hidden?
	      // Changed to check is an element truly visible
	      if (!t.is(':visible')) {
	        // it became hidden
	        t.appeared = false;
	
	        return;
	      }
	
	      // is the element inside the visible window?
	      var a = w.scrollLeft();
	      var b = w.scrollTop();
	      var o = t.offset();
	      var x = o.left;
	      var y = o.top;
	      var height = w.height();
	      var width = w.width();
	
	      if (y + t.height() >= b && y <= b + height && x + t.width() >= a && x <= a + width) {
	        // trigger the custom event
	        if (!t.appeared) {
	          t.trigger('appear', settings.data);
	        }
	      } else {
	        // it scrolled out of view
	        t.appeared = false;
	      }
	    };
	
	    // create a modified fn with some additional logic
	    var modifiedFn = function modifiedFn() {
	      // mark the element as visible
	      t.appeared = true;
	
	      // is this supposed to happen only once?
	      if (settings.one) {
	        // remove the check
	        w.unbind('scroll', check);
	        w.unbind('resize', check);
	
	        // w.unbind('orientationchange', check);
	        var i = _jquery2.default.inArray(check, _jquery2.default.fn.appear.checks);
	
	        if (i >= 0) {
	          _jquery2.default.fn.appear.checks.splice(i, 1);
	        }
	      }
	
	      // trigger the original fn
	      fn.apply(this, arguments);
	    };
	
	    // bind the modified fn to the element
	    if (settings.one) {
	      t.one('appear', settings.data, modifiedFn);
	    } else {
	      t.bind('appear', settings.data, modifiedFn);
	    }
	
	    // check whenever the window scrolls or resizes
	
	    w.scroll(check).resize(check);
	
	    _jquery2.default.fn.appear.checks.push(check);
	
	    // check now
	    check();
	  });
	};
	
	// keep a queue of appearance checks
	_jquery2.default.extend(_jquery2.default.fn.appear, {
	  checks: [],
	  timeout: null,
	
	  // process the queue
	  checkAll: function checkAll() {
	    var length = _jquery2.default.fn.appear.checks.length;
	
	    if (length > 0) {
	      while (length--) {
	        if (typeof _jquery2.default.fn.appear.checks[length] === 'function') {
	          _jquery2.default.fn.appear.checks[length]();
	        }
	      }
	    }
	  },
	
	  // check the queue asynchronously
	  run: function run() {
	    if (_jquery2.default.fn.appear.timeout) {
	      clearTimeout(_jquery2.default.fn.appear.timeout);
	    }
	    _jquery2.default.fn.appear.timeout = setTimeout(_jquery2.default.fn.appear.checkAll, 20);
	  }
	});
	
	// run checks when these methods are called
	_jquery2.default.each(['append', 'prepend', 'after', 'before', 'attr', 'removeAttr', 'addClass', 'removeClass', 'toggleClass', 'remove', 'css', 'show', 'hide'], function (i, n) {
	  var old = _jquery2.default.fn[n];
	
	  if (old) {
	    _jquery2.default.fn[n] = function () {
	      var r = old.apply(this, arguments);
	
	      _jquery2.default.fn.appear.run();
	
	      return r;
	    };
	  }
	});

/***/ },
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	'use strict';
	
	/**
	 * jQuery "splendid textchange" plugin
	 * http://benalpert.com/2013/06/18/a-near-perfect-oninput-shim-for-ie-8-and-9.html
	 *
	 * (c) 2013 Ben Alpert, released under the MIT license
	 */
	
	(function ($) {
	  var testNode = document.createElement('input');
	  var isInputSupported = 'oninput' in testNode && (!('documentMode' in document) || document.documentMode > 9);
	
	  var hasInputCapabilities = function hasInputCapabilities(elem) {
	    // The HTML5 spec lists many more types than `text` and `password` on
	    // which the input event is triggered but none of them exist in IE 8 or
	    // 9, so we don't check them here.
	    // TODO: <textarea> should be supported too but IE seems to reset the
	    // selection when changing textarea contents during a selectionchange
	    // event so it's not listed here for now.
	    return elem.nodeName === 'INPUT' && (elem.type === 'text' || elem.type === 'password');
	  };
	
	  var activeElement = null;
	  var activeElementValue = null;
	  var activeElementValueProp = null;
	
	  /**
	   * (For old IE.) Replacement getter/setter for the `value` property that
	   * gets set on the active element.
	   */
	  var newValueProp = {
	    get: function get() {
	      return activeElementValueProp.get.call(this);
	    },
	    set: function set(val) {
	      activeElementValue = val;
	      activeElementValueProp.set.call(this, val);
	    }
	  };
	
	  /**
	   * (For old IE.) Starts tracking propertychange events on the passed-in element
	   * and override the value property so that we can distinguish user events from
	   * value changes in JS.
	   */
	  var startWatching = function startWatching(target) {
	    activeElement = target;
	    activeElementValue = target.value;
	    activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	    Object.defineProperty(activeElement, 'value', newValueProp);
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  };
	
	  /**
	   * (For old IE.) Removes the event listeners from the currently-tracked
	   * element, if any exists.
	   */
	  var stopWatching = function stopWatching() {
	    if (!activeElement) return;
	
	    // delete restores the original property definition
	    delete activeElement.value;
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	    activeElement = null;
	    activeElementValue = null;
	    activeElementValueProp = null;
	  };
	
	  /**
	   * (For old IE.) Handles a propertychange event, sending a textChange event if
	   * the value of the active element has changed.
	   */
	  var handlePropertyChange = function handlePropertyChange(nativeEvent) {
	    if (nativeEvent.propertyName !== 'value') return;
	
	    var value = nativeEvent.srcElement.value;
	
	    if (value === activeElementValue) return;
	    activeElementValue = value;
	
	    $(activeElement).trigger('textchange');
	  };
	
	  if (isInputSupported) {
	    $(document).on('input', function (e) {
	      // In modern browsers (i.e., not IE 8 or 9), the input event is
	      // exactly what we want so fall through here and trigger the
	      // event...
	      if (e.target.nodeName !== 'TEXTAREA') {
	        // ...unless it's a textarea, in which case we don't fire an
	        // event (so that we have consistency with our old-IE shim).
	        $(e.target).trigger('textchange');
	      }
	    });
	  } else {
	    $(document).on('focusin', function (e) {
	      // In IE 8, we can capture almost all .value changes by adding a
	      // propertychange handler and looking for events with propertyName
	      // equal to 'value'.
	      // In IE 9, propertychange fires for most input events but is buggy
	      // and doesn't fire when text is deleted, but conveniently,
	      // selectionchange appears to fire in all of the remaining cases so
	      // we catch those and forward the event if the value has changed.
	      // In either case, we don't want to call the event handler if the
	      // value is changed from JS so we redefine a setter for `.value`
	      // that updates our activeElementValue variable, allowing us to
	      // ignore those changes.
	      if (hasInputCapabilities(e.target)) {
	        // stopWatching() should be a noop here but we call it just in
	        // case we missed a blur event somehow.
	        stopWatching();
	        startWatching(e.target);
	      }
	    }).on('focusout', function () {
	      stopWatching();
	    }).on('selectionchange keyup keydown', function () {
	      // On the selectionchange event, e.target is just document which
	      // isn't helpful for us so just check activeElement instead.
	      //
	      // 90% of the time, keydown and keyup aren't necessary. IE 8 fails
	      // to fire propertychange on the first input event after setting
	      // `value` from a script and fires only keydown, keypress, keyup.
	      // Catching keyup usually gets it and catching keydown lets us fire
	      // an event for the first keystroke if user does a key repeat
	      // (it'll be a little delayed: right before the second keystroke).
	      // Other input methods (e.g., paste) seem to fire selectionchange
	      // normally.
	      if (activeElement && activeElement.value !== activeElementValue) {
	        activeElementValue = activeElement.value;
	        $(activeElement).trigger('textchange');
	      }
	    });
	  }
	})(jQuery);
	}.call(window));

/***/ },
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(18, function (require) {
	      resolve(__webpack_require__(244));
	    });
	  });
	}

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(17, function (require) {
	      resolve(__webpack_require__(245));
	    });
	  });
	}

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(16, function (require) {
	      resolve(__webpack_require__(246));
	    });
	  });
	}

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(15, function (require) {
	      resolve(__webpack_require__(247));
	    });
	  });
	}

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(14, function (require) {
	      resolve(__webpack_require__(248));
	    });
	  });
	}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(13, function (require) {
	      resolve(__webpack_require__(249));
	    });
	  });
	}

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(12, function (require) {
	      resolve(__webpack_require__(250));
	    });
	  });
	}

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function () {
	  return new Promise(function (resolve) {
	    __webpack_require__.e/* nsure */(11, function (require) {
	      resolve(__webpack_require__(251));
	    });
	  });
	}

/***/ },
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addAllListener = addAllListener;
	
	var _buy = __webpack_require__(89);
	
	var _buy2 = _interopRequireDefault(_buy);
	
	var _pictures = __webpack_require__(254);
	
	var _pictures2 = _interopRequireDefault(_pictures);
	
	var _options = __webpack_require__(253);
	
	var _options2 = _interopRequireDefault(_options);
	
	var _selectors = __webpack_require__(25);
	
	var selectors = _interopRequireWildcard(_selectors);
	
	var _swiper = __webpack_require__(53);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addSwiper = function addSwiper(slidesPerView) {
	  new _swiper2.default('.' + selectors.SLIDER, {
	    direction: 'vertical',
	    spaceBetween: 12,
	    slidesPerView: slidesPerView,
	    pagination: {
	      clickable: true
	    },
	    grabCursor: true,
	    navigation: {
	      nextEl: '.' + selectors.SWIPERDOWM,
	      prevEl: '.' + selectors.SWIPERUP
	    }
	  });
	};
	
	function addAllListener(data) {
	  var selectableAttributesAmount = Object.keys(data.selectedMvcAttributes).length;
	  var slidesPerView = 3;
	
	  if (selectableAttributesAmount === 2 || selectableAttributesAmount === 3) {
	    slidesPerView = 4;
	  }
	
	  addSwiper(slidesPerView);
	
	  (0, _buy2.default)({
	    selector: selectors.BUYBUTTON,
	    cfg: data.cfg,
	    smp: data.smp,
	    price: data.price.trackingPrice,
	    name: data.name,
	    variant: data.variantName,
	    currencyCode: data.price.currency,
	    lng: data.lngcode
	  });
	  (0, _pictures2.default)(data.images.length);
	  (0, _options2.default)(data.cfg, data.otherSkus, data.selectedMvcAttributes);
	}

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeEventListenerToOptions = undefined;
	
	var _classNamesSwiper = __webpack_require__(46);
	
	var _classNamesSwiper2 = _interopRequireDefault(_classNamesSwiper);
	
	var _render = __webpack_require__(116);
	
	var _notSellable = __webpack_require__(294);
	
	var _notSellable2 = _interopRequireDefault(_notSellable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentValuesSelected = function currentValuesSelected(selectoptions, selectedMvcAttributes) {
	  return Object.keys(selectedMvcAttributes).map(function (key) {
	    return selectoptions[key].value;
	  }).sort();
	};
	
	var findCorrectSku = function findCorrectSku(otherSkus, selected) {
	  var findsku = Object.keys(otherSkus).filter(function (key) {
	    var arr = Object.values(otherSkus[key].selectedMvcAttributes).sort();
	    return arr.length === selected.length && arr.every(function (element, index) {
	      return element === selected[index];
	    });
	  });
	  if (!findsku) {
	    return;
	  }
	  if (findsku.length === 0) {
	    return undefined;
	  }
	  if (otherSkus[findsku[0]].isSellable === false) {
	    return undefined;
	  }
	  return otherSkus[findsku[0]].sku;
	};
	
	var findAlternativeSku = function findAlternativeSku(otherSkus, targetvalue) {
	  var skuarr = Object.keys(otherSkus).filter(function (key) {
	    return otherSkus[key].isSellable === true && key.includes(targetvalue);
	  });
	
	  if (skuarr.length === 0 || skuarr === undefined) {
	    skuarr = Object.keys(otherSkus).filter(key = otherSkus[key].isSellable);
	  }
	
	  return otherSkus[skuarr[0]].sku;
	};
	
	var addEventListenerToOptions = function addEventListenerToOptions(config, otherSkus, selectedMvcAttributes) {
	  var selectoptions = document.getElementsByClassName(_classNamesSwiper2.default.DETAILS.OPTIONS.SELECT);
	  for (var i = 0; i < selectoptions.length; i++) {
	    var element = selectoptions[i];
	    element.addEventListener('change', function (e) {
	      var selected = currentValuesSelected(selectoptions, selectedMvcAttributes);
	      var selectedChildSku = findCorrectSku(otherSkus, selected);
	      if (!selectedChildSku) {
	        var alternativeSku = findAlternativeSku(otherSkus, e.target.value);
	        (0, _notSellable2.default)(config, alternativeSku);
	        return null;
	      }
	
	      (0, _render.reRender)(selectedChildSku);
	    });
	  }
	};
	
	var removeEventListenerToOptions = exports.removeEventListenerToOptions = function removeEventListenerToOptions() {
	  var selectoptions = document.getElementsByClassName(_classNamesSwiper2.default.DETAILS.OPTIONS.SELECT);
	  if (selectoptions === undefined || selectoptions === null) {
	    return null;
	  }
	  for (var i = 0; i < selectoptions.length; i++) {
	    var element = selectoptions[i];
	    $(element).off();
	  }
	};
	
	exports.default = addEventListenerToOptions;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeEventlistenerPictures = undefined;
	
	var _classNamesSwiper = __webpack_require__(46);
	
	var _classNamesSwiper2 = _interopRequireDefault(_classNamesSwiper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = function func(e) {
	  var newelement = e.target;
	  var bigURL = newelement.getAttribute('data-bigpic');
	  if (!bigURL) {
	    return null;
	  }
	  $("[data-qvh24-pic-active='true']").attr('class', _classNamesSwiper2.default.SLIDER.INNERWRAP.IMG.STANDARD);
	  $("[data-qvh24-pic-active='true']").attr('data-qvh24-pic-active', 'false');
	  var bigPicture = document.getElementById('qvh24-bigPic');
	  newelement.className = _classNamesSwiper2.default.SLIDER.INNERWRAP.IMG.ACTIVE;
	  newelement.setAttribute('data-qvh24-pic-active', 'true');
	  bigPicture.src = bigURL;
	};
	
	var addEventListenerPictures = function addEventListenerPictures() {
	  document.querySelector('.swiper-wrapper').addEventListener('mouseover', func);
	  document.querySelector('.swiper-wrapper').addEventListener('click', func);
	};
	
	var removeEventlistenerPictures = exports.removeEventlistenerPictures = function removeEventlistenerPictures() {
	  document.querySelector('.swiper-wrapper').removeEventListener('mouseover', func);
	  document.querySelector('.swiper-wrapper').removeEventListener('click', func);
	};
	
	exports.default = addEventListenerPictures;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TeaserBaseView = __webpack_require__(123);
	
	var _TeaserBaseView2 = _interopRequireDefault(_TeaserBaseView);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TeaserBaseView2.default.extend({
	  events: {
	    'click .ui-slider-to-left': 'onClickToTheLeft',
	    'click .ui-slider-to-right': 'onClickToTheRight',
	    'touchstart .content': 'onTouchStart',
	    'touchend .content': 'onTouchEnd'
	  },
	
	  /**
	   * @type {Number}
	   */
	  fadeTime: config.getInt('marketing.teaser.sliding.intervals.fade'),
	
	  /**
	   * @type {int}
	   */
	  previousTeaser: 0,
	
	  onTimeout: function onTimeout() {
	    if (!this.blockTransition) {
	      this.onClickToTheRight();
	    }
	  },
	
	  toGlobalFallback: function toGlobalFallback() {
	    this.$('.ui-slider-to-left').hide();
	    this.$('.ui-slider-to-right').hide();
	  },
	
	  onClickToTheLeft: function onClickToTheLeft() {
	    this.fadeTo(this.getPrevTeaser());
	    this.restartTimer();
	  },
	
	  onClickToTheRight: function onClickToTheRight() {
	    this.fadeTo(this.getNextTeaser());
	    this.restartTimer();
	  },
	
	  /**
	   * @param {int} target
	   */
	  fadeTo: function fadeTo(target) {
	    var $active = this.$teasers.eq(this.activeTeaser);
	    var $new = this.$teasers.eq(target);
	
	    if (this.activeTeaser !== target) {
	      $active.fadeOut(this.fadeTime);
	    }
	
	    this.activeTeaser = target;
	    $new.fadeIn(this.fadeTime);
	
	    this.postFadeTo();
	  }
	});

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _UploadManager = __webpack_require__(333);
	
	var _UploadManager2 = _interopRequireDefault(_UploadManager);
	
	var _translation = __webpack_require__(12);
	
	var _Utils = __webpack_require__(15);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  /**
	   * File remove handler
	   * @param event
	   */
	  onFileRemoveClicked: function onFileRemoveClicked(event) {
	    event.preventDefault();
	
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	    var uploadManager = new _UploadManager2.default();
	
	    uploadManager.remove($cT.data('uid'));
	
	    $cT.closest('li').remove();
	
	    this.postFileRemove();
	  },
	
	  startUpload: function startUpload(event) {
	    var uploadManager = new _UploadManager2.default();
	
	    this.prepareUploadManager(uploadManager, event);
	
	    this.messageBox.clear();
	
	    if (uploadManager.isValid()) {
	      /*
	             Proceed with upload process
	             */
	      uploadManager.setOnSuccess(_jquery2.default.proxy(this.onUploadSuccess, this)).setOnFailure(_jquery2.default.proxy(this.onUploadFailure, this));
	
	      lightbox.close();
	
	      this.showPreloader();
	
	      uploadManager.execute();
	
	      this.insertTemplate(uploadManager.getUid(), uploadManager.getParsedFilename(), this.getUploadContainer());
	    } else {
	      /*
	             Handle errors
	             */
	      var errors = uploadManager.getErrors();
	
	      for (var i = 0; i < errors.length; i++) {
	        this.messageBox.addError(errors[i].message);
	      }
	    }
	
	    this.messageBox.render();
	  },
	
	  showPreloader: function showPreloader() {
	    (0, _jquery2.default)('#preloader').show();
	  },
	
	  hidePreloader: function hidePreloader() {
	    (0, _jquery2.default)('#preloader').hide();
	  },
	
	  /**
	   * Method inserts new file container and populates it with dummy data
	   * @param {string} uid
	   * @param {string} sName
	   * @param {Object} $container
	   */
	  insertTemplate: function insertTemplate(uid, sName, $container) {
	    var $cloned = this.$uploadTemplate.clone();
	
	    $cloned.find('.fttc2-name').html(sName);
	    $cloned.attr('id', this.formatRowId(uid));
	    $container.find('.fttc2-uploaded-files').first().append($cloned);
	
	    this.postInsertTemplate($cloned);
	  },
	
	  /**
	   * On upload success handler. It updates previously generated view stub
	   * @param {string} uid
	   * @param {object} json
	   */
	  onUploadSuccess: function onUploadSuccess(uid, json) {
	    var $container = this.$('#' + this.formatRowId(uid));
	
	    $container.find('.fttc2-close').data('uid', json.uid);
	
	    /** @namespace json.thumbPath */
	    if (json.thumbPath) {
	      $container.find('.fttc2-img-holder img').attr('src', json.thumbPath);
	    }
	
	    /** @namespace json.fileSize */
	    if (json.fileSize) {
	      $container.find('.fttc2-size').html('(' + (0, _Utils.bytesToSize)(json.fileSize) + ')');
	    }
	
	    this.hidePreloader();
	    this.postUploadSuccess();
	  },
	
	  /**
	   * Method if fired on upload failure
	   * @param {String} uid upload identifier
	   * @param {Object} json JSON object returned by backend
	   * @return void
	   */
	  onUploadFailure: function onUploadFailure(uid, json) {
	    this.$('#' + this.formatRowId(uid)).remove();
	
	    this.messageBox.clear();
	
	    /** @namespace json.errorMessage */
	    if (json.errorMessage) {
	      this.messageBox.addError(json.errorMessage);
	    } else {
	      this.messageBox.addError((0, _translation.get)('fileUpload.unknownError.message'));
	    }
	
	    this.messageBox.render();
	    this.hidePreloader();
	    this.postUploadFailure();
	  },
	
	  formatRowId: function formatRowId(uid) {
	    return 'row_' + uid;
	  }
	});

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize(options) {
	    /*
	        Store additional model when required
	         */
	    if (options && options.additionalModel) {
	      this.additionalModel = options.additionalModel;
	    }
	
	    this.preInit();
	    this.localInitialize();
	    this.postInit();
	  },
	
	  preInit: function preInit() {},
	
	  localInitialize: function localInitialize() {},
	
	  postInit: function postInit() {}
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _BaseSliderView = __webpack_require__(257);
	
	var _BaseSliderView2 = _interopRequireDefault(_BaseSliderView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseSliderView2.default.extend({
	  events: {
	    'click .js-slider-forward': 'onForwardClick',
	    'click .js-slider-backward': 'onBackwardClick'
	  },
	
	  selectors: {
	    elements: '.image-preload-icon',
	    container: '.slider-content',
	    controls: {
	      forward: '.slider-arrow-right',
	      backward: '.slider-arrow-left'
	    }
	  },
	
	  /**
	   * @type {$}
	   */
	  $elements: null,
	
	  /**
	   * @type {$}
	   */
	  $container: null,
	
	  /**
	   * @type {Boolean}
	   */
	  wasTouchMoved: false,
	
	  localInitialize: function localInitialize() {
	    this.$elements = this.$(this.selectors.elements);
	    this.$container = this.$(this.selectors.container);
	
	    this.model.set({
	      elementCount: this.$elements.length
	    });
	
	    /*
	         check if there are are any products inside slider, and initialize all events only if so
	         */
	    if (this.model.get('elementCount') > 0) {
	      this.$elements.appear(_jquery2.default.proxy(this.onElementAppear, this));
	
	      /*
	             Setup other model properties
	             */
	
	      var itemNumber = this.$el.attr('data-item-number');
	
	      if (itemNumber) {
	        this.model.set({
	          maxElements: parseInt(itemNumber, 10)
	        });
	      }
	
	      this.model.set({
	        elementSize: this.getElementSize(),
	        minOffset: this.getCurrentOffset(),
	        currentOffset: this.getCurrentOffset()
	      });
	
	      this.model.updateMaxOffset();
	
	      this.setContainerSize(this.model.get('elementSize') * this.model.get('elementCount'));
	
	      this.listenTo(this.model, 'change:currentOffset', this.handleControlsVisibility);
	      this.listenTo(this.model, 'change:currentOffset', this.positionContainer);
	
	      if (this.model.get('elementCount') > this.model.get('maxElements')) {
	        this.$container.on('touchstart.slider-nav', _jquery2.default.proxy(this.onTouchStart, this));
	      }
	    } else {
	      /*
	            If slider is empty, hide it, there is really no point of keeping it taking space
	             */
	      this.$el.addClass('is-hidden');
	    }
	
	    this.handleControlsVisibility();
	  },
	
	  onForwardClick: function onForwardClick(event) {
	    event.preventDefault();
	    this.model.move(this.model.directions.forward);
	  },
	
	  onBackwardClick: function onBackwardClick(event) {
	    event.preventDefault();
	    this.model.move(this.model.directions.backward);
	  },
	
	  handleControlsVisibility: function handleControlsVisibility() {
	    var method;
	
	    if (this.model.isControlBackwardVisible()) {
	      method = 'removeClass';
	    } else {
	      method = 'addClass';
	    }
	
	    this.$(this.selectors.controls.backward)[method]('is-invisible');
	
	    if (this.model.isControlForwardVisible()) {
	      method = 'removeClass';
	    } else {
	      method = 'addClass';
	    }
	
	    this.$(this.selectors.controls.forward)[method]('is-invisible');
	  },
	
	  /**
	   * @param {Event} event
	   */
	  onElementAppear: function onElementAppear(event) {
	    var $preloader = (0, _jquery2.default)(event.currentTarget);
	    var $imageContainer = $preloader.find('.slider-article');
	    var imagePath = $imageContainer.data('image');
	
	    if (imagePath) {
	      (0, _jquery2.default)('<img />').load(function () {
	        $preloader.css('background-image', 'none');
	      }).attr('src', imagePath);
	
	      $imageContainer.css('background-image', 'url(' + imagePath + ')');
	    }
	  },
	
	  onTouchStart: function onTouchStart(event) {
	    this.setStartTouch(event);
	
	    this.$container.on('touchmove.slider-nav', _jquery2.default.proxy(this.onTouchMove, this));
	    this.$container.on('touchend.slider-nav', _jquery2.default.proxy(this.onTouchEnd, this));
	  },
	
	  onTouchMove: function onTouchMove(event) {
	    this.setCurrentTouch(event);
	
	    var deltaMain;
	    var deltaAuxilary;
	
	    deltaMain = this.model.get('touchStartMainAxis') - this.model.get('touchCurrentMainAxis');
	    deltaAuxilary = this.model.get('touchStartAuxilaryAxis') - this.model.get('touchCurrentAuxilaryAxis');
	
	    if (Math.abs(deltaMain) * 1.2 >= Math.abs(deltaAuxilary)) {
	      event.preventDefault();
	    }
	
	    if (Math.abs(deltaAuxilary) > 15 && Math.abs(deltaAuxilary) > Math.abs(deltaMain) * 2) {
	      this.$container.off('touchmove.slider-nav');
	
	      return;
	    }
	
	    if (Math.abs(deltaMain) >= 1) {
	      this.model.updateOffsetFromDelta(deltaMain);
	    }
	
	    this.wasTouchMoved = true;
	  },
	
	  onTouchEnd: function onTouchEnd(event) {
	    if (this.wasTouchMoved) {
	      event.preventDefault();
	      this.wasTouchMoved = false;
	    }
	
	    this.$container.off('touchmove.slider-nav');
	    this.$container.off('touchend.slider-nav');
	  },
	
	  getCurrentOffset: function getCurrentOffset() {
	    return this.$container.position().left;
	  },
	
	  getElementSize: function getElementSize() {
	    // noinspection JSValidateTypes
	    return this.$elements.first().outerWidth(true);
	  },
	
	  setContainerSize: function setContainerSize(value) {
	    this.$container.width(value);
	  },
	
	  positionContainer: function positionContainer() {
	    this.$container.css('left', this.model.get('currentOffset') + 'px');
	  },
	
	  setStartTouch: function setStartTouch(event) {
	    this.model.set({
	      touchStartMainAxis: event.originalEvent.touches[0].pageX,
	      touchStartAuxilaryAxis: event.originalEvent.touches[0].pageY,
	      touchStartOffset: this.model.get('currentOffset')
	    });
	  },
	
	  setCurrentTouch: function setCurrentTouch(event) {
	    this.model.set({
	      touchCurrentMainAxis: event.originalEvent.touches[0].pageX,
	      touchCurrentAuxilaryAxis: event.originalEvent.touches[0].pageY
	    });
	  }
	});

/***/ },
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(469);
	
	__webpack_require__(418);
	
	__webpack_require__(415);
	
	__webpack_require__(468);
	
	__webpack_require__(226);
	
	__webpack_require__(416);
	
	__webpack_require__(205);
	
	__webpack_require__(67);
	
	__webpack_require__(18);
	
	__webpack_require__(410);
	
	__webpack_require__(409);
	
	var _lightbox = __webpack_require__(11);
	
	var _validationController = __webpack_require__(13);
	
	var _adblock = __webpack_require__(295);
	
	var _adblock2 = _interopRequireDefault(_adblock);
	
	__webpack_require__(92);
	
	__webpack_require__(163);
	
	__webpack_require__(162);
	
	__webpack_require__(164);
	
	__webpack_require__(165);
	
	var _bootstrapper = __webpack_require__(8);
	
	__webpack_require__(411);
	
	__webpack_require__(412);
	
	__webpack_require__(49);
	
	__webpack_require__(413);
	
	__webpack_require__(342);
	
	__webpack_require__(91);
	
	__webpack_require__(288);
	
	__webpack_require__(130);
	
	__webpack_require__(304);
	
	__webpack_require__(308);
	
	__webpack_require__(313);
	
	__webpack_require__(300);
	
	__webpack_require__(301);
	
	__webpack_require__(306);
	
	__webpack_require__(307);
	
	__webpack_require__(311);
	
	__webpack_require__(312);
	
	__webpack_require__(302);
	
	__webpack_require__(125);
	
	__webpack_require__(134);
	
	__webpack_require__(314);
	
	__webpack_require__(137);
	
	__webpack_require__(316);
	
	__webpack_require__(317);
	
	__webpack_require__(334);
	
	__webpack_require__(147);
	
	__webpack_require__(152);
	
	__webpack_require__(336);
	
	__webpack_require__(350);
	
	__webpack_require__(166);
	
	__webpack_require__(346);
	
	__webpack_require__(171);
	
	__webpack_require__(178);
	
	__webpack_require__(348);
	
	__webpack_require__(182);
	
	__webpack_require__(353);
	
	__webpack_require__(347);
	
	var _home = __webpack_require__(194);
	
	var _home2 = __webpack_require__(193);
	
	var _stickyOverview = __webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _home.init)();
	(0, _home2.bindListenersToSlidingMenu)();
	(0, _lightbox.exportLightBoxToWindow)();
	(0, _validationController.exportValidationToWindow)();
	new _adblock2.default();
	(0, _stickyOverview.start)();
	
	(0, _bootstrapper.run)();

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Collapsible;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectors = {
	  parent: '.collapsible',
	  trigger: '.collapsible__trigger',
	  content: '.collapsible__content',
	  activeModifier: 'collapsible--open'
	};
	
	function Collapsible(element) {
	  this.$parent = (0, _jquery2.default)(element);
	  this.$trigger = this.$parent.find(selectors.trigger);
	  this.$content = this.$parent.find(selectors.content);
	
	  this.bindEvents();
	}
	
	Collapsible.prototype.bindEvents = function () {
	  this.$trigger.on('click', _jquery2.default.proxy(this.onTriggerClick, this));
	};
	
	Collapsible.prototype.onTriggerClick = function () {
	  if (this.$parent.hasClass(selectors.activeModifier)) {
	    this.hideContent();
	  } else {
	    this.showContent();
	  }
	};
	
	Collapsible.prototype.showContent = function () {
	  this.$parent.addClass(selectors.activeModifier);
	};
	
	Collapsible.prototype.hideContent = function () {
	  this.$parent.removeClass(selectors.activeModifier);
	};

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _collapsible = __webpack_require__(287);
	
	var _collapsible2 = _interopRequireDefault(_collapsible);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $collapsibles = (0, _jquery2.default)('.collapsible');
	
	if ($collapsibles.length) {
	  $collapsibles.each(function (index, item) {
	    new _collapsible2.default(item);
	  });
	}

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _details = __webpack_require__(291);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _selectors = __webpack_require__(25);
	
	var selectors = _interopRequireWildcard(_selectors);
	
	var _picturesDsSwiper = __webpack_require__(292);
	
	var _picturesDsSwiper2 = _interopRequireDefault(_picturesDsSwiper);
	
	var _classNamesSwiper = __webpack_require__(46);
	
	var _classNamesSwiper2 = _interopRequireDefault(_classNamesSwiper);
	
	var _helpers = __webpack_require__(39);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function App(_ref) {
	  var data = _ref.data;
	
	  var height = (0, _helpers.height)(data.selectedMvcAttributes);
	  var strDataOptions = JSON.stringify((0, _helpers.getDataOptions)()).replace(/'/g, "\\'");
	
	  return '\n<article class="' + _classNamesSwiper2.default.ARTICLE + ' js-quick-view" data-options=\'' + strDataOptions + '\'>\n  <div class="' + _classNamesSwiper2.default.WRAP + '" style="height: ' + height + 'px">\n  <div id="' + selectors.NOTIFICATION + '"></div>\n  <div id="' + selectors.NOTSELLABLE + '"></div>\n    ' + (0, _details2.default)({ className: _classNamesSwiper2.default, data: data, height: height }) + '\n    ' + (0, _picturesDsSwiper2.default)({ className: _classNamesSwiper2.default, images: data.images, height: height }) + '\n  </div>\n</article>\n  ';
	};
	
	exports.default = App;

/***/ },
/* 290 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Buttons = function Buttons(_ref) {
	  var className = _ref.className,
	      BUY = _ref.BUY,
	      url = _ref.url,
	      PDP = _ref.PDP;
	
	  return "\n<div class=\"" + className.DETAILS.BUTTONS.WRAP + "\">\n    <a class=\"" + className.DETAILS.BUTTONS.ADD_TO_CART + "\" id=\"qvh24-buy-button\">" + BUY + "</a>\n    <a class=\"" + className.DETAILS.BUTTONS.GO_TO_PRODUCTPAGE + "\" href=\"" + url + "\">" + PDP + "</a>\n</div>\n  ";
	};
	
	exports.default = Buttons;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _buttons = __webpack_require__(290);
	
	var _buttons2 = _interopRequireDefault(_buttons);
	
	var _options = __webpack_require__(404);
	
	var _options2 = _interopRequireDefault(_options);
	
	var _title = __webpack_require__(187);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _price = __webpack_require__(186);
	
	var _price2 = _interopRequireDefault(_price);
	
	var _delivery = __webpack_require__(185);
	
	var _delivery2 = _interopRequireDefault(_delivery);
	
	var _languages = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Stars = function Stars(_ref) {
	  var className = _ref.className,
	      isVisible = _ref.isVisible,
	      amount = _ref.amount,
	      valueInPercentage = _ref.valueInPercentage;
	
	  if (!isVisible) {
	    return '';
	  }
	  return '\n<div class="' + className.DETAILS.STARS.WRAP + '">\n    <div class="' + className.DETAILS.STARS.INNER + '">\n        <div style="width: ' + valueInPercentage + '%" class="' + className.DETAILS.STARS.INSIDE + '"></div>\n    </div>\n    <div class="' + className.DETAILS.STARS.RATING + '">\n        (' + amount + ')\n    </div>\n</div>\n  ';
	};
	
	var Details = function Details(_ref2) {
	  var className = _ref2.className,
	      height = _ref2.height,
	      _ref2$data = _ref2.data,
	      stars = _ref2$data.stars,
	      price = _ref2$data.price,
	      isValuePack = _ref2$data.isValuePack,
	      delivery = _ref2$data.delivery,
	      url = _ref2$data.url,
	      name = _ref2$data.name,
	      variantName = _ref2$data.variantName,
	      mvcAttributes = _ref2$data.mvcAttributes,
	      selectedMvcAttributes = _ref2$data.selectedMvcAttributes,
	      lngcode = _ref2$data.lngcode;
	
	  var lng = (0, _languages.lngprovider)(lngcode);
	  return '\n<div class="' + className.DETAILS.WRAP + '" style="height: ' + height + 'px">\n    ' + (0, _title2.default)({
	    className: className,
	    url: url,
	    headline: name,
	    subline: variantName
	  }) + '\n    ' + Stars({
	    className: className,
	    isVisible: stars.isVisible,
	    amount: stars.amount,
	    valueInPercentage: stars.valueInPercentage
	  }) + '\n    ' + (0, _price2.default)({
	    className: className,
	    isReduced: price.isReduced,
	    isRecommended: price.isRecommended,
	    isValuePack: isValuePack,
	    sellPrice: price.sellPrice,
	    originalPrice: price.originalPrice,
	    priceDifference: price.priceDifference,
	    currency: price.currency,
	    translations: lng
	  }) + '\n    ' + (0, _delivery2.default)({
	    className: className,
	    translated: delivery.translated,
	    isFastDelivery: delivery.isFastDelivery,
	    DELIVERY: lng.DELIVERY
	  }) + '\n    ' + (0, _options2.default)({
	    className: className,
	    mvcAttributes: mvcAttributes,
	    selectedMvcAttributes: selectedMvcAttributes
	  }) + '\n    ' + (0, _buttons2.default)({
	    className: className,
	    url: url,
	    BUY: lng.BUY,
	    PDP: lng.PDP
	  }) + '\n</div>\n  ';
	};
	
	exports.default = Details;

/***/ },
/* 292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SinglePicture = function SinglePicture(props) {
	  var height = props.height === 320 ? 300 : 350;
	  return '\n<div class="' + props.className.BIG_IMAGE + '">\n    <img id="qvh24-bigPic" src="' + props.url.src + '" alt="' + props.url.alt + '" style="height: ' + height + 'px"/>\n</div>\n  ';
	};
	
	var PictureSlider = function PictureSlider(_ref) {
	  var className = _ref.className,
	      images = _ref.images,
	      height = _ref.height;
	
	  var farbe = images.length <= 4 && height > 320 || images.length <= 3 && height === 320 ? 'white' : '#8e9597';
	  var templatedImages = images.map(function (pic, index) {
	    var imgClass = index === 0 ? className.SLIDER.INNERWRAP.IMG.ACTIVE : className.SLIDER.INNERWRAP.IMG.STANDARD;
	    return '\n<div class="' + className.SLIDER.INNERWRAP.IMG.INNERWRAP + '">\n    <img data-bigpic="' + pic.big.src + '" \n        data-qvh24-pic-active="' + (index === 0) + '"\n        id="qvh24-slider-img-' + index + '"\n        class="' + imgClass + '"\n        src="' + pic.small.src + '"\n        alt="' + pic.small.alt + '"\n    />\n</div>\n    ';
	  });
	
	  var sliderContent = '\n<div class="' + className.SLIDER.WRAP + '" style="height: ' + height + 'px">\n    <div class="' + className.SLIDER.ARROWUP + '" style="color: ' + farbe + '"></div>\n    <div class="' + className.SLIDER.INNERWRAP.WRAP + '">\n        <div class="' + className.SLIDER.INNERWRAP.IMG.WRAP + '" >\n            ' + templatedImages + '\n        </div>\n    </div>\n    <div class="' + className.SLIDER.ARROWDOWN + '" style="color: ' + farbe + '"></div>\n</div>\n        ';
	
	  return sliderContent.replace(/,/g, '');
	};
	
	var Pictures = function Pictures(_ref2) {
	  var images = _ref2.images,
	      className = _ref2.className,
	      height = _ref2.height;
	
	  return '\n  ' + PictureSlider({ images: images, className: className, height: height }) + '\n  ' + SinglePicture({ url: images[0].big, className: className, height: height }) + '\n  ';
	};
	
	exports.default = Pictures;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.quickview = quickview;
	
	var _classNamesSwiper = __webpack_require__(46);
	
	var _classNamesSwiper2 = _interopRequireDefault(_classNamesSwiper);
	
	var _getArticleData = __webpack_require__(90);
	
	var _recommendations = __webpack_require__(66);
	
	var _renderer = __webpack_require__(40);
	
	var _recommendations2 = __webpack_require__(190);
	
	var _addAllListeners = __webpack_require__(252);
	
	var _render = __webpack_require__(116);
	
	var _helpers = __webpack_require__(39);
	
	var _languages = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function quickview() {
	  var articleData = (0, _getArticleData.getArticleData)();
	  if (Object.keys(articleData).length === 0) {
	    return;
	  }
	
	  var translations = (0, _languages.lngprovider)(articleData.lngcode);
	  (0, _helpers.pushQvDisplayedEvent)(articleData);
	  (0, _render.initalRender)(articleData, '.' + _classNamesSwiper2.default.WRAP, (0, _helpers.alternativeDIVprovider)(), (0, _helpers.alternativeDIV2Provider)());
	  (0, _addAllListeners.addAllListener)(articleData);
	  (0, _recommendations.getRecommendationsData)(articleData.smp, articleData.lngcode).then(function (data) {
	    if (data !== null) {
	      // no slider hence neither we render it nor track
	      (0, _renderer.renderRecommendations)(translations.RECOMMENDATIONS_HEADLINE, data, '.js-quick-view', 4, 16);
	
	      (0, _recommendations.isRecommendationsResponseDYO)(data) ? (0, _recommendations.trackDYORecommendations)() : (0, _recommendations2.attachInhouseRecommendationsTracking)();
	    }
	  }).catch(function (err) {
	    console.error(err);
	  });
	}

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _render = __webpack_require__(116);
	
	var _selectors = __webpack_require__(25);
	
	var s = _interopRequireWildcard(_selectors);
	
	var _notsellable = __webpack_require__(403);
	
	var _notsellable2 = _interopRequireDefault(_notsellable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function notSellable(selectedChildSku) {
	  (0, _render.empty)(s.NOTSELLABLE, null, null);
	  (0, _render.fill)(s.NOTSELLABLE, null, null, (0, _notsellable2.default)());
	  setTimeout(function () {
	    (0, _render.reRender)(selectedChildSku);
	  }, 2000);
	}
	
	exports.default = notSellable;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * adblocker detection mechanism
	 */
	var AdBlock = function () {
	  function AdBlock() {
	    _classCallCheck(this, AdBlock);
	
	    this.$scope = (0, _jquery2.default)('body');
	
	    this.delayedDetection();
	  }
	
	  /**
	   * Method detects if in-browser DOM manipulation based advertisements blocking script is in use
	   * @return {boolean}
	   */
	
	
	  _createClass(AdBlock, [{
	    key: 'isAdBlockerEnabled',
	    value: function isAdBlockerEnabled() {
	      var x = document.getElementById('ad1');
	      var xstyle = false;
	      var attributesToCheck = ['MozBinding', 'display', 'position', 'top', 'left'];
	      var attributeCondition = ['none', 'inline', 'static', 'auto', 'auto'];
	      var bRetVal = false;
	      var i = 0;
	
	      if (!x) {
	        return true;
	      }
	
	      if (x.currentStyle) {
	        // IE
	        xstyle = x.currentStyle;
	      } else if (document.defaultView && document.defaultView.getComputedStyle) {
	        // Firefox & Chrome
	        xstyle = document.defaultView.getComputedStyle(x, '');
	      }
	
	      while (i < attributesToCheck.length) {
	        if (xstyle[attributesToCheck[i]] !== attributeCondition[i]) {
	          if (undefined != xstyle[attributesToCheck[i]]) {
	            bRetVal = true;
	            break;
	          }
	        }
	        i++;
	      }
	
	      return bRetVal;
	    }
	
	    /**
	     * Method tries to determine if any iframe request blocking script was in use
	     * @return {boolean}
	     */
	
	  }, {
	    key: 'requestBlockerEnabledByIframe',
	    value: function requestBlockerEnabledByIframe() {
	      /*
	       * in case of Firefox browser we are unable to detect if iframe succeeded to load any content for different origin.
	       * The same case is for mobile Safari browsers (iPad)
	       * In this case, to avoid false positives, always assume that request were not blocked
	       */
	      if (_jquery2.default.browser.mozilla || navigator.userAgent.match(/(iPad|iPhone|iPod touch)/i) || _jquery2.default.browser.webkit && !/chrome/.test(navigator.userAgent.toLowerCase())) {
	        return false;
	      }
	
	      var iSuccess = 0;
	      var iTotal = 0;
	
	      this.$scope.find('[data-external-url] > iframe').each(function () {
	        iTotal++;
	
	        /*
	         * In case of modern browsers accessing iframe content for different origin causes SecurityError.
	         * SecurityError does not appear when iframe request was canceled by request blocking script
	         */
	        try {
	          if ((0, _jquery2.default)(this).contents().find('body').children().length > 0) {
	            iSuccess++;
	          }
	        } catch (exception) {
	          iSuccess++;
	        }
	      });
	
	      return iTotal > 0 && iSuccess === 0;
	    }
	  }, {
	    key: 'requestBlockerEnabledByScript',
	    value: function requestBlockerEnabledByScript() {
	      var iSuccess = 0;
	      var iTotal = 0;
	
	      this.$scope.find('.dblclick-content').each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var $firstChild = $this.children().eq(0);
	        var $secondChild = $this.children().eq(1);
	
	        iTotal++;
	
	        if (!$firstChild.is('script')) {
	          return;
	        }
	
	        if (!$secondChild.is('a,img')) {
	          return;
	        }
	
	        iSuccess++;
	      });
	
	      return iTotal > 0 && iSuccess === 0;
	    }
	
	    /**
	     * @return {Boolean}
	     */
	
	  }, {
	    key: 'check',
	    value: function check() {
	      return this.isAdBlockerEnabled() || this.requestBlockerEnabledByIframe() || this.requestBlockerEnabledByScript();
	    }
	
	    /**
	     * Method removes doubleclick content and replaces it with fallbacks
	     */
	
	  }, {
	    key: 'switchToFallbacks',
	    value: function switchToFallbacks() {
	      this.$scope.find('.fallback').each(function () {
	        (0, _jquery2.default)(this).removeClass('is-hidden').parent().find('>[data-external-url], > script:first, > a:first, .dblclick-content').remove();
	      });
	    }
	
	    /**
	     * Method performs delayed check if any kind of adblocker is enabled on client side
	     * If yes, removes doubleclick content and serves fallbacks
	     * @trigger AdBlockDetected
	     */
	
	  }, {
	    key: 'delayedDetection',
	    value: function delayedDetection() {
	      var _this = this;
	
	      window.setTimeout(function () {
	        if (_this.check()) {
	          _this.switchToFallbacks();
	          (0, _jquery2.default)(window).trigger('AdBlockDetected');
	        }
	      }, config.getInt('marketing.delayedAdBlockDetectionTime'));
	    }
	  }]);
	
	  return AdBlock;
	}();
	
	exports.default = AdBlock;

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MessageBox;
	function MessageBox($scope) {
	  this.messages = [];
	
	  /**
	   * @param {String} message
	   * @param {String} type
	   */
	  this.addMessage = function (message, type) {
	    this.messages.push({
	      message: message,
	      type: type
	    });
	  };
	
	  /**
	   * @param {String} message
	   */
	  this.addError = function (message) {
	    this.addMessage(message, 'error');
	  };
	
	  this.clear = function () {
	    $scope.html('');
	    this.messages = [];
	  };
	
	  this.render = function () {
	    for (var i = 0; i < this.messages.length; i++) {
	      $scope.append('<div class="' + this.messages[i].type + '">' + this.messages[i].message + '</div>');
	    }
	
	    if (this.messages.length > 0) {
	      window.scrollTo(0, 0);
	    }
	  };
	}

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _TeaserFadeView = __webpack_require__(255);
	
	var _TeaserFadeView2 = _interopRequireDefault(_TeaserFadeView);
	
	var _Utils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TeaserFadeView2.default.extend({
	  disableRandomSeed: false,
	
	  /**
	   * @type {$}
	   */
	  $bullets: null,
	
	  /**
	   * Return array index based on weights
	   *
	   * @param {Array} weight
	   * @return {Number}
	   */
	  getRandomWithWeight: function getRandomWithWeight(weight) {
	    var totalWeight = weight.reduce(function (prev, cur) {
	      return prev + cur;
	    });
	
	    var randomNum = (0, _Utils.randRange)(0, totalWeight);
	    var weightSum = 0;
	
	    for (var i = 0; i < weight.length; i++) {
	      weightSum += weight[i];
	      weightSum = +weightSum.toFixed(2);
	
	      if (randomNum <= weightSum) {
	        return i;
	      }
	    }
	
	    // TODO: before it returned undefined
	    return 0;
	  },
	
	  /**
	   * This method selects first teaser with weighted probability from all available teasers
	   * @returns {Number}
	   */
	  seedTeaser: function seedTeaser() {
	    if (this.disableRandomSeed) {
	      this.activeTeaser = 0;
	    } else {
	      var iLength = this.$teasers.length;
	      var i;
	      var iLastWeight = 1;
	      var aWeights = [];
	
	      /*
	       * Generate weights array
	       */
	      for (i = 0; i < iLength; i++) {
	        aWeights[i] = iLastWeight;
	
	        iLastWeight -= 0.1;
	        if (iLastWeight < 0.1) {
	          iLastWeight = 0.1;
	        }
	      }
	
	      this.activeTeaser = this.getRandomWithWeight(aWeights);
	    }
	  },
	
	  toGlobalFallback: function toGlobalFallback() {
	    this.$('.ui-slider-to-left').remove();
	    this.$('.ui-slider-to-right').remove();
	    this.$('.bullet-teaser__bullet-container').remove();
	  },
	
	  /**
	   * Rescale teaser to desired dimensions
	   * @param {Number} width
	   * @param {Number} height
	   */
	  rescale: function rescale(width, height) {
	    var iWidth = parseInt(width, 10) > 0 ? parseInt(width, 10) : 0;
	    var iHeight = parseInt(height, 10) > 0 ? parseInt(height, 10) : 0;
	
	    if (iWidth > 0) {
	      this.$el.width(iWidth);
	      this.$('.iframe, .teaser-element').width(iWidth);
	    }
	
	    if (iHeight > 0) {
	      this.$el.height(iHeight);
	      this.$('.iframe, .teaser-element').height(iHeight);
	    }
	  },
	
	  /**
	   * Method renders nav bullets based on included teasers
	   */
	  addBullets: function addBullets() {
	    var iLength = this.$teasers.length;
	    var $bulletContainer;
	    var i;
	    var sHtml = '';
	
	    this.$el.append("<div class='bullet-teaser__bullet-container'></div>");
	    $bulletContainer = this.$('.bullet-teaser__bullet-container');
	
	    for (i = 0; i < iLength; i++) {
	      sHtml += '<span class="bullet-teaser__bullet" data-index="' + i + '"></span>';
	    }
	
	    $bulletContainer.append(sHtml);
	
	    this.$bullets = this.$('.bullet-teaser__bullet');
	    this.$bullets.on('click', _jquery2.default.proxy(this.onBulletClick, this));
	  },
	
	  onBulletClick: function onBulletClick(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	    var iIndex = $cT.data('index');
	
	    if (typeof iIndex === 'number') {
	      this.fadeTo(iIndex);
	      this.restartTimer();
	    }
	  },
	
	  syncBullets: function syncBullets() {
	    this.$bullets.removeClass('bullet-teaser__bullet--active');
	    this.$bullets.eq(this.activeTeaser).addClass('bullet-teaser__bullet--active');
	  },
	
	  /**
	   * Teaser preinit hook used in implement per slider adjustments
	   */
	  preInit: function preInit() {
	    if (this.$el.data('disable-random-seed')) {
	      this.disableRandomSeed = true;
	    }
	
	    this.rescale(this.$el.data('width'), this.$el.data('height'));
	  },
	
	  postInit: function postInit() {
	    if (!this.$el.data('disable-bullets')) {
	      this.addBullets();
	      this.syncBullets();
	    }
	  },
	
	  postFadeTo: function postFadeTo() {
	    this.syncBullets();
	  }
	});

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _TeaserBaseView = __webpack_require__(123);
	
	var _TeaserBaseView2 = _interopRequireDefault(_TeaserBaseView);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TeaserBaseView2.default.extend({
	  events: {
	    'mouseenter-not-touch .new-teaser-list a': 'onLinkMouseEnter',
	    'touchend .new-teaser-list a': 'onLinkTouchEnd',
	    'touchstart .content': 'onTouchStart',
	    'touchend .content': 'onTouchEnd'
	  },
	
	  /**
	   * @type {int}
	   */
	  fadeTime: config.getInt('marketing.teaser.hovering.intervals.fade'),
	
	  /**
	   * @type {Number}
	   */
	  hoverDelay: config.getInt('marketing.teaser.hovering.intervals.hover'),
	
	  /**
	   * @type {Number}
	   */
	  delayTimer: null,
	
	  /**
	   * @type {$}
	   */
	  $links: null,
	
	  /**
	   * @type {Number}
	   */
	  temporaryTarget: null,
	
	  onLinkMouseEnter: function onLinkMouseEnter(event) {
	    this.moveToTeaserByEvent(event);
	  },
	
	  onLinkTouchEnd: function onLinkTouchEnd(event) {
	    var $target = (0, _jquery2.default)(event.currentTarget);
	
	    this.blockTransition = true;
	
	    /*
	     * check if currently active is equal to touched, if yes then reload page, if not update image
	     */
	    if (!$target.hasClass('active')) {
	      event.preventDefault();
	      this.moveToTeaserByEvent(event);
	    } else {
	      $target.trigger('click');
	    }
	  },
	
	  moveToTeaserByEvent: function moveToTeaserByEvent(event) {
	    this.fadeTo((0, _jquery2.default)(event.currentTarget).parent().index());
	  },
	
	  /**
	   * @param {Number} target
	   */
	  fadeTo: function fadeTo(target) {
	    var $target = this.$teasers.eq(target);
	
	    if (this.activeTeaser !== target && $target.length > 0) {
	      if (this.delayTimer) {
	        window.clearTimeout(this.delayTimer);
	      }
	
	      this.temporaryTarget = target;
	
	      this.delayTimer = window.setTimeout(_jquery2.default.proxy(this.onLinkHoverTimeout, this), this.hoverDelay);
	    }
	  },
	
	  /**
	   * Sync current teaser to temporaryTarget
	   */
	  onLinkHoverTimeout: function onLinkHoverTimeout() {
	    var $target = this.$teasers.eq(this.temporaryTarget);
	
	    this.activeTeaser = this.temporaryTarget;
	
	    this.$teasers.stop(true, true);
	    this.$teasers.fadeOut(this.fadeTime);
	
	    if ($target.length === 1) {
	      $target.fadeIn(this.fadeTime);
	      this.markMenu();
	    }
	    this.postFadeTo();
	  },
	
	  /**
	   * This pre-hook is executed before constructor logic
	   */
	  preInit: function preInit() {
	    this.$links = this.$('.new-teaser-list a');
	  },
	
	  postInit: function postInit() {
	    this.markMenu();
	  },
	
	  markMenu: function markMenu() {
	    this.$links.removeClass('active');
	    this.$links.eq(this.activeTeaser).addClass('active');
	  },
	
	  onTimeout: function onTimeout() {
	    if (!this.blockTransition) {
	      this.fadeTo(this.getNextTeaser());
	    }
	  },
	
	  toGlobalFallback: function toGlobalFallback() {
	    this.$links.removeClass('active');
	  }
	});

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TeaserBaseView = __webpack_require__(123);
	
	var _TeaserBaseView2 = _interopRequireDefault(_TeaserBaseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TeaserBaseView2.default.extend({
	  events: {
	    'click .ui-slider-to-left': 'onClickToTheLeft',
	    'click .ui-slider-to-right': 'onClickToTheRight',
	    'touchstart .content': 'onTouchStart',
	    'touchend .content': 'onTouchEnd'
	  },
	
	  fadeTime: 600,
	  treshold: 100,
	
	  postInit: function postInit() {
	    // show what was hidden in BaseView.init
	    this.$teasers.show();
	    this.$el.width(this.$el.data('width'));
	    this.$el.height(this.$el.data('height'));
	    this.$container = this.$('.content');
	  },
	
	  toGlobalFallback: function toGlobalFallback() {
	    this.$('.ui-slider-to-left').hide();
	    this.$('.ui-slider-to-right').hide();
	  },
	
	  onTimeout: function onTimeout() {
	    if (!this.blockTransition) {
	      this.onClickToTheRight();
	    }
	  },
	
	  onClickToTheLeft: function onClickToTheLeft() {
	    this.fadeTo(this.getPrevTeaser());
	    this.restartTimer();
	  },
	
	  onClickToTheRight: function onClickToTheRight() {
	    this.fadeTo(this.getNextTeaser());
	    this.restartTimer();
	  },
	
	  fadeTo: function fadeTo(target) {
	    var activeTeaser = this.activeTeaser;
	    var teaserCount = this.$teasers.length;
	    var distanceLeft = activeTeaser <= target ? teaserCount + activeTeaser - target : activeTeaser - target;
	    var distanceRight = activeTeaser >= target ? teaserCount + target - activeTeaser : target - activeTeaser;
	
	    if (distanceLeft > distanceRight) {
	      this.slideRight(distanceRight);
	    } else {
	      this.slideLeft(distanceLeft);
	    }
	  },
	
	  slideRight: function slideRight(distance) {
	    if (this.isSliding) {
	      return;
	    }
	    this.isSliding = true;
	
	    this.$container.css({
	      left: -(distance * this.$el.width()),
	      transition: 'left ease-out ' + this.fadeTime + 'ms'
	    });
	
	    setTimeout(function () {
	      for (var i = 0; i < distance; i++) {
	        this.$container.find('.teaser-element:first').appendTo(this.$container);
	      }
	      this.$container.css({
	        left: 0,
	        transition: 'none'
	      });
	
	      this.isSliding = false;
	    }.bind(this), distance * this.fadeTime + this.treshold);
	  },
	
	  slideLeft: function slideLeft(distance) {
	    if (this.isSliding) {
	      return;
	    }
	    this.isSliding = true;
	
	    for (var i = 0; i < distance; i++) {
	      this.$container.find('.teaser-element:last').prependTo(this.$container);
	    }
	    this.$container.css({
	      left: -(distance * this.$el.width())
	    });
	
	    setTimeout(function () {
	      this.$container.css({
	        left: 0,
	        transition: 'left ease-out ' + this.fadeTime + 'ms'
	      });
	    }.bind(this), 0);
	
	    setTimeout(function () {
	      this.$container.css({
	        transition: 'none'
	      });
	      this.isSliding = false;
	    }.bind(this), distance * this.fadeTime + this.treshold);
	  }
	});

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  var self = {};
	
	  self.$scope = (0, _jquery2.default)('body');
	
	  self.toggle = function (event) {
	    event.preventDefault();
	
	    var $arrow = (0, _jquery2.default)(event.target);
	
	    $arrow.toggleClass('icon-arrow-open icon-arrow-close');
	    $arrow.parent().find('.categoryList-content').toggle('is-open');
	  };
	
	  self.init = function () {
	    self.$scope.find('.cmsCategoryList .icon-arrow-open, .cmsCategoryList .icon-arrow-close').on('click', self.toggle);
	  };
	
	  self.init();
	
	  return self;
	})();

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selector = '#contact-message-box';
	var $html = (0, _jquery2.default)(selector);
	
	if ($html.length > 0) {
	  lightbox.setConfig({
	    $dialog: $html,
	    className: 'contact-message-box'
	  }).open();
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.run = run;
	exports.setScope = setScope;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _base = __webpack_require__(28);
	
	var _Utils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $scope = (0, _jquery2.default)('body');
	
	function run() {
	  $scope.find('[data-def]').not('.def-processed').each(function () {
	    var $this = (0, _jquery2.default)(this);
	
	    try {
	      $this.html((0, _base.decode)((0, _Utils.rot13)($this.attr('data-def'))));
	      $this.addClass('def-processed');
	    } catch (ignore) {}
	  });
	}
	
	function setScope(s) {
	  $scope = s;
	}
	
	run();

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.destroy = destroy;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectors = {
	  countBadge: '.js-header__cart-articles-count'
	};
	
	function init() {
	  _jquery2.default.subscribe('update.header:cart', updateCounter);
	}
	
	function destroy() {
	  _jquery2.default.unsubscribe('.header:cart');
	}
	
	function updateCounter(event, newVal) {
	  (0, _jquery2.default)(selectors.countBadge).text(newVal);
	}

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _bootstrapper = __webpack_require__(8);
	
	var _wishlist = __webpack_require__(195);
	
	var _cart = __webpack_require__(303);
	
	var _userAccount = __webpack_require__(305);
	
	var _userAccount2 = _interopRequireDefault(_userAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)(null, function () {
	  (0, _userAccount2.default)();
	  (0, _cart.init)();
	  (0, _wishlist.init)();
	});

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = init;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var selectors = {
	  accountIcon: '.js-header-user-account',
	  linkClass: '.js-a-force-click'
	};
	var cssClasses = {
	  hoverClassCss: 'hover'
	};
	var isAlreadyClicked = false;
	var $accountIcon;
	var $link;
	
	function init() {
	  $accountIcon = (0, _jquery2.default)(selectors.accountIcon);
	  $link = $accountIcon.find(selectors.linkClass);
	
	  // touchend is used to allow :hover state be triggered by browser
	  $accountIcon.on('touchend', selectors.linkClass, function (event) {
	    event.preventDefault();
	
	    if (isAlreadyClicked) {
	      isAlreadyClicked = false;
	      toggleHoverClass(false);
	      goToLinkAddress();
	    } else {
	      isAlreadyClicked = true;
	      attachDocumentEvent();
	      toggleHoverClass(true);
	    }
	  });
	
	  $link.on('touchstart', function (event) {
	    event.preventDefault();
	  });
	}
	
	// fallback for mobile browsers, which don't support hover state
	function toggleHoverClass(addOrRemove) {
	  $accountIcon.toggleClass(cssClasses.hoverClassCss, addOrRemove);
	}
	
	function attachDocumentEvent() {
	  (0, _jquery2.default)(window.document).on('touchstart.headerLink', function (event) {
	    var target = event.target;
	
	    // if header or children were clicked - skip. Appropriate event for header will take care
	    while (target !== this) {
	      if (target === $accountIcon[0]) {
	        return;
	      }
	
	      target = target.parentNode;
	    }
	
	    isAlreadyClicked = false;
	    deattachDocumentEvent();
	    toggleHoverClass(false);
	  });
	}
	
	function deattachDocumentEvent() {
	  (0, _jquery2.default)(window.document).off('.headerLink');
	}
	
	function goToLinkAddress() {
	  window.location.assign($link.attr('href'));
	}

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clicked = false;
	var $container = (0, _jquery2.default)('#home24-fixed-container');
	var right = -$container.width() + 41;
	
	$container.css('right', right);
	
	(0, _jquery2.default)('.js-helparea').on('click', function () {
	  if (!clicked) {
	    clicked = true;
	    window.location = (0, _jquery2.default)(this).stop(true).find('a').prop('href');
	  }
	}).on('mouseenter', function () {
	  (0, _jquery2.default)(this).stop(true).animate({ opacity: 1, right: -right }, config.getInt('general.appearSpeed'));
	}).on('mouseleave', function () {
	  (0, _jquery2.default)(this).stop(true).animate({ opacity: 1, right: '0' }, config.getInt('general.appearSpeed'));
	});

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _validationController = __webpack_require__(13);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RedirectedTrafficView = _baseView2.default.extend({
	  initialize: function initialize(options) {
	    this.className = options.className;
	    this.showLightbox();
	  },
	
	  showLightbox: function showLightbox() {
	    lightbox.setConfig({
	      $dialog: this.$el,
	      className: this.className
	    }).open();
	
	    (0, _validationController.reload)();
	  }
	});
	
	/*
	 register bootstrap function
	 */
	(0, _bootstrapper.register)(null, function () {
	  var el = (0, _jquery2.default)('.redirected-traffic');
	
	  if (el.length) {
	    new RedirectedTrafficView({
	      el: el,
	      className: 'redirected-traffic'
	    });
	  }
	});

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _searchFieldView = __webpack_require__(310);
	
	var _searchFieldView2 = _interopRequireDefault(_searchFieldView);
	
	var _searchFieldModel = __webpack_require__(309);
	
	var _searchFieldModel2 = _interopRequireDefault(_searchFieldModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)(null, function () {
	  _underscore2.default.each((0, _jquery2.default)('.search-block'), function (el) {
	    new _searchFieldView2.default({
	      el: el,
	      model: new _searchFieldModel2.default()
	    });
	  });
	});

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    apiUrl: config.getBaseUrl() + config.get('search.suggest.url'),
	    searchPhrase: '',
	    searchPhraseLengthThreshold: config.getInt('search.suggest.lengthThreshold'),
	    suggestions: [],
	    suggestItemIndex: -1,
	    submittedByClick: false,
	    showSuggestionsBox: false,
	    formSubmitted: false
	  },
	
	  initialize: function initialize() {
	    this.on('change:searchPhrase', function (model) {
	      var searchPhrase = model.get('searchPhrase');
	
	      if (!model.get('formSubmitted') && searchPhrase.length > model.get('searchPhraseLengthThreshold')) {
	        model.getSuggestions();
	      }
	    });
	
	    this.on('change:suggestions', function (model) {
	      model.set({
	        showSuggestionsBox: model.get('suggestions').length > 0
	      });
	    });
	  },
	
	  /**
	   * Method loads search suggestions from server
	   */
	  getSuggestions: function getSuggestions() {
	    $.ajax({
	      type: 'GET',
	      url: this.get('apiUrl'),
	      context: this,
	      data: {
	        query: this.get('searchPhrase')
	      },
	      dataType: 'json',
	      success: this.onGetSuggestionsSuccess
	    });
	  },
	
	  onGetSuggestionsSuccess: function onGetSuggestionsSuccess(data) {
	    this.set({
	      suggestions: data,
	      suggestItemIndex: -1
	    });
	  },
	
	  setSearchPhrase: function setSearchPhrase(phrase) {
	    this.set({
	      searchPhrase: phrase
	    });
	  },
	
	  moveIndexUp: function moveIndexUp() {
	    if (this.get('showSuggestionsBox')) {
	      var index = this.get('suggestItemIndex');
	
	      index--;
	
	      if (index < 0) {
	        index = this.get('suggestions').length - 1;
	      }
	
	      this.set({
	        suggestItemIndex: index
	      });
	    }
	  },
	
	  moveIndexDown: function moveIndexDown() {
	    if (this.get('showSuggestionsBox')) {
	      var index = this.get('suggestItemIndex');
	
	      index++;
	
	      if (index >= this.get('suggestions').length) {
	        index = 0;
	      }
	
	      this.set({
	        suggestItemIndex: index
	      });
	    }
	  },
	
	  isSuggestionSelectedByKeyboard: function isSuggestionSelectedByKeyboard() {
	    return !this.get('submittedByClick') && this.get('suggestItemIndex') >= 0;
	  },
	
	  setCurrentSearchPhrase: function setCurrentSearchPhrase() {
	    this.set({
	      searchPhrase: this.get('suggestions')[this.get('suggestItemIndex')].name
	    });
	  },
	  setFormAsSubmitted: function setFormAsSubmitted() {
	    this.set({
	      formSubmitted: true
	    });
	  },
	  isFormSubmitable: function isFormSubmitable() {
	    return !this.get('formSubmitted');
	  }
	});

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(227);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'keyup .search-field-input': 'onKeyUp',
	    'click .suggest-result': 'onSuggestClick',
	    'touchend .suggest-result': 'onSuggestClick',
	    'change .search-field-input': 'onInputChange',
	    'submit form': 'onFormSubmit'
	  },
	
	  $suggestContainer: null,
	
	  keyCode: {
	    up: config.getInt('keyCodes.up'),
	    down: config.getInt('keyCodes.down')
	  },
	
	  initialize: function initialize() {
	    this.binding = _rivets2.default.bind(this.el, {
	      results: this.model,
	      eventHandlers: this
	    });
	
	    this.$el.find('.search-field-input').placeholder();
	
	    this.$suggestContainer = this.$el.find('.suggest');
	
	    this.$suggestContainer.width(this.$el.width() - 2);
	
	    (0, _jquery2.default)(document).on('click.hideSuggest touchend.hideSuggest', _jquery2.default.proxy(this.onClickOutsideContainer, this.model));
	  },
	
	  onFormSubmit: function onFormSubmit() {
	    if (!this.model.isFormSubmitable()) {
	      return false;
	    }
	
	    this.model.setFormAsSubmitted();
	
	    if (this.model.isSuggestionSelectedByKeyboard()) {
	      this.model.setCurrentSearchPhrase();
	    }
	
	    return true;
	  },
	
	  /**
	   * Method removes all suggestions to hide suggestion box
	   * Because it is binded on document level has to be called via proxy with content pointing to this.model
	   */
	  onClickOutsideContainer: function onClickOutsideContainer(event) {
	    // Clear suggestions only when click came from outside of form button
	    if (!(0, _jquery2.default)(event.target).hasClass('search-field-submit')) {
	      this.set({
	        suggestions: []
	      });
	    }
	  },
	
	  resizeSuggestContainer: function resizeSuggestContainer() {
	    var windowHeight = (0, _jquery2.default)(window).height();
	    var bodyScrollTop = (0, _jquery2.default)(document).scrollTop();
	    var windowLowerEdge = bodyScrollTop + windowHeight;
	    var height = windowLowerEdge - (this.$el.offset().top + this.$el.height() + 30);
	
	    if (height < 150) {
	      height = 150;
	    }
	
	    this.$suggestContainer.css('max-height', height + 'px');
	  },
	
	  onInputChange: function onInputChange(event) {
	    this.model.setSearchPhrase(event.currentTarget.value);
	  },
	
	  /**
	   * @param {Event} event
	   */
	  onKeyUp: function onKeyUp(event) {
	    this.model.setSearchPhrase(event.currentTarget.value);
	
	    var keyCode = event.keyCode;
	    var doSelection = false;
	
	    if (keyCode === this.keyCode.up) {
	      this.model.moveIndexUp();
	      doSelection = true;
	    } else if (keyCode === this.keyCode.down) {
	      this.model.moveIndexDown();
	      doSelection = true;
	    }
	
	    if (doSelection) {
	      this.$el.find('.suggest-result').removeClass('selected');
	      this.$el.find('.suggest-result').eq(this.model.get('suggestItemIndex')).addClass('selected');
	    }
	
	    this.resizeSuggestContainer();
	  },
	
	  onSuggestClick: function onSuggestClick(event) {
	    this.model.set({
	      searchPhrase: this.model.get('suggestions')[(0, _jquery2.default)(event.currentTarget).index()].name,
	      submittedByClick: true
	    });
	    this.$el.find('form').submit();
	  }
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _touch = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  'use strict';
	
	  var shopTheLook = {
	    init: function init() {
	      (0, _jquery2.default)('.js-shop-the-look__trigger').on('mouseenter-not-touch', _jquery2.default.proxy(this.onTriggerMouseEnter, this)).on('touchend', _jquery2.default.proxy(this.onTriggerTouch, this));
	
	      (0, _jquery2.default)('.js-shop-the-look__content').on('mouseleave-not-touch', _jquery2.default.proxy(this.onMouseLeave, this));
	
	      if (_touch.hasTouch) {
	        (0, _jquery2.default)('.js-shop-the-look__content').addClass('is-hidden');
	      }
	    },
	
	    hideAll: function hideAll() {
	      var that = this;
	
	      (0, _jquery2.default)('.js-shop-the-look__trigger').each(function () {
	        that.hide(this);
	      });
	    },
	
	    onTriggerTouch: function onTriggerTouch(event) {
	      var that = this;
	
	      this.hideAll();
	
	      setTimeout(function () {
	        that.show(event.currentTarget);
	      }, 500);
	    },
	
	    onTriggerMouseEnter: function onTriggerMouseEnter(event) {
	      this.show(event.currentTarget);
	    },
	
	    onMouseLeave: function onMouseLeave(event) {
	      this.hide(event.currentTarget.previousSibling);
	    },
	
	    hide: function hide(currentMarker) {
	      var $parent = (0, _jquery2.default)(currentMarker).parent();
	
	      if (_touch.hasTouch) {
	        $parent.find('.js-shop-the-look__content').addClass('is-hidden');
	      }
	      $parent.removeClass('marker--active');
	    },
	
	    show: function show(currentMarker) {
	      var $parent = (0, _jquery2.default)(currentMarker).parent();
	
	      if (_touch.hasTouch) {
	        $parent.find('.js-shop-the-look__content').removeClass('is-hidden');
	      }
	      $parent.addClass('marker--active');
	      $parent.find('a').addClass('hover');
	    }
	  };
	
	  if ((0, _jquery2.default)('.js-shop-the-look').length > 0) {
	    shopTheLook.init();
	  }
	})();

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _TeaserFadeView = __webpack_require__(255);
	
	var _TeaserFadeView2 = _interopRequireDefault(_TeaserFadeView);
	
	var _TeaserBulletView = __webpack_require__(297);
	
	var _TeaserBulletView2 = _interopRequireDefault(_TeaserBulletView);
	
	var _TeaserListView = __webpack_require__(298);
	
	var _TeaserListView2 = _interopRequireDefault(_TeaserListView);
	
	var _TeaserSlideView = __webpack_require__(299);
	
	var _TeaserSlideView2 = _interopRequireDefault(_TeaserSlideView);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)(null, function () {
	  (0, _jquery2.default)('.main-teaser').each(function () {
	    new _TeaserFadeView2.default({
	      el: (0, _jquery2.default)(this)
	    });
	  });
	
	  (0, _jquery2.default)('.bullet-teaser').each(function () {
	    new _TeaserBulletView2.default({
	      el: (0, _jquery2.default)(this)
	    });
	  });
	
	  (0, _jquery2.default)('.new-teaser').each(function () {
	    new _TeaserListView2.default({
	      el: (0, _jquery2.default)(this)
	    });
	  });
	
	  (0, _jquery2.default)('.slide-teaser').each(function () {
	    new _TeaserSlideView2.default({
	      el: (0, _jquery2.default)(this)
	    });
	  });
	});

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _buttonView = __webpack_require__(199);
	
	var _buttonView2 = _interopRequireDefault(_buttonView);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('category-new search-new article article-new', function () {
	  new _buttonView2.default();
	});

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _addToCart = __webpack_require__(55);
	
	var _addToCart2 = _interopRequireDefault(_addToCart);
	
	var _visualNavigationView = __webpack_require__(315);
	
	var _visualNavigationView2 = _interopRequireDefault(_visualNavigationView);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('category-new search-new', function () {
	  var $visualNavigation = $('#visual-navigation');
	
	  if ($visualNavigation.length > 0) {
	    new _visualNavigationView2.default({
	      el: $visualNavigation
	    });
	  }
	
	  new _addToCart2.default({
	    pageType: 'pdp_qv'
	  });
	});

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  itemsInRow: registry.get('visualNavigation.itemsInRow') || 5,
	  loadedImages: [],
	  imagesLength: [],
	  rowGroups: [],
	
	  selectors: {
	    item: '.visual-navigation__item',
	    image: '.visual-navigation__image',
	    container: '.visual-navigation__image-container'
	  },
	
	  initialize: function initialize() {
	    // split visual categories by row
	    this.rowGroups = this.splitIntoGroups(this.$(this.selectors.item), this.itemsInRow);
	
	    // wait for all images in row to be loaded
	    this.rowGroups.forEach(_jquery2.default.proxy(this.waitForImagesToLoad, this));
	  },
	
	  splitIntoGroups: function splitIntoGroups($items, itemsInGroup) {
	    var groups = [];
	    var sliceFrom = 0;
	    var sliceTo = this.itemsInRow;
	    var i;
	    var $itemsLength = $items.length;
	
	    for (i = 0; i < $itemsLength; i += itemsInGroup) {
	      groups.push($items.slice(sliceFrom, sliceTo));
	
	      sliceFrom = sliceTo;
	      sliceTo += itemsInGroup;
	    }
	
	    return groups;
	  },
	
	  waitForImagesToLoad: function waitForImagesToLoad($group, index) {
	    var $images = $group.find(this.selectors.image);
	
	    this.loadedImages[index] = 0;
	    this.imagesLength[index] = $images.length;
	
	    $images.each(_jquery2.default.proxy(this.loadImage, this, index));
	  },
	
	  loadImage: function loadImage(groupIndex, ignore, img) {
	    if (img.complete) {
	      this.nextImgLoaded(groupIndex);
	    } else {
	      (0, _jquery2.default)(img).on('load', _jquery2.default.proxy(this.nextImgLoaded, this, groupIndex));
	    }
	  },
	
	  /**
	   * check if all images from one row loaded
	   * if yes, call function to adjust their height
	   * @param index
	   */
	  nextImgLoaded: function nextImgLoaded(index) {
	    this.loadedImages[index]++;
	
	    if (this.loadedImages[index] === this.imagesLength[index]) {
	      // if all in row loaded, adjust their height
	      this.adjustHeight(index);
	    }
	  },
	
	  adjustHeight: function adjustHeight(index) {
	    var $group = this.rowGroups[index];
	
	    // find all image containers
	    var $imageContainers = $group.find(this.selectors.container);
	    var maxHeight;
	
	    // find highest value
	    maxHeight = this.findMaxHeightOfElements($imageContainers);
	
	    // set height of others in group to highest one
	    this.setHeightForElements($imageContainers, maxHeight);
	  },
	
	  findMaxHeightOfElements: function findMaxHeightOfElements($items) {
	    var heights = [];
	
	    $items.each(function (index, item) {
	      heights.push((0, _jquery2.default)(item).height());
	    });
	
	    return _underscore2.default.max(heights);
	  },
	
	  setHeightForElements: function setHeightForElements($items, height) {
	    $items.each(function (index, item) {
	      (0, _jquery2.default)(item).height(height);
	    });
	  }
	});

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _storageFactory = __webpack_require__(7);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('cms', function () {
	  /* See REBOOT-10236 */
	  (0, _jquery2.default)('#contactForm').on('submit', function () {
	    var sSubject = (0, _jquery2.default)('#raw_fttc_subject').val();
	
	    if (sSubject) {
	      (0, _storageFactory.getStorage)().set('GtmContactRequest', sSubject);
	    }
	  });
	});

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _fttc1Model = __webpack_require__(318);
	
	var _fttc1Model2 = _interopRequireDefault(_fttc1Model);
	
	var _fttc1Router = __webpack_require__(319);
	
	var _fttc1Router2 = _interopRequireDefault(_fttc1Router);
	
	var _fttc1View = __webpack_require__(320);
	
	var _fttc1View2 = _interopRequireDefault(_fttc1View);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)(null, function () {
	  var fttc1Model = new _fttc1Model2.default(registry.get('helpTreeStructureJSON'));
	
	  if ($('#fttc-wrapper').length > 0) {
	    var fttc1View = new _fttc1View2.default({
	      model: fttc1Model,
	      el: $('#fttc-wrapper')
	    });
	    var fttc1Router = new _fttc1Router2.default();
	
	    fttc1Router.view = fttc1View;
	
	    if (!_backbone2.default.History.started) {
	      _backbone2.default.history.start();
	    }
	  }
	});

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  returnTreeColsById: function returnTreeColsById(nodeId) {
	    var treeNodes = {
	      n1: undefined,
	      n2: undefined,
	      n3: undefined
	    };
	
	    var id = parseInt(nodeId, 10);
	
	    _underscore2.default.each(this.attributes, function (n1, nodeLevel1Key) {
	      /*
	       * Check node level 1
	       */
	      if (parseInt(nodeLevel1Key, 10) === id) {
	        treeNodes.n1 = n1;
	
	        return false;
	      }
	
	      _underscore2.default.each(n1.children, function (n2, nodeLevel2Key) {
	        /*
	         * Check node level 2
	         */
	        if (parseInt(nodeLevel2Key, 10) === id) {
	          treeNodes.n1 = n1;
	          treeNodes.n2 = n2;
	
	          return false;
	        }
	
	        _underscore2.default.each(n2.children, function (n3) {
	          if (n3.id === id) {
	            treeNodes.n1 = n1;
	            treeNodes.n2 = n2;
	            treeNodes.n3 = n3;
	
	            return false;
	          }
	        });
	      });
	    });
	
	    return treeNodes;
	  }
	});

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Router.extend({
	  routes: {
	    ':query': function query(_query) {
	      this.view.setFttcById(_query);
	    }
	  }
	});

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _rivets = __webpack_require__(9);
	
	var _rivets2 = _interopRequireDefault(_rivets);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _fttc1ViewModel = __webpack_require__(321);
	
	var _fttc1ViewModel2 = _interopRequireDefault(_fttc1ViewModel);
	
	var _translation = __webpack_require__(12);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    this.viewModel = new _fttc1ViewModel2.default();
	
	    this.viewModel.get('col1').items = _underscore2.default.values(this.model.attributes);
	
	    this.setupRivetsBindings();
	  },
	
	  rivetsEventHandlers: ['mainTopicChange', 'subTopicChange', 'questionClicked', 'submitReclamationRequest', 'submitContactRequest', 'showFttcCallPopup'],
	
	  setupRivetsBindings: function setupRivetsBindings() {
	    this.binding = _rivets2.default.bind(this.el, {
	      viewModel: this.viewModel,
	      eventHandlers: this
	    });
	  },
	
	  mainTopicChange: function mainTopicChange(event, binding) {
	    if (binding.item) {
	      var col2;
	
	      _underscore2.default.each(this.viewModel.get('col1').items, function (item) {
	        item.selected = false;
	      });
	
	      _underscore2.default.each(this.viewModel.get('col2').items, function (item) {
	        item.selected = false;
	      });
	
	      binding.item.selected = true;
	
	      col2 = this.viewModel.get('col2');
	
	      col2.show = true;
	      col2.name = binding.item.name;
	      col2.items = _underscore2.default.values(binding.item.children);
	
	      this.viewModel.get('col3').show = false;
	    }
	  },
	
	  subTopicChange: function subTopicChange(event, binding) {
	    if (binding.item) {
	      _underscore2.default.each(this.viewModel.get('col2').items, function (item) {
	        item.selected = false;
	      });
	
	      binding.item.selected = true;
	
	      this.viewModel.get('col3').items = _underscore2.default.values(binding.item.children);
	
	      _underscore2.default.each(this.viewModel.get('col3').items, function (item) {
	        var dataVariantUrl;
	
	        if (item.reclamation) {
	          switch (item.reclamation) {
	            case 'variant1':
	              dataVariantUrl = registry.get('fttcFormUrls').dataVariant1Url;
	              break;
	            case 'variant2':
	              dataVariantUrl = registry.get('fttcFormUrls').dataVariant2Url;
	              break;
	            case 'variant3':
	              dataVariantUrl = registry.get('fttcFormUrls').dataVariant3Url;
	              break;
	          }
	
	          item.dataVariantUrl = dataVariantUrl;
	        }
	      });
	
	      // if we have one only one item in 3rd row - open it
	      if (this.viewModel.get('col3').items.length === 1) {
	        this.viewModel.get('col3').items[0].show = true;
	      }
	
	      this.viewModel.get('col3').show = true;
	
	      this.$el.find('.fttc-area .fttc-block1').slideUp(0);
	    }
	  },
	
	  questionClicked: function questionClicked(event, binding) {
	    if (binding.item) {
	      // Visibility status of the clicked item
	      var itemVisibility = binding.item.show;
	
	      // Hide all the items in the list
	      _underscore2.default.each(this.viewModel.get('col3').items, function (item) {
	        item.show = false;
	      });
	
	      // Toggle visibility of the clicked item
	      binding.item.show = !itemVisibility;
	    }
	  },
	
	  submitReclamationRequest: function submitReclamationRequest(event, binding) {
	    this.viewModel.set('formAction', binding.item.dataVariantUrl);
	    this.submitForm();
	  },
	
	  submitContactRequest: function submitContactRequest() {
	    this.viewModel.set('formAction', registry.get('fttcFormUrls').contactUrl);
	    this.submitForm();
	  },
	
	  submitForm: function submitForm() {
	    var $form = this.$('#helparea_form');
	
	    $form.submit();
	  },
	
	  showFttcCallPopup: function showFttcCallPopup() {
	    lightbox.setConfig({
	      className: 'fttc1-call-lightbox'
	    }).open((0, _translation.get)('ui.fttc.call_button.hover.label'));
	  },
	
	  setFttcById: function setFttcById(id) {
	    var cols = this.model.returnTreeColsById(id);
	
	    this.mainTopicChange({}, {
	      item: cols.n1
	    });
	
	    this.subTopicChange({}, {
	      item: cols.n2
	    });
	
	    this.questionClicked({}, {
	      item: cols.n3
	    });
	  }
	});

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseModel = __webpack_require__(45);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseModel2.default.extend({
	  defaults: {
	    col1: {
	      items: []
	    },
	    col2: {
	      show: false,
	      name: undefined,
	      items: []
	    },
	    col3: {
	      show: false,
	      items: []
	    },
	    formAction: undefined
	  }
	});

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'click #next': 'onNextClick'
	  },
	
	  /**
	   * @type {Step1OrdersListView}
	   */
	  orderList: null,
	
	  /**
	   * @type {Step1UploadView}
	   */
	  uploadView: null,
	
	  /**
	   * @type {Step1Model}
	   */
	  model: null,
	
	  messageBox: null,
	
	  initialize: function initialize(options) {
	    this.orderList = options.orderList;
	    this.uploadView = options.uploadView;
	    this.messageBox = options.messageBox;
	  },
	
	  onNextClick: function onNextClick() {
	    var validationResult;
	
	    this.orderList.buildModelFromView();
	
	    validationResult = this.model.validate();
	
	    this.messageBox.clear();
	
	    if (validationResult !== true) {
	      /*
	       * There was a validation error
	       */
	      this.messageBox.addError(validationResult);
	    } else {
	      /*
	       * update model with data from UploadView
	       */
	      this.uploadView.updateModelFromView();
	
	      /*
	       * Order list is valid, so we can create new virtual form and submit it
	       */
	      this.$el.append(this.buildForm());
	      this.$('#virtualSubmitForm').submit();
	    }
	    this.messageBox.render();
	  },
	
	  /**
	   * Method build form representation of model to send it via POST request to get to next step
	   */
	  buildForm: function buildForm() {
	    /*
	        Create empty form
	         */
	    var $form = (0, _jquery2.default)('<form id="virtualSubmitForm" method="post" action="' + registry.get('submitUrl') + '"></form>');
	
	    var sHtml = '';
	    var aList = this.model.get('articles');
	    var oItem;
	
	    /*
	        Iterate over model and render all the fields
	         */
	    for (var i in aList) {
	      /* istanbul ignore else */
	      if (aList.hasOwnProperty(i)) {
	        oItem = aList[i];
	        sHtml += '<input type="hidden" name="article[' + oItem.sku + '][quantity]" value="' + oItem.quantity + '" />';
	        sHtml += '<input type="hidden" name="article[' + oItem.sku + '][relatedSku]" value="' + oItem.relatedSku + '" />';
	      }
	    }
	
	    sHtml += '<input type="hidden" name="chosen_order_number" value="' + this.model.get('orderId') + '" />';
	    sHtml += '<input type="hidden" name="comment" value="' + this.model.get('comment').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '"/>';
	
	    $form.append(sHtml);
	
	    return $form;
	  }
	});

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseModel = __webpack_require__(45);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	var _translation = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseModel2.default.extend({
	  defaults: {
	    orderId: null,
	    errorCount: 0,
	    articles: [],
	    comment: ''
	  },
	
	  clear: function clear() {
	    this.set({
	      orderId: null,
	      errorCount: 0,
	      articles: [],
	      comment: ''
	    });
	  },
	
	  /**
	   * Method validates current model and returns true if valid, in the other case returns localized
	   * error message
	   * @return {bool|String}
	   */
	  validate: function validate() {
	    var retVal = true;
	
	    if (this.get('errorCount') > 0) {
	      retVal = (0, _translation.get)('orderItem.quantityIsRequired.message');
	    } else if (!this.get('orderId') || !this.get('articles').length) {
	      retVal = (0, _translation.get)('orderItem.atleastOneIsRequired.message');
	    }
	
	    return retVal;
	  }
	});

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _customElements = __webpack_require__(18);
	
	var _dataTipped = __webpack_require__(49);
	
	var dataTipped = _interopRequireWildcard(_dataTipped);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'mouseleave .fttc2-checkbox-holder': 'onSelectAllLeave',
	    'change input.js-select-all': 'onSelectAllChange',
	    'change input.js-select-item': 'onItemCheckboxChange',
	    'change .js-quantity-select': 'onQuantitySelectChange'
	  },
	
	  onSelectAllLeave: function onSelectAllLeave() {
	    dataTipped.hideAll();
	  },
	
	  onSelectAllChange: function onSelectAllChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	    var $orderContainer = $cT.closest('.fttc2-open-close');
	    var bIsOrderOpened = $orderContainer.hasClass('active');
	    var bIsChecked = !!$cT.prop('checked');
	    var bOtherSelected;
	
	    if (!bIsChecked) {
	      /*
	       * If we unselect, then just unselect all
	       */
	      this.unselectAllItems($orderContainer);
	    } else {
	      if (bIsOrderOpened) {
	        this.selectAllItems($orderContainer);
	      } else {
	        /*
	         * If item in any other order (visible) is currently selected
	         */
	        bOtherSelected = !!this.$('.fttc2-open-close.active').find('input.js-select-item:checked').length;
	        bOtherSelected = bOtherSelected || this.$('.js-select-all:checked').length > 1;
	        if (bOtherSelected) {
	          /*
	           * Cancel selection and show a message
	           */
	          $cT.prop('checked', false);
	          dataTipped.show($cT.prev());
	        } else {
	          this.selectAllItems($orderContainer);
	          $orderContainer.find('.section-opener').trigger('click');
	        }
	      }
	    }
	
	    (0, _customElements.updateState)();
	  },
	
	  /**
	   * Method selects all items inside order container
	   * @param {$} $container
	   */
	  selectAllItems: function selectAllItems($container) {
	    $container.find('input.js-select-item').prop('checked', 'checked');
	    $container.find('.js-quantity-select').each(function (index, el) {
	      var $el = (0, _jquery2.default)(el);
	
	      $el.find('option').prop('selected', false);
	      $el.children(':last-child').prop('selected', 'selected');
	    });
	  },
	
	  /**
	   * Method unselects all items inside order container
	   * @param {$} $container
	   */
	  unselectAllItems: function unselectAllItems($container) {
	    $container.find('input.js-select-item').prop('checked', false);
	    $container.find('.js-quantity-select').each(function (index, el) {
	      var $el = (0, _jquery2.default)(el);
	
	      $el.find('option').prop('selected', false);
	      $el.children(':first-child').prop('selected', 'selected');
	    });
	  },
	
	  onItemCheckboxChange: function onItemCheckboxChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	    var $select = $cT.closest('.article').find('.js-quantity-select');
	    var bCurrentState = $cT.prop('checked');
	    var singleProduct = $select.find('option').length === 2;
	
	    $select.find('option:selected').prop('selected', false);
	
	    this.handleAssociatedAssemblyService($cT.val(), bCurrentState);
	
	    if (bCurrentState) {
	      if (singleProduct) {
	        $select.children(':last-child').prop('selected', 'selected');
	      }
	    } else {
	      /*
	       * Unselect "all items" checkbox
	       */
	      this.$('.js-select-all').prop('checked', false);
	
	      $select.children(':first-child').prop('selected', 'selected');
	    }
	
	    (0, _customElements.updateState)();
	  },
	
	  /**
	   * @param {String} sku
	   * @param {bool} bState
	   */
	  handleAssociatedAssemblyService: function handleAssociatedAssemblyService(sku, bState) {
	    var $element = this.$('[data-assembly-for="' + sku + '"]');
	
	    if (bState) {
	      $element.prop('checked', 'checked');
	    } else {
	      $element.prop('checked', false);
	    }
	  },
	
	  onQuantitySelectChange: function onQuantitySelectChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	    var $checkbox = $cT.closest('.article').find('input.js-select-item');
	    var selectedQuantity = parseInt($cT.val(), 10);
	
	    if (selectedQuantity) {
	      $checkbox.prop('checked', 'checked');
	    } else {
	      $checkbox.prop('checked', false);
	    }
	
	    this.handleAssociatedAssemblyService($checkbox.val(), !!selectedQuantity);
	
	    if (selectedQuantity !== parseInt($cT.children(':last-child').val(), 10)) {
	      this.$('.js-select-all').prop('checked', false);
	    }
	    (0, _customElements.updateState)();
	  },
	
	  buildModelFromView: function buildModelFromView() {
	    var $openedOrder = this.$('.fttc2-open-close.active');
	    var $articles = $openedOrder.find('.article, .assembly');
	    var aData = [];
	    var $item;
	    var $checkbox;
	    var $select;
	    var bIsChecked;
	    var bIsQuantified;
	    var sSku;
	    var iQuantity;
	    var sRelatedSku;
	    var iErrorCount = 0;
	
	    this.model.clear();
	
	    if ($openedOrder.length !== 1) {
	      return false;
	    }
	
	    for (var i = 0; i < $articles.length; i++) {
	      $item = $articles.eq(i);
	
	      $checkbox = $item.find('input.js-select-item');
	      $select = $item.find('.js-quantity-select');
	
	      sSku = $checkbox.val();
	
	      if (!sSku) {
	        continue;
	      }
	
	      sRelatedSku = '';
	      iQuantity = 0;
	
	      if ($item.hasClass('assembly')) {
	        sRelatedSku = $checkbox.data('assembly-for');
	        sSku += '_' + sRelatedSku;
	
	        iQuantity = parseInt(this.$('input[value="' + sRelatedSku + '"]').closest('.article').find('.js-quantity-select').val(), 10);
	      } else {
	        iQuantity = parseInt($select.val(), 10);
	      }
	
	      bIsChecked = $checkbox.is(':checked');
	      bIsQuantified = !!iQuantity;
	
	      if (bIsChecked !== bIsQuantified) {
	        iErrorCount++;
	      }
	
	      if (!iQuantity || !bIsChecked) {
	        continue;
	      }
	
	      aData.push({
	        sku: sSku,
	        quantity: iQuantity,
	        relatedSku: sRelatedSku
	      });
	    }
	
	    this.model.set({
	      orderId: $openedOrder.data('order-number'),
	      articles: aData,
	      errorCount: iErrorCount
	    });
	
	    return true;
	  }
	});

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _BaseUploadView = __webpack_require__(256);
	
	var _BaseUploadView2 = _interopRequireDefault(_BaseUploadView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseUploadView2.default.extend({
	  events: {
	    'change input.fileUploadField': 'onUploadInputChanged',
	    'click .js-file-remove': 'onFileRemoveClicked'
	  },
	
	  $boxLeft: null,
	  $boxRight: null,
	
	  $uploadTemplate: null,
	
	  messageBox: null,
	
	  initialize: function initialize(options) {
	    this.$uploadTemplate = options.$uploadTemplate;
	    this.messageBox = options.messageBox;
	    this.setBoxesHeight();
	  },
	
	  getUploadContainer: function getUploadContainer() {
	    return this.$el;
	  },
	
	  prepareUploadManager: function prepareUploadManager(uploadManager, event) {
	    uploadManager.$scope = this.$el;
	
	    uploadManager.setForm(this.$('.fttc2-upload-form').first()).setInput((0, _jquery2.default)(event.currentTarget)).validate();
	  },
	
	  /**
	   * Event handler that start file upload process
	   * @param event
	   */
	  onUploadInputChanged: function onUploadInputChanged(event) {
	    event.preventDefault();
	    if (event.currentTarget.value) {
	      this.startUpload(event);
	    }
	    event.currentTarget.value = '';
	  },
	
	  postInsertTemplate: function postInsertTemplate() {
	    this.setBoxesHeight();
	  },
	
	  postUploadSuccess: function postUploadSuccess() {
	    this.setBoxesHeight();
	  },
	
	  postUploadFailure: function postUploadFailure() {
	    this.setBoxesHeight();
	  },
	
	  /**
	   * Method is executed after uploaded file has been deleted from view
	   */
	  postFileRemove: function postFileRemove() {
	    this.setBoxesHeight();
	  },
	
	  updateModelFromView: function updateModelFromView() {
	    if (this.$el.length > 0) {
	      this.model.set({
	        comment: this.$el.find('#reclamationComment').val()
	      });
	    }
	  },
	
	  setBoxesHeight: function setBoxesHeight() {
	    var heightLeft;
	    var heightRight;
	    var newHeight;
	
	    if (!this.$boxLeft) {
	      this.$boxLeft = this.$('#box-left');
	    }
	    if (!this.$boxRight) {
	      this.$boxRight = this.$('#box-right');
	    }
	
	    this.$boxRight.css('height', 'auto');
	    this.$boxLeft.css('height', 'auto');
	
	    heightLeft = this.$boxLeft.height();
	    heightRight = this.$boxRight.height();
	
	    if (heightLeft > heightRight) {
	      newHeight = heightLeft;
	    } else {
	      newHeight = heightRight;
	    }
	
	    this.$boxRight.height(newHeight);
	    this.$boxLeft.height(newHeight);
	
	    this.$boxLeft.find('textarea').height(newHeight - this.$boxLeft.find('p').outerHeight() * 2);
	  }
	});

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _BaseUploadView = __webpack_require__(256);
	
	var _BaseUploadView2 = _interopRequireDefault(_BaseUploadView);
	
	var _Utils = __webpack_require__(15);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseUploadView2.default.extend({
	  events: {
	    'click .change-type-action .action': 'onReclamationTypeClick',
	    'change .reclamation-type-input': 'onReclamationTypeChange',
	    'click .different-complains label': 'onDifferentComplainsClick',
	    'change .reclamation-category-input': 'onCategoryChange',
	    'change .reclamation-reason-input': 'onReasonChange',
	    'click .fttc2-upload': 'onUploadOpenClick',
	    'click .js-file-remove': 'onFileRemoveClicked'
	  },
	
	  selectors: {
	    reclamationCategoryInput: '.reclamation-category-input',
	    reclamationTypeSelect: '.reclamation-type-input',
	    reclamationReasonInput: '.reclamation-reason-input',
	    reclamationPictureUploadWrapper: '.fttc2-download-holder',
	    reclamationPictureUploadLabel: '.js-fttc2-file-description'
	  },
	
	  $uploadParent: null,
	  $popup: null,
	  reasonOptions: {},
	
	  messageBox: null,
	
	  initialize: function initialize(options) {
	    this.commentView = options.commentView;
	    this.$popup = options.$popup;
	    this.$uploadTemplate = options.$uploadTemplate;
	    this.messageBox = options.messageBox;
	    this.isBusinessAccount = Boolean(registry.get('isBusinessAccount'));
	
	    this.model.set({
	      differentComplainsVisible: this.$('.different-complains input').prop('checked'),
	      type: this.$(this.selectors.reclamationTypeSelect).val()
	    });
	
	    this.listenTo(this.model, 'change:differentComplainsVisible', this.onDifferentComplainsModelChange);
	
	    this.repositionExpandedVerticalLine();
	
	    /*
	         Trigger view elements
	         */
	    this.onReclamationTypeChange();
	  },
	
	  /**
	   * Method is executed after uploaded file has been deleted from view
	   */
	  postFileRemove: function postFileRemove() {
	    this.handleEmptyDownloadSections();
	    this.repositionExpandedVerticalLine();
	  },
	
	  onUploadOpenClick: function onUploadOpenClick(event) {
	    event.preventDefault();
	
	    this.$uploadParent = (0, _jquery2.default)(event.currentTarget).closest('.reason-parent');
	
	    lightbox.setConfig({
	      $dialog: this.$popup,
	      className: 'upload-dialog'
	    }).open();
	
	    var $content = lightbox.getLightboxContainer();
	
	    $content.find('[name=sku]').val(this.$uploadParent.attr('data-sku'));
	
	    /*
	        Unbind old event and bind new for upload form
	         */
	    $content.off('.upload');
	
	    /*
	        Bind new events for this instance of file upload dialog
	         */
	    $content.on('change.upload', '.fileUploadField', _jquery2.default.proxy(this.onFileSelected, this));
	    $content.on('click.upload', '.js-upload-submit', _jquery2.default.proxy(this.onUploadSubmit, this));
	
	    if (!_jquery2.default.browser.msie) {
	      $content.on('click.upload', '.photo-filename', _jquery2.default.proxy(this.onFilenameClick, this));
	    }
	  },
	
	  getUploadContainer: function getUploadContainer() {
	    return this.$uploadParent;
	  },
	
	  prepareUploadManager: function prepareUploadManager(uploadManager) {
	    var $content = lightbox.getLightboxContainer();
	
	    uploadManager.$scope = this.$el;
	
	    uploadManager.setForm($content.find('form').first()).setInput($content.find('.fileUploadField').first()).validate();
	  },
	
	  onUploadSubmit: function onUploadSubmit(event) {
	    event.preventDefault();
	    this.startUpload(event);
	  },
	
	  postUploadSuccess: function postUploadSuccess() {
	    this.repositionExpandedVerticalLine();
	  },
	
	  postUploadFailure: function postUploadFailure() {
	    this.repositionExpandedVerticalLine();
	  },
	
	  postInsertTemplate: function postInsertTemplate($cloned) {
	    this.$uploadParent.find('.fttc2-file-box').first().removeClass('is-hidden');
	
	    if (!this.$uploadParent.hasClass('is-group-parent')) {
	      $cloned.attr('data-for', this.$uploadParent.find('.fttc2-uploaded-files').attr('data-target'));
	    }
	
	    this.repositionExpandedVerticalLine();
	  },
	
	  onFilenameClick: function onFilenameClick(event) {
	    event.preventDefault();
	    lightbox.getLightboxContainer().find('[name=fileUpload]').trigger('click');
	  },
	
	  onFileSelected: function onFileSelected(event) {
	    this.startUpload(event);
	  },
	
	  validateImages: function validateImages() {
	    if (this.reasonOptions.imageUpload && this.$('.fttc2-uploaded-files').children().length === 0) {
	      this.model.set('imagesValid', false);
	    }
	  },
	
	  validateSelects: function validateSelects() {
	    var $list = this.$('.reclamation-category-input, .reclamation-reason-input');
	    var i;
	
	    $list.removeClass('invalid');
	
	    for (i = 0; i < $list.length; i++) {
	      var $element = $list.eq(i);
	
	      if ($element.is(':visible') && $element.is(':enabled') && !$element.find('option:selected').val()) {
	        $element.addClass('invalid');
	        this.model.set('selectsValid', false);
	      }
	    }
	
	    var reclamationTypeValue = this.$(this.selectors.reclamationTypeSelect).val();
	
	    if (this.isBusinessAccount && (reclamationTypeValue === 'cancel' || reclamationTypeValue === 'return')) {
	      this.model.set('b2bCancellationValid', false);
	    }
	  },
	
	  preselect: function preselect() {
	    this.$('[data-preselected-value]').each(function () {
	      var $this = (0, _jquery2.default)(this);
	
	      $this.val($this.data('preselected-value')).trigger('change');
	    });
	  },
	
	  onCategoryChange: function onCategoryChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	    var $parent = this.getReasonParent($cT);
	    var $input = $parent.find(this.selectors.reclamationReasonInput).eq(0);
	    var reclamationType = this.model.get('type');
	    var value = $cT.val();
	
	    if (value) {
	      this.populateReasonSelects($parent, this.model.getReasons(reclamationType, value), '.reclamation-reason-input:first');
	
	      // set currently chosen children for future reference
	      $parent.attr('data-current-reclamation-path', reclamationType + '.' + value);
	
	      $cT.removeClass('invalid');
	      $input.prop('disabled', false);
	      $input.trigger('change');
	      $parent.find('.reason-holder').addClass('active');
	    } else {
	      $input.val($input.find('option:first').val());
	      $input.trigger('change');
	      $input.prop('disabled', true);
	      $parent.find('.reason-holder').removeClass('active');
	    }
	  },
	
	  onReasonChange: function onReasonChange(event) {
	    var $cT = (0, _jquery2.default)(event.currentTarget);
	    var $parent = this.getReasonParent($cT);
	
	    $cT.removeClass('invalid');
	
	    // set currently chosen children for future reference
	    var currentReclamationPath = $parent.attr('data-current-reclamation-path');
	
	    if (currentReclamationPath) {
	      var pathAsArray = currentReclamationPath.split('.');
	
	      $parent.attr('data-current-reclamation-path', pathAsArray[0] + '.' + pathAsArray[1] + '.' + $cT.val());
	    }
	
	    this.showInputSet($parent);
	
	    // DON'T DELETE! We need it for android's chrome. Without it:
	    // option dropdown menu, user selection will not be displayed until page is touched one more time
	    (0, _jquery2.default)(event.currentTarget).css({ color: '#333' });
	    (0, _jquery2.default)('body').trigger('touch');
	  },
	
	  /**
	   * show correct inputs set based on reclamation path
	   * check http://confluence.home24.de/display/pm/Reclamation+Status for details
	   * @param {$} $parent
	   */
	  showInputSet: function showInputSet($parent) {
	    this.reasonOptions = this.model.getReasonOptions($parent.attr('data-current-reclamation-path'));
	
	    this.hideConditionalElements($parent);
	
	    this.commentNotRequired($parent);
	    this.commentView.updateLabel(this.reasonOptions.commentId);
	    this.commentView.show();
	
	    if (this.reasonOptions.imageUpload) {
	      this.showSpecificPictureLabel($parent, this.reasonOptions.imageId);
	      this.showPictureUpload($parent);
	    }
	
	    this.repositionExpandedVerticalLine();
	  },
	
	  commentNotRequired: function commentNotRequired($el) {
	    this.model.get('commentRequired')[$el.data('index-article') + '_' + $el.data('index-piece')] = false;
	  },
	
	  commentRequired: function commentRequired($el) {
	    this.model.get('commentRequired')[$el.data('index-article') + '_' + $el.data('index-piece')] = true;
	  },
	
	  showPictureUpload: function showPictureUpload($parent) {
	    $parent.find(this.selectors.reclamationPictureUploadWrapper).first().removeClass('is-hidden');
	  },
	
	  showSpecificPictureLabel: function showSpecificPictureLabel($parent, imageId) {
	    var id = 1;
	
	    if (imageId) {
	      id = imageId;
	    }
	
	    $parent.find(this.selectors.reclamationPictureUploadLabel).text(this.model.get('translations').images[id]);
	  },
	
	  hideConditionalElements: function hideConditionalElements($el) {
	    $el.find(this.selectors.reclamationPictureUploadWrapper).first().addClass('is-hidden');
	  },
	
	  /**
	   * Method finds parent container for return/reclamation reason input (any kind of input)
	   * @param {Object} $element select box which value has been changed
	   * @return {Object}
	   */
	  getReasonParent: function getReasonParent($element) {
	    return $element.closest('.reason-parent');
	  },
	
	  onDifferentComplainsClick: function onDifferentComplainsClick() {
	    this.model.set({
	      differentComplainsVisible: !this.model.get('differentComplainsVisible')
	    });
	  },
	
	  onDifferentComplainsModelChange: function onDifferentComplainsModelChange() {
	    var bState = this.model.get('differentComplainsVisible');
	    var $label = this.$('.different-complains label');
	    var $bottom = this.$('.fttc2-bottom-block');
	    var $target;
	
	    this.$('.js-different-checkbox').prop('checked', bState);
	
	    if (bState) {
	      this.$('.top-block').addClass('is-hidden');
	      this.$('.fttc2-bottom-block').removeClass('is-hidden');
	
	      $label.html($label.attr('data-label-expanded'));
	
	      /*
	            Move uploaded files to first child
	             */
	      this.$('.fttc2-uploaded-files').first().find('li').each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var dataFor = $this.attr('data-for');
	
	        if (dataFor && dataFor.length > 0) {
	          $target = $bottom.find('[data-target="' + dataFor + '"]');
	        } else {
	          $target = $bottom.find('.fttc2-uploaded-files').first();
	        }
	
	        $target.append(this);
	      });
	    } else {
	      this.$('.top-block').removeClass('is-hidden');
	      this.$('.fttc2-bottom-block').addClass('is-hidden');
	
	      $label.html($label.attr('data-label-collapsed'));
	
	      /*
	            Move from different to top section
	             */
	      $target = this.$('.fttc2-uploaded-files').first();
	
	      $bottom.find('.fttc2-uploaded-files li').each(function () {
	        $target.append(this);
	      });
	
	      this.clearDifferentComplains();
	    }
	
	    this.handleEmptyDownloadSections();
	    this.repositionExpandedVerticalLine();
	  },
	
	  handleEmptyDownloadSections: function handleEmptyDownloadSections() {
	    this.$('.fttc2-uploaded-files').each(function () {
	      var $this = (0, _jquery2.default)(this);
	      var $parent = $this.closest('.fttc2-file-box');
	
	      if ($this.find('li').length > 0) {
	        $parent.removeClass('is-hidden');
	      } else {
	        $parent.addClass('is-hidden');
	      }
	    });
	  },
	
	  /**
	   * Remove values from different complains window.
	   */
	  clearDifferentComplains: function clearDifferentComplains() {
	    var $categorySelectInput = this.$('.reason-category select');
	    var $textInput = this.$('input[type="text"]');
	    var countTextInput = $textInput.length;
	    var i;
	    var $select;
	    var $firstChild;
	
	    $textInput.val('');
	
	    for (i = 0; i < countTextInput; i++) {
	      $select = $categorySelectInput.eq(i);
	      $firstChild = $select.children(':first-child');
	
	      $select.val($firstChild.val());
	      $select.trigger('change');
	    }
	  },
	
	  repositionExpandedVerticalLine: function repositionExpandedVerticalLine() {
	    var $block = this.$('.fttc2-bottom-block');
	
	    /*
	        If there is no bottom block, there is no reason to reposition lines, since they do not exists
	         */
	    if ($block.length === 0) {
	      return;
	    }
	
	    var $line = $block.find('>.vertical-line');
	    var $lastBlock = $block.find('.fttc2-column').last();
	    var $horizontalLine = $lastBlock.find('>.ie-before');
	
	    $line.css('height', $lastBlock.offset().top - $block.offset().top + parseInt($horizontalLine.css('top'), 10) - +parseInt($line.css('top'), 10));
	  },
	
	  /**
	   * Show select box that allows to choose different reclamation type.
	   */
	  onReclamationTypeClick: function onReclamationTypeClick() {
	    this.$('.reclamation-type-label').addClass('is-hidden');
	    this.$('.reclamation-type-input').removeClass('is-hidden');
	    this.$('.change-type-action').addClass('is-hidden');
	  },
	
	  onReclamationTypeChange: function onReclamationTypeChange() {
	    this.model.set({
	      type: this.$(this.selectors.reclamationTypeSelect).val()
	    });
	
	    this.populateReasonSelects(this.$el, this.model.getCategories(this.model.get('type')), this.selectors.reclamationCategoryInput);
	    this.$(this.selectors.reclamationCategoryInput).trigger('change');
	  },
	
	  /**
	   * Method recreates options for all select in $container matching selectorId with data passed in jsonData parameter
	   *
	   * @param {Object} $container $ object of reclamation reason parent
	   * @param {Object} jsonData reclamation reason tree structure
	   * @param {String} selector selector of select to recreate
	   */
	  populateReasonSelects: function populateReasonSelects($container, jsonData, selector) {
	    var $selects = $container.find(selector);
	    var len = $selects.length;
	    var html = this.buildSelectHtml(jsonData);
	    var i;
	
	    for (i = 0; i < len; i++) {
	      this.populateReasonSelect($selects.eq(i), html);
	    }
	  },
	
	  /**
	   * Method recreates select options using passed html. It preserves first option
	   *
	   * @param {Object} $target jQuery object pointing at select that needs to be repopulated
	   * @param {String} html html of inserted options
	   */
	  populateReasonSelect: function populateReasonSelect($target, html) {
	    var $firstChild = $target.children(':first-child');
	
	    $firstChild.detach();
	    $target.html(html);
	    $target.prepend($firstChild);
	
	    $target.val($target.find('option:first').val());
	  },
	
	  /**
	   * Method creates and returns HTML options for reclamation category and reason selects based on passed tree structure
	   * @param {Object} data fragment of reclamation reason structure tree passed from backend
	   * @return {String}
	   */
	  buildSelectHtml: function buildSelectHtml(data) {
	    var html = '';
	    var key;
	
	    if (!data.children) {
	      return '';
	    }
	
	    for (key in data.children) {
	      /* istanbul ignore else */
	      if (data.children.hasOwnProperty(key)) {
	        html += '<option value="' + key + '">' + data.children[key].name + '</option>';
	      }
	    }
	
	    return html;
	  }
	});

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    'keyup #reason-comment': 'validate'
	  },
	
	  $label: null,
	  $textarea: null,
	
	  initialize: function initialize() {
	    this.$label = this.$('.js-reason-comment-label');
	    this.$textarea = this.$('#reason-comment');
	  },
	
	  show: function show() {
	    this.model.set('commentFieldVisible', true);
	    this.$el.removeClass('is-hidden');
	  },
	
	  hide: function hide() {
	    this.model.set('commentFieldVisible', false);
	    this.$el.addClass('is-hidden');
	  },
	
	  updateLabel: function updateLabel(commentId) {
	    var id = 1;
	
	    if (commentId) {
	      id = commentId;
	    }
	
	    this.$label.text(this.model.get('translations').commentField[id]);
	  },
	
	  validate: function validate() {
	    var bValid = true;
	
	    if (this.model.get('commentFieldVisible') && this.$textarea.val().length > this.model.get('maxCommentLength')) {
	      bValid = false;
	    }
	
	    this.model.set('commentFieldValid', bValid);
	
	    if (bValid) {
	      this.$textarea.removeClass('invalid');
	    } else {
	      this.$textarea.addClass('invalid');
	    }
	  }
	});

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _translation = __webpack_require__(12);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	var _Step2ImageNotificationView = __webpack_require__(329);
	
	var _Step2ImageNotificationView2 = _interopRequireDefault(_Step2ImageNotificationView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    submit: 'onSubmit'
	  },
	
	  articleViews: null,
	  commentView: null,
	
	  messageBox: null,
	
	  initialize: function initialize(options) {
	    this.articleViews = options.articleViews;
	    this.messageBox = options.messageBox;
	    this.commentView = options.commentView;
	  },
	
	  submitForm: function submitForm() {
	    this.$el.submit();
	  },
	
	  onSubmit: function onSubmit() {
	    var isValid = this.isValid();
	
	    if (!this.model.get('b2bCancellationValid')) {
	      lightbox.setConfig({
	        $dialog: (0, _jquery2.default)('.js-b2b-order-cancellation'),
	        className: 'b2b-order-cancellation'
	      }).open();
	
	      return false;
	    }
	
	    if (isValid && !this.model.get('imagesValid')) {
	      new _Step2ImageNotificationView2.default({
	        $form: this.$el
	      });
	
	      return false;
	    }
	
	    return isValid;
	  },
	
	  /**
	   * Method checks if all required fields are filled with proper data before form is submitted
	   * @return {bool}
	   */
	  isValid: function isValid() {
	    /*
	        Validate comments view
	         */
	    this.commentView.validate();
	
	    this.model.set({
	      imagesValid: true,
	      selectsValid: true,
	      b2bCancellationValid: true
	    });
	
	    /*
	        Validate each article view
	         */
	    _underscore2.default.each(this.articleViews, function (view) {
	      view.validateSelects();
	      view.validateImages();
	    });
	
	    this.messageBox.clear();
	
	    if (!this.model.get('selectsValid')) {
	      this.messageBox.addError((0, _translation.get)('orderItem.categoryIsRequired.message'));
	    }
	
	    if (!this.model.get('commentFieldValid')) {
	      this.messageBox.addError((0, _translation.get)('ui.input.validation.standardMessages.maxLength').replace('%value%', config.get('fttc2.validation.comment.maxLength')));
	    }
	
	    this.messageBox.render();
	
	    return this.model.get('commentFieldValid') && this.model.get('selectsValid');
	  }
	});

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  $form: null,
	
	  initialize: function initialize(options) {
	    this.$form = options.$form;
	
	    lightbox.setConfig({
	      $dialog: (0, _jquery2.default)('.js-fttc2-image-notification'),
	      className: 'fttc2-image-notification',
	      onOpen: this.onOpen.bind(this)
	    }).open();
	  },
	
	  onOpen: function onOpen() {
	    (0, _jquery2.default)('.js-fttc2-image-notification-proceed').on('click', this.submitHandler.bind(this));
	  },
	
	  submitHandler: function submitHandler() {
	    this.$form[0].submit();
	  }
	});

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = __webpack_require__(30);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _baseModel = __webpack_require__(45);
	
	var _baseModel2 = _interopRequireDefault(_baseModel);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseModel2.default.extend({
	  defaults: {
	    structure: {},
	
	    commentRequired: {},
	
	    maxCommentLength: config.get('fttc2.validation.comment.maxLength'),
	
	    commentFieldVisible: false,
	
	    commentFieldValid: true,
	    selectsValid: true,
	    imagesValid: true,
	
	    differentComplainsVisible: false,
	    type: ''
	  },
	
	  initialize: function initialize() {
	    this.set({
	      structure: registry.get('reclamationTreeStructure'),
	      translations: registry.get('reclamationTranslations')
	    });
	  },
	
	  getCategories: function getCategories(type) {
	    return this.get('structure')[type];
	  },
	
	  getReasons: function getReasons(type, category) {
	    return this.get('structure')[type].children[category];
	  },
	
	  getReasonOptions: function getReasonOptions(path) {
	    if (path) {
	      return (0, _get2.default)(this.get('structure'), path.replace(/\./g, '.children.'), {});
	    }
	
	    return {};
	  }
	});

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _remotePreloaderView = __webpack_require__(26);
	
	var _remotePreloaderView2 = _interopRequireDefault(_remotePreloaderView);
	
	var _translation = __webpack_require__(12);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  events: {
	    submit: 'onSubmit'
	  },
	
	  selectors: {
	    ibanField: '.js-iban input',
	    bicField: '.js-bic input'
	  },
	
	  validationRules: {
	    remoteIban: {
	      url: config.getBaseUrl() + '/default/validator/validateiban',
	      type: 'GET',
	      data: {
	        iban: function iban() {
	          return (0, _jquery2.default)('.js-iban input').val();
	        }
	      },
	      beforeSend: function beforeSend() {
	        this.preloader = this.preloader || new _remotePreloaderView2.default({
	          el: (0, _jquery2.default)(this).find('.js-iban input')
	        });
	        this.preloader.show();
	      },
	      complete: function complete() {
	        this.preloader.hide();
	      }
	    },
	    remoteBic: {
	      url: config.getBaseUrl() + '/default/validator/validatebic',
	      type: 'GET',
	      data: {
	        id: function id() {
	          return (0, _jquery2.default)('.js-bic input').val();
	        }
	      },
	      beforeSend: function beforeSend() {
	        this.preloader = this.preloader || new _remotePreloaderView2.default({
	          el: (0, _jquery2.default)(this).find('.js-bic input')
	        });
	        this.preloader.show();
	      },
	      complete: function complete() {
	        this.preloader.hide();
	      }
	    }
	  },
	
	  initialize: function initialize() {
	    this.$ibanField = this.$el.find(this.selectors.ibanField);
	    this.$bicField = this.$el.find(this.selectors.bicField);
	
	    this.$bicField.rules('remove');
	
	    this.addRulesToValidator(this.$ibanField, this.validationRules.remoteIban, (0, _translation.get)('ui.input.validation.iban.remote.error'));
	
	    this.addRulesToValidator(this.$bicField, this.validationRules.remoteBic, (0, _translation.get)('ui.input.validation.bic.remote.error'));
	  },
	
	  onSubmit: function onSubmit() {
	    var _this = this;
	    var result = false;
	
	    if (this.isEmpty()) {
	      lightbox.setConfig({
	        $dialog: (0, _jquery2.default)('.js-fttc2-bank-details'),
	        className: 'fttc2-bank-details'
	      }).open();
	
	      (0, _jquery2.default)('.js-fttc2-bank-details__proceed').one('click', function () {
	        _this.$el[0].submit();
	      });
	    } else {
	      result = this.$el.valid() && !this.$ibanField.prev().hasClass('is-invalidate');
	    }
	
	    return result;
	  },
	
	  isEmpty: function isEmpty() {
	    var isEmpty = true;
	    var $fields = this.$el.find('input');
	
	    $fields.each(function () {
	      if (this.value.length) {
	        isEmpty = false;
	      }
	    });
	
	    return isEmpty;
	  },
	
	  addRulesToValidator: function addRulesToValidator($field, $remoteRule, message) {
	    $field.rules('add', {
	      remote: $remoteRule,
	      messages: {
	        remote: message
	      }
	    });
	  }
	});

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  step: null,
	  step1Controller: null,
	  step2Controller: null,
	
	  initialize: function initialize(options) {
	    this.step = options.step;
	    this.step1Controller = options.step1Controller;
	    this.step2Controller = options.step2Controller;
	
	    if (this.$el.length > 0) {
	      switch (this.step) {
	        case 1:
	          this.bindStep1();
	          break;
	
	        case 2:
	          this.bindStep2();
	          break;
	
	        case 3:
	          this.bindStep3();
	          break;
	      }
	    }
	  },
	
	  bindStep1: function bindStep1() {
	    this.$('li').eq(1).on('click', _jquery2.default.proxy(this.step1Controller.onNextClick, this.step1Controller));
	  },
	
	  bindStep2: function bindStep2() {
	    this.$('li').eq(0).on('click', function () {
	      document.location = (0, _jquery2.default)('#prevButton').attr('href');
	    });
	
	    this.$('li').eq(2).on('click', _jquery2.default.proxy(this.step2Controller.submitForm, this.step2Controller));
	  },
	
	  bindStep3: function bindStep3() {
	    this.$('li').eq(1).on('click', function () {
	      document.location = (0, _jquery2.default)('.back.button').attr('href');
	    });
	  }
	});

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = UploadManager;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _translation = __webpack_require__(12);
	
	var _Utils = __webpack_require__(15);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UploadManager() {
	  'use strict';
	
	  this.$form = null;
	  this.$input = null;
	  this.onSuccess = null;
	
	  /**
	   * @type {function}
	   */
	  this.onFailure = null;
	  this.uid = null;
	
	  this.aErrors = [];
	
	  this.$scope = (0, _jquery2.default)('body');
	
	  /**
	   * @return {string}
	   */
	  this.getUid = function () {
	    return this.uid;
	  };
	
	  this.setForm = function ($element) {
	    this.$form = $element;
	
	    return this;
	  };
	
	  this.setInput = function ($element) {
	    this.$input = $element;
	
	    return this;
	  };
	
	  this.getParsedFilename = function () {
	    return (0, _Utils.parseFilename)(this.$input.val());
	  };
	
	  // extracted mostly for stubbing purposes
	  //
	  // <input type="file"/> value attribute cannot
	  // be set / stubbed during testing
	  this.getFilename = function () {
	    return this.$input.val();
	  };
	
	  this.validate = function () {
	    var validFileExtensions = ['.jpg', '.jpeg', '.gif', '.png'];
	    var filename = this.getFilename();
	    var valid = false;
	    var currentExtension;
	
	    this.aErrors = [];
	
	    if (filename.length === 0) {
	      this.aErrors.push({ code: 1, message: (0, _translation.get)('fileUpload.noFile.message') });
	
	      return;
	    }
	
	    if (filename.length < 5) {
	      this.aErrors.push({
	        code: 2,
	        message: (0, _translation.get)('fileUpload.nameTooShort.message')
	      });
	
	      return;
	    }
	
	    // Check file extension
	    for (var j = 0; j < validFileExtensions.length; j++) {
	      currentExtension = validFileExtensions[j];
	      if (filename.substr(filename.length - currentExtension.length, currentExtension.length).toLowerCase() === currentExtension.toLowerCase()) {
	        valid = true;
	        break;
	      }
	    }
	
	    if (!valid) {
	      this.aErrors.push({
	        code: 3,
	        message: (0, _translation.get)('fileUpload.unknownExtension.message')
	      });
	    }
	  };
	
	  this.isValid = function () {
	    return this.aErrors.length === 0;
	  };
	
	  this.getErrors = function () {
	    return this.aErrors;
	  };
	
	  /**
	   * Method generates pseudo UUID used for APC Upload Progress
	   * @param {=string} prefix
	   * @return {string}
	   */
	  this.createUUID = function (prefix) {
	    var s = [];
	    var hexDigits = '0123456789abcdef';
	    var i;
	    var uuid;
	
	    for (i = 0; i < 16; i++) {
	      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
	    }
	    s[14] = '4';
	    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
	
	    uuid = s.join('');
	
	    if (prefix) {
	      uuid = prefix + '_' + uuid;
	    }
	
	    return uuid;
	  };
	
	  this.getIframeId = function (uid) {
	    return 'postiframe_' + uid;
	  };
	
	  this.setOnSuccess = function (handler) {
	    this.onSuccess = handler;
	
	    return this;
	  };
	
	  this.setOnFailure = function (handler) {
	    this.onFailure = handler;
	
	    return this;
	  };
	
	  this.execute = function () {
	    this.uid = this.createUUID();
	
	    var frameId = this.getIframeId(this.uid);
	
	    /*
	        Inject iframe for async operations
	         */
	    this.$scope.append('<iframe name="' + frameId + '" id="' + frameId + '" class="fileUpload" />');
	
	    this.$form.attr('target', frameId).submit();
	
	    this.$scope.find('#' + frameId).load(_jquery2.default.proxy(this.onRequestFinished, this));
	  };
	
	  /**
	   * Method removes hidden iframe from DOM
	   * @return void
	   */
	  this.removeUploadIframe = function () {
	    this.$scope.find('#' + this.getIframeId(this.uid)).remove();
	  };
	
	  /**
	   * Method if fired when iframe post request is completed
	   * @return void
	   */
	  this.onRequestFinished = function () {
	    var replyText = (0, _jquery2.default)(frames[this.getIframeId(this.uid)].document.documentElement).text();
	    var replyJSON = {};
	
	    try {
	      replyJSON = _jquery2.default.parseJSON(replyText);
	    } catch (e) {
	      // Parsing reply JSON failed, there was an error
	      this.onFailure(this.uid, {});
	
	      return;
	    }
	
	    // Empty response returned, parseJSON returned null or undefined or 'success' property is not true
	    if (!replyJSON) {
	      this.onFailure(this.uid, {});
	    } else if (replyJSON.success !== true && replyJSON.success !== 'true') {
	      this.onFailure(this.uid, replyJSON);
	    } else {
	      // On any other situation upload was successful
	      this.onSuccess(this.uid, replyJSON);
	    }
	
	    this.removeUploadIframe();
	  };
	
	  this.remove = function (uid) {
	    _jquery2.default.post(config.getBaseUrl() + config.get('fttc2.upload.delete.url'), { uid: uid }, function () {});
	  };
	}

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _MessageBox = __webpack_require__(296);
	
	var _MessageBox2 = _interopRequireDefault(_MessageBox);
	
	var _Step1Controller = __webpack_require__(322);
	
	var _Step1Controller2 = _interopRequireDefault(_Step1Controller);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _Step1Model = __webpack_require__(323);
	
	var _Step1Model2 = _interopRequireDefault(_Step1Model);
	
	var _Step1OrdersListView = __webpack_require__(324);
	
	var _Step1OrdersListView2 = _interopRequireDefault(_Step1OrdersListView);
	
	var _Step1UploadView = __webpack_require__(325);
	
	var _Step1UploadView2 = _interopRequireDefault(_Step1UploadView);
	
	var _Step2ArticleView = __webpack_require__(326);
	
	var _Step2ArticleView2 = _interopRequireDefault(_Step2ArticleView);
	
	var _Step2CommentView = __webpack_require__(327);
	
	var _Step2CommentView2 = _interopRequireDefault(_Step2CommentView);
	
	var _Step2Controller = __webpack_require__(328);
	
	var _Step2Controller2 = _interopRequireDefault(_Step2Controller);
	
	var _Step2Model = __webpack_require__(330);
	
	var _Step2Model2 = _interopRequireDefault(_Step2Model);
	
	var _Step3Controller = __webpack_require__(331);
	
	var _Step3Controller2 = _interopRequireDefault(_Step3Controller);
	
	var _StepsView = __webpack_require__(332);
	
	var _StepsView2 = _interopRequireDefault(_StepsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var messageBox = void 0;
	var step1Model = void 0;
	var step1UploadView = void 0;
	var step1OrdersList = void 0;
	var step1Controller = void 0;
	
	var step2ArticleView = [];
	var step2Model = void 0;
	var step2CommentView = void 0;
	var step2Controller = void 0;
	
	(0, _bootstrapper.register)('myaccount', function () {
	  var $fttc2Content = (0, _jquery2.default)('#fttc2-wrapper');
	  var $uploadTemplate = (0, _jquery2.default)('#upload-file-template');
	
	  if ($fttc2Content.length > 0) {
	    messageBox = new _MessageBox2.default((0, _jquery2.default)('.messages'));
	
	    switch ($fttc2Content.data('step')) {
	      case 1:
	        step1Model = new _Step1Model2.default();
	
	        step1UploadView = new _Step1UploadView2.default({
	          el: (0, _jquery2.default)('.js-upload-section'),
	          model: step1Model,
	          $uploadTemplate: $uploadTemplate,
	          messageBox: messageBox
	        });
	
	        step1OrdersList = new _Step1OrdersListView2.default({
	          el: (0, _jquery2.default)('.js-order-list'),
	          model: step1Model
	        });
	
	        step1Controller = new _Step1Controller2.default({
	          el: (0, _jquery2.default)('.fttc2-button-holder'),
	          model: step1Model,
	          orderList: step1OrdersList,
	          uploadView: step1UploadView,
	          messageBox: messageBox
	        });
	
	        break;
	
	      case 2:
	        step2Model = new _Step2Model2.default();
	
	        var $popup = (0, _jquery2.default)('#upload-dialog');
	
	        step2CommentView = new _Step2CommentView2.default({
	          el: (0, _jquery2.default)('.fttc2-textarea-holder'),
	          model: step2Model
	        });
	
	        _underscore2.default.each((0, _jquery2.default)('.fttc2-section.reason-parent'), function (el) {
	          step2ArticleView.push(new _Step2ArticleView2.default({
	            el: el,
	            model: step2Model,
	            commentView: step2CommentView,
	            $popup: $popup,
	            $uploadTemplate: $uploadTemplate,
	            messageBox: messageBox
	          }));
	        });
	
	        _underscore2.default.each(step2ArticleView, function (view) {
	          view.preselect();
	        });
	
	        /*
	                 initialize main form controller
	                 */
	        step2Controller = new _Step2Controller2.default({
	          el: (0, _jquery2.default)('#reasonForm'),
	          model: step2Model,
	          articleViews: step2ArticleView,
	          commentView: step2CommentView,
	          messageBox: messageBox
	        });
	
	        break;
	
	      case 3:
	        var $fttc2BankDetailsForm = (0, _jquery2.default)('.fttc2-bank-details-form');
	
	        if ($fttc2BankDetailsForm.length) {
	          new _Step3Controller2.default({
	            el: $fttc2BankDetailsForm
	          });
	        }
	        break;
	    }
	
	    new _StepsView2.default({
	      el: (0, _jquery2.default)('.checkout-steps'),
	      step: $fttc2Content.data('step'),
	      step1Controller: step1Controller,
	      step2Controller: step2Controller
	    });
	  }
	});

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * add to wishlist view
	 * responsible of handling add to wishlist button
	 */
	exports.default = _baseView2.default.extend({
	  selectors: {
	    wishlistIcon: '.wishlist-icon',
	    wishlistIconActiveClass: 'wishlist-icon--active'
	  },
	
	  initialize: function initialize() {
	    this.listenTo(this.model, 'change:simpleSku', this.restoreButtonState);
	  },
	
	  restoreButtonState: function restoreButtonState() {
	    this.$el.find(this.selectors.wishlistIcon).removeClass(this.selectors.wishlistIconActiveClass);
	  }
	});

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _addToCart = __webpack_require__(55);
	
	var _addToCart2 = _interopRequireDefault(_addToCart);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _addToWishlistView = __webpack_require__(335);
	
	var _addToWishlistView2 = _interopRequireDefault(_addToWishlistView);
	
	var _pdpWishlistButtonEvents = __webpack_require__(352);
	
	var _pdpWishlistButtonEvents2 = _interopRequireDefault(_pdpWishlistButtonEvents);
	
	var _Configuration = __webpack_require__(351);
	
	var _Configuration2 = _interopRequireDefault(_Configuration);
	
	var _PageVisit = __webpack_require__(198);
	
	var _PageVisit2 = _interopRequireDefault(_PageVisit);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('article-new', function () {
	  // reviews
	  _jquery2.default.subscribe('save.PdpApp:review', function (event, data) {
	    var submitReviewUrl = config.getBaseUrl() + '/article/saverating';
	
	    _jquery2.default.post(submitReviewUrl, _jquery2.default.param(data), function (resp) {
	      _jquery2.default.publish('saveFinished.PdpApp:review', { success: resp.success });
	    });
	  });
	
	  // add to cart
	  new _addToCart2.default({
	    pageType: 'pdp_product'
	  });
	
	  // model
	  var pdpArticleModel = new _backbone2.default.Model();
	
	  // wishlist button
	  new _addToWishlistView2.default({
	    el: (0, _jquery2.default)('#pdp-app-root'),
	    model: pdpArticleModel
	  });
	
	  // tracking
	  new _pdpWishlistButtonEvents2.default({
	    model: pdpArticleModel
	  });
	
	  new _Configuration2.default({
	    model: pdpArticleModel
	  });
	
	  var pdpVisitTracking = new _PageVisit2.default(pdpArticleModel);
	
	  pdpVisitTracking.setupEvents();
	
	  // set initial model data, used by ProductClick
	  _jquery2.default.subscribe('loaded.PdpApp:article', function (event, data) {
	    var options = {
	      silent: true
	    };
	
	    pdpArticleModel.set({
	      trackingData: data.trackingData
	    }, options);
	
	    pdpVisitTracking.executeCookieCallbacks();
	  });
	
	  // will trigger model change, used by
	  // AddToWishlistView
	  // WishlistButtonEvents
	  // and Configuration
	  _jquery2.default.subscribe('changed.PdpApp:article', function (event, data) {
	    var price = '';
	
	    if (data.price && data.price.sellPrice) {
	      price = data.price.sellPrice.single * 100;
	    }
	
	    pdpArticleModel.set({
	      priceRaw: price,
	      simpleSku: data.sku,
	      trackingData: data.trackingData
	    });
	  });
	});

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BaseSliderView = __webpack_require__(257);
	
	var _BaseSliderView2 = _interopRequireDefault(_BaseSliderView);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseSliderView2.default.extend({
	  events: {
	    'click .pdp-show-more-accessories': 'onShowMoreClick',
	    'click .pdp-show-less-accessories': 'onShowLessClick'
	  },
	
	  onShowMoreClick: function onShowMoreClick() {
	    this.$('.js-below-fold').removeClass('is-hidden');
	    this.$('.pdp-show-less-accessories').removeClass('is-hidden');
	    this.$('.pdp-show-more-accessories').addClass('is-hidden');
	  },
	
	  onShowLessClick: function onShowLessClick() {
	    this.$('.js-below-fold').addClass('is-hidden');
	    this.$('.pdp-show-less-accessories').addClass('is-hidden');
	    this.$('.pdp-show-more-accessories').removeClass('is-hidden');
	
	    (0, _jquery2.default)('body, html').animate({
	      scrollTop: this.$el.offset().top
	    }, 10);
	  }
	});

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderBuilder = SliderBuilder;
	exports.build = build;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SliderModel = __webpack_require__(340);
	
	var _SliderModel2 = _interopRequireDefault(_SliderModel);
	
	var _HorizontalSliderView = __webpack_require__(258);
	
	var _HorizontalSliderView2 = _interopRequireDefault(_HorizontalSliderView);
	
	var _VerticalSliderView = __webpack_require__(341);
	
	var _VerticalSliderView2 = _interopRequireDefault(_VerticalSliderView);
	
	var _AccessoriesSliderView = __webpack_require__(337);
	
	var _AccessoriesSliderView2 = _interopRequireDefault(_AccessoriesSliderView);
	
	var _SliderGroup = __webpack_require__(339);
	
	var _SliderGroup2 = _interopRequireDefault(_SliderGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SliderBuilder($scope) {
	  'use strict';
	
	  var selectors = {
	    sliderContainer: '.js-slider--container',
	    sliderGroup: '.js-slider--group'
	  };
	  var registeredSliders = [];
	
	  /**
	   * Method creates slider view for given element based on provided class
	   * @param {$} $element
	   * @param {Object} SliderClass
	   */
	  this.register = function ($element, SliderClass) {
	    var config = {
	      el: $element,
	      model: new _SliderModel2.default()
	    };
	
	    // noinspection JSValidateTypes
	    registeredSliders.push(new SliderClass(config));
	  };
	
	  /**
	   * @return {BaseSliderView[]}
	   */
	  this.getSliders = function () {
	    return registeredSliders;
	  };
	
	  this.destroyAll = function () {
	    var slider;
	
	    for (var i = 0, len = registeredSliders.length; i < len; i++) {
	      /* istanbul ignore else */
	      slider = registeredSliders[i];
	      slider.undelegateEvents();
	      slider.$el.unbind();
	    }
	    registeredSliders = [];
	  };
	
	  /**
	   * This method builds sliders for all those that are in DOM
	   * @param {Boolean=} force force recreation of all sliders
	   */
	  this.build = function (force) {
	    var $this;
	    var context = this;
	
	    if (force === true) {
	      this.destroyAll();
	    }
	
	    /*
	         Iterate over slider containers
	         */
	    $scope.find(selectors.sliderContainer).each(function () {
	      $this = (0, _jquery2.default)(this);
	
	      if (force === true || !$this.data('sliderProcesses')) {
	        switch ($this.data('sliderType')) {
	          case 'accessories':
	            context.register($this, _AccessoriesSliderView2.default);
	            break;
	
	          case 'series':
	            context.register($this, _HorizontalSliderView2.default);
	            break;
	
	          case 'vertical':
	            context.register($this, _VerticalSliderView2.default);
	            break;
	
	          default:
	            context.register($this, _HorizontalSliderView2.default);
	            break;
	        }
	
	        /*
	                 Mark as processed
	                 */
	        $this.attr('data-slider-processes', true);
	      }
	    });
	
	    /*
	         Iterate over slider groups
	         */
	    $scope.find(selectors.sliderGroup).each(function () {
	      $this = (0, _jquery2.default)(this);
	      if (force === true || !$this.data('sliderProcesses')) {
	        new _SliderGroup2.default({
	          el: $this,
	          model: null
	        });
	      }
	
	      /*
	             Mark as processed
	             */
	      $this.attr('data-slider-processes', true);
	    });
	  };
	}
	
	var sliderBuilder = new SliderBuilder((0, _jquery2.default)('body'));
	
	function build(force) {
	  sliderBuilder.build(force);
	}

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseView2.default.extend({
	  $elements: null,
	  switchProperty: null,
	  updateProperty: null,
	
	  initialize: function initialize() {
	    this.$elements = this.$('>.js-slider--container');
	    this.switchProperty = this.$el.data('modelSwitchProperty');
	    this.updateProperty = this.$el.data('modelPropertyToUpdate');
	
	    /*
	        If model and switch property is set, start listening to model changes
	         */
	    if (this.model && this.switchProperty) {
	      this.listenTo(this.model, 'change:' + this.switchProperty, this.onSwitchPropertyChange);
	      this.onSwitchPropertyChange();
	    }
	  },
	
	  getSwitchValue: function getSwitchValue() {
	    return this.model.get(this.switchProperty);
	  },
	
	  onSwitchPropertyChange: function onSwitchPropertyChange() {
	    var $visibleElement;
	
	    this.$elements.addClass('is-hidden');
	
	    $visibleElement = this.$elements.filter('[data-group-item-id="' + this.getSwitchValue() + '"]').removeClass('is-hidden');
	
	    /*
	        If group should update model, do it here
	         */
	    if (this.updateProperty) {
	      this.model.set(this.updateProperty, Boolean($visibleElement.length));
	    }
	
	    /*
	        Also, trigger event on that element so connected slider view can know that it became just visible
	         */
	    if ($visibleElement.length > 0) {
	      $visibleElement.trigger('sliderBecameVisible');
	    }
	  }
	});

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(6);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _backbone2.default.Model.extend({
	  defaults: {
	    elementCount: 0,
	    currentOffset: 0,
	    elementSize: 0,
	    maxElements: 5,
	    minOffset: 0,
	    maxOffset: 0,
	    touchStartMainAxis: 0,
	    touchStartAuxilaryAxis: 0,
	    touchStartOffset: 0,
	    touchCurrentMainAxis: 0,
	    touchCurrentAuxilaryAxis: 0
	  },
	
	  directions: {
	    forward: 1,
	    backward: -1
	  },
	
	  updateMaxOffset: function updateMaxOffset() {
	    this.set({
	      maxOffset: -1 * (this.get('elementCount') - this.get('maxElements')) * this.get('elementSize') + this.get('minOffset')
	    });
	  },
	
	  move: function move(direction) {
	    var visibleItemsSize = this.get('elementSize') * this.get('maxElements');
	    var directionModifier1;
	    var directionModifier2;
	    var currentSet;
	    var newOffset;
	
	    if (direction === this.directions.forward) {
	      directionModifier1 = 0;
	      directionModifier2 = 1;
	    } else {
	      directionModifier1 = 10;
	      directionModifier2 = 0;
	    }
	
	    // count in which set of items we are
	    currentSet = Math.floor(Math.abs((this.get('currentOffset') - this.get('minOffset') + directionModifier1) / visibleItemsSize));
	
	    newOffset = -visibleItemsSize * (currentSet + directionModifier2) + this.get('minOffset');
	
	    this.set('currentOffset', this.capOffset(newOffset));
	  },
	
	  capOffset: function capOffset(value) {
	    var result = value;
	
	    /*
	         Cap to max offset
	         */
	    if (result < this.get('maxOffset')) {
	      result = this.get('maxOffset');
	    }
	
	    /*
	         Cap to min offset
	         */
	    if (result > this.get('minOffset')) {
	      result = this.get('minOffset');
	    }
	
	    return result;
	  },
	
	  updateOffsetFromDelta: function updateOffsetFromDelta(delta) {
	    this.set('currentOffset', this.capOffset(this.get('touchStartOffset') - delta));
	  },
	
	  isControlForwardVisible: function isControlForwardVisible() {
	    if (this.get('elementCount') <= this.get('maxElements')) {
	      return false;
	    }
	
	    return this.get('currentOffset') > this.get('maxOffset');
	  },
	
	  isControlBackwardVisible: function isControlBackwardVisible() {
	    if (this.get('elementCount') <= this.get('maxElements')) {
	      return false;
	    }
	
	    return this.get('currentOffset') < this.get('minOffset');
	  }
	});

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _HorizontalSliderView = __webpack_require__(258);
	
	var _HorizontalSliderView2 = _interopRequireDefault(_HorizontalSliderView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _HorizontalSliderView2.default.extend({
	  selectors: {
	    elements: '.image-preload-icon',
	    container: '.slider-content',
	    controls: {
	      forward: '.icon-arrow-down',
	      backward: '.icon-arrow-up'
	    }
	  },
	
	  getCurrentOffset: function getCurrentOffset() {
	    return this.$container.position().top;
	  },
	
	  getElementSize: function getElementSize() {
	    // noinspection JSValidateTypes
	    return this.$elements.first().outerHeight(true);
	  },
	
	  setContainerSize: function setContainerSize(value) {
	    this.$container.height(value);
	  },
	
	  positionContainer: function positionContainer() {
	    this.$container.css('top', this.model.get('currentOffset') + 'px');
	  },
	
	  setStartTouch: function setStartTouch(event) {
	    this.model.set({
	      touchStartMainAxis: event.originalEvent.touches[0].pageY,
	      touchStartAuxilaryAxis: event.originalEvent.touches[0].pageX,
	      touchStartOffset: this.model.get('currentOffset')
	    });
	  },
	
	  setCurrentTouch: function setCurrentTouch(event) {
	    this.model.set({
	      touchCurrentMainAxis: event.originalEvent.touches[0].pageY,
	      touchCurrentAuxilaryAxis: event.originalEvent.touches[0].pageX
	    });
	  }
	});

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _SliderBuilder = __webpack_require__(338);
	
	var _bootstrapper = __webpack_require__(8);
	
	(0, _bootstrapper.register)(null, function () {
	  $(document).ready(function () {
	    (0, _SliderBuilder.build)();
	  });
	});

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WishlistButtonEvents;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseWishlistButtonEvents = __webpack_require__(183);
	
	var baseWishlistButtonEvents = _interopRequireWildcard(_baseWishlistButtonEvents);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WishlistButtonEvents() {
	  _underscore2.default.bindAll(this, 'onAddToWishlist', 'onRemoveFromWishlist', 'onQuickViewOpen', 'onQuickViewLeave', 'onQuickViewArticleChange');
	
	  _jquery2.default.subscribe('added.wishlist', this.onAddToWishlist);
	  _jquery2.default.subscribe('removed.wishlist', this.onRemoveFromWishlist);
	
	  // quickview
	  _jquery2.default.subscribe('openOverlay.quickView:tracking', this.onQuickViewOpen);
	  _jquery2.default.subscribe('leaveOverlay.quickView:tracking', this.onQuickViewLeave);
	  _jquery2.default.subscribe('articleChange.quickView:tracking', this.onQuickViewArticleChange);
	
	  this.isQuickViewOpen = false;
	  this.quickViewData = {};
	  this.extraArticleData = {};
	}
	
	WishlistButtonEvents.prototype = _underscore2.default.extend({}, baseWishlistButtonEvents, {
	  onAddToWishlist: function onAddToWishlist(event, eventData) {
	    var data = this.getTrackingData(eventData.sku);
	
	    this.pushAddToWishlistEvent(data, this.getPageType());
	  },
	
	  onRemoveFromWishlist: function onRemoveFromWishlist(event, eventData) {
	    var data = this.getTrackingData(eventData.sku);
	
	    this.pushRemoveFromWishlistEvent(data, this.getPageType());
	  },
	
	  getTrackingData: function getTrackingData(sku) {
	    var data = {};
	
	    if (this.isQuickViewOpen) {
	      data = this.getQuickViewTrackingData(sku);
	    } else {
	      data = this.getListViewTrackingData(sku);
	    }
	
	    return data;
	  },
	
	  getPageType: function getPageType() {
	    if (this.isQuickViewOpen) {
	      return 'pdp_qv';
	    }
	
	    return '10';
	  },
	
	  // try to get extra data from listView tracking data
	  getArticleDataFromRegistry: function getArticleDataFromRegistry(sku) {
	    var data = {};
	    var dataSource = registry.get('listView.trackingData');
	
	    // on list-view read from Registry
	    if (dataSource && dataSource[sku]) {
	      data = dataSource[sku];
	    }
	
	    return data;
	  },
	
	  getListViewTrackingData: function getListViewTrackingData(sku) {
	    var tempData = this.getArticleDataFromRegistry(sku);
	
	    return {
	      sku: sku,
	      price: tempData.price,
	      brand: tempData.brand,
	      category: tempData.category
	    };
	  },
	
	  getQuickViewTrackingData: function getQuickViewTrackingData(sku) {
	    return {
	      sku: sku,
	      price: this.quickViewData.child.price.trackingPrice.single,
	      brand: this.extraArticleData.brand,
	      category: this.extraArticleData.category
	    };
	  },
	
	  onQuickViewOpen: function onQuickViewOpen(event, data) {
	    this.isQuickViewOpen = true;
	    this.quickViewData = data;
	
	    // try to get extra data, will success if article is on the page
	    this.extraArticleData = this.getArticleDataFromRegistry(data.child.sku);
	  },
	
	  onQuickViewLeave: function onQuickViewLeave() {
	    this.isQuickViewOpen = false;
	    this.quickViewData = {};
	    this.extraArticleData = {};
	  },
	
	  onQuickViewArticleChange: function onQuickViewArticleChange(event, data) {
	    this.quickViewData = data;
	  },
	
	  destroy: function destroy() {
	    _jquery2.default.unsubscribe('added.wishlist', this.onAddToWishlist);
	    _jquery2.default.unsubscribe('removed.wishlist', this.onRemoveFromWishlist);
	
	    // quickview
	    _jquery2.default.unsubscribe('openOverlay.quickView:tracking', this.onQuickViewOpen);
	    _jquery2.default.unsubscribe('leaveOverlay.quickView:tracking', this.onQuickViewLeave);
	    _jquery2.default.unsubscribe('articleChange.quickView:tracking', this.onQuickViewArticleChange);
	  }
	});

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _storageFactory = __webpack_require__(7);
	
	var _helper = __webpack_require__(10);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * new list view: tracking for filters
	 */
	exports.default = _baseView2.default.extend({
	  events: {
	    submit: 'onFormSubmit'
	  },
	
	  // object that is pushed to dataLayer
	  data: {},
	
	  // name of cookie where data will be stored
	  cookieName: 'GtmOnFilterNavigation',
	
	  // flag to prevent double push as form is sent twice
	  wasPushedToDataLayer: false,
	
	  initialize: function initialize() {
	    this.readCookie();
	    this.setDefaultData();
	  },
	
	  setDefaultData: function setDefaultData() {
	    this.data = {
	      current_page: [location.protocol, '//', location.host, location.pathname].join(''),
	      current_page_type: (0, _helper.getCurrentDataLayer)().pageType,
	      current_page_level: registry.get('categoryLevel') ? registry.get('categoryLevel') : 0,
	
	      // is set after page reload
	      click_destination_level: '',
	      click_position: 'FilterTop',
	      event: 'filter_click',
	      filters: []
	    };
	  },
	
	  setCookie: function setCookie() {
	    (0, _storageFactory.getStorage)().set(this.cookieName, JSON.stringify(this.data));
	  },
	
	  readCookie: function readCookie() {
	    var cookieValue = (0, _storageFactory.getStorage)().get(this.cookieName);
	
	    if (cookieValue) {
	      this.pushData(_jquery2.default.parseJSON(cookieValue));
	    }
	  },
	
	  pushData: function pushData(data) {
	    var clickDestination;
	
	    clickDestination = registry.get('categoryLevel');
	
	    if (data.click_destination_level === '' && typeof clickDestination !== 'undefined') {
	      data.click_destination_level = clickDestination;
	    }
	
	    window.dataLayer.push(data);
	    this.clearCookie();
	  },
	
	  clearCookie: function clearCookie() {
	    (0, _storageFactory.getStorage)().unset(this.cookieName);
	  },
	
	  onFormSubmit: function onFormSubmit() {
	    if (!this.wasPushedToDataLayer) {
	      this.data.filters = this.getActiveFilters();
	      this.setCookie();
	      this.wasPushedToDataLayer = true;
	    }
	  },
	
	  getActiveFilters: function getActiveFilters() {
	    var filters = [];
	    var singleFilterData = {};
	    var that = this;
	
	    this.$el.find('.js-filter-range').each(function (index, element) {
	      singleFilterData = that.getRangeFilterData(element);
	
	      if (singleFilterData) {
	        filters.push(singleFilterData);
	      }
	    });
	
	    this.$el.find('.js-filter-list-with-buttons').each(function (index, element) {
	      singleFilterData = that.getCheckboxFilterData(element);
	
	      if (singleFilterData) {
	        filters.push(singleFilterData);
	      }
	    });
	
	    return filters;
	  },
	
	  // for range filters, check if anyone is enabled, then prepare tracking data
	  getRangeFilterData: function getRangeFilterData(element) {
	    var $filter = (0, _jquery2.default)(element);
	    var $minInput = $filter.find('.js-filter-range-min-input');
	    var $maxInput = $filter.find('.js-filter-range-max-input');
	    var name;
	    var enabled = true;
	    var result = false;
	
	    // check if both are not disabled
	    if ($minInput.prop('disabled') && $maxInput.prop('disabled')) {
	      enabled = false;
	    }
	
	    if (enabled) {
	      // prepare name
	      name = $filter.find('.js-filter-range-min-input').attr('name');
	      name = name.substring(0, name.length - 4);
	
	      result = {
	        position: $filter.data('position'),
	        name: name,
	        value: $minInput.val() + '-' + $maxInput.val()
	      };
	    }
	
	    return result;
	  },
	
	  getCheckboxFilterData: function getCheckboxFilterData(element) {
	    var $filter = (0, _jquery2.default)(element);
	    var value;
	    var result = false;
	
	    value = $filter.find('.js-filter-list-hidden').val();
	
	    if (value !== '') {
	      result = {
	        position: $filter.data('position'),
	        name: $filter.find('.js-filter-list-hidden').attr('name'),
	        value: value
	      };
	    }
	
	    return result;
	  }
	});

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _helper = __webpack_require__(10);
	
	var _baseView = __webpack_require__(3);
	
	var _baseView2 = _interopRequireDefault(_baseView);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * tracking for quick view on new list view
	 * most of data coming through pub/sub from shop-app
	 * check https://jira.home24.de/browse/REBOOT-20912 for details
	 */
	exports.default = _baseView2.default.extend({
	  initialize: function initialize() {
	    _jquery2.default.subscribe('openOverlay.quickView:tracking', _underscore2.default.bind(this.onQuickViewOpen, this));
	    _jquery2.default.subscribe('leaveOverlay.quickView:tracking', _underscore2.default.bind(this.onQuickViewLeave, this));
	    _jquery2.default.subscribe('articleChange.quickView:tracking', _underscore2.default.bind(this.onArticleChange, this));
	    _jquery2.default.subscribe('galleryClicked.quickView:tracking', _underscore2.default.bind(this.onGalleryClicked, this));
	  },
	
	  events: {
	    'click .js-article-tile__quick-view-link': 'onQuickViewLinkClick'
	  },
	
	  // extra info if coming from deeplink or link click
	  articleWasClicked: false,
	  extraArticleData: {},
	
	  // after clicking we know more info about article
	  onQuickViewLinkClick: function onQuickViewLinkClick() {
	    this.articleWasClicked = true;
	  },
	
	  cleanData: function cleanData() {
	    this.articleWasClicked = false;
	    this.extraArticleData = {};
	  },
	
	  // try to get extra data from listView tracking data
	  getExtraArticleData: function getExtraArticleData(sku) {
	    var result = {};
	
	    if (registry.get('listView.trackingData') && registry.get('listView.trackingData')[sku]) {
	      result = registry.get('listView.trackingData')[sku];
	    }
	
	    return result;
	  },
	
	  push: function push(data) {
	    window.dataLayer.push(data);
	  },
	
	  // quick view open
	  onQuickViewOpen: function onQuickViewOpen(event, data) {
	    var onArticleClickData;
	
	    // try to get extra data, will success if article is on the page
	    this.extraArticleData = this.getExtraArticleData(data.child.sku);
	
	    this.articleRendered(data);
	
	    // trigger this only if coming from quick view link click, not from deeplink
	    if (this.articleWasClicked) {
	      onArticleClickData = this.prepareOnArticleClickData(data);
	      this.push(onArticleClickData);
	    }
	  },
	
	  // only on article click and quick view opened
	  prepareOnArticleClickData: function prepareOnArticleClickData(data) {
	    var subCategory = (0, _helper.getCurrentDataLayer)().pageProdGroup;
	
	    // ie. 'Catalog - Möbel'
	    var categoryWithSubCategory = this.extraArticleData.list + ' - ' + subCategory;
	
	    return {
	      event: 'productClick',
	      ecommerce: {
	        click: {
	          actionField: {
	            action: 'click',
	            list: categoryWithSubCategory
	          },
	          products: [{
	            name: data.child.name + ' - ' + data.child.variantName,
	            id: data.child.sku,
	            price: data.child.price.trackingPrice.single,
	            brand: this.extraArticleData.brand,
	            category: this.extraArticleData.category,
	            variant: data.child.variantName,
	            position: this.extraArticleData.position,
	            dimension64: this.extraArticleData.dimension64
	          }]
	        }
	      }
	    };
	  },
	
	  // article rendered, trigger on every rerender too
	  articleRendered: function articleRendered(data) {
	    this.push(this.prepareOnArticleRenderedData(data));
	    this.push(this.prepareOnArticleRenderedEnhancedData(data));
	  },
	
	  prepareOnArticleRenderedData: function prepareOnArticleRenderedData(data) {
	    var currentDataLayer = (0, _helper.getCurrentDataLayer)();
	
	    return {
	      pageType: 'QuickView',
	      event: 'QV_open',
	      productConfigSKU: data.parentSku,
	      productName: data.child.name + ' - ' + data.child.variantName,
	      productSimpleSKU: data.child.sku,
	      productPrice: this._getArticlePrice(data),
	      productBrand: this.extraArticleData.brand || '',
	      variantName: data.child.variantName,
	      purchasingCategories: this.extraArticleData.category ? this.extraArticleData.category.split('/') : '',
	      visitorDemographicInfo: currentDataLayer.visitorDemographicInfo,
	      visitorLoginState: currentDataLayer.visitorLoginState,
	      webserver: currentDataLayer.webserver
	    };
	  },
	
	  prepareOnArticleRenderedEnhancedData: function prepareOnArticleRenderedEnhancedData(data) {
	    var subCategory;
	    var categoryWithSubCategory;
	
	    subCategory = (0, _helper.getCurrentDataLayer)().pageProdGroup;
	
	    if (this.extraArticleData.list) {
	      // ie. 'Catalog - Möbel'
	      categoryWithSubCategory = this.extraArticleData.list + ' - ' + subCategory;
	    }
	
	    return {
	      event: 'productDetail',
	      ecommerce: {
	        detail: {
	          actionField: {
	            list: categoryWithSubCategory || subCategory
	          },
	          products: [{
	            name: data.child.name + ' - ' + data.child.variantName,
	            id: data.child.sku,
	            price: this._getArticlePrice(data),
	
	            // when coming from deeplink this data might be not available
	            brand: this.extraArticleData.brand || '',
	            category: this.extraArticleData.category || '',
	            variant: data.child.variantName,
	
	            // means pdpType :/
	            dimension65: 'pdp_qv',
	
	            // means deliveryTime in days :/
	            dimension64: this._getArticleDeliveryTime(data)
	          }]
	        }
	      }
	    };
	  },
	
	  // if article is not sellable, there is no price object
	  _getArticlePrice: function _getArticlePrice(data) {
	    var price = '';
	
	    if (data.child.price) {
	      price = data.child.price.trackingPrice.single;
	    }
	
	    return price;
	  },
	
	  // if article is not sellable, there is no delivery object
	  _getArticleDeliveryTime: function _getArticleDeliveryTime(data) {
	    var delivery = '';
	
	    if (data.child.delivery) {
	      delivery = data.child.delivery.days;
	    }
	
	    return delivery;
	  },
	
	  // quick view leave
	  onQuickViewLeave: function onQuickViewLeave(event, data) {
	    var onOverlayLeaveData = this.prepareOnOverlayLeaveData(data);
	
	    this.push(onOverlayLeaveData);
	
	    // remove extra data set by opening quick view
	    this.cleanData();
	  },
	
	  prepareOnOverlayLeaveData: function prepareOnOverlayLeaveData(data) {
	    return {
	      simple_sku: data.child.sku,
	      parent_sku: data.parentSku,
	
	      // close | add_to_cart | pdp_link
	      click_position: data.reason,
	      event: 'QV_leave'
	    };
	  },
	
	  // article change
	  onArticleChange: function onArticleChange(event, data) {
	    this.push(this.prepareOnArticleChangeData(data));
	
	    this.articleRendered(data);
	  },
	
	  prepareOnArticleChangeData: function prepareOnArticleChangeData(data) {
	    return {
	      simple_sku: data.child.sku,
	      parent_sku: data.parentSku,
	
	      // mvc attribute id
	      filter_used: data.attributeId,
	      event: 'QV_filter_interaction'
	    };
	  },
	
	  // gallery click
	  onGalleryClicked: function onGalleryClicked(event, data) {
	    this.push(this.prepareOnGalleryClickedData(data));
	  },
	
	  prepareOnGalleryClickedData: function prepareOnGalleryClickedData(data) {
	    return {
	      simple_sku: data.child.sku,
	      parent_sku: data.parentSku,
	
	      // up or down
	      filter_used: data.direction,
	      event: 'QV_image_interaction'
	    };
	  }
	});

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _catalogWishlistButtonEvents = __webpack_require__(343);
	
	var _catalogWishlistButtonEvents2 = _interopRequireDefault(_catalogWishlistButtonEvents);
	
	var _filterEvents = __webpack_require__(344);
	
	var _filterEvents2 = _interopRequireDefault(_filterEvents);
	
	var _quickViewEvents = __webpack_require__(345);
	
	var _quickViewEvents2 = _interopRequireDefault(_quickViewEvents);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('category-new search-new', function () {
	  (0, _jquery2.default)(document).ready(function () {
	    if (typeof window.dataLayer !== 'undefined') {
	      new _filterEvents2.default({
	        el: (0, _jquery2.default)('.js-list-view-form')
	      });
	
	      new _quickViewEvents2.default({
	        el: (0, _jquery2.default)('.js-article-list')
	      });
	    }
	  });
	
	  new _catalogWishlistButtonEvents2.default();
	});

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onArticleClick = onArticleClick;
	exports.send = send;
	exports.onPdpEntry = onPdpEntry;
	exports.init = init;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _storageFactory = __webpack_require__(7);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This module supports FactFinder click tracking on search page
	 * Event originates on search page, but request is sent on PDP to
	 * minimize lag
	 */
	var storage = (0, _storageFactory.getStorage)();
	
	var self = {};
	
	self.$scope = (0, _jquery2.default)('body');
	
	self.trackingKey = 'factFinderTracking';
	
	self.send = function (properties) {
	  /*
	   * Sanitize properties
	   */
	  var allowedProperties = config.get('tracking.factfinder.allowedProperties');
	
	  for (var i in properties) {
	    if (properties.hasOwnProperty(i) && allowedProperties.indexOf(i) === -1) {
	      delete properties[i];
	    }
	  }
	
	  if (properties.event) {
	    _jquery2.default.ajax({
	      type: 'POST',
	      url: config.getBaseUrl() + config.get('tracking.factfinder.url'),
	      data: properties,
	      contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
	      cache: false
	    });
	  }
	};
	
	self.onArticleClick = function (event) {
	  var $item = self.$scope.find(event.currentTarget).find('.article-container').first();
	  var properties;
	  var factFinderProperties = registry.get('factFinderProperties');
	
	  /** @namespace factFinderProperties.searchQuery */
	  /** @namespace factFinderProperties.pagesize */
	  properties = {
	    event: factFinderProperties.event,
	    channel: factFinderProperties.channel,
	    sid: factFinderProperties.sid,
	    userId: factFinderProperties.userId,
	    id: $item.data('sku'),
	    masterId: $item.data('parentSku'),
	    title: $item.data('title'),
	    query: factFinderProperties.searchQuery,
	    pos: $item.data('pos'),
	    origPos: $item.data('origPos'),
	    page: factFinderProperties.currentPage,
	    simi: $item.data('simi'),
	    pageSize: factFinderProperties.pagesize,
	    origPageSize: factFinderProperties.origPageSize
	  };
	
	  storage.set(self.trackingKey, properties);
	};
	
	self.onPdpEntry = function () {
	  var trackingData = storage.get(self.trackingKey);
	
	  if (!trackingData) {
	    return;
	  }
	
	  self.send(trackingData);
	  storage.unset(self.trackingKey);
	};
	
	self.populateEvents = function () {
	  var factFinderEvents = registry.get('factFinderEvents') || [];
	
	  factFinderEvents.forEach(function (event) {
	    self.send(event);
	  });
	};
	
	self.init = function () {
	  if (self.$scope.find('#search-page').length > 0) {
	    self.$scope.find('#category-articles').on('click', 'a.article-container', self.onArticleClick);
	  } else if (self.$scope.find('#pdp-wrapper').length > 0) {
	    self.onPdpEntry();
	  }
	
	  self.populateEvents();
	};
	
	self.init();
	
	function onArticleClick(e) {
	  return self.onArticleClick(e);
	}
	
	function send(properties) {
	  return self.send(properties);
	}
	
	function onPdpEntry() {
	  return self.onPdpEntry();
	}
	
	function init() {
	  return self.init();
	}

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _logout = __webpack_require__(408);
	
	var _bootstrapper = __webpack_require__(8);
	
	(0, _bootstrapper.register)(null, function () {
	  (0, _logout.init)();
	});

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _helper = __webpack_require__(10);
	
	var _helper2 = __webpack_require__(197);
	
	var _helper3 = __webpack_require__(20);
	
	var commonTrackingHelper = _interopRequireWildcard(_helper3);
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  events: {
	    'submit .js-select-form': 'onSelectActionSubmit',
	    'click .js-image-box-link': 'onItemImageClick',
	    'click .js-item-name-link': 'onItemNameClick',
	    'click .js-order-collapsible': 'onOrderArrowClick',
	    'click .js-reclamation-cancel-item': 'onCancelItemClick',
	    'click .js-reclamation-return-item': 'onReturnItemClick',
	    'click .js-reclamation-correction-item': 'onComplainItemClick',
	    'click .js-delivery-question-item': 'onDeliveryQuestionItemClick',
	    'click .js-invoice-download': 'onInvoiceDownloadClick',
	    'click .js-return-label-download': 'onReturnLabelDownloadClick'
	  },
	
	  onSelectActionSubmit: function onSelectActionSubmit(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var actionType = $currentTarget.find('.js-action-select').find(':selected').data('action-type');
	      (0, _helper.addToDataLayerForSubmit)(e, {
	        event: 'myOrder_selectAction_dropDown',
	        eventCategory: 'dropDown',
	        eventAction: 'click',
	        eventData: {
	          placement: 'My Order page',
	          label: actionType,
	          labelIdentifier: 'Order Info',
	          orderId: $currentTarget.closest('.js-order').data('order-id')
	        }
	      });
	    }
	  },
	
	  onItemImageClick: function onItemImageClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var $orderItem = $currentTarget.closest('.js-order-item');
	      var orderData = (0, _helper2.getOrderItemData)($orderItem);
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_itemPic',
	        eventCategory: 'image',
	        eventAction: 'click',
	        eventData: orderData
	      });
	    }
	  },
	
	  onItemNameClick: function onItemNameClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var $orderItem = $currentTarget.closest('.js-order-item');
	      var orderData = (0, _helper2.getOrderItemData)($orderItem);
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_itemName',
	        eventCategory: 'link',
	        eventAction: 'click',
	        eventData: orderData
	      });
	    }
	  },
	
	  onOrderArrowClick: function onOrderArrowClick(e) {
	    if ((0, _jquery2.default)(event.target).is('select, option')) {
	      return;
	    }
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var $order = $currentTarget.closest('.js-order');
	      var isExpanded = $order.hasClass('active');
	
	      window.dataLayer.push({
	        event: 'myOrder_orderArrow',
	        eventCategory: 'icon',
	        eventAction: isExpanded ? 'collapse' : 'expand',
	        eventData: {
	          placement: 'My Order page',
	          labelIdentifier: 'Order_Info',
	          orderId: $order.data('order-id')
	        }
	      });
	    }
	  },
	
	  onCancelItemClick: function onCancelItemClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var $orderItem = $currentTarget.closest('.js-order-item');
	      var orderData = (0, _helper2.getOrderItemData)($orderItem);
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_itemCancellation',
	        eventCategory: 'link',
	        eventAction: 'click',
	        eventData: _extends({}, orderData, {
	          targetUrl: $currentTarget.attr('href'),
	          label: 'Cancel Item'
	        })
	      });
	    }
	  },
	
	  onReturnItemClick: function onReturnItemClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var $orderItem = $currentTarget.closest('.js-order-item');
	      var orderData = (0, _helper2.getOrderItemData)($orderItem);
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_itemReturn',
	        eventCategory: 'link',
	        eventAction: 'click',
	        eventData: _extends({}, orderData, {
	          targetUrl: $currentTarget.attr('href'),
	          label: 'Return Item'
	        })
	      });
	    }
	  },
	
	  onComplainItemClick: function onComplainItemClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var $orderItem = $currentTarget.closest('.js-order-item');
	      var orderData = (0, _helper2.getOrderItemData)($orderItem);
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_itemComplaint',
	        eventCategory: 'link',
	        eventAction: 'click',
	        eventData: _extends({}, orderData, {
	          targetUrl: $currentTarget.attr('href'),
	          label: 'Complaint'
	        })
	      });
	    }
	  },
	
	  onDeliveryQuestionItemClick: function onDeliveryQuestionItemClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var $orderItem = $currentTarget.closest('.js-order-item');
	      var orderData = (0, _helper2.getOrderItemData)($orderItem);
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_deliveryQuestion',
	        eventCategory: 'link',
	        eventAction: 'click',
	        eventData: _extends({}, orderData, {
	          targetUrl: $currentTarget.attr('href'),
	          label: 'Question about Delivery Status'
	        })
	      });
	    }
	  },
	
	  onInvoiceDownloadClick: function onInvoiceDownloadClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var linkNumber = $currentTarget.index('.js-invoice-download');
	
	      var $lastElement = window.home24.dataTipped._$lastEl;
	      var $order = $lastElement.closest('.js-order');
	      var orderId = $order.data('order-id');
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_invoice',
	        eventCategory: linkNumber + 1,
	        eventAction: 'click',
	        eventData: {
	          placement: 'My Order Page',
	          labelIdentifier: 'Order Info',
	          orderId: orderId
	        }
	      });
	    }
	  },
	
	  onReturnLabelDownloadClick: function onReturnLabelDownloadClick(e) {
	    if (commonTrackingHelper.isGTMLoaded()) {
	      var $currentTarget = (0, _jquery2.default)(e.currentTarget);
	      var linkNumber = $currentTarget.index('.js-return-label-download');
	
	      var $lastElement = window.home24.dataTipped._$lastEl;
	      var $orderItem = $lastElement.closest('.js-order-item');
	      var orderData = (0, _helper2.getOrderItemData)($orderItem);
	
	      (0, _helper.addToDataLayerForLinks)(e, {
	        event: 'myOrder_returnLabels',
	        eventCategory: linkNumber + 1,
	        eventAction: 'click',
	        eventData: orderData
	      });
	    }
	  }
	});

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _bootstrapper = __webpack_require__(8);
	
	var _MyOrdersEvents = __webpack_require__(349);
	
	var _MyOrdersEvents2 = _interopRequireDefault(_MyOrdersEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('myaccount-orders', function () {
	  var myOrdersEvents = new _MyOrdersEvents2.default({
	    el: (0, _jquery2.default)('body')
	  });
	
	  (0, _jquery2.default)(document).ready(function () {
	    myOrdersEvents.executeCookieCallbacks();
	  });
	});

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseTrackingView = __webpack_require__(14);
	
	var _baseTrackingView2 = _interopRequireDefault(_baseTrackingView);
	
	var _helper = __webpack_require__(10);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _baseTrackingView2.default.extend({
	  initialize: function initialize() {
	    this.listenTo(this.model, 'change:simpleSku', this.onSimpleSkuChanged);
	  },
	
	  onSimpleSkuChanged: function onSimpleSkuChanged() {
	    var trackingData = this.model.get('trackingData');
	
	    // in case new PDP is not providing tracking data
	    if (!trackingData) {
	      return;
	    }
	
	    this.pushEnhancedArticleImpression(trackingData);
	    this.pushLegacyArticleImpression(trackingData);
	  },
	
	  pushLegacyArticleImpression: function pushLegacyArticleImpression(trackingData) {
	    if (_typeof(window.dataLayer) === 'object') {
	      var initialDataLayer = (0, _helper.getCurrentDataLayer)();
	
	      var legacyArticleImpression = _underscore2.default.extend({}, initialDataLayer, {
	        productSimpleSKU: trackingData.sku,
	        productName: trackingData.name,
	        variantName: trackingData.variant,
	        productDeliveryTime: trackingData.deliveryTime,
	        productPrice: trackingData.price,
	        productIntPrice: Math.round(trackingData.price)
	      });
	
	      window.dataLayer.push(legacyArticleImpression);
	    }
	  },
	
	  pushEnhancedArticleImpression: function pushEnhancedArticleImpression(trackingData) {
	    if (typeof window.dataLayer === 'undefined' || typeof trackingData === 'undefined') {
	      return;
	    }
	
	    var name = trackingData.name,
	        price = trackingData.price,
	        brand = trackingData.brand,
	        variant = trackingData.variant,
	        category = trackingData.category,
	        categoryBreadcrumb = trackingData.categoryBreadcrumb,
	        id = trackingData.sku,
	        dimension64 = trackingData.deliveryTime;
	
	
	    var product = {
	      name: name,
	      id: id,
	      price: price,
	      brand: brand,
	      variant: variant,
	      dimension64: dimension64
	    };
	
	    if (typeof category === 'string') {
	      product.category = category;
	    }
	
	    if (typeof categoryBreadcrumb === 'string') {
	      product.categoryBreadcrumb = categoryBreadcrumb;
	    }
	
	    window.dataLayer.push({
	      event: 'PDPview',
	      ecommerce: {
	        currencyCode: registry.get('currencyCode'),
	        detail: {
	          products: [_extends({}, product)]
	        }
	      }
	    });
	  }
	});

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WishlistButtonEvents;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseWishlistButtonEvents = __webpack_require__(183);
	
	var baseWishlistButtonEvents = _interopRequireWildcard(_baseWishlistButtonEvents);
	
	var _helper = __webpack_require__(10);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// initialized in /pages/pdp/pdpBootstrap.js
	// as it needs to have access to model
	
	function WishlistButtonEvents(options) {
	  this.model = options.model;
	
	  _underscore2.default.bindAll(this, 'onAddToWishlist', 'onRemoveFromWishlist');
	
	  _jquery2.default.subscribe('added.wishlist', this.onAddToWishlist);
	  _jquery2.default.subscribe('removed.wishlist', this.onRemoveFromWishlist);
	}
	
	WishlistButtonEvents.prototype = _underscore2.default.extend({}, baseWishlistButtonEvents, {
	  onAddToWishlist: function onAddToWishlist(event, eventData) {
	    var data = this.getTrackingData(eventData.sku);
	
	    this.pushAddToWishlistEvent(data, this.getPageType());
	  },
	
	  onRemoveFromWishlist: function onRemoveFromWishlist(event, eventData) {
	    var data = this.getTrackingData(eventData.sku);
	
	    this.pushRemoveFromWishlistEvent(data, this.getPageType());
	  },
	
	  getTrackingData: function getTrackingData(sku) {
	    var currentDataLayer = (0, _helper.getCurrentDataLayer)();
	
	    return {
	      sku: sku,
	      price: currentDataLayer.productPrice,
	      brand: currentDataLayer.productBrand,
	      category: getCategoryFromPageTypeEvent(currentDataLayer)
	    };
	  },
	
	  getPageType: function getPageType() {
	    return 'pdp_product';
	  },
	
	  destroy: function destroy() {
	    _jquery2.default.unsubscribe('added.wishlist', this.onAddToWishlist);
	    _jquery2.default.unsubscribe('removed.wishlist', this.onRemoveFromWishlist);
	  }
	});
	
	/**
	 * Transforms category information from page type track data into a
	 * single string shape to be tracked with wishlist button event.
	 *
	 * @param {object} pageData - Product page track object
	 * @returns {string}
	 */
	function getCategoryFromPageTypeEvent(pageData) {
	  // NOTE: This is for when shop is operating in Navision mode
	  if (Array.isArray(pageData.purchasingCategories)) {
	    return pageData.purchasingCategories.join('/');
	  }
	
	  // NOTE: This is for when shop is operating in SAP mode
	  if (pageData.categoryBreadcrumb) {
	    return pageData.categoryBreadcrumb;
	  }
	
	  return '';
	}

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _wishlistButtonEvents = __webpack_require__(354);
	
	var _wishlistButtonEvents2 = _interopRequireDefault(_wishlistButtonEvents);
	
	var _wishlistEvents = __webpack_require__(355);
	
	var _wishlistEvents2 = _interopRequireDefault(_wishlistEvents);
	
	var _bootstrapper = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _bootstrapper.register)('wishlist', function () {
	  new _wishlistEvents2.default();
	  new _wishlistButtonEvents2.default();
	});

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WishlistButtonEvents;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _baseWishlistButtonEvents = __webpack_require__(183);
	
	var baseWishlistButtonEvents = _interopRequireWildcard(_baseWishlistButtonEvents);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WishlistButtonEvents() {
	  this.selectors = {
	    page: '.js-wishlist-article-list',
	    removeButton: '.js-wishlist-article__remove',
	    articleParent: '.js-wishlist-article__wrap'
	  };
	
	  this.bindEvents();
	}
	
	WishlistButtonEvents.prototype = _underscore2.default.extend({}, baseWishlistButtonEvents, {
	  bindEvents: function bindEvents() {
	    (0, _jquery2.default)(this.selectors.page).on('click.wishlistButtonEvents', this.selectors.removeButton, _underscore2.default.bind(this.onRemoveButtonClick, this));
	  },
	
	  onRemoveButtonClick: function onRemoveButtonClick(event) {
	    var data = this.getTrackingData((0, _jquery2.default)(event.currentTarget));
	
	    this.pushRemoveFromWishlistEvent(data, this.getPageType());
	  },
	
	  getTrackingData: function getTrackingData($clickedEl) {
	    // jquery caches the attribute value if retrieved with .data()
	    var sku = $clickedEl.parents(this.selectors.articleParent).attr('data-sku');
	    var data = {};
	    var dataSource = registry.get('wishlist.trackingData');
	
	    // on wishlist page read from Registry
	    if (dataSource && dataSource[sku]) {
	      data = dataSource[sku];
	    }
	
	    return {
	      sku: sku,
	      price: data.price || '',
	      brand: data.brand || '',
	      category: data.category || ''
	    };
	  },
	
	  getPageType: function getPageType() {
	    return 'wishlist';
	  },
	
	  destroy: function destroy() {
	    (0, _jquery2.default)(this.selectors.page).off('click.wishlistButtonEvents');
	  }
	});

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WishlistEvents;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _registry = __webpack_require__(5);
	
	var registry = _interopRequireWildcard(_registry);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function WishlistEvents() {
	  this.selectors = {
	    articleParent: '.js-wishlist-article__wrap',
	    articleName: '.js-tracking-wishlist-product-click'
	  };
	
	  this.bindEvents();
	}
	
	/**
	 * Checks whether the given event has been executed
	 * holding appropriate keyboard button in order to open a new tab
	 *
	 * event.metaKey = ⌘ (command in apple)
	 * event.button == 1 = middle mouse button
	 *
	 * @param {MouseEvent} event
	 */
	function isClickedForNewTab(event) {
	  return event.ctrlKey || event.shiftKey || event.metaKey || event.button && event.button == 1;
	}
	
	WishlistEvents.prototype = {
	  bindEvents: function bindEvents() {
	    (0, _jquery2.default)(this.selectors.articleName).on('click.wishlistEvents', _underscore2.default.bind(this.onArticleClicked, this));
	  },
	
	  onAddToWishlist: function onAddToWishlist(event) {
	    event.preventDefault();
	
	    var $form = (0, _jquery2.default)(event.currentTarget);
	
	    window.dataLayer.push({
	      productSku: $form.find('[name="sku[]"]').val(),
	      productPrice: '',
	      productBrand: '',
	      productCategory: '',
	      event: 'addToWL',
	      eventCallback: _underscore2.default.bind(this.submitTheForm, this, $form)
	    });
	  },
	
	  onRemoveFromWishlist: function onRemoveFromWishlist(event) {
	    event.preventDefault();
	
	    var $form = (0, _jquery2.default)(event.currentTarget);
	
	    window.dataLayer.push({
	      productSku: $form.find('[name=sku]').val(),
	      productPrice: '',
	      event: 'removeFromWL',
	      eventCallback: _underscore2.default.bind(this.submitTheForm, this, $form)
	    });
	  },
	
	  onArticleAddedToCart: function onArticleAddedToCart(event) {
	    event.preventDefault();
	
	    var trackingData;
	    var $form;
	
	    $form = (0, _jquery2.default)(event.currentTarget);
	
	    trackingData = this.getTrackingData($form);
	
	    trackingData.dimension65 = 'wishlist';
	
	    window.dataLayer.push({
	      event: 'addToCart',
	      ecommerce: {
	        add: {
	          // needs to be an array
	          products: [trackingData]
	        },
	        cartValue: '',
	        currencyCode: registry.get('currencyCode'),
	        pageType: 'wishlist'
	      },
	      eventCallback: _underscore2.default.bind(this.submitTheForm, this, $form)
	    });
	  },
	
	  // another implementation of productClick tracking event,
	  // to avoid http/https localStorage issues
	  onArticleClicked: function onArticleClicked(event) {
	    var clickedForNewTab = isClickedForNewTab(event);
	
	    if (!clickedForNewTab) {
	      event.preventDefault();
	    }
	
	    var $clickedElement = (0, _jquery2.default)(event.currentTarget);
	    var trackingData = this.getTrackingData($clickedElement);
	    var dataLayerEvent = {
	      event: 'productClick',
	      ecommerce: {
	        click: {
	          actionField: {
	            action: 'click',
	            list: 'Wishlist'
	          },
	          products: [trackingData]
	        }
	      }
	    };
	
	    if (!clickedForNewTab) {
	      dataLayerEvent.eventCallback = _underscore2.default.bind(this.redirect, this, $clickedElement.attr('href'));
	    }
	
	    window.dataLayer.push(dataLayerEvent);
	  },
	
	  getTrackingData: function getTrackingData($clickedEl) {
	    var sku = $clickedEl.parents(this.selectors.articleParent).attr('data-sku');
	    var data = {};
	    var dataSource = registry.get('wishlist.trackingData');
	
	    // on wishlist page read from Registry
	    if (dataSource && dataSource[sku]) {
	      data = dataSource[sku];
	    }
	
	    return data;
	  },
	
	  redirect: function redirect(url) {
	    document.location = url;
	  },
	
	  destroy: function destroy() {
	    (0, _jquery2.default)(this.selectors.articleName).off('click.wishlistEvents');
	  }
	};

/***/ },
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classNamesSwiper = __webpack_require__(46);
	
	var _classNamesSwiper2 = _interopRequireDefault(_classNamesSwiper);
	
	var _languages = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotSellable = function NotSellable() {
	  var lng = dataLayer ? (0, _languages.lngprovider)(dataLayer[0].language) : (0, _languages.lngprovider)('de_DE');
	  return '\n<div class="' + _classNamesSwiper2.default.NOTIFICATION.WRAP + '">\n    <img class="' + _classNamesSwiper2.default.NOTIFICATION.IMG + '" src="https://cdn.home24.net/shop-app/assets/bdbd2c6/images/icons/info.svg">\n    <div class="' + _classNamesSwiper2.default.NOTIFICATION.INNER + '">\n        ' + lng.NOTSELLABLE + '\n    </div>\n</div>\n  ';
	};
	
	exports.default = NotSellable;

/***/ },
/* 404 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MultipleOptions = function MultipleOptions(props) {
	  if (Array.isArray(props.mvcAttributes) && (props.mvcAttributes.length === 0 || props.mvcAttributes.length > 3)) {
	    return '';
	  }
	
	  var selectedAttributeKeys = Object.keys(props.selectedMvcAttributes);
	  if (selectedAttributeKeys.length > 3) {
	    // Won't show configuration if there are > 3 config options
	    return '';
	  }
	
	  var attribute = selectedAttributeKeys.sort().map(function (key) {
	    return SingleOption({
	      selectedOption: props.selectedMvcAttributes[key],
	      attributeName: key,
	      option: props.mvcAttributes[key],
	      className: props.className
	    });
	  });
	  var div = '<div>' + attribute + '</div>';
	  return div.replace(/,/g, '');
	};
	
	var SingleOption = function SingleOption(_ref) {
	  var className = _ref.className,
	      attributeName = _ref.attributeName,
	      option = _ref.option,
	      selectedOption = _ref.selectedOption;
	
	  var options = Object.keys(option.options).map(function (keyName) {
	    var selected = selectedOption === keyName ? ' selected' : '';
	    return '\n<option value="' + keyName + '"' + selected + '>\n    ' + option.options[keyName].label + '\n</option>\n      ';
	  });
	
	  return '\n<div class="' + className.DETAILS.OPTIONS.WRAPHEADER + '">\n    <label class="' + className.DETAILS.OPTIONS.LABEL + '" for="mvc-select-' + attributeName + '">' + option.name + '</label>\n    <div class="' + className.DETAILS.OPTIONS.WRAPOPTIONS + '">\n        <select name="' + attributeName + '" id="mvc-select-' + attributeName + '" class="' + className.DETAILS.OPTIONS.SELECT + '">\n            ' + options + '\n        </select>\n    </div>\n</div>\n  ';
	};
	
	exports.default = MultipleOptions;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.start = start;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _stickyOverview = __webpack_require__(407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function start() {
	  (0, _jquery2.default)(document).ready(function () {
	    var stickOverview = new _stickyOverview.StickyOverview({
	      $el: (0, _jquery2.default)('[data-sticky-element]')
	    });
	
	    stickOverview.init();
	  });
	}

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyElement = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var selectors = {
	  anchor: 'data-sticky-anchor'
	};
	
	var StickyElement = exports.StickyElement = function () {
	  function StickyElement($element) {
	    _classCallCheck(this, StickyElement);
	
	    this.$stickyElement = $element;
	    this.$anchorElement = this.getAnchor();
	
	    this.position = {};
	    this.state = 'unstick';
	  }
	
	  _createClass(StickyElement, [{
	    key: 'getAnchor',
	    value: function getAnchor() {
	      var src = this.$stickyElement.data('sticky-src');
	
	      return (0, _jquery2.default)('[' + selectors.anchor + '=' + src + ']');
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      this.$stickyElement.css({
	        width: this.$stickyElement.width(),
	        height: this.$stickyElement.height()
	      });
	      this.$stickyElement.parent().css({
	        position: 'relative',
	        height: this.$anchorElement.outerHeight()
	      });
	
	      this.position = {
	        topOffset: this.$anchorElement.offset().top,
	        stickElementHeight: this.$stickyElement.outerHeight(),
	        anchorElementHeight: this.$anchorElement.outerHeight()
	      };
	    }
	  }, {
	    key: 'emit',
	    value: function emit(nextState) {
	      if (this.state !== nextState) {
	        this.state = nextState;
	
	        if (nextState === 'unstick') {
	          this.unstick();
	        }
	
	        if (nextState === 'top') {
	          this.stickToTop();
	        }
	
	        if (nextState === 'bottom') {
	          this.stickToBottom();
	        }
	      }
	    }
	  }, {
	    key: 'stickToTop',
	    value: function stickToTop() {
	      this.$stickyElement.css({
	        position: 'fixed',
	        top: 0,
	        bottom: ''
	      });
	    }
	  }, {
	    key: 'stickToBottom',
	    value: function stickToBottom() {
	      this.$stickyElement.css({
	        position: 'absolute',
	        top: '',
	        bottom: 0
	      });
	    }
	  }, {
	    key: 'unstick',
	    value: function unstick() {
	      this.$stickyElement.css({ position: '' });
	    }
	  }, {
	    key: 'isStickyElementSmallerThanAnchor',
	    value: function isStickyElementSmallerThanAnchor() {
	      return this.$stickyElement.height() < this.$anchorElement.height();
	    }
	  }]);

	  return StickyElement;
	}();

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StickyOverview = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _stickyElement = __webpack_require__(406);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StickyOverview = exports.StickyOverview = function () {
	  function StickyOverview() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, StickyOverview);
	
	    this.$sticky = new _stickyElement.StickyElement(options.$el);
	    this.$document = (0, _jquery2.default)(document);
	
	    this.onScroll = _underscore2.default.throttle(this.onScroll, 16).bind(this);
	  }
	
	  _createClass(StickyOverview, [{
	    key: 'init',
	    value: function init() {
	      if (this.$sticky.isStickyElementSmallerThanAnchor()) {
	        this.$sticky.init();
	        this.bindScrollListener();
	      }
	    }
	  }, {
	    key: 'onScroll',
	    value: function onScroll() {
	      var scrollTop = this.$document.scrollTop();
	      var _$sticky$position = this.$sticky.position,
	          stickElementHeight = _$sticky$position.stickElementHeight,
	          anchorElementHeight = _$sticky$position.anchorElementHeight,
	          topOffset = _$sticky$position.topOffset;
	
	
	      if (scrollTop < topOffset) {
	        return this.$sticky.emit('unstick');
	      }
	
	      var limit = anchorElementHeight - stickElementHeight + topOffset;
	
	      if (scrollTop >= topOffset && scrollTop <= limit) {
	        return this.$sticky.emit('top');
	      }
	
	      return this.$sticky.emit('bottom');
	    }
	  }, {
	    key: 'bindScrollListener',
	    value: function bindScrollListener() {
	      (0, _jquery2.default)(window).on('scroll', this.onScroll);
	    }
	  }]);

	  return StickyOverview;
	}();

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _helper = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init() {
	  (0, _jquery2.default)('.js-tracking-logout-link').on('click', onLogOut);
	}
	
	function onLogOut(event) {
	  var trackingData = {
	    event: 'logout',
	    visitorID: (0, _helper.getCurrentDataLayer)().visitorID || ''
	  };
	
	  (0, _helper.addToDataLayerForLinks)(event, trackingData);
	}

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var w = window;
	
	w.home24 = w.home24 || {};
	w.home24.helpers = w.home24.helpers || {};
	
	w.home24.helpers.doubleclick = function () {
	  'use strict';
	
	  var publicScope = {};
	  var privateScope = {};
	
	  privateScope.selectors = {
	    iframes: '.iframe-teaser[data-external-url],.iframe[data-external-url]'
	  };
	
	  privateScope.convertToIframe = function () {
	    var $this = (0, _jquery2.default)(this);
	    var sUrl = $this.data('externalUrl');
	    var iWidth = parseInt($this.data('width'), 10);
	    var iHeight = parseInt($this.data('height'), 10);
	
	    if (sUrl && iWidth > 0 && iHeight > 0 && $this.children('iframe').length === 0) {
	      (0, _jquery2.default)('<iframe></iframe>').attr({
	        width: iWidth,
	        height: iHeight,
	        frameborder: '0',
	        scrolling: 'no',
	        marginwidth: '0',
	        marginheight: '0',
	        src: sUrl
	      }).appendTo($this);
	    }
	  };
	
	  publicScope.init = function () {
	    (0, _jquery2.default)(privateScope.selectors.iframes).each(privateScope.convertToIframe);
	  };
	
	  publicScope.init();
	
	  return publicScope;
	}();

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
	  var $refresher = (0, _jquery2.default)('.js-refresher');
	
	  if ($refresher.length) {
	    setTimeout(function () {
	      location.reload();
	    }, 30000);
	  }
	})(_jquery2.default);

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * if you want to add accordion behaviour just add data-accordion-mode=true to the sliders container
	 */
	var SectionSlider = function SectionSlider() {
	  'use strict';
	
	  var slideSpeed = config.getInt('sliders.slideSpeed');
	
	  this.self = {
	    init: function init() {
	      (0, _jquery2.default)('body').on('click', '.section-opener', this.onClick);
	    },
	    onClick: function onClick(event) {
	      event.preventDefault();
	
	      var $currentTarget = (0, _jquery2.default)(event.currentTarget);
	      var $header = $currentTarget.closest('.section-slider');
	      var bOpened = $header.is('.active');
	      var $slideSection = $header.find('.section-content').first();
	      var speed = slideSpeed;
	      var headerSlideSpeed = $header.data('slideSpeed');
	
	      if (headerSlideSpeed) {
	        speed = parseInt(headerSlideSpeed, 10);
	      }
	
	      if ((0, _jquery2.default)(event.target).is('select, option')) {
	        return;
	      }
	
	      if (bOpened) {
	        $slideSection.slideUp(speed);
	        $header.removeClass('active');
	      } else {
	        $currentTarget.closest('[data-accordion-mode=true]').find('.active').each(function (i, val) {
	          (0, _jquery2.default)(val).removeClass('active').find('.section-content').slideUp(speed);
	        });
	        $slideSection.slideDown(speed);
	        $header.addClass('active');
	      }
	    }
	  };
	
	  this.self.init();
	};
	
	new SectionSlider();

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageSlider(el) {
	  var self = this;
	
	  this.$el = (0, _jquery2.default)(el);
	  this.$content = this.$el.find(this.selectors.content);
	  this.$moveEl = this.$el.find(this.selectors.moveEl);
	  this.$elements = this.$el.find(this.selectors.elements);
	  this.$arrowLeft = this.$el.find(this.selectors.arrowLeft);
	  this.$arrowRight = this.$el.find(this.selectors.arrowRight);
	  this.totalElWidth = 0;
	
	  this.$elements.each(function (n, element) {
	    var $el = (0, _jquery2.default)(element);
	    var width = $el.outerWidth(true) + 4;
	
	    $el.attr('data-width', width);
	    self.totalElWidth += width;
	  });
	
	  this.$moveEl.css({ width: self.totalElWidth + 'px' });
	
	  this.updateControls(true);
	  this.initEvents();
	}
	
	ImageSlider.prototype = {
	  contentWidth: 850,
	  elementsMargin: 48,
	  selectors: {
	    slider: '.cms-image-slider',
	    content: '.content',
	    moveEl: '.move',
	    elements: '.move > *',
	    arrowLeft: '.arrow.left',
	    arrowRight: '.arrow.right'
	  },
	  $el: null,
	  $content: null,
	  $moveEl: null,
	  $elements: null,
	  $arrowLeft: null,
	  $arrowRight: null,
	
	  currentElNumber: 0,
	
	  initEvents: function initEvents() {
	    this.$arrowRight.on('click', _jquery2.default.proxy(this.slideRight, this));
	    this.$arrowLeft.on('click', _jquery2.default.proxy(this.slideLeft, this));
	
	    if (this.totalElWidth > this.contentWidth) {
	      this.$moveEl.on('touchstart', _jquery2.default.proxy(this.onTouchStart, this));
	    }
	  },
	
	  onTouchStart: function onTouchStart(event) {
	    this.startX = event.originalEvent.touches[0].pageX;
	    this.startY = event.originalEvent.touches[0].pageY;
	
	    this.$moveEl.on('touchmove', _jquery2.default.proxy(this.onTouchMove, this));
	    this.$moveEl.on('touchend', _jquery2.default.proxy(this.onTouchEnd, this));
	
	    this.currentOffset = this.$moveEl.position().left;
	  },
	
	  isEdge: false,
	
	  onTouchMove: function onTouchMove(event) {
	    var currentX;
	    var currentY;
	    var deltaX;
	    var deltaY;
	
	    currentX = event.originalEvent.touches[0].pageX;
	    deltaX = this.startX - currentX;
	
	    currentY = event.originalEvent.touches[0].pageY;
	    deltaY = this.startY - currentY;
	
	    if (Math.abs(deltaX) * 1.2 >= Math.abs(deltaY)) {
	      event.preventDefault();
	    }
	
	    if (Math.abs(deltaY) > 20 && Math.abs(deltaY) > Math.abs(deltaX) * 2) {
	      this.$moveEl.off('touchmove');
	
	      return;
	    }
	
	    this.marginLeft = this.currentOffset - deltaX;
	
	    if (this.marginLeft > 0) {
	      this.marginLeft = 0;
	      this.isEdge = true;
	    } else if (this.marginLeft < -this.totalElWidth + this.contentWidth) {
	      this.marginLeft = -this.totalElWidth + this.contentWidth;
	      this.isEdge = true;
	    } else {
	      this.isEdge = false;
	    }
	
	    this.$moveEl.css('left', this.marginLeft);
	  },
	
	  onTouchEnd: function onTouchEnd() {
	    var $el;
	    var width = 0;
	
	    this.$moveEl.off('touchmove');
	    this.$moveEl.off('touchend');
	
	    this.startX = null;
	    this.startY = null;
	
	    for (var i = 0; i < this.$elements.length; i++) {
	      $el = (0, _jquery2.default)(this.$elements.get(i));
	      width += $el.attr('data-width') - 0;
	
	      if (-width < this.marginLeft) {
	        this.currentElNumber = i;
	        break;
	      }
	    }
	
	    this.updateControls(this.isEdge);
	    this.currentOffset = null;
	  },
	
	  marginLeft: 0,
	
	  slideRight: function slideRight() {
	    var width = 0;
	    var marginLeft = 0;
	    var $el;
	    var endWithBreak = false;
	    var leftElsWidth = 0;
	
	    for (var i = this.currentElNumber; i < this.$elements.length; i++) {
	      $el = (0, _jquery2.default)(this.$elements.get(i));
	      width += $el.attr('data-width') - 0;
	
	      if (width - 48 > this.contentWidth) {
	        marginLeft = width - ($el.attr('data-width') - 0);
	        this.currentElNumber = i;
	        endWithBreak = true;
	        break;
	      }
	    }
	
	    if (!endWithBreak) {
	      this.updateControls(true);
	    } else {
	      for (var _i = this.currentElNumber; _i < this.$elements.length; _i++) {
	        $el = (0, _jquery2.default)(this.$elements.get(_i));
	        leftElsWidth += $el.attr('data-width') - 0;
	      }
	
	      if (leftElsWidth < this.contentWidth) {
	        this.updateControls(true);
	      } else {
	        this.updateControls(false);
	      }
	    }
	
	    this.marginLeft -= marginLeft;
	
	    this.$moveEl.css({ left: this.marginLeft + 'px' });
	  },
	
	  slideLeft: function slideLeft() {
	    var width = 0;
	    var marginLeft = 0;
	    var $el;
	    var endWithBreak = false;
	    var i;
	
	    for (i = this.currentElNumber - 1; i >= 0; i--) {
	      $el = (0, _jquery2.default)(this.$elements.get(i));
	      width += $el.attr('data-width') - 0;
	
	      if (width - 48 > this.contentWidth) {
	        endWithBreak = true;
	        marginLeft = width - ($el.attr('data-width') - 0);
	        break;
	      }
	    }
	
	    if (!endWithBreak) {
	      this.marginLeft = 0;
	      this.currentElNumber = 0;
	      this.updateControls(true);
	    } else {
	      this.marginLeft += marginLeft;
	      this.currentElNumber = i + 1;
	      this.updateControls(false);
	    }
	
	    this.$moveEl.css({ left: this.marginLeft + 'px' });
	  },
	
	  updateControls: function updateControls(isEdge) {
	    if (this.totalElWidth < this.contentWidth) {
	      this.$arrowLeft.hide();
	      this.$arrowRight.hide();
	    } else if (isEdge) {
	      if (this.currentElNumber === 0) {
	        this.$arrowLeft.hide();
	        this.$arrowRight.show();
	      } else {
	        this.$arrowLeft.show();
	        this.$arrowRight.hide();
	      }
	    } else {
	      this.$arrowLeft.show();
	      this.$arrowRight.show();
	    }
	  }
	};
	
	function init() {
	  (0, _jquery2.default)('.cms-image-slider').each(function (num, el) {
	    new ImageSlider(el);
	  });
	}
	
	(0, _jquery2.default)(function () {
	  init();
	});

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _dataBind = __webpack_require__(201);
	
	var _config = __webpack_require__(4);
	
	var config = _interopRequireWildcard(_config);
	
	var _lightbox = __webpack_require__(11);
	
	var lightbox = _interopRequireWildcard(_lightbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privateScope = {};
	var publicScope = {};
	
	privateScope.formatSupplierDataUrl = function (supplierId) {
	  return (config.getBaseUrl() + config.get('marketplace.supplier.url')).replace('%1', supplierId);
	};
	
	privateScope.getTemplate = function () {
	  return (0, _jquery2.default)(config.get('marketplace.supplier.selector')).html();
	};
	
	privateScope.onSuccess = function (data) {
	  (0, _dataBind.update)(data, lightbox.setConfig({ className: 'supplier-details' }).open(privateScope.getTemplate()).getContent());
	
	  lightbox.getContent().find('.supplier-details--row').each(function () {
	    var iLength = 0;
	    var $this = (0, _jquery2.default)(this);
	
	    $this.find('span').each(function () {
	      iLength += (0, _jquery2.default)(this).html().length;
	    });
	
	    if (iLength === 0) {
	      $this.hide();
	    }
	  });
	};
	
	publicScope.showSupplierOverlay = function (supplierId) {
	  _jquery2.default.getJSON(privateScope.formatSupplierDataUrl(supplierId), privateScope.onSuccess);
	};
	
	publicScope.init = function () {
	  (0, _jquery2.default)('[data-supplier-id]').on('click', function (event) {
	    event.preventDefault();
	    publicScope.showSupplierOverlay((0, _jquery2.default)(this).attr('data-supplier-id'));
	  });
	};
	
	privateScope.getOrderItemPosition = function (orderId, sku) {
	  var $offset = (0, _jquery2.default)('[data-order-id="' + orderId + '"]').find('[data-sku="' + sku + '"]').first().offset();
	
	  return $offset ? $offset.top - parseInt((0, _jquery2.default)(window).height() / 2, 10) : 0;
	};
	
	privateScope.scrollToOrderItem = function (position, supplierId) {
	  var scrollTop = parseInt(position, 10);
	
	  if (scrollTop < 0) {
	    scrollTop = 0;
	  }
	
	  (0, _jquery2.default)('body, html').animate({
	    scrollTop: scrollTop
	  }, config.getInt('marketplace.scrollSpeed'), function () {
	    publicScope.showSupplierOverlay(supplierId);
	  });
	};
	
	publicScope.preopenOverlay = function (orderId, sku, supplierId) {
	  privateScope.scrollToOrderItem(privateScope.getOrderItemPosition(orderId, sku), supplierId);
	};
	
	publicScope.init();
	
	var w = window;
	
	w.home24 = w.home24 || {};
	w.home24.marketplace = publicScope;

/***/ },
/* 414 */,
/* 415 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function () {
	  var NAMESPACE = 'a3320',
	      NETWORK_ID = 3320,
	      URL_TRACKING_ALLOWED = false,
	      SITE_ID = '0',
	      LOG_URL = location.protocol == 'https:' ? 'https://www.econda-monitor.de/els/logging' : 'http://www.econda-monitor.de/els/logging',
	      JUNK_SIZE = 1600,
	      PROTOKOLL_VERSION = '2',
	      CLIENT_COOKIE_LIFETIME = 2592000,
	      COOKIENAME_SESSION_ID = 'emos_jcsid',
	      SESSION_COOKIES_DISABLED = 'NULL',
	      COOKIENAME_VISITOR_ID = 'emos_jcvid',
	      PERSISTENT_COOKIES_DISABLED = 'NULL',
	      COOKIENAME_CAMPAIGN = 'emos_jckamp',
	      COOKIE_DOMAIN = null,
	      TRACK_FIRSTPARTY = true,
	      TRACK_POSTCONVERSION = true,
	      EVENT_MILLIS = 200,
	      TRACK_THIRD_PARTY = true,
	      ca = 0,
	      ak,
	      be = 0,
	      bk = 1,
	      bv = 0,
	      ah = 1,
	      bi,
	      bh,
	      bg = 0,
	      co = 0,
	      w,
	      ev,
	      at,
	      ad,
	      h = null,
	      as = [],
	      trackPageLoads = true;
	
	  window[NAMESPACE] = {};
	  var fq = window.encodeURIComponent ? window.encodeURIComponent : window.escape,
	      f = function f(s) {
	    try {
	      if (window.decodeURIComponent) {
	        try {
	          s = window.decodeURIComponent(s);
	        } catch (e1) {
	          s = window.unescape(s);
	        }
	      } else s = window.unescape(s);
	    } catch (e) {}
	    s = s.replace(/\+/g, ' ');
	
	    return s;
	  };
	  var en = function en(submitData, requestId, y, m) {
	    var gl = Math.floor(submitData.length / JUNK_SIZE) + 1,
	        v = [];
	
	    for (var i = 0; i < gl; i++) {
	      v[i] = {};
	      v[i].v = PROTOKOLL_VERSION;
	      v[i].emrid = requestId;
	      if (TRACK_FIRSTPARTY == true) {
	        v[i].emsid = be;
	        v[i].emvid = bv;
	      }
	      if (TRACK_THIRD_PARTY && TRACK_POSTCONVERSION) {
	        var s = am(h);
	
	        if (s.length > 0) {
	          v[i].emcl = CLIENT_COOKIE_LIFETIME;
	          v[i].emcc = s;
	        }
	      }
	      v[i].emnc = gl;
	      v[i].emtn = i + 1;
	      v[i].emhost = location.hostname;
	      v[i].emkd = NETWORK_ID;
	      v[i].advid = y;
	      v[i].advr = m ? 1 : 0;
	      if (TRACK_THIRD_PARTY) {
	        v[i].tpct = 1;
	      }
	      v[i].d = submitData.substr(i * JUNK_SIZE, JUNK_SIZE);
	    }
	
	    return v;
	  };
	  var cz = function cz() {
	    var a = {},
	        bs = [];
	
	    z(a);
	    if (!trackPageLoads) return;
	    ag(l(a), ak, 0);
	  };
	  var z = function z(a) {
	    if (!a.content) a.content = document.title;
	    w = new Date().getTime();
	    ak = ac();
	    cl();
	    if (!trackPageLoads) return;
	    o(a);
	    k(a);
	    if (TRACK_FIRSTPARTY && !TRACK_THIRD_PARTY) {
	      a.sPI = bk;
	      a.lhVt = ad ? Math.floor(w - ad) : 'NULL';
	      a.lhId = at ? at : 'NULL';
	      a.vS = ah;
	      if (bi) a.gf = bi;
	      if (bh) a.recency = bh;
	      a.vmon = bg / 100;
	    }
	  };
	  var o = function o(a) {
	    a.host = location.host.substring(0, 63);
	    if (URL_TRACKING_ALLOWED) a.url = location.pathname.substring(0, 254);
	    var g = 'NULL',
	        p = 'NULL';
	
	    try {
	      g = top.document.referrer;
	    } catch (exception) {
	      g = document.referrer;
	    }
	    try {
	      p = cc(g);
	      g = cb(g);
	    } catch (exception) {}
	    a.ref = g;
	    if (p != 'NULL') {
	      a.refUrl = p;
	    }
	    a.jv = navigator.javaEnabled() ? 1 : 0;
	    a.swsh = screen.width + 'x' + screen.height;
	    a.siteid = SITE_ID;
	    a.emosV = '40pt';
	  };
	  var cc = function cc(au) {
	    var cu = 'NULL';
	
	    try {
	      var u = bu(au);
	
	      if (u.url) {
	        cu = f(u.url);
	      }
	    } catch (exception) {}
	    cu = cu.substring(0, 127);
	
	    return cu;
	  };
	  var cb = function cb(au) {
	    try {
	      if (au == null || au.length == 0) {
	        au = 'http://unknown';
	      }
	      if (au.substr(0, 4) != 'http') {
	        au = 'http://' + au;
	      } else {
	        var dv = au.split('/');
	
	        au = dv[0] + '/' + dv[1] + '/' + dv[2];
	      }
	    } catch (exception) {}
	
	    return au.substring(0, 127);
	  };
	  var ag = function ag(dz, requestId, waitMillis) {
	    var y = window[NAMESPACE].advertiserId,
	        m = window[NAMESPACE].advertiserRestricted;
	
	    if (typeof y !== 'string' && typeof y !== 'number') return;
	    if (typeof m !== 'boolean') return;
	    var dd = en(dz, requestId, y, m);
	
	    for (var i = 0; i < dd.length; i++) {
	      ca = ca + 1;
	      fh(dd[i], ca, waitMillis);
	    }
	  };
	  var fh = function fh(a, count, waitMillis) {
	    var q = am(a),
	        go = new Image();
	
	    as[count] = go;
	    go.onload = function () {
	      as[count] = null;
	    };
	    go.src = LOG_URL + '?' + q;
	    var aw = new Date().getTime() + waitMillis;
	
	    while (new Date().getTime() < aw) {}
	  };
	  var am = function am(a) {
	    var q = '';
	
	    for (var dp in a) {
	      var t = _typeof(a[dp]);
	
	      if (t == 'string' || t == 'boolean' || t == 'number') {
	        if (q != '') q += '&';
	        q += dp + '=' + fq(a[dp]);
	      }
	    }
	
	    return q;
	  };
	  var bz = function bz(ab) {
	    var ae = ab.split('&'),
	        a = {};
	
	    for (var j = 0; j < ae.length; j++) {
	      var el = ae[j].split('=');
	
	      a[el[0]] = f(el[1]);
	    }
	
	    return a;
	  };
	  var l = function l(a) {
	    var q = [];
	
	    for (var dp in a) {
	      if (q.length != 0) q[q.length] = 28;
	      q = q.concat(eh(dp), [31], ch(a[dp], 29));
	    }
	
	    return fy(q);
	  };
	  var ch = function ch(value, separator) {
	    if (typeof value === 'string') return eh(value);
	    if (typeof value === 'number' || value == 'boolean') return eh('' + value);
	    var dz = [];
	
	    for (var i = 0; i < value.length; i++) {
	      if (i != 0) dz[dz.length] = separator;
	      dz = dz.concat(ch(value[i], 30));
	    }
	
	    return dz;
	  };
	  var cl = function cl() {
	    if (!TRACK_FIRSTPARTY) {
	      return;
	    }
	    var aq = true,
	        value = bo(COOKIENAME_SESSION_ID);
	
	    if (value && value.length > 0) {
	      var ae = value.split(':');
	
	      if (ae.length == 4) {
	        be = ae[0];
	        bk = parseInt(ae[1]) + 1;
	        at = ae[2];
	        ad = parseInt(ae[3]);
	        if (!isNaN(bk) && !isNaN(ad)) {
	          aq = false;
	          if (ad == 0) ad = null;
	          fz(COOKIENAME_SESSION_ID, be + ':' + bk + ':' + ak + ':' + w);
	        }
	      }
	    }
	    if (aq) {
	      ad = null;
	      at = null;
	      var gn = ac(),
	          ab = gn + ':1:' + ak + ':' + w;
	
	      fz(COOKIENAME_SESSION_ID, ab);
	      var cg = bo(COOKIENAME_SESSION_ID);
	
	      if (ab == cg) {
	        be = gn;
	        bk = 1;
	        aq = true;
	      } else {
	        be = SESSION_COOKIES_DISABLED;
	        bk = -1;
	        aq = false;
	      }
	    }
	    var value = bo(COOKIENAME_VISITOR_ID);
	
	    if (value && value.length > 0) {
	      var ae = value.split(':');
	
	      if (ae.length == 5) {
	        bv = ae[0];
	        ah = parseInt(ae[1]) + (aq ? 1 : 0);
	        var gf = ae[2],
	            av = parseInt(ae[3]);
	
	        if (aq) {
	          bi = gf;
	          bh = w - av;
	          av = w;
	        } else {
	          bi = null;
	          bh = null;
	        }
	        bg = co;
	        var cf = parseInt(ae[4]);
	
	        if (!isNaN(cf)) bg += cf;
	        if (!isNaN(ah)) {
	          fz(COOKIENAME_VISITOR_ID, bv + ':' + ah + ':' + be + ':' + av + ':' + bg, 0x2fffffff);
	
	          return;
	        }
	      }
	    }
	    var gm = be;
	
	    bg = co;
	    var ab = gm + ':1:' + be + ':' + w + ':' + bg;
	
	    fz(COOKIENAME_VISITOR_ID, ab, 0x2fffffff);
	    var cg = bo(COOKIENAME_VISITOR_ID);
	
	    if (ab == cg) {
	      bv = gm;
	      ah = 1;
	    } else {
	      bv = PERSISTENT_COOKIES_DISABLED;
	      ah = -1;
	    }
	  };
	  var bo = function bo(cookieName) {
	    var bp = document.cookie.split(';');
	    var length = cookieName.length;
	
	    for (var i = 0; i < bp.length; i++) {
	      var e = bp[i];
	
	      if (e.charAt(0) == ' ') e = e.substr(1);
	      if (e.substr(0, length) == cookieName) {
	        var da = e.indexOf('=');
	
	        if (da < 0) continue;
	
	        return e.substring(da + 1);
	      }
	    }
	
	    return null;
	  };
	  var fz = function fz(name, value, lifetime) {
	    var ai = name + '=' + value + ';path=/;';
	
	    if (COOKIE_DOMAIN) ai = ai + 'domain=' + COOKIE_DOMAIN + ';';
	    if (lifetime) ai = ai + 'max-age=' + lifetime + ';expires=' + new Date(new Date().getTime() + lifetime * 1000).toGMTString() + ';';
	    document.cookie = ai;
	  };
	  var dm = function dm(name) {
	    var ai = name + '=;path=/;max-age=0;';
	
	    if (COOKIE_DOMAIN) ai = ai + 'domain=' + COOKIE_DOMAIN + ';';
	    document.cookie = ai;
	  };
	  var ac = function ac() {
	    var ed = new Date().getTime(),
	        es = ed & 0xffffffff,
	        er = ed / 0x100000000 & 0xffffffff,
	        b = [];
	
	    b[b.length] = er >>> 24;
	    b[b.length] = er >>> 16 & 0xff;
	    b[b.length] = er >>> 8 & 0xff;
	    b[b.length] = er & 0xff;
	    b[b.length] = es >>> 24;
	    b[b.length] = es >>> 16 & 0xff;
	    b[b.length] = es >>> 8 & 0xff;
	    b[b.length] = es & 0xff;
	    for (var i = 0; i < 4; i++) {
	      var r = 0x100000000 * Math.random() & 0xffffffff;
	
	      b[b.length] = r >>> 24;
	      b[b.length] = r >>> 16 & 0xff;
	      b[b.length] = r >>> 8 & 0xff;
	      b[b.length] = r & 0xff;
	    }
	
	    return fy(b);
	  };
	  var eh = function eh(t) {
	    var d = [],
	        cm = String.fromCharCode(237);
	
	    if (cm.charCodeAt(0) < 0) {
	      for (var n = 0; n < t.length; n++) {
	        var c = t.charCodeAt(n);
	
	        if (c > 0) {
	          if (c >= 32) {
	            d[d.length] = c;
	          }
	        } else {
	          d[d.length] = 256 + c >> 6 | 192;
	          d[d.length] = 256 + c & 63 | 128;
	        }
	      }
	    } else {
	      for (var n = 0; n < t.length; n++) {
	        var c = t.charCodeAt(n);
	
	        if (c < 128) {
	          if (c >= 32) {
	            d[d.length] = c;
	          }
	        } else if (c > 127 && c < 2048) {
	          d[d.length] = c >> 6 | 192;
	          d[d.length] = c & 63 | 128;
	        } else {
	          d[d.length] = c >> 12 | 224;
	          d[d.length] = c >> 6 & 63 | 128;
	          d[d.length] = c & 63 | 128;
	        }
	      }
	    }
	
	    return d;
	  };
	  var eo = function eo() {
	    var b64s = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789*_',
	        b64 = [];
	
	    for (var i = 0; i < b64s.length; i++) {
	      b64[i] = b64s.charAt(i);
	    }
	    ev = b64;
	  };
	  var fy = function fy(d) {
	    var b64 = ev,
	        r = [],
	        i = 0,
	        dl = d.length;
	
	    if (dl % 3 == 1) {
	      d[d.length] = 0;
	      d[d.length] = 0;
	    }
	    if (dl % 3 == 2) d[d.length] = 0;
	    while (i < d.length) {
	      r[r.length] = b64[d[i] >> 2];
	      r[r.length] = b64[(d[i] & 3) << 4 | d[i + 1] >> 4];
	      r[r.length] = b64[(d[i + 1] & 15) << 2 | d[i + 2] >> 6];
	      r[r.length] = b64[d[i + 2] & 63];
	      i += 3;
	    }
	    if (dl % 3 == 1) r[r.length - 1] = r[r.length - 2] = '';
	    if (dl % 3 == 2) r[r.length - 1] = '';
	    var t = r.join('');
	
	    return t;
	  };
	  var k = function k(a) {
	    var u,
	        cw,
	        ax = '',
	        dk = 0;
	
	    h = {};
	    try {
	      u = bu(top.location.search);
	    } catch (exception) {
	      u = bu(location.search);
	    }
	    try {
	      cw = top.document.referrer;
	    } catch (exception) {
	      cw = document.referrer;
	    }
	    var cv = cc(cw),
	        ff = cb(cw);
	
	    if (cv != 'NULL') {
	      dk = 1;
	    }
	    var hasPubId = false,
	        hasSeoPage = false,
	        allChannelsActive = false,
	        pubId = window[NAMESPACE].publisherId,
	        seoPage = window[NAMESPACE].PageName,
	        trackAllSources = window[NAMESPACE].trackAllChannels;
	
	    if (typeof pubId === 'string' || typeof pubId === 'number') hasPubId = true;
	    if (typeof seoPage === 'string') hasSeoPage = true;
	    if (typeof trackAllSources === 'boolean' && trackAllSources == true) allChannelsActive = true;
	    if (cw.length < 1 || cw == null) {
	      ax = 'direct';
	    } else {
	      if (ck(ff)) {
	        ax = 'intern';
	      } else {
	        if (eg(cw, a) == true || ff.indexOf('images.google') >= 0) {
	          ax = 'suma';
	          h.smqp = a.smqp;
	          h.ref = ff;
	          h.source = ax;
	          if (hasPubId) {
	            h.pbid = pubId;
	          }
	          if (hasSeoPage) {
	            h.refUrl = seoPage.substring(0, 254);
	          } else {
	            h.refUrl = location.href.substring(0, 254);
	          }
	        } else {
	          ax = 'ref';
	        }
	      }
	    }
	    if (ax != 'suma') {
	      if (!allChannelsActive && hasPubId) {
	        trackPageLoads = false;
	      } else {
	        if (allChannelsActive) {
	          if (hasPubId) {
	            a.pbid = pubId;
	            if (hasSeoPage) {
	              a.refUrl = seoPage.substring(0, 254);
	            } else {
	              a.refUrl = location.href.substring(0, 254);
	            }
	          }
	        }
	      }
	    }
	    a.osource = ax;
	    a.source = ax;
	    if (TRACK_FIRSTPARTY) {
	      var cq = ea();
	
	      if (cq) {
	        for (var dp in cq) {
	          a[dp] = cq[dp];
	        }
	      }
	    }
	  };
	  var ck = function ck(ff) {
	    return ff.split('/')[2] == location.host;
	  };
	  var SEARCH_ENGINES = [['q', 'start', 1], ['p', 'b', 1], ['su', 'pageIndex', 10], ['query'], ['qry_str'], ['begriff'], ['words'], ['encquery'], ['qt'], ['terms']],
	      eg = function eg(au, a) {
	    var u;
	
	    try {
	      u = bu(au);
	    } catch (e) {
	      return false;
	    }
	    var ref = au.toLowerCase();
	
	    for (var i = 0; i < SEARCH_ENGINES.length; i++) {
	      var az = u[SEARCH_ENGINES[i][0]];
	
	      if (az) {
	        a.smqp = f(az);
	        if (SEARCH_ENGINES[i].length == 3) {
	          var da = parseInt(u[SEARCH_ENGINES[i][1]]);
	
	          if (!isNaN(da)) a.smstart = da * SEARCH_ENGINES[i][2];
	        }
	
	        return true;
	      }
	    }
	
	    return false;
	  };
	  var ea = function ea() {
	    var dw = bo(COOKIENAME_CAMPAIGN),
	        fd = am(h);
	
	    if (fd != '') {
	      fz(COOKIENAME_CAMPAIGN, fd, CLIENT_COOKIE_LIFETIME);
	
	      return h;
	    } else {
	      if (dw && dw.length > 0) {
	        var fc = bz(dw);
	
	        if (fc.scnd && fc.scnd == '1') {
	          carriesSecondaryCookie = true;
	        }
	        fc.postconv = '1';
	
	        return fc;
	      }
	    }
	
	    return null;
	  };
	  var an = function an() {
	    if (COOKIE_DOMAIN == null) {
	      var af = window.location.hostname.split('.'),
	          al = af[af.length - 1],
	          gl = al == 'uk' || al == 'tr' || al == 'br' || al == 'at' && af[af.length - 2] == 'co' ? 3 : 2;
	
	      if (isNaN(parseInt(al)) && af.length >= gl) {
	        COOKIE_DOMAIN = '';
	        for (var i = af.length - gl; i < af.length; i++) {
	          COOKIE_DOMAIN = COOKIE_DOMAIN + '.' + af[i];
	        }
	      } else {
	        COOKIE_DOMAIN = window.location.hostname;
	      }
	    }
	  };
	
	  window[NAMESPACE].trackEvent = function (a) {
	    z(a);
	    if (!trackPageLoads) return true;
	    ag(l(a), ak, 0);
	
	    return true;
	  };
	  window[NAMESPACE].userEvent1 = function (shortcut, value) {
	    var a = {};
	
	    z(a);
	    if (!trackPageLoads) return true;
	    a[shortcut] = value;
	    ag(l(a), ak, EVENT_MILLIS);
	
	    return true;
	  };
	  window[NAMESPACE].userEvent2 = function (shortcut, value1, value2) {
	    var a = {};
	
	    z(a);
	    if (!trackPageLoads) return true;
	    a[shortcut] = [[value1, value2]];
	    ag(l(a), ak, EVENT_MILLIS);
	
	    return true;
	  };
	  window[NAMESPACE].targetEvent = function (tid, tlabel, covinfo) {
	    var a = {};
	
	    z(a);
	    if (!trackPageLoads) return true;
	    a.Target = [[tid, tlabel]];
	    a.cGoal = '1';
	    ag(l(a), ak, EVENT_MILLIS);
	
	    return true;
	  };
	  window[NAMESPACE].userEvent = function (type, param1, param2) {
	    var a = {};
	
	    z(a);
	    if (!trackPageLoads) return true;
	    a.uEvent = [[type, param1, param2]];
	    ag(l(a), ak, EVENT_MILLIS);
	
	    return true;
	  };
	  var bu = function bu(queryString) {
	    var da = queryString.indexOf('?');
	
	    if (da >= 0) queryString = queryString.substr(da + 1);
	    var du = {},
	        gc = queryString.split('&');
	
	    for (var i = 0; i < gc.length; i++) {
	      var aa = gc[i].split('=');
	
	      if (aa[1]) du[aa[0]] = aa[1];else du[aa[0]] = '';
	    }
	
	    return du;
	  };
	  var gr = function gr() {
	    an();
	    eo();
	    if (window.addEventListener) {
	      window.addEventListener('pageshow', function (event) {
	        if (event.persisted) cz();
	      }, false);
	    }
	  };
	
	  gr();
	})();

/***/ },
/* 416 */
/***/ function(module, exports) {

	'use strict';
	
	// ////////////////////////////////////////////////////////////////////////////////
	// Cloud Zoom V1.0.2.5
	// (c) 2010 by R Cecco. <http://www.professorcloud.com>
	// with enhancements by Philipp Andreas <https://github.com/smurfy/cloud-zoom>
	//
	// MIT License
	//
	// Please retain this copyright header in all versions of the software
	// ////////////////////////////////////////////////////////////////////////////////
	
	// @repository https://github.com/smurfy/cloud-zoom
	
	(function ($) {
	  function format(str) {
	    for (var i = 1; i < arguments.length; i++) {
	      str = str.replace('%' + (i - 1), arguments[i]);
	    }
	
	    return str;
	  }
	
	  function CloudZoom(jWin, opts) {
	    var sImg = $('img', jWin);
	    var img1;
	    var img2;
	    var zoomDiv = null;
	    var $mouseTrap = null;
	    var lens = null;
	    var $tint = null;
	    var softFocus = null;
	    var $ie6Fix = null;
	    var zoomImage;
	    var controlTimer = 0;
	    var cw, ch;
	    var destU = 0;
	    var destV = 0;
	    var currV = 0;
	    var currU = 0;
	    var filesLoaded = 0;
	    var mx, my;
	    var ctx = this,
	        zw;
	
	    // Display an image loading message. This message gets deleted when the images have loaded and the zoom init function is called.
	    // We add a small delay before the message is displayed to avoid the message flicking on then off again virtually immediately if the
	    // images load really fast, e.g. from the cache.
	    // var	ctx = this;
	
	    setTimeout(function () {
	      //						 <img src="/images/loading.gif"/>
	      if ($mouseTrap === null) {
	        var w = jWin.width();
	
	        jWin.parent().append(format('<div style="width:%0px;position:absolute;top:75%;left:%1px;text-align:center" class="cloud-zoom-loading" >Loading...</div>', w / 3, w / 2 - w / 6)).find(':last').css('opacity', 0.5);
	      }
	    }, 200);
	
	    var ie6FixRemove = function ie6FixRemove() {
	      if ($ie6Fix !== null) {
	        $ie6Fix.remove();
	        $ie6Fix = null;
	      }
	    };
	
	    // Removes cursor, tint layer, blur layer etc.
	    this.removeBits = function () {
	      // $mouseTrap.unbind();
	      if (lens) {
	        lens.remove();
	        lens = null;
	      }
	      if ($tint) {
	        $tint.remove();
	        $tint = null;
	      }
	      if (softFocus) {
	        softFocus.remove();
	        softFocus = null;
	      }
	      ie6FixRemove();
	
	      $('.cloud-zoom-loading', jWin.parent()).remove();
	    };
	
	    this.destroy = function () {
	      jWin.data('zoom', null);
	
	      if ($mouseTrap) {
	        $mouseTrap.unbind();
	        $mouseTrap.remove();
	        $mouseTrap = null;
	      }
	      if (zoomDiv) {
	        zoomDiv.remove();
	        zoomDiv = null;
	      }
	
	      // ie6FixRemove();
	      this.removeBits();
	
	      // DON'T FORGET TO REMOVE JQUERY 'DATA' VALUES
	    };
	
	    // This is called when the zoom window has faded out so it can be removed.
	    this.fadedOut = function () {
	      if (zoomDiv) {
	        zoomDiv.remove();
	        zoomDiv = null;
	      }
	      this.removeBits();
	
	      // ie6FixRemove();
	    };
	
	    this.controlLoop = function () {
	      if (lens) {
	        var x = mx - sImg.offset().left - cw * 0.5 >> 0;
	        var y = my - sImg.offset().top - ch * 0.5 >> 0;
	
	        if (x < 0) {
	          x = 0;
	        } else if (x > sImg.outerWidth() - cw) {
	          x = sImg.outerWidth() - cw;
	        }
	        if (y < 0) {
	          y = 0;
	        } else if (y > sImg.outerHeight() - ch) {
	          y = sImg.outerHeight() - ch;
	        }
	
	        lens.css({
	          left: x,
	          top: y
	        });
	        lens.css('background-position', -x + 'px ' + -y + 'px');
	
	        destU = x / sImg.outerWidth() * zoomImage.width >> 0;
	        destV = y / sImg.outerHeight() * zoomImage.height >> 0;
	        currU += (destU - currU) / opts.smoothMove;
	        currV += (destV - currV) / opts.smoothMove;
	
	        zoomDiv.css('background-position', -(currU >> 0) + 'px ' + (-(currV >> 0) + 'px'));
	      }
	      controlTimer = setTimeout(function () {
	        ctx.controlLoop();
	      }, 30);
	    };
	
	    this.init2 = function (img, id) {
	      filesLoaded++;
	      if (id === 1) {
	        zoomImage = img;
	      }
	
	      // this.images[id] = img;
	      if (filesLoaded === 2) {
	        this.init();
	      }
	    };
	
	    /* Init function start.  */
	    this.init = function () {
	      // Remove loading message (if present);
	      $('.cloud-zoom-loading', jWin.parent()).remove();
	
	      /* Add a box (mouseTrap) over the small image to trap mouse events.
	             It has priority over zoom window to avoid issues with inner zoom.
	             We need the dummy background image as IE does not trap mouse events on
	             transparent parts of a div.
	             */
	      $mouseTrap = jWin.parent().append(format("<div class='mousetrap' style='background-image:url(\"" + opts.transparentImage + '");z-index:999;position:absolute;width:%0px;height:%1px;left:%2px;top:%3px;\'></div>', sImg.outerWidth(), sImg.outerHeight(), 0, 0)).find(':last');
	
	      // ////////////////////////////////////////////////////////////////////
	      /* Do as little as possible in mousemove event to prevent slowdown. */
	      $mouseTrap.bind('mousemove', this, function (event) {
	        // Just update the mouse position
	        mx = event.pageX;
	        my = event.pageY;
	      });
	
	      // ////////////////////////////////////////////////////////////////////
	      $mouseTrap.bind('mouseleave', this, function (event) {
	        clearTimeout(controlTimer);
	
	        // event.data.removeBits();
	        if (lens) {
	          lens.fadeOut(299);
	        }
	        if ($tint) {
	          $tint.fadeOut(299);
	        }
	        if (softFocus) {
	          softFocus.fadeOut(299);
	        }
	        zoomDiv.fadeOut(300, function () {
	          ctx.fadedOut();
	        });
	      });
	
	      // ////////////////////////////////////////////////////////////////////
	      $mouseTrap.bind('mouseenter', this, function (event) {
	        mx = event.pageX;
	        my = event.pageY;
	        zw = event.data;
	        if (zoomDiv) {
	          zoomDiv.stop(true, false);
	          zoomDiv.remove();
	        }
	
	        var xPos = opts.adjustX,
	            yPos = opts.adjustY;
	
	        var siw = sImg.outerWidth();
	        var sih = sImg.outerHeight();
	
	        var w = opts.zoomWidth;
	        var h = opts.zoomHeight;
	
	        if (opts.zoomWidth == 'auto') {
	          w = siw;
	        }
	        if (opts.zoomHeight == 'auto') {
	          h = sih;
	        }
	
	        // $('#info').text( xPos + ' ' + yPos + ' ' + siw + ' ' + sih );
	        var appendTo = jWin.parent(); // attach to the wrapper
	
	        switch (opts.position) {
	          case 'top':
	            yPos -= h; // + opts.adjustY;
	            break;
	          case 'right':
	            xPos += siw; // + opts.adjustX;
	            break;
	          case 'bottom':
	            yPos += sih; // + opts.adjustY;
	            break;
	          case 'left':
	            xPos -= w; // + opts.adjustX;
	            break;
	          case 'inside':
	            w = siw;
	            h = sih;
	            break;
	
	          // All other values, try and find an id in the dom to attach to.
	          default:
	            appendTo = $('#' + opts.position);
	
	            // If dom element doesn't exit, just use 'right' position as default.
	            if (!appendTo.length) {
	              appendTo = jWin;
	              xPos += siw; // + opts.adjustX;
	              yPos += sih; // + opts.adjustY;
	            } else {
	              w = appendTo.innerWidth();
	              h = appendTo.innerHeight();
	            }
	        }
	
	        zoomDiv = appendTo.append(format('<div id="cloud-zoom-big" class="cloud-zoom-big" style="display:none;position:absolute;left:%0px;top:%1px;width:%2px;height:%3px;background-image:url(\'%4\');z-index:99;"></div>', xPos, yPos, w, h, zoomImage.src)).find(':last');
	
	        // Add the title from title tag.
	        if (sImg.attr('title') && opts.showTitle) {
	          zoomDiv.append(format('<div class="cloud-zoom-title">%0</div>', sImg.attr('title'))).find(':last').css('opacity', opts.titleOpacity);
	        }
	
	        // Fix ie6 select elements wrong z-index bug. Placing an iFrame over the select element solves the issue...
	        var browserCheck = /(msie) ([\w.]+)/.exec(navigator.userAgent);
	
	        if (browserCheck) {
	          if ((browserCheck[1] || '') == 'msie' && (browserCheck[2] || '0') < 7) {
	            $ie6Fix = $('<iframe frameborder="0" src="#"></iframe>').css({
	              position: 'absolute',
	              left: xPos,
	              top: yPos,
	              zIndex: 99,
	              width: w,
	              height: h
	            }).insertBefore(zoomDiv);
	          }
	        }
	
	        zoomDiv.fadeIn(500);
	
	        if (lens) {
	          lens.remove();
	          lens = null;
	        } /* Work out size of cursor */
	        cw = sImg.outerWidth() / zoomImage.width * zoomDiv.width();
	        ch = sImg.outerHeight() / zoomImage.height * zoomDiv.height();
	
	        // Attach mouse, initially invisible to prevent first frame glitch
	        lens = jWin.append(format("<div class = 'cloud-zoom-lens' style='display:none;z-index:98;position:absolute;width:%0px;height:%1px;'></div>", cw, ch)).find(':last');
	
	        $mouseTrap.css('cursor', lens.css('cursor'));
	
	        var noTrans = false;
	
	        // Init tint layer if needed. (Not relevant if using inside mode)
	        if (opts.tint) {
	          lens.css('background', 'url("' + sImg.attr('src') + '")');
	          $tint = jWin.append(format('<div style="display:none;position:absolute; left:0px; top:0px; width:%0px; height:%1px; background-color:%2;" />', sImg.outerWidth(), sImg.outerHeight(), opts.tint)).find(':last');
	          $tint.css('opacity', opts.tintOpacity);
	          noTrans = true;
	          $tint.fadeIn(500);
	        }
	        if (opts.softFocus) {
	          lens.css('background', 'url("' + sImg.attr('src') + '")');
	          softFocus = jWin.append(format('<div style="position:absolute;display:none;top:2px; left:2px; width:%0px; height:%1px;" />', sImg.outerWidth() - 2, sImg.outerHeight() - 2, opts.tint)).find(':last');
	          softFocus.css('background', 'url("' + sImg.attr('src') + '")');
	          softFocus.css('opacity', 0.5);
	          noTrans = true;
	          softFocus.fadeIn(500);
	        }
	
	        if (!noTrans) {
	          lens.css('opacity', opts.lensOpacity);
	        }
	        if (opts.position !== 'inside') {
	          lens.fadeIn(500);
	        }
	
	        // Start processing.
	        zw.controlLoop();
	
	        return; // Don't return false here otherwise opera will not detect change of the mouse pointer type.
	      });
	    };
	
	    img1 = new Image();
	    $(img1).load(function () {
	      ctx.init2(this, 0);
	    });
	
	    img1.src = sImg.attr('src');
	
	    img2 = new Image();
	    $(img2).load(function () {
	      ctx.init2(this, 1);
	    });
	
	    img2.src = jWin.attr('data-big-image');
	  }
	
	  $.fn.CloudZoom = function (options) {
	    // IE6 background image flicker fix
	    try {
	      document.execCommand('BackgroundImageCache', false, true);
	    } catch (e) {}
	    this.each(function () {
	      var relOpts, opts;
	
	      // Hmm...eval...slap on wrist.
	
	      eval('var	a = {' + $(this).attr('data-rel') + '}');
	      relOpts = a;
	      if ($(this).is('.cloud-zoom')) {
	        opts = $.extend({}, $.fn.CloudZoom.defaults, options);
	        opts = $.extend({}, opts, relOpts);
	
	        $(this).css({
	          position: 'relative',
	          display: 'block'
	        });
	        $('img', $(this)).css({
	          display: 'block'
	        });
	
	        // Wrap an outer div around the link so we can attach things without them becoming part of the link.
	        // But not if wrap already exists.
	        if (!$(this).parent().hasClass('cloud-zoom-wrap') && opts.useWrapper) {
	          $(this).wrap('<div class="cloud-zoom-wrap"></div>');
	        }
	        $(this).data('zoom', new CloudZoom($(this), opts));
	      } else if ($(this).is('.cloud-zoom-gallery')) {
	        opts = $.extend({}, relOpts, options);
	        $(this).data('relOpts', opts);
	        $(this).bind('click', $(this), function (event) {
	          event.preventDefault();
	
	          var data = event.data.data('relOpts');
	          var $el = $('#' + data.useZoom);
	
	          // Destroy the previous zoom
	          $el.data('zoom').destroy();
	
	          // Change the biglink to point to the new big image.
	          $el.attr('data-big-image', event.data.attr('data-big-image'));
	
	          // Change the small image to point to the new small image.
	          $el.find('img').attr('src', event.data.data('relOpts').smallImage);
	
	          // copy data-id of small img
	          $el.attr('data-id', event.data.attr('data-id'));
	
	          // copy href attr for lightbox gallery
	          $el.attr('href', event.data.attr('href'));
	
	          // Init a new zoom with the new images.
	          $('#' + event.data.data('relOpts').useZoom).CloudZoom();
	        });
	      }
	    });
	
	    return this;
	  };
	
	  $.fn.CloudZoom.defaults = {
	    zoomWidth: 'auto',
	    zoomHeight: 'auto',
	    position: 'right',
	    transparentImage: '.',
	    useWrapper: true,
	    tint: false,
	    tintOpacity: 0.5,
	    lensOpacity: 0.5,
	    softFocus: false,
	    smoothMove: 3,
	    showTitle: true,
	    titleOpacity: 0.5,
	    adjustX: 0,
	    adjustY: 0
	  };
	})(jQuery);
	
	/* REBOOT-1810
	 * By default cloud-zoom plugin looks for a big image url in "href" attribute.
	 * It is changed that now it reads the big image from a "big-image" attribute.
	 *
	 * REBOOT-2417
	 * Regarding HTML5 validation "big-image" was changed to "data-big-image"
	 */

/***/ },
/* 417 */,
/* 418 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Author: Jason Farrell
	 * Author URI: http://useallfive.com/
	 *
	 * Description: Checks if a DOM element is truly visible.
	 * Package URL: https://github.com/UseAllFive/true-visibility
	 */
	Element.prototype.isVisible = function () {
	  'use strict';
	
	  /**
	   * Checks if a DOM element is visible. Takes into
	   * consideration its parents and overflow.
	   *
	   * @param (el)      the DOM element to check if is visible
	   *
	   * These params are optional that are sent in recursively,
	   * you typically won't use these:
	   *
	   * @param (t)       Top corner position number
	   * @param (r)       Right corner position number
	   * @param (b)       Bottom corner position number
	   * @param (l)       Left corner position number
	   * @param (w)       Element width number
	   * @param (h)       Element height number
	   */
	
	  function _isVisible(el, t, r, b, l, w, h) {
	    var p = el.parentNode,
	        VISIBLE_PADDING = 2;
	
	    if (!_elementInDocument(el)) {
	      return false;
	    }
	
	    // -- Return true for document node
	    if (p.nodeType === 9) {
	      return true;
	    }
	
	    // -- Return false if our element is invisible
	    if (_getStyle(el, 'opacity') === '0' || _getStyle(el, 'display') === 'none' || _getStyle(el, 'visibility') === 'hidden') {
	      return false;
	    }
	
	    if (typeof t === 'undefined' || typeof r === 'undefined' || typeof b === 'undefined' || typeof l === 'undefined' || typeof w === 'undefined' || typeof h === 'undefined') {
	      t = el.offsetTop;
	      l = el.offsetLeft;
	      b = t + el.offsetHeight;
	      r = l + el.offsetWidth;
	      w = el.offsetWidth;
	      h = el.offsetHeight;
	    }
	
	    // -- If we have a parent, let's continue:
	    if (p) {
	      // -- Check if the parent can hide its children.
	      if (_getStyle(p, 'overflow') === 'hidden' || _getStyle(p, 'overflow') === 'scroll') {
	        // -- Only check if the offset is different for the parent
	        if (
	        // -- If the target element is to the right of the parent elm
	        l + VISIBLE_PADDING > p.offsetWidth + p.scrollLeft ||
	        // -- If the target element is to the left of the parent elm
	        l + w - VISIBLE_PADDING < p.scrollLeft ||
	        // -- If the target element is under the parent elm
	        t + VISIBLE_PADDING > p.offsetHeight + p.scrollTop ||
	        // -- If the target element is above the parent elm
	        t + h - VISIBLE_PADDING < p.scrollTop) {
	          // -- Our target element is out of bounds:
	          return false;
	        }
	      }
	
	      // -- Add the offset parent's left/top coords to our element's offset:
	      if (el.offsetParent === p) {
	        l += p.offsetLeft;
	        t += p.offsetTop;
	      }
	
	      // -- Let's recursively check upwards:
	      return _isVisible(p, t, r, b, l, w, h);
	    }
	
	    return true;
	  }
	
	  // -- Cross browser method to get style properties:
	  function _getStyle(el, property) {
	    if (window.getComputedStyle) {
	      return document.defaultView.getComputedStyle(el, null)[property];
	    }
	    if (el.currentStyle) {
	      return el.currentStyle[property];
	    }
	  }
	
	  function _elementInDocument(element) {
	    while (element = element.parentNode) {
	      if (element == document) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  return _isVisible(this);
	};

/***/ },
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 466 */,
/* 467 */,
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * jQuery.appear http://code.google.com/p/jquery-appear/ Copyright (c) 2009 Michael Hixson Licensed under the MIT license (http://www.opensource.org/licenses/mit-license.php)
	 */
	
	_jquery2.default.fn.appear = function (fn, options) {
	  var settings = _jquery2.default.extend({
	    // arbitrary data to pass to fn
	    data: undefined,
	
	    // call fn only on the first appear?
	    one: true
	  }, options);
	
	  return this.each(function () {
	    var t = (0, _jquery2.default)(this);
	
	    // whether the element is currently visible
	    t.appeared = false;
	
	    if (!fn) {
	      // trigger the custom event
	      t.trigger('appear', settings.data);
	
	      return;
	    }
	
	    var w = (0, _jquery2.default)(window);
	
	    // fires the appear event when appropriate
	    var check = function check() {
	      // is the element hidden?
	      // Changed to check is an element truly visible
	      if (!t.is(':visible')) {
	        // it became hidden
	        t.appeared = false;
	
	        return;
	      }
	
	      // is the element inside the visible window?
	      var a = w.scrollLeft();
	      var b = w.scrollTop();
	      var o = t.offset();
	      var x = o.left;
	      var y = o.top;
	      var height = w.height();
	      var width = w.width();
	
	      if (y + t.height() >= b && y <= b + height && x + t.width() >= a && x <= a + width) {
	        // trigger the custom event
	        if (!t.appeared) {
	          t.trigger('appear', settings.data);
	        }
	      } else {
	        // it scrolled out of view
	        t.appeared = false;
	      }
	    };
	
	    // create a modified fn with some additional logic
	    var modifiedFn = function modifiedFn() {
	      // mark the element as visible
	      t.appeared = true;
	
	      // is this supposed to happen only once?
	      if (settings.one) {
	        // remove the check
	        w.unbind('scroll', check);
	        w.unbind('resize', check);
	
	        // w.unbind('orientationchange', check);
	        var i = _jquery2.default.inArray(check, _jquery2.default.fn.appear.checks);
	
	        if (i >= 0) {
	          _jquery2.default.fn.appear.checks.splice(i, 1);
	        }
	      }
	
	      // trigger the original fn
	      fn.apply(this, arguments);
	    };
	
	    // bind the modified fn to the element
	    if (settings.one) {
	      t.one('appear', settings.data, modifiedFn);
	    } else {
	      t.bind('appear', settings.data, modifiedFn);
	    }
	
	    // check whenever the window scrolls or resizes
	
	    w.scroll(check).resize(check);
	
	    _jquery2.default.fn.appear.checks.push(check);
	
	    // check now
	    check();
	  });
	};
	
	// keep a queue of appearance checks
	_jquery2.default.extend(_jquery2.default.fn.appear, {
	  checks: [],
	  timeout: null,
	
	  // process the queue
	  checkAll: function checkAll() {
	    var length = _jquery2.default.fn.appear.checks.length;
	
	    if (length > 0) {
	      while (length--) {
	        if (typeof _jquery2.default.fn.appear.checks[length] === 'function') {
	          _jquery2.default.fn.appear.checks[length]();
	        }
	      }
	    }
	  },
	
	  // check the queue asynchronously
	  run: function run() {
	    if (_jquery2.default.fn.appear.timeout) {
	      clearTimeout(_jquery2.default.fn.appear.timeout);
	    }
	    _jquery2.default.fn.appear.timeout = setTimeout(_jquery2.default.fn.appear.checkAll, 20);
	  }
	});
	
	// run checks when these methods are called
	_jquery2.default.each(['append', 'prepend', 'after', 'before', 'attr', 'removeAttr', 'addClass', 'removeClass', 'toggleClass', 'remove', 'css', 'show', 'hide'], function (i, n) {
	  var old = _jquery2.default.fn[n];
	
	  if (old) {
	    _jquery2.default.fn[n] = function () {
	      var r = old.apply(this, arguments);
	
	      _jquery2.default.fn.appear.run();
	
	      return r;
	    };
	  }
	});
	}.call(window));

/***/ }
]);


/** WEBPACK FOOTER **
 ** desktop-home24.js
 **/